export default {
  'QR6K9h': 'Change Account',
  'SXr/TJ': 'Change the customer name and address',
  'cDZ00w': 'Check',
  'tVoPUq': 'New',
  'tXBsQE': 'Undo changes',
  'yeM3H9': 'There is currently changing information, and the change review has not been completed. The new information can only be used for operations after the review is passed. Click to view the details.',
  '37UnDp': 'Whether to allow the sale of inventory in the master account',
  '5yWf2/': 'Account Authentication Status',
  'E8fzoC': 'Account availability status',
  'ElicqC': 'Company Name',
  'OtNA8e': 'My Profile',
  'yOMNOj': 'Yes',
  'P/eul9': 'No',
  'UBD4b9': 'Address',
  'a3sL9l': 'Account type',
  'ehoAjT': 'Customer type',
  'pV2t/S': 'Basic Information',
  '1vuDaF': 'To be activated',
  '3+1Jck': 'Certified',
  '8PESa6': 'Disabled',
  'CLqPBU': 'Edit',
  'DUQXFs': 'China mainland customers',
  'KOVFgK': 'Pending Review',
  'Nxf0U5': 'Individual client',
  'P13p8i': 'Approval Rejected',
  'Wt7gRM': 'Overseas customers',
  'XDzVGN': 'Customers in macao, China',
  'Xqm9/H': 'To be authenticated',
  'YA0JvR': 'Customers in Australia',
  'bzvDaH': 'Customers from Hong Kong, China',
  'dqeSBE': 'Corporate client',
  'eobwrx': 'Customers in taiwan, China',
  'sZSyGZ': 'Enabled',
  'QsOl4N': 'View change history',
  '0unUTD': 'Emergency Contact Number',
  '4wwVxZ': 'Recipients Cell no',
  '6YyMOz': 'Recipients',
  'Ojk15q': 'Recipients Address',
  'fJNcQC': 'Wallet Consumable Countries',
  'tuGgMn': 'Emergency Contact Person',
  'b5l2vN': 'Save',
  'dGBGbt': 'All',
  'KASLGt': 'Please select the corresponding country according to the currency in which the current account is expected to be recharged to avoid unnecessary exchange losses.',
  'MEbxQi': 'Incorrect mobile number',
  'Kwqd8h': 'Contact Person',
  'LabgPq': 'Add',
  '+4lD9e': 'Name',
  '5aTPaf': 'Finance',
  '5cbASK': 'ISP',
  '87+CkL': 'Domestic Warehouse',
  'CS1nBc': 'Person in charge of the logistics department of your company',
  'FlbEqp': 'Last mile',
  'JeSd9K': 'Other',
  'JsKHKZ': 'All',
  'KNi3io': 'Wechat',
  'O77bxe': 'Sales department',
  'Q0U6lO': 'Main contact',
  'SiW90w': 'Specific title',
  'UtE0dS': 'Action',
  'XeiAal': 'Delete',
  'XlmRrF': 'Global transfer',
  'ayzEHe': 'Clearance',
  'bBGcVD': 'Inventory',
  'dedKWK': 'Person in charge of your company',
  'e0Sn9Q': 'General staff member',
  'hDx3/S': 'Email',
  'kjXGsB': 'Business type',
  'sZ4TxG': 'Return',
  't9+g0f': 'Mobile number',
  'vkuBHV': 'Contact title',
  'ZhSSVD': 'Edit contact',
  'FkpSdN': 'Wechat',
  'SgFQRw': 'Tips: The email address and mobile number of the main contact will be used as the way to retrieve the password, please fill in carefully',
  'Tkqx5r': 'Position',
  'gSS3He': 'contact name',
  '0iSYp3': 'Will you remove the contact person?',
  '0iT2j9': 'If this operation involves the change of email address, mobile number and password retrieval,The system default subscription and password recovery email will be sent to the new mailbox,Address or mobile phone, continue?',
  'Xhn2gT': 'Select',
  'bKAoaM': 'Phone verification code',
  'jhfb/7': 'succeeded',
  'mZGgaM': 'Resend ({countdown}s)',
  'ypMY0M': 'get verification code',
  '0pw2t2': 'Shipper',
  '5FboZ/': 'Type',
  'UWWODP': 'Consignee',
  'Unr58u': 'Update Time',
  'YQa0fs': 'Add',
  'ekxzlF': 'Last Name',
  'f9OHsz': 'B/L consignee/shipper configuration',
  'h/j3a5': 'Contact Phone',
  'iUMM+c': 'Contact number',
  'wCmFtE': 'Please enter non-Chinese characters',
  'zYYUzJ': 'Add receiver/shipper',
  'Qqmpu5': 'Are you sure to delete? ',
  '0P9Dam': 'Organization ',
  '174V9v': 'The value is a positive integer ranging from 1 to 999.',
  'BfpU2q': 'DE VAT priority configuration',
  'JcnLqY': 'Only VAT that has passed the status is supported.',
  'Zf1gfY': 'Avoid automatic storage allocation',
  'gUQJOD': 'Outbound automatically assigned priorities',
  'n/weLR': 'The value is a positive integer ranging from 1 to 999. If no, the value is assigned according to the default rule',
  'vrXgIZ': 'UK VAT priority configuration',
  'IuggbZ': 'Special Notice, the following circumstances WINIT will not arrange for return',
  'Vzw58T': '(3) Others shall not be returned according to law.',
  'nRN2tZ': 'Overseas Warehouse',
  'pjeZQ1': '(2) Do not accept buyer self-delivery returns.',
  'qU4NBE': '(1) Do not accept any freight collect returns ,please pay the freight in advance.',
  'Cmh20w': 'Add Address',
  'EGCtVA': 'Address ID',
  'I/ecfs': 'The addresses below can only be used as Destination Warehouse address for Global Transfer orders.',
  'Ls/792': 'Priority',
  'Ozm+wK': 'Country/area',
  'R2D5Dv': 'Creation Time',
  'Ut8+i2': 'Approved',
  'W9Nshi': 'Approval Status',
  'o/NKeE': 'Default Address',
  'zarB4B': 'Tel',
  '+mhlOQ': 'Only applicable to customers returning by courier.',
  '2cscD/': 'The address code is used to create order by API or batch import way, you can defined the code in your style (composed of any letters and numbers), but it can not be modified after the submission.',
  '4P3k8y': 'ISP return address',
  '5iyXaV': 'The following address is only used for the "International Delivery ISP" Express Return Receipt Address',
  'HJ9/xO': 'Please enter letters and numbers',
  'I3KHY+': 'Pick-up Adress/Mailing Address',
  'LZGKge': 'FBA Shipping Address',
  'ZT3XmT': 'Province',
  'aqQg0p': 'District',
  'gvnY3J': 'City',
  'lfTX1B': 'Zip code',
  'xnNdNf': 'Return Address',
  '89AO9d': 'Such as:OAK6',
  'EPwTKQ': 'Address 1',
  'Y0pQ9+': 'Street 2',
  'Zh3+AG': 'The address code is used to create order by API or batch import way,you can defined the code in your style (composed of any letters and numbers),but it can not be modified after the submission.',
  'cAO9+Q': 'You can enter the Warehouse Name and relevant notes.',
  'h/rxnW': 'Region/State',
  'ma1bk0': 'House Number',
  'Vy+2vj': '(Reminder, Please provide (enter) the Cellphone Number)',
  'kavVIg': 'Your changes have been submitted, customer service staff will review the information, please be patient to wait for about 1 working days.',
  '2cJWcY': 'Contact Person (Chn)',
  '6X3PH/': 'Contact Person (Eng)',
  'FdxNc2': 'CN address selection District, Post Code will automatically fill in',
  'I1csCB': 'Address (Chn)',
  'iXLW4z': 'Please enter the detailed address, the provincial city information does not need to be entered again',
  's4Uh1V': 'Address (Eng)',
  '+a6DnG': 'In progress',
  'C2bl/o': 'Inspection Warehouse',
  'FjEahZ': 'View details',
  'K+M18J': 'This address is not available for pick up',
  'MTtFwJ': 'Audit status',
  'W4KBof': 'Pickup Type',
  'Xcsk6t': 'This city is not available for pick up',
  'XmRKnc': 'Remarks',
  'jnerdQ': 'Not support more than two pick-up addresses for this city',
  'ptQCRK': 'Product Line',
  'sEnMXQ': 'Audit failed',
  'uyiJ3u': 'To be verified',
  '3Y6eOz': 'Invalid',
  'BbeuTL': 'Non Winit carrier importer',
  'C/pEBf': 'View maintenance records',
  'D+H90c': 'Business unit list',
  'G93Pnn': 'Type of declaration',
  'MFvoiw': 'Exporter',
  'MSzsZn': 'Void',
  'QV3pnn': 'Status',
  'SaqVpv': 'Deferred Customs Clearance by Own Importers',
  'WrhSGw': 'Ordinary customs clearance',
  'Zq5tH7': 'Maintenance time',
  'bqbDVw': 'Search',
  'cawvIS': 'Last Update',
  'gnxH14': 'Invoicing importer',
  'lH1uep': 'Importer',
  'rafcJa': 'Maintenance records',
  'wpl80v': 'Trader',
  'zeMk2K': 'Draft',
  '7fXxGd': 'English Unit',
  'CaAumf': 'Unit of Weight: (lb); Unit of Length: (inch)',
  'EFsNaj': 'Preferences',
  'H2shJb': 'Unit of Weight: (kg); Unit of Length: (cm)',
  'veounH': 'Metric Unit',
  'wZ+mT6': 'Select unit of measure',
  '/CDgDv': 'EIN NO.',
  '1AeGN2': 'LUCID NO.',
  '47GdDb': 'Close',
  '62OTLP': 'Ordering Channels',
  'EJNWSf': '<strong>API: </strong>{break}When ordering through API,  By enabling smart ordering recommendation, The system would return error if suggested shipping warehouse is different from original one.  Customer can re-submit the order according to suggested information.{break}<strong>Bulk-Load ordering: </strong>{break}When do bulk-load ordering and smart ordering recommendation is enabled, if the recommended approach is different from original plan, the suggestion box will popup. If recommended approach has no stock, no change will be taken place on original plan, only for awareness.',
  'sX4SJM': '<strong>Smart Ordering Recommendation: </strong>{break}According to order information regarding buyer address, shipping methods, oversea warehouse stock etc , System will automatically calculate the best shipping approach(The combination of shipping warehouse and shipping method) based on the principle of last mile cost optimization & time optimization and make recommendation to customers. If you need to use smart recommendations, please select the main warehouse to place an order.',
  'EJpN+O': 'ABN NO.',
  'M+2rs2': 'BOND NO.',
  'M32toW': 'Submitted Time',
  'QCtV9X': 'Smart Ordering Recommendation',
  'ZUPzqr': 'Open',
  'cBSx2y': 'Automatic delivery',
  'dWSaKv': 'EORI NO.',
  'RKlsu6': 'Configuration for Outbound Smart Order Recommendation',
  'ilxqI8': 'Automatic delivery: Automatic delivery means that the system will automatically deliver the goods automatically according to the optimal delivery plan calculated by the automatic recommendation, without the need for customer confirmation. Do not open if you have the requirements for the specified warehouse delivery.',
  'nlhDkH': 'Bussiness Number(BN)',
  'th8lNA': 'VAT NO.',
  'ux3AEe': 'Description',
  'uzP8rj': 'Approved Time',
  '0POKcW': 'Applied area',
  'bfcFzv': 'GFS',
  'l6DYl/': 'Bulk import ',
  'Qc8f+x': 'Select one Ordering channel at least !',
  'k8xgfx': 'Select one Applied area at least !',
  '0hqZKL': 'Language settings',
  '/zJh7j': 'The total amount of product sales filled in and submitted when placing an order through the page or API',
  '6tpF/e': 'Fill in the order',
  '7wofGo': 'apply',
  'C8evWc': 'Export declaration value of SKU shipping warehouse country',
  'GlTTjv': 'Platform sales price (ebay platform only)',
  'Gwj7xc': 'Reset',
  'JUpZ++': 'Import declaration value of SKU shipping warehouse country',
  'MDCxK0': 'order',
  'RKJ5i8': 'notice: {break} 1. You cannot cancel all the options for obtaining the declared valuer, and keep at least one item.{break} 2. When the order of obtaining declared values is not set, the order of obtaining is the default: {break} Fill in the order > Platform sales price (ebay platform only) >  export declaration value of SKU shipping warehouse country > Import declaration value of SKU shipping warehouse country',
  'W3sY1n': 'The source of the declared value',
  'aBSjju': 'source',
  'aq5/iT': 'The declared import price of the goods obtained by the corresponding country of the order shipping warehouse',
  'cUGZlH': 'The declared export price of the goods obtained by the corresponding country of the order shipping warehouse',
  'kyIaVY': 'If you bind an eBay store synchronously on the Wanyilian platform, the system automatically obtains the total cost of the order items',
  'qJVc8e': 'Declared value acquisition settings',
  'BG+fLq': 'Help Guide',
  'FJZaXL': 'Search results for {total} records "{keyword}"',
  'zUjHmW': '<strong>Sorry, no documents related to "{keyword}" were found</strong>{break} I suggest you:{break} See the text you typed Is there a mistake{break} to remove words that may be unnecessary, such as "", "what", etc.',
  'zvNTfS': 'Access guide',
  'xUjLTE': 'Search',
  '3/xobX': 'Please authorize eBay to inquire the agreement',
  '7uKffF': 'Authorize the eBay inquiry agreement',
  'GKxsGv': 'Authorize the eBay inquiry agreement!',
  'r0/TUu': 'OK',
  '/554iQ': 'eBay account',
  'H0w708': 'Associate eBay account',
  'IPC1Nx': 'SKU NO.',
  'VpfuUi': 'Specification',
  'c4RKNC': 'Batch export',
  'r2dEd/': 'Reset',
  'xJ3UzU': 'Country',
  'zJ+fPt': 'Maintenance goods',
  '1WkxFB': 'If you have not submitted the product, please search for the product and submit it again!',
  'AFr5qh': 'Please enter country',
  'OxFkJJ': 'Please enter associated eBay account number',
  'a6Yyuu': 'Please enter the product code!',
  'JN5iZt': 'Submitted successfully',
  'ENPgS/': 'Submit',
  'Idl9bN': 'Download and upload template',
  'OVecAI': 'Success',
  'UxWoxB': 'Please upload the file!',
  'e6Kx8h': 'Upload and import files',
  'jvT5eh': 'The allowed file type is.xls.xlsx',
  '553X02': 'Single change',
  '7hIS0P': 'New binding relationship',
  'IGEePO': 'Batch change',
  'i+8CAV': 'Commit changes',
  'uq1Q7O': 'Available inventory',
  'yy7EDI': 'Upload',
  'h7PahP': 'Binding time',
  'kc0dbR': 'Change',
  '7tXP5z': 'Please enter the SKU No.',
  '5vOrMy': 'The SKU No. you modified has been submitted successfully',
  'OiUovQ': 'Note: {break} 1. Please do not modify any field or file format; {break} 2. Only 2000 data files are allowed to be imported at a time. If more than 2000 data files are imported, split them into multiple files. {break} 3. Please go to [<a>eBay certification warehouse SKU query </a>] to view the successful import result. {break}',
  'Q3iOKS': 'eBay certified warehouse goods query',
  'S0QUcN': 'You have successfully imported, please go to the eBay authentication bin push product page to view the binding result. {break} Success in submitting {successNum}, failure in submitting {failNum}. {failNum, select, 0 {} other {failed to import data and failure reasons <failUrl>Click to download file</failUrl>} }',
  'l85pdw': 'Note: {break} 1. Only in [Account management] is the enabled eBay account, the inventory information will be synchronized to eBay, you can go to [<a0> account management </a0>] to check the status of the eBay account; 2. This page only displays the bound commodity information, if not bound, please go to [<a1>eBay authentication warehouse Commodity Management </a1>] to bind; {break}',
  'tqdJgC': 'Bind and push/unbind',
  'w5d7pQ': 'You have successfully imported, please go to the eBay authentication warehouse push product page to view the binding result.',
  'zQgm+f': '1. It is not allowed to change the eBay account and country associated with the goods that have been bound and pushed; {break} 2. Please verify the submission result when submitting the change. After submitting the change, the binding will push the association information or unbind the binding and no longer push the association information. {break}',
  'Tjer6Q': 'Outbound automatically assigned priorities: including outbound, stock loss and other documents reducing inventory, Only normal stock is available; and UK-Defer inventory will still be allocated first in first out.',
  'U5Vumz': 'The value of VAT that is not configured is automatically allocated according to the default rule, and the value of VAT that is automatically allocated out of the database has a lower priority than that specified in the configuration rule.',
  'sCNEKm': 'Outbound automatically assigned priorities: including outbound, stock loss and other documents reducing inventory.',
  'x7XBYH': 'Avoid automatic storage allocation: if Y is selected, the VAT will not participate in distribution in the scenario of returning goods and stock surplus.',
  'cMDiKi': 'The addresses below can be used as the pick-up or shipper address for Overseas Warehouse orders, ISP orders and Global Transfer orders.',
  'oSlHJh': 'International Express ISP/eDS products, do not allow more than 2 pickup addresses in the same city.',
  '+eZfm3': 'Information Authorization Agreement',
  '2QzYmY': 'Cancel',
  '2dToBQ': 'VAT information',
  '32RoB6': 'German Overseas Warehouse Warehousing Agreement',
  '3YXmhj': 'Re-submit',
  '608d8o': 'Log',
  '9WauWf': 'Business Number (BN) documents',
  'C6gmWp': 'Registered Address of Exporter',
  'DZfXfd': 'Please review the agreement carefully and agree to it',
  'DnlTlc': 'UK Overseas Warehouse Warehousing Agreement',
  'F70ljy': 'Those who choose ordinary customs clearance need to pay import customs clearance VAT and customs duties',
  'FNgKWM': 'Withdraw',
  'FsjBUE': 'Tax Agent Statement Letter',
  'GkNbe+': 'Data',
  'Hd1SOD': 'Selecting the billing importer cannot be the customs clearance importer',
  'I+27a0': 'EBAY store binding VAT screenshot',
  'JfR4m8': 'Cannot contain Chinese characters',
  'KfmqkT': 'Save the draft',
  'LRaUkx': 'Inbound and Outbound Data Authorization Protocol',
  'ODfvW/': 'Exporter\'s name',
  'Qv+LG3': 'Legally binding declaration regarding obligations under German packaging law',
  'Rq/p8Q': 'We confirm that we have complied with the requirements of the UK VAT and agree to sign',
  'SSUtSr': 'EORI File/Activation Screenshot',
  'Sxq3ys': 'Please enter the name of the EU country',
  'VsT/ah': 'Business license',
  'WEgQND': 'Commitment letter for PVA import',
  'WSq7p2': 'VAT registration certificate',
  'ZKKStI': 'BOND proof',
  'ZXhbHG': 'Registered address of trader',
  'dbS2AO': 'Do not take WINIT first-leg transportation',
  'eGYTrD': 'Registered address of the importer',
  'fKSz21': 'Trader name',
  'fRH1j+': 'Please enter the business unit name',
  'g+ULz4': 'WINIT will provide corresponding information and documents to HMRC at the request of HMRC',
  'gA384i': 'Maintenance',
  'h/HUTI': 'Applicable countries/regions',
  'hMAtte': 'RIS-File',
  'nubBQI': 'I have read and agree to sign',
  'prYaF1': 'If you choose your own importer to defer customs clearance, you need to pay import customs clearance duties and do not pay value-added tax. UK importers need to upload "PVA application letter", "UK tax agent\'s letterhead declaration letter", "VAT tax declaration certificate" "(The VAT registration date is more than 6 months, provide the tax declaration certificate of the previous quarter / the VAT registration date is within 6 months, and then provide the declaration record of the fifth month from the registration date), please complete the submission when uploading the materials',
  'q3xYc9': 'ABN registration certificate',
  'qSAraU': 'Legal Person/Director',
  'rgQ1Wi': 'and',
  'tsqy8I': 'LUCID registration file/screenshot of registration',
  'usIIRS': 'Application Letter for PVA',
  'vDCwZ9': 'Upload file',
  'vr5TVT': 'Please input',
  'xykin+': 'Unified Social Credit Code',
  'yn1SL5': 'Importer\'s name',
  'BdHisb': 'operating time',
  'Da7ks5': 'Please input 18 letters and numbers',
  'a/r3qH': 'Operator',
  'atGbyi': 'Please enter the 18-digit credit code',
  'e1tqgk': 'It cannot be withdrawn after being invalidated. Please confirm whether it is invalidated?',
  'tLzna4': 'operation action',
  'IbJWUq': 'Do you want to invalidate the current maintenance information?',
  'QieJUI': 'Change Field',
  'gsnEOr': 'Before the change',
  'pS8NPW': 'After the change',
  'Dj/XZS': 'Please do not enter spaces',
  'ej75mI': 'Please enter a valid phone number',
  'XwwFFy': 'Customs declaration method',
  'mqQjid': 'Front and back of ID card/passport',
  'r+pn1G': 'If you choose your own importer to defer customs clearance, you need to pay import customs clearance duties and do not pay value-added tax. UK importers need to upload "PVA application letter", "UK tax agent\'s letterhead declaration letter", "VAT tax declaration certificate" "(The VAT registration date is more than 6 months, provide the tax declaration certificate of the previous quarter / the VAT registration date is within 6 months, and then provide the declaration record of the fifth month from the registration date), please complete the submission when uploading the materials.',
  '6RphVF': 'Please upload the file',
  'D+QVwb': 'The first leg of non-WINIT carrier can choose this customs clearance method.',
  'o1vWQc': 'The current maintenance record refers to the audit record that has been audited and activated by the importer, and needs to be audited again when the key information is changed.{break} Changes can only be made successfully after approval, and changes will be invalid if they are not approved.',
  'v8rn/V': 'Use the customer\'s own importer to import, only pay customs duties, and do not pay VAT value-added tax. UK importers applying for this customs clearance method need to send the "UK tax agent\'s letterhead declaration letter" to the designated mailbox (you can consult sales to open it), and upload the "PVA application letter", "inbound and outbound authorization agreement" and "PVA statement letter".',
  'vsXTPj': 'Use a third-party importer to import, you need to pay customs duties and miscellaneous fees (tax bills are not provided).',
  '3Atmuu': 'Confirm invalidation',
  'BTlPVu': 'Login Verification Logs',
  'BbSb0z': 'Modify',
  'BtZh7z': 'Create',
  'Q4mnEi': 'Modified after approval',
  'liLr1Z': 'Do you want to delete the current information?',
  'mUCGVr': 'Confirmation is valid',
  'rthds+': 'Do you want to withdraw the current information?',
  'sdupnt': 'Confirm exception',
  'xk9Koe': 'Maintenance Log',
  'y3ogvt': 'Maintenance audit passed',
  'yyHJG6': 'Do you want to delete the current maintenance information?',
  'N5niLf': 'Business Number(BN)',
  'T61GlG': 'The current maintenance record refers to the audit record that has passed the audit and is enabled, and needs to be audited again when key information is changed. Changes can be made only after the approval is passed, otherwise the changes will be invalid.',
  'WMI5sr': 'Business Number (BN) documents',
  '+hneSS': 'Submit maintenance',
  'OTPfbv': 'Change time',
  'WMGcE3': 'The maintenance review failed',
  'byKmgP': '{start} to {end}, a total of {total} records',
  'N5Lfmq': 'Not allowed file format',
  'niXKkN': 'The file size exceeds 10M',
  '7gd0PB': 'Data error prompt',
  '86uQ8V': 'The following file address is invalid, please upload again: {files}',
  'GJghrF': 'Note: The uploaded data format is limited to pdf, jpg, png, and the size limit is 10M, and limit of 10 single file types',
  'HlgPNt': 'Chinese Mainland',
  'Lszars': 'America',
  'PIBLYF': 'Hong Kong, China',
  'trcfDz': 'Example diagram {index}',
  '/Fo4sl': 'UK overseas warehouse online agreement',
  '/h0Qy3': 'Address name',
  '1m6Ukk': 'Address code',
  'AcTHLQ': 'Invalid',
  'Cyu6TT': 'Receiver address',
  'FXq3sc': 'Delivery address',
  'JJl2M9': 'Export',
  'naS99r': 'Valid',
  'yjFeF+': 'Third-party warehouse address',
  'qZZtQ0': 'This address is not available for ordering',
  'Df3vzk': 'Drag and drop to adjust order',
  'FS9wfs': 'Resubmit maintenance',
  '2lXLcA': 'Please select the applicable country',
  '3GEmd9': 'View address character automatic correction logic',
  'hiw+Xi': 'Address automatic correction configuration',
  'kyspuD': 'Applicable country',
  'pyipaf': 'Enable automatic correction of address characters',
  'rVuTxV': 'Updated Log',
  'gYnrwb': 'ALL',
  '10jb3V': 'Enable automatic house number interception',
  'Yx3wUi': 'Enable automatic correction of cities',
  'o1Hwo3': 'Updated by',
  'tGCYrC': '	Updated Content',
  '876ii/': '2、After signing<url>《the Global Address Automatic Optimization Agreement》</url>, the system will automatically enable all the following correction items. If you need to close it, please uncheck and save.',
  'B8Is1c': '1、To enable automatic address correction, <url>《the Global Address Automatic Optimization Agreement》</url> must be signed in advance, otherwise the following configuration cannot be edited。',
  'P4iDwm': 'View house number interception logic',
  'UYZ3z+': 'View automatic correction of cities logic',
  '6AxC42': 'Email',
  'CmaYfv': 'VAT/EORI',
  'UVmTM9': 'Name',
  'abk9Do': 'Telephone',
  'k/3yRK': 'Common outbound address',
  'oN/kSF': 'Reservation information',
  'uoZwj+': 'Founder',
  '3eRWcP': 'Email',
  '6kdpEu': 'Consignee Information',
  '9YhIAD': 'Email Appointment',
  'HNavdr': 'Corporate name',
  'V2u2QJ': 'Appointment requirements',
  'jetAYE': 'Telephone booking',
  'siSti3': 'Address information',
  'ea3Q5D': 'Telephone',
  '3XMw6o': 'European Authorised Representativ',
  'AG/fPb': 'address2',
  'B7TTEB': 'Based on the above submitted content：{break} 1.For each product covered by my European Authorised Representative{break} a.the European Authorised Representative\’s name, registered trade name, and contact details, including the postal address, are indicated on the product, it\'s packaging, the parcel or an accompanying document, and{break} b.the European Authorised Representative has the Declaration of Conformity(or Declaration of Performance) and has access to the related technical documentation to show conformity{break} 2.I will notify you of any change to my European Authorised Representative.{break} 3.All the information I have submitted on this form is true, and I am aware that any responsibilities and consequences caused by false information will be borne by me.',
  'EpqiOL': 'Are you sure it will take effect?',
  'IIqX9O': 'Email',
  'KZEXfv': 'Is it confirmed to be invalid?',
  'etW1Tw': 'Responsible person status',
  'jrh2fV': 'Code',
  'qRFx1i': 'Add responsible person',
  'qWBL/6': 'Responsible Person',
  's4hJju': 'Details',
  'uUvS4a': 'address1',
  'w1B/h4': 'Valid',
  '1AtZdk': 'Go to submit order page',
  '36+mbi': 'Status',
  '9AIfVS': 'Successfull Lines',
  'ARrflw': 'Info name',
  'KnTZPE': 'Failed Lines',
  'NLpJXo': 'Time Consuming(min)',
  'NPKHC7': 'Export Failed Lines',
  'O2kIme': 'Batch upload results',
  'uMZCpR': 'Total Lines',
  '+eaHJw': 'Batch increase',
  'G2smdP': 'Chinese name',
  'L5h07e': 'Batch removal',
  'Ly/R6V': 'Specify mixed storage of defective products',
  'RlzFYp': 'Are you sure to remove it? ',
  'XF6xi6': 'Please select the product to be removed! ',
  'aHlr3k': 'Remove',
  'D1o32K': 'Exception date',
  'IIpaxH': 'Exception type',
  'UfxykZ': 'Reason',
  'l0qKOL': 'Abnormal inventory quantity',
  'hYlWkF': 'Support up to {count} encodings, separated by commas or newlines',
  'veOJme': 'The number exceeds {count}',
  'txkkWO': 'Associated tracking number',
  '2C37Hc': 'Exception no.',
  'LLD1es': 'Exception reason',
  'k1dsDk': 'Associated business no.',
  '0D60ha': 'more',
  '46Xee4': 'Destination country importers and exporters',
  'WVZBn4': 'Registered address of importer and exporter in destination country',
  'sWBQDd': 'Name of importer and exporter in the destination country',
  '6qPVaC': 'Designated importer for the final shipment',
  '7BkuKz': 'Order Setting',
  'QeeTzU': 'importing country',
  'ckpzhc': 'exporting country',
  'yvg8P4': 'Designated exporter for final shipment',
  '75uiZ7': 'Please enter {fieldName}',
  '+benQU': 'Hello, it is not possible to select both the same cmountry and EU countries for import and export purposes. Please reselect',
  'm3uVGW': 'Duplicate configuration of import and export country combination, please reselect',
  'n/orQt': 'Configuration of final import and export merchants',
  'h+ZVJS': 'The configuration of the final importer and exporter must specify one of the designated exporters and importers, and cannot be empty at the same time',
  '+k3Q5q': 'The final importer/exporter can specify the importer/exporter to be used in the country. Both the final designated exporter and the final designated importer must specify one of them and cannot be empty at the same time',
  'wxbfiR': 'The importer and exporter of the destination country has expired, please reconfigure it.',
  'KR0Hgn': 'Registered address of origin exporter',
  'O8r6Nr': 'Name of origin exporter',
  'auxh85': 'Other settings',
  'eu9UcL': 'Origin exporter',
  '7Rb0P0': 'Please enter 0-30 characters',
  '9SnCRm': 'Error reminder',
  'BugeSn': 'Only compression packages in zip format are supported.{break}the specification of the German specification file name for each commodity, compressed into a zip file before upload.{break}File name specification in the compression package: commodity code & & & specification Paper German instructions need to be stored along with the goods.',
  'DqPtfZ': 'Yes',
  'EIebSr': 'No',
  'HvXKb+': 'Import Type',
  'MCgWp2': 'Import successfully',
  'NzmP6C': 'Commodity Instructions (paper)',
  'O6OGAx': 'Product Barcode',
  'Up6Ro9': 'Download the import template',
  'X5vmSB': 'Commodity Instructions link',
  'cpiawR': 'The doc format or the pdf format is supported. Limit is below 10M.',
  'hwLqlW': 'Support XLS,XLSX format only.The link supports up to 30 characters.',
  'iwbG4U': 'Description (Chn){break}Description (Eng)',
  'oH13Vj': 'Import',
  'pVp/bh': 'Please select a file to upload',
  'rpg4rj': 'Commodity Instructions files',
  'xraZsK': 'Click here',
  'srQkrR': 'illustration:{break}a. Electronic file manuals, need to add value in the warehouse, print out the instructions, and add them to the goods.{break}b. German manuals link, the corresponding German manuals link will be printed on the courier note when the product is out of the warehouse, but this function is limited to the final delivery supplier, it is recommended that you add the German manuals paper file to the product as soon as possible.{break}c. SKU marked in red must have paper manuals in German.',

  '+CFe0t': 'Winit standard packaging',
  '/CesoY': 'Volume (CBM)',
  '0B0jPm': 'Day',
  '1ZbDC3': 'Weight(kg)',
  '2+X2n8': 'Batch Delete',
  '23ZRo5': 'Exporter VAT',
  '2IBaY7': 'Please enter numbers',
  '3xzQSW': 'Reason for can not choose',
  '6+iYA0': 'No.',
  '63L59R': 'Customized',
  '6EHwdX': 'Pallet Type',
  '7FRGXg': 'Batch Add Product',
  '7n6a/K': 'SKU Information',
  '7riRKk': 'Batch Add',
  '8VzrEu': 'Please select currency',
  '9bnXiC': 'Single product',
  '9k+FW2': 'Pallet with rest',
  '9ll3dY': 'Packing material type',
  '9qzdVH': 'Package Weight(kg)',
  'Ao74DA': 'Order packaging material SKU No.',
  'BHT1Cr': 'SKU type',
  'CKRHYP': 'Discount',
  'DTvHkh': 'Above quotation is only for reference, and the actual cost is based on your outbound order. Should you have any query, please contact your customer representative/sale manager',
  'Dpm+6x': 'Shipping warehouse, recipient country and postal code, product information is required{break} If you fill in the postal code incorrectly, the cost will not be calculated{break} If you use [non-WINIT registered goods] for calculation, fill in the weight or volume If the channel limit is exceeded, the cost cannot be calculated{break} If you need to calculate the channel cost related to TOLL, or the recipient country is AU, please fill in the province/state and city information{break} If you need to calculate the channel to be declared, use [Non- WINIT Registered Products] When calculating, please fill in the sales amount and currency information and please check the [Declared Value Obtaining Source] as "Fill in when placing an order" on the [Wanyilian-Personal Center-Declared Value Obtaining Settings] page',
  'GBQ8fq': 'Pallet\'s length * width * height',
  'GMujSv': 'Sales amount',
  'HRSUhm': 'If the SKU type is a single product, please fill in the number of goods in the outbound order; if the SKU type is a suite product or a box product, please fill in the number of sets or boxes out of the warehouse',
  'HzFVgP': 'Please select the SKU do caculation',
  'KgH03N': 'Full Pallet',
  'MBDvr0': 'Please enter the width.',
  'MPleAI': 'Product Name',
  'NgGZZ2': 'Please enter 12 or more digits or letters.',
  'O0A1Oq': 'Length*width*height (cm)',
  'Og2Qdv': 'Product selection is not available.',
  'P410bl': 'Please enter the length.',
  'QrBLOg': 'One order with several packages',
  'THHekX': 'SKU Standard Qty',
  'TTavqO': 'Conventional',
  'TdB0f7': 'Please enter the height.',
  'UH1kCc': 'Add',
  'VGcpgt': 'Delivery Time',
  'WHdJYA': 'Winit Product',
  'Z+i6Rm': 'Specification',
  'bZaON1': 'Amount input limit is 0.01-999999.99, up to two decimal places',
  'bduxF6': 'Winit Registered Products',
  'cIVTIx': 'Pallet Quantity',
  'cQZEJX': 'Pallet with allowed exceeding',
  'cstWzE': 'Importer VAT',
  'dJ89Br': 'Value Added Services',
  'eLEnSl': 'Non-Winit Registered Products',
  'fMEG4U': 'one order packing with multiple waybills',
  'hAZ9h3': 'Height please enter numbers',
  'hR9/2a': 'Package length(cm) x width(cm) x height(cm)',
  'hTL5aU': 'Tray Number',
  'hTZnwL': 'Rebate',
  'i0bc3f': 'Currency',
  'i1oH9G': 'Packing Method',
  'i738m0': 'Packing before delivery',
  'igMfLW': 'Suite product',
  'jOZW14': 'Tray',
  'k7s6O7': 'Origin Warehouse',
  'lqAG8L': 'Box product',
  'mDikX0': 'Outbound Quantity',
  'mhxee1': 'Charge Item Name',
  'nIWEr7': 'Product selection is available.',
  'ohULHS': 'Country',
  'w6vqtD': 'IOSS NO.',
  'wauDMi': 'Total Cost',
  'xuLZNZ': 'Length please enter numbers',
  'yx2O+K': 'Receivable Amount',
  'zO/rYo': 'Delivery mode',
  'zy6bEq': 'Width please enter numbers',
  '2w153i': 'Paid in amount',
  'IFSxrU': 'Charge Item Code',
  'tc4Ood': 'Please select data',
  'Bc++8m': 'Padded Envelope',
  'Dm23uJ': 'Carton Box',
  'f9THke': 'Courier satchel',
  'sPJoAT': 'Estimated Cost',
  'TdtC9s': 'Please select a shipping warehouse',
  'XiHRkz': 'Total {total} records',
  'bFMl+l': 'Please select the product and add',
  'SfYiE5': 'Please enter an integer greater than 0',
  '//WaV/': 'Item Management',
  '/XgsKl': 'With CAO label',
  '1+Uose': 'Permission settings',
  '1E5dGB': 'Branded',
  '2MJUJn': 'Enable outbound package',
  '44gmfc': 'SKU Management',
  '5xncPr': 'With Lithium Batteries – Forbidden for Transport Aboard Aircraft and Vessel',
  '7RULl5': 'Once enabled, you can manage products by batch and specify batch shipments.',
  'A5gRQm': 'With lithium battery UN label',
  'B5hVJ7': 'Expand more settings',
  'BTv3tF': 'No package',
  'EcMORf': 'Enable batch management',
  'FOxVvr': 'Once enabled, you can maintain packaging items. Customized logistics packaging can be configured and used when leaving the warehouse.',
  'Hs7Y9S': 'SKU settings',
  'I8NwoI': 'If you choose not to add packaging, all registered products will be unpackaged by default.{break}{break}Packaging is required. Only when you register a product will you need to fill in the packaging information. You can add packaging preferences to the product, and you can still modify individual products later.',
  'IOnZfu': 'With fragile label',
  'JJR2vL': 'With front-face-upper label',
  'KWQDuK': 'Once enabled, you can specify that the goods are packaged according to the outbound grouping rules.',
  'L4Rf/B': 'Default settings, individual SKU can still be modified later.',
  'RShmXn': 'Management Method',
  'S/KCTh': 'Require additional packaging',
  'S30Plx': 'SKU outbound packaging',
  'V2w9jQ': 'Enable suite product',
  'XL7Ecj': 'With 9 classes of dangerous goods label',
  'XQ0eW6': 'SKU inbound packaging',
  'Z2NCKN': 'Enable customized packaging materials',
  'dBkhSm': 'Once enabled, box products can be maintained for a single product SKU.',
  'eq/wHb': 'No brand',
  'et9PbY': 'Enable multiple third-party product barcodes',
  'fZCpT7': 'Enable box product',
  'ipcBHJ': 'Default settings, individual SKU can still be modified later.{break}{break}When registering a product through the API, if left blank, the default management method will be the current preference.',
  'nkXqB0': 'Branded Product',
  'ooWceD': 'With Surface Mail Only',
  'rvY6SV': 'Collapse more settings',
  'sCJ51j': 'Once enabled, multiple third-party product barcodes can be maintained for the same product.',
  'wgwaXi': 'Once enabled, package products can be maintained for a single product SKU.',
  'xE1H+X': 'Settings',
  '5knzXk': 'SKU outbound packaging preference',
  'Ak9BaJ': 'Outbound package material',
  'CB041o': 'An item in order',
  'DxV5Uw': 'Outbound package category',
  'EMKEjY': 'Default settings, individual SKU can still be modified later.',
  'NV9VX7': 'Multiple item in order',
  'V0RiZp': 'Successful operation',
  'nP04RA': 'Selecting that you need to add packaging will enable the use of outbound packaging by default. You need to fill in the packaging information when registering the product, and the import template will also be changed accordingly (you need to download the import template again). Are you sure you need to add packaging?',
  '1i8ZrX': 'Commodity packaging material',
  '4MGor2': 'Inbound packaging',
  'EWhdiR': 'Products without outer packaging can not be shipped directly from the warehouse.Please maintain the shipping packaging preference to require additional packaging, otherwise the product can not be registered and submitted.',
  'Gz4aGL': 'Outbound packaging',
  'H6C/SG': 'SKU packaging shape',
  'OD7P5z': 'Go to Sign',
  'vDrXbl': 'Sku inbound packaging preferences',
  'NFpCub': 'Sales packaging does not support direct delivery. Please maintain the delivery packaging preference to require additional packaging, otherwise the product can not be registered and submitted.{break}{break}If you still need to use sales packaging for shipment, please sign the "<url>Overseas Warehouse Disclaimer Agreement for Sales Packaged Goods</url>"',
  'DmqHzL': 'The instructions for using customized packaging materials are as follows, please read them carefully before opening them. If the customized packaging material is maintained after opening, it will not be allowed to be closed, so please operate with caution! {break}<url>"View Operation Guide"</url>{break}{break}Are you sure you want to enable customized packaging materials?',
  'IKjl4Y': 'The instructions for use of the outbound set are as follows, please read them carefully before opening them. If you add a set after opening, you will not be allowed to close it, so please operate with caution! {break}<url>"View Operation Guide"</url>{break}{break}Are you sure you want to activate the outbound package?',
  'i2iyhb': 'The instructions for using the product are as follows, please read them carefully before opening. If a box is created after opening, the product will not be allowed to be closed, please operate with caution!{break}<url>"View Operation Guide"</url>{break}{break}Are you sure you want to activate the box product?',
  'iZYhRR': 'The instructions for batch management are as follows, please read them carefully before opening them. Once opened, it will not be closed, so please operate with caution! {break}<url>"View Operation Guide"</url>{break}{break}Are you sure you want to enable batch management?',
  'jX7MAR': 'The instructions for using third-party product barcodes are as follows, please read them carefully before opening them. After opening, if multiple third-party barcodes are configured for the product, it will not be allowed to be closed, so please operate with caution!{break}<url>"View Operation Guide"</url>{break}{break}Are you sure you want to enable multiple third-party product barcodes?',
  'mLKBZu': 'The instructions for using the product set are as follows, please read them carefully before opening them. If you create a package product after opening it, you will not be allowed to close it, so please operate with caution!{break}<url>"View Operation Guide"</url>{break}{break}Are you sure you want to activate the package product?',
  '+Xgzdq': 'With battery',
  'DpcGY6': 'Is food',
  'FGVjpL': 'With liquid',
  'nJAKFn': 'Changing the management method preference will affect the default value when registering the SKU, so please operate with caution. Are you sure you want to switch preferences?{break}Special note: When ERP docking is used to register products through the API interface, if the management method does not pass a value, the current preferred management method will be used by default. Updates will affect the attributes of subsequent registered products. If the API registered SKU has passed the value, it will not be affected.',
  'USKhsn': 'Search results for "{keyword}"',
  'J1Q+MP': 'Skip',
  '66h8jy': 'Operation Guide',
  '19Jq5n': '{count} items selected in total',
  '1WXIxS': 'Unbind',
  'DBt/Kx': 'Item Barcode',
  'FEb7U2': 'Confirm',
  'Ig8gbN': 'Single item status',
  'R5GY4d': 'Import date',
  'Wz9vSw': 'Format input error, please separate with new lines',
  'XlNGpT': 'Import time',
  'ZPVUga': 'The reasons for the failure are as follows:',
  'CW17P+': 'Copy barcodes that failed to be deleted',
  'XOD0e7': 'Delete failed!',
  'mUf6oZ': 'A total of {totalNumber} item was deleted,{sucessNumber} were successful,and {failNumber} were failed',
  'u4FyMa': 'Delete successful!',
  'x79O39': 'Are you sure you want to delete it?',
  'J9jPRL': 'Replicating Success',
  'Zmju6f': 'Are you sure to delete?{break}After deletion, this item code will not be recognized. If you need to use it, you can import it again.',
  'aINg/w': 'A total of {count} items are selected.{brack}This item code will not be recognized after deletion. If you need to use it, you can import it again.',
  'nE9ED6': 'SKU NO./Item Barcode required',
  'v0yFyE': 'Supports {count} queries with multiple line breaks separating them',
  '16GLc2': 'Import Title',
  'EJ8eWW': 'Please upload the file again',
  'PqthfX': 'Import only supports XLS and XLSX format files',
  'QJWMv+': 'Download details',
  'Qw6uy2': 'SI code',
  'aFoyrY': 'Exception Information',
  'yiJCTd': 'Import quantity',
  'zKvO0B': 'Import failed',
  'DVNJXJ': 'Overseas Warehouse Name',
  'qXXyG3': 'Current Permission Status',
  'trneJA': 'Display When Placing an Order',
  'x/c7oO': 'Inbound warehouse permissions and preferences',
  'CYysYX': 'Once the inbound permission of warehouse is enabled, you cannot deactivate it yourself. If you are not currently using the warehouse , you can close it here, and it will not be displayed when placing orders.',
  'Dpt9uk': '1.Please read the permission description in [Description] carefully. For some warehouse, you need to contact sales to enable the inbound permission after discussing the details. For some warehouse, you can enable the inbound permission by yourself.{break}2.Once the permission is enabled, it cannot be disabled. You can choose not to display it when placing an order. If you really need to disable it, please contact sales offline.',
  'JSgfNL': 'Once the permission is enabled, it cannot be disabled. But you can choose not to display it when placing an order.Please confirm the description of this warehouse before enabling.[{content}]',
  'Yms1oN': 'Confirm to open',
  'dNnCF+': 'Once the permission is enabled, it cannot be disabled. But you can choose not to display it when placing an order.Please confirm the description of this warehouse before enabling.',
  '+QWQ7W': 'Loss',
  '3oxdqD': 'Freeze inventory details',
  '4Cv856': 'Warehouse',
  '51UNgD': 'Order type',
  '7NAcml': 'In transit pre-sale inventory',
  '7jOH23': 'Prohibited Outbound Details',
  '8eXVBt': 'Scrap',
  '9YU+8d': 'Lost to be confirmed by customer',
  '9y5qSL': 'Customer confirmation time',
  'AG7PGl': 'Quantity Available - Single Product',
  'BEt562': 'Unaccepted SKU',
  'BNzv8f': 'Dispose Inventory',
  'C9KK8/': 'Origin Warehouse DOI',
  'D/f5lj': '{count} items selected, ',
  'ID5w3K': 'Frozen Inventory',
  'IXB0ef': 'In Inventory Total',
  'JPAdAP': 'Inventory Status',
  'JQ/Ist': 'Country DOI',
  'Km0LJq': 'In Inventory Total = Available Inventory + Frozen Inventory',
  'L9MjKF': 'Avg. Inventory Of 30 Days',
  'Lt5p5C': 'Standard Quantity',
  'OA+Xwp': 'Pre-sale Occupied Inventory',
  'P7a7B/': 'Adjustment reason',
  'PnCden': 'Available Inventory',
  'QSV2/G': 'Order No.',
  'QchsUr': 'Avg. Daily Sales Of 15 Days',
  'Qo/0n7': 'Lost confirming',
  'RT/7og': 'Cumulative Sales',
  'RbA7OQ': 'Abnormal inventory quantity',
  'SWKjFA': '{code} Item Barcode of Abnormal change',
  'T7WawI': 'Barcode value',
  'TpgfJ8': 'Please check the items first before proceeding with batch operations',
  'URlHB2': 'Avg. Daily Sales Of 30 Days',
  'VdJkh+': 'Avg. Inventory Of 15 Days',
  'W2+wGW': 'Merchandise Grade',
  'WsRSAn': 'Freeze',
  'WwDNC5': 'Occupied Inventory',
  'X762xx': 'Confirm whether to "destroyed"?',
  'XOOIse': 'Freeze Time',
  'XlFayN': 'Prohibition time',
  'YUZvPl': 'Classification adjustment',
  'YnxgOi': 'VAT invalidation',
  'ZVeUDz': 'Quantity Available - Suite Product',
  'Zdo26n': 'Winit batch NO.',
  'btoiBR': 'History Sell Goods Quantity',
  'cRTCYq': 'No item Barcode',
  'cU49d1': 'Confirm whether to "lost"?',
  'ccnZxp': 'Incoming Inventory',
  'cflP7Y': 'Batch Operation',
  'cuhpZK': 'Cumulative Inventory',
  'dLxQHX': 'Batch inventory surplus',
  'dgQSya': 'Batch destruction',
  'fFmyYM': 'Quantity',
  'fWbzVI': 'Reason for prohibiting outbound',
  'fnadHf': 'Quantity Available - Box Product',
  'j6IHvr': 'Detail',
  'jCTrLS': 'Reason type',
  'k6yR1Q': 'Batch loss',
  'lGKG8E': 'SKU No.:',
  'lLWqdW': 'Outbound Limited',
  'n+BMoU': 'Inventory profit',
  'nESkNw': 'Outbound',
  'oOn0Fr': 'Confirm whether to "Inventory profit" ?',
  'pii09f': 'DOI',
  'qauzml': 'SKU No.: {code}',
  'tQ0Q32': 'Accepted SKU',
  'w9wMqE': '90 Over',
  'wKT8Cc': 'Abnormal change type',
  'xR2mTp': 'Avg. Inventory Of 7 Days',
  'xRoxY9': 'In library exception',
  'yq0/8z': 'Avg. Daily Sales Of 7 Days',
  'zVQSYe': 'Copy all single item barcodes',
  'zgawnw': '30 Under',
  '3etnsJ': 'Product inventory details',
  'mlFgct': 'Details of abnormal inventory in stock',
  't0kvjC': 'View all',
  '2Po2YS': 'Custom Notes',
  'CMMjhY': 'Column display',
  'dS21yU': 'Total Incoming inventory for domestic inspection orders, including pre-sale inventory in transit.',
  '1DsLji': 'Inventory shortage',
  'AZxE/7': 'Inventory shortage to be confirmed by customer',
  'WA8SWg': 'Batch inventory shortage',
  'zJebwh': 'Confirm whether to "Inventory shortage" ?',
  'eZAtxt': 'Field expansion',
  '/54ans': 'Contact Us', '5XTs5h': 'Not activated',
  'AzoW7u': 'Bind platform account',
  'CYaf7V': 'Cooperation platform',
  'CqNtWB': 'Online services',
  'FO80Dr': 'Notice',
  'L9AWTW': 'Recharge now',
  'LJ4oo0': 'Fulfillment total available balance',
  'bpnKHs': 'ISP total available balance',
  'cDLItQ': 'service hotline',
  'dQk0wJ': 'QQ group',
  'iAGw0w': 'ISP order balance',
  'mFqrQH': 'Monday to Saturday',
  'qCIS/C': 'Overseas warehouse wallet account',
  'yYPe3y': 'Official WeChat',
  'z3zd1c': 'My e-Wallet',
  '0NHAD7': 'ASCAN time consumption (working day/hour)',
  '26DC55': 'Register SKU',
  '3R9vaL': 'Manually enter product information',
  '4IKihp': 'Provided your information',
  '5WHhDh': 'Registered SKUs',
  '7XxAs8': 'Order delivery quantity',
  '7fauGF': 'Outbound Inventory Accuracy Rate',
  '8RMTyh': 'DSCAN time consumption (working days/day)',
  '9HIheN': 'Payment Pending',
  'Al4hA+': 'Calculate cost',
  'AmrrcV': 'Download detailed warehouse lease last mile quotation',
  'BJTA9X': 'Timely rate of shelving in the warehouse',
  'Cpevaa': 'Weight',
  'EdQOh6': 'To-Do List',
  'FBa9eA': 'Create Inbound Order',
  'FE59Oe': 'Please select a warehouse',
  'GwpK9X': 'Contact Account Manager',
  'KiyShr': 'The number of goods stored in Wanyitong warehouse (units)? ',
  'LMdsl4': 'In which country will the goods be fulfilled? ',
  'MvStWs': 'Last 3 months',
  'OrZu3X': 'Public price',
  'PTKAsz': 'Open warehouse permissions',
  'Pv8aT1': 'On-Time Outbound Processing Rate',
  'Rh/Y5b': 'Abnormal order',
  'Sa0aiY': 'Nearly a year',
  'SkRR/r': 'Current customer data',
  'UHii1H': 'Some warehouses are opened by default. You need to open the warehouse permissions in the United States and the United Kingdom. Please click here',
  'V8qnx7': 'Nearly 6 months',
  'W0fifu': 'Sign the contract',
  'WWlgnl': 'Quickly create SKU',
  'Xfbnoa': 'Last 7 days',
  'Zh1x4W': 'Return pending',
  'aedLAU': 'wide',
  'baV1Ei': 'long',
  'cMSkQ5': 'Order delivery time',
  'hBkLmp': 'High',
  'ik+mqU': 'Nearly 1 month',
  'jSyO7i': 'warehouse allocation indicator',
  'kTgc5v': 'Winit first leg transportation',
  'kteyYj': 'Download detailed first-trip quotation',
  'm/LYrd': 'Select registered products',
  'mvaPZW': 'Warehouse rental fee',
  'o9u8xE': 'Last trip cost estimate',
  'r8cl4c': 'Product Pending Proccessing',
  'rV6Ikp': 'Please sign a service contract and agreement first before we can provide you with basic services',
  'uWDBT3': 'WinIt data',
  'v+gjOA': 'The following indicator data is T+1, non-real-time data',
  'vN3oQA': 'Video tutorial',
  'wpzAgZ': 'Winit warehouse indicator information',
  'wwmySt': 'Winit Fulfillment Plus',
  'zLIDw1': 'Performance cost calculation',
  'zdb024': 'Last Leg Fulfillment fee',
  'uqm47n': 'Average time taken',
  'B8/NTe': 'My data',
  'UdsGuw': 'Unbind',
  '4uI559': 'The proportion of accurate and error free outgoing skus to all skus within the statistical period',
  '5/pZpj': 'The logistics company collects the time point information from the first scan to the last scan at the destination',
  '9Fzg5x': 'The proportion of normal outbound orders to all orders within the statistical period',
  'Yueu4d': 'The time efficiency of sku from warehouse to shelf',
  'bybWts': 'After the customer places an order, the logistics company collects the package and enters the final warehouse for the first scan of the time point information',
  'E7VjfS': 'Estimation of warehouse rental costs',
  'Ge0lbr': 'Item weight',
  'w+DoTf': 'Product size',
  'kPcnam': '[{fieldName}] Please enter a number greater than 0, up to {digits} decimal places',
  'h1qBUu': 'Calculate product selection',
  '+c20Bq': 'Tail process indicator',
  '2IVg9s': 'Return indicator',
  '42ASVQ': 'Standard overseas warehouse express delivery',
  '6EkZOI': 'Cargo logistics attributes',
  '7PAub+': 'On-Time Warehouse Processing Rate',
  '9QCBnw': 'Outbound index',
  '9p6smW': 'Which domestic port does the goods ship from? ',
  '9qb80q': 'Warehouse method',
  'A9Tz/W': 'Air transport',
  'BKXdVC': 'Winit first leg freight',
  'D2G0C4': 'Statistical unit',
  'Epktmm': 'Send directly to the warehouse for self-inspection',
  'Hg/8GB': 'Sea',
  'ID6XQq': 'Timely rate of unloading and putting on shelves',
  'MNTXeZ': 'month',
  'Np+Iw0': 'week',
  'Qpi3DY': 'day',
  'R/uhzG': 'Which country should the goods be sent to for fulfillment of the contract',
  'SVKHsT': 'Custom date',
  'WZ68qc': 'Package',
  'WbPzFJ': 'Abscissa dimension',
  'XYdT8p': 'Mode Of Transport',
  'ZGJHHK': 'Timely rate of unloading at the warehouse',
  'ZcM+gl': 'Send directly to overseas for inspection and storage',
  'aDdguC': 'Standard overseas warehouse storage',
  'd5xPIO': 'Inbound indicator',
  'gNbcdl': 'Express',
  'o8kLqD': 'First leg transportation method',
  'DpnauN': 'time',
  'MHQn6p': 'The user selects the period and then converts it into a specific date, starting from week {starting on Sunday and ending on Saturday}; the first and last weeks of each year will be counted across the year',
  'SGfALI': 'Indicator type',
  'VLj4TX': 'Indicator value',
  'dRP+2A': 'denominator',
  'upV5YZ': 'Data description',
  'ySoacE': 'molecule',
  '+70F5G': 'Timely rate of package placement (excluding exceptions)',
  '+tjEe2': 'Number of abnormal packages',
  '3wNvEr': 'Normally not on the shelves',
  'JkNfUW': 'Number of packages put on shelves in time',
  'S1rbJ3': 'Timed out but not on the shelves',
  'SeNsek': 'Number of packages on shelves after timeout',
  'SnHWjC': 'Timely rate of package placement (including exceptions)',
  'ek1T28': 'Number of packages that should be put on the shelves',
  'iV9J/A': 'Indicator',
  'qee9ZL': 'Dimension',
  'uqF4+w': 'Number of unlisted packages',
  'VglISO': 'Quarterly',
  '04xGKp': '1. Denominator: The actual number of outbound packages within the target statistical period {break} Numerator: Within the range of the denominator, the actual number of packages with Dscan time <= the target Dscan time" {break} 2. Denominator: Actual Within the delivery date range, the {break} numerator of the actual number of packages delivered from the warehouse: the total time taken to generate Dscan"',
  '2Bdgmz': 'Timeout Ascan package number',
  '2lkHR6': 'Number of unfulfilled orders',
  '4D20an': 'Number of orders to be fulfilled',
  '4kz3bn': 'Standard Outbound',
  '70rwvT': 'Denominator: The number of self-pickup orders that should be temporarily stored on the date {break}Numerator: Within the range of the denominator, the number of orders that should be temporarily stored in the self-pickup shelf area before 23:59 on the temporary storage date',
  '7XH7nH': 'Package unloading timely rate (including exceptions)',
  '80fD5c': 'Number of packages that have not been put on the shelf after timeout',
  '8VFtm8': 'Number of undelivered orders',
  '9AWRj6': 'Package AATscan rate',
  'C63z6s': 'Package Dscan timely rate',
  'CAyA0a': 'Normal number of unstaged orders',
  'CCv+GA': 'Number of packages unloaded in time',
  'CDh1Z0': 'Package Ascan timely rate',
  'DKuZRC': 'Ascan average time taken',
  'DPV9rx': 'Self-export library',
  'DSYISn': 'Timely Ascan package number',
  'FPMFhy': 'Number of packages to be unloaded',
  'Fjwf8i': 'Dscan average time taken',
  'HkwQAL': 'Number of timeout temporary orders',
  'IFg102': 'Normal number of outbound orders',
  'KCCu84': 'Number of fulfillment orders that have not been shipped out of the warehouse after timeout',
  'KetzY1': 'Number of Dscan packages that have timed out',
  'O3tvz6': 'Number of orders to be processed',
  'OXckHM': 'Number of orders that should be temporarily stored',
  'QflAU5': 'Temporary storage time rate',
  'QhGzOU': 'Denominator: the number of packages that should be put on the shelf within the target shelf date (package arrival time + SLA); {break}numerator: within the denominator range, the number of packages with the actual shelf date <= the target shelf date',
  'R+bb+H': 'Normal number of unAscan packages',
  'R05sfI': 'Timeout AATscan rate package number',
  'T8EZBS': 'Number of unAscan packages',
  'UAuAfS': 'Number of unprocessed orders over time',
  'Uh+qYa': 'Destroy outbound',
  'UqstXw': 'Ascan timely rate & average time consumption',
  'Uu9ZOD': 'Number of orders to be shipped',
  'VSe5Uw': 'Denominator: Actual number of outbound packages within the actual outbound date range{break}Numerator: Number of ATTscan packages generated"',
  'VVFpWJ': 'Order delivery and fulfillment timely rate',
  'VsSqY5': 'Order error rate',
  'WUr4rT': 'Number of packages that have not been unloaded over time',
  'WxCghz': 'Denominator: target unloading date (package arrival time + SLA) range',
  'XSSKN4': 'Timeout Dscan package number',
  'YSXXUs': 'Order',
  'YSfC7P': 'Normal unprocessed orders',
  'Z2dCu9': 'Denominator: Within the range of the target shelf date (package unloading scan time + SLA), the number of packages that should be put on the shelf {break}Numerator: Within the range of the denominator, the number of packages with the actual shelf date <= the target shelf date',
  'ZkUwmd': 'Number of unscheduled orders',
  'a+G37I': 'Normal number of unlisted packages',
  'b1DsV8': 'Denominator: Within the target delivery date range, the number of non-draft/customer-voided/Wanyitong voided/failed to capture orders that should be delivered {break}Numerator: Within the denominator range, the actual delivery date<= Number of packages on target delivery date"',
  'bReBTV': 'Number of normal unDscan packages',
  'c5ZVUt': 'Number of Ascan packages that have timed out',
  'cDzsuR': 'Number of timely outbound orders',
  'cGhzfI': 'Timely AATscan rate package number',
  'd9LVhN': 'Dscan timely rate & average time consumption',
  'e5FeD4': 'Number of overtime outbound orders',
  'ecuDmM': 'Order delivery error rate',
  'eelcKV': 'Transfer warehouse out',
  'h5/Zm7': 'Number of unscheduled orders after timeout',
  'hfS5uu': 'Package unloading timely rate (excluding exceptions)',
  'iNmyS0': '1. Denominator: During the target statistical period, the actual number of outbound packages{break}Numerator: Within the range of the denominator, the number of packages with actual Ascan time <= target Ascan time"{break}2. Denominator: Target Within the delivery date range, the {break} numerator of the number of Ascan packages generated: the total time taken to generate Ascan "',
  'inzYEx': 'Return type',
  'iySA8M': 'Normal number of undelivered orders',
  'jBvMBS': 'Number of unloaded packages overtime',
  'jQ8TO3': 'Order temporary storage timely rate',
  'jed6Xm': 'Denominator: Within the target delivery date range, the number of packages that should be shipped out of the warehouse if they are not drafts/customer voids/Wanyitong voids/failed to capture orders {break}Numerator: Within the denominator range, the actual delivery time <= The number of packages at the target delivery time',
  'k75tZv': 'Number of orders that have not been shipped out after timeout',
  'kMNnhp': 'Number of packages to be Dscan',
  'l/MdYt': 'Number of orders processed in a timely manner',
  'n/cvYW': 'AATscan rate',
  'nCq48k': 'Normal number of unloaded packages',
  'ntw3S3': 'Number of packages that should be AATscan rate',
  'ofFLk1': 'Return processing timely rate',
  'pJfOu6': 'Order delivery timely rate',
  'qcRLQI': 'Outbound fulfillment timely rate',
  'rjLU6N': 'Number of timeout fulfillment orders',
  'sN8Get': 'Number of timely delivery fulfillment orders',
  'tMq0kR': 'Number of unloaded packages',
  'ta6pfJ': 'Number of temporary orders in time',
  'tmRLpn': 'Number of orders processed over time',
  'tueJPY': 'Number of normal fulfillment orders that have not been shipped out of the warehouse',
  'u/Nmqf': 'Real-time Dscan package number',
  'u9OXnl': 'Number of packages not Dscanned',
  'v++ddI': 'Wrong number of warehouse orders issued',
  'v5BXop': 'Ascan package number',
  'w3cM8T': 'Order processing timely rate',
  'xvWSVx': 'Denominator: The number of orders that should be shipped out of the warehouse within the target shipping date range, non-draft/customer voided/Wanyitong voided/failed to capture orders and voided{break}Numerator: Within the arrival date range, the number of wrong orders (In overseas warehouse standard claims, the claim types are "wrong goods shipped", "missed goods shipped" and "multiple goods shipped")',
  'yHvp8+': 'Inventory unit',
  'z1MEnJ': 'Number of unprocessed orders',
  '71WlLj': 'Return/return processing timely rate',
  'BUgJtV': 'Focus on indicators',
  'E/j2ry': 'Timely rate of warehousing/arriving on shelves',
  'O3Cery': 'Outbound/outbound fulfillment timely rate',
  'gsXmkI': 'Last journey/Ascan timely rate',
  '/HSkL1': 'How long are the goods expected to be stored in Wanyitong warehouse? ',
  '4xrCgJ': 'length*width*height',
  '2ABlbj': 'Only supports Ebay and Tiktok platforms, and the fee includes inbound and outbound processing fees',
  'Q260fk': 'You have not activated service permissions, this function is temporarily unavailable',
  'TSMoUa': 'After creating 1 SKU: You have created a product, you can create more products for use',
  'gKKcGV': 'Go to enable permission',
  'G5HeYy': 'The volume of this product < the minimum storage volume of a single product {m}CBM, then the total inventory volume of this product is calculated as {m}CBM',
  'qR+EsV': 'The total inventory volume <{n}CBM, the storage fee is calculated based on the minimum storage volume {n}CBM',
  '1/vSZm': 'Outbound fulfillment rate',
  'Ayb5cF': 'Order delivery fulfillment rate',
  'BiLWKP': 'Outbound/outbound fulfillment rate',
  'sNnQU4': 'Transparent and clear quotation plan, our account manager will contact you within 12 hours~',
  'aerjpH': 'The information has been reviewed and approved, and we have enabled you to access overseas warehouse services. You can now view the menu.',
  'aHWOLO': 'Please provided your information first and wait for manual review, we will opening the overseas warehouse service permission for you.',
  'Nc3gof': 'The SKU needs to be reviewed and approved before it can be officially used.',
  'OmtISj': 'You have created a SKU, you can create more SKUs to use.',
  '7rA83N': 'Please create a warehouse order first, select product services, and fill in other information in order to successfully place the order.',
  'KdyIP8': 'You have created a warehouse order, and you can continue to create more warehouse orders to meet your needs.',
  'hZ7k5Z': 'Winit Fulfillment',
  '+1q99V': 'Copying failed SKU No.',
  '+3E5ja': 'SKU No. /Product Barcode',
  '+Kr+Se': 'Number of items not shipped out after timeou',
  '+NQng8': 'Please select the importing country',
  '+QQt1w': 'Upload commodity instructions',
  '+QVEe6': 'Supports up to 500 queries',
  '+WN6K9': 'the specification of the German specification file name for each commodity, compressed into a zip file before upload.',
  '+XkXdN': 'Registered Weight{break}Verify Weight',
  '+Z+s/M': 'Registering',
  '+lSrdL': 'Continue to register products',
  '//OPe1': 'Chemical Products',
  '/4CAvs': 'Only drafts, registered returns, and updated return status can be submitted',
  '/51T4K': 'Commodities exported to the United States are supervised by various departments in the United States, and have strict requirements on product safety, labeling, certification, etc. In order to avoid the return or destruction of goods due to such problems after they are shipped to the United States, merchants are reminded to pay attention to the following issues:',
  '/EyqOO': 'Normal number of unloaded goods',
  '/SaZle': 'There is no valid WEEE information for the corresponding category of the current SKU, please add it and submit it for review, and perform associated operations after the review is passed! ',
  '/jX11C': 'Packaging materials',
  '/qfPiv': 'Commodity packaging',
  '/y/o6o': 'please select the modified type',
  '/yVpDb': 'Default',
  '0J/EZT': 'Dscan timely rate',
  '0mdRKn': 'Line Number',
  '0oOC0x': '<strong>without outer packing</strong>:without any packed goods.{break} Do not support bare goods out of storage, bare goods please maintain out of storage packaging{break} <strong>sale package</strong>:The packing with which the goods leave the factory.{break}Goods for sale packaging, and high value, do not support direct delivery,please maintain outgoing packaging{break} <strong>logistics package</strong>:The packing of goods can support delivery.{break}Goods for logistics packaging, support for direct delivery, can not maintain packaging.',
  '0wrGaG': 'The input content cannot be less than {min} characters',
  '15n1gp': 'Number of rows',
  '1CVLEB': 'Too much data to fill in the template?{a}',
  '1EETXi': 'Underable weight(kg)',
  '1WEaVW': 'Processing timely rate',
  '1eOrvk': 'Quickly associate WEEE',
  '1fFSJC': 'Unloading timely rate (excluding exceptions)',
  '1l12Kb': 'WEEE registration number',
  '23GoDH': 'A total of {total} pieces of data, If the return needs to be associated with the original SKU after invalidation, does it need to be re-validated and confirm the batch invalid product information?',
  '2AAXee': 'Box product details',
  '2KeuAm': 'Create suite product',
  '2LLzO1': 'In the export file, modify the product information that needs to be updated, select the standard template to import and resubmit the registration <a>Go to submit></a>',
  '2Nufpg': 'Whether it belongs to DG dangerous SKU',
  '2O5LA4': 'Batch invalid',
  '2PBb7y': 'No Country of Origin',
  '2Rvzhl': 'the fumigation of wood products and wooden packaging needs to provide a fumigation certificate, especially wood products need to pay attention to the due diligence information of the EU EUTR regulations.',
  '2T9AV3': 'Sharing Inventory Quantity',
  '2TXB25': 'The following products already contain registered import countries：',
  '2TqpMq': 'Timely delivery fulfillment number',
  '2oCbSB': 'With Liquid',
  '2zRAX7': 'Product registration successful',
  '2zlu4l': 'The UK government has updated the guidance document for placing products on the UK market:{break} 1. Commodities covered by the UKCA mark field imported into the UK after January 1, 2023 must have the UKCA mark, which replaces the original CE mark.{break} 2. For existing stock products that have been imported into the UK market, re-testing or re-UKCA marking is not required.{break} 3. Before December 31, 2025, enterprises will continue to be allowed to choose to mark the UKCA mark on the nameplate of the product itself or on the documents accompanying the product. From January 1, 2026, it can only be marked on the nameplate of the product itself.{break} 4. For products imported into the UK from regions other than the EEA, according to the original regulations, from January 1, 2023, the importer information needs to be marked on the label of the product body. Marking on accompanying documents is acceptable unless the size or shape of the product is too small to allow it.{break} For details, please check the UK official website link:{url}',
  '3+8YgJ': 'Please enter the number of days of warning',
  '3CpNmb': 'Battery caution label',
  '3UDwTJ': 'Suite/box standard quantity',
  '3emMvn': 'auxiliary indicator',
  '3m2zVX': 'Please provide a schematic diagram according to the selected batch attributes. It is necessary to be able to identify the specific location of the attribute information in the product, and the picture needs to be marked as a schematic diagram. Follow-up Winit will check the product information according to the provided schematic diagram.<red>A maximum of 1 image can be uploaded, limited to jpg, gif, bmp, png formats within 5M.</red>',
  '430sH9': 'DG supplementary information',
  '4Cyq/R': 'Number of days of warning',
  '4Jk7wc': 'Number of contracts to be fulfilled',
  '4cdhBz': 'Important indicators',
  '4mJLTr': 'Number of timely releases',
  '57UMhM': 'Commodities with plugs exported to the UK must be UK-standard plugs and British-standard adapters are not allowed. For example, the kind of products with American or European plugs and British adapters can only be returned or destroyed if they are found by the quality supervision department.',
  '5BFAgi': 'Regulatory Conditions',
  '5BJFy9': 'Batch upload of files',
  '5M7Vly': 'Upload results',
  '5QMQYr': 'Do WEEE information need to be supplemented or updated?<a>Go edit</a>',
  '5vH5Pk': 'Timeout unscheduled number',
  '5yAzV3': 'Brand Name',
  '64kzDB': 'SKU Characteristics',
  '6DKIQa': 'Tip: If there is no paper instruction manual in the product, you need to provide a link to the German instruction manual. The link to the corresponding German instruction manual will be printed on the face sheet when the product is shipped out of the warehouse. However, this function is limited to last-mile delivery suppliers.it is recommended that you add the German manual paper document to the product as soon as possible',
  '6DlkQ0': 'Number of items not shipped out',
  '6M2O6P': 'Associate WEEE',
  '6ON040': 'Is it return SKU',
  '6Qu7pB': 'Box Product Maintenance',
  '6Y0p2/': 'Next',
  '7/jbov': 'Updating',
  '73SuB6': 'Please filter the products that need to be updated in the product list, and choose to export according to the standard import template or <a>download the import template</a>,fill in all the product information and then import.',
  '7KxUw1': 'Quantity to be unloaded',
  '7YEo3Z': 'The number should be temporarily stored',
  '7jl7uN': 'Update product batch information',
  '7oy56p': 'Timeout number',
  '7u24R2': 'Remarks',
  '88Ahen': 'To be modified',
  '89eJ3z': 'Other information has been filled in, country needs to be selected',
  '8DMyyb': 'If the product or package is labeled with UL, ETL and EPA, please provide a copy of the relevant certification. Once the product cannot be provided with the corresponding certificate, it will be returned or destroyed due to infringement.',
  '8FC2V+': 'Number of standard pieces in the box',
  '8K9huq': 'Print quantity',
  '8KQe8R': 'Commodity Instructions type',
  '8chdAt': 'Year',
  '90BZso': 'alter packing(outbound/inbound)',
  '9HPrzg': 'Supports up to 500 SKU No./Product Barcode/Third-party SKU No.',
  '9Kfyp/': 'After invalidation, if the return needs to be associated with the original item, it needs to be re-validated. Please confirm whether the product is invalid.',
  '9Rk5ct': '(Including fragile product markings, cargo loading only markings, export restrictions, land transportation only, front side markings)',
  '9VJr3i': 'Please enter a number greater than 0, with a maximum of 2 decimal places retained',
  '9l1yrc': 'Failed reason',
  '9q5iFF': 'Product grouping',
  'A6gWi0': 'Wrong bank number sent',
  'A94SDx': 'Add peak season surcharge during peak season',
  'AIm0ow': 'Upload SOP',
  'AM5ZYU': 'Limited to jpg, gif, bmp, png format',
  'AOBoNV': 'This suite product contains x pieces of a single product',
  'AXD5yi': 'To be supplemented',
  'AcRVLv': 'If it is necessary to collect the parcel code, it will be collected during the outbound process. The outbound order information supports query, provided that the parcel barcode exists on the physical package!',
  'AcfqYm': 'Battery weight(kg)',
  'Aoiung': 'You have not set preferences yet. Please set relevant information in [Personal Center-Preferences-SKU Preferences].After setting, click Hide Preference Information, and the information that has set preferences will be automatically hidden.',
  'Aqtj8n': 'Print an SKU Barcode',
  'AroxgK': 'Delete result',
  'AsN7cg': 'Timeout Ascan number',
  'B13gcH': '<strong>Item management:</strong>one item, one code. Each single product sold has only one globally unique single product barcode.{break}<strong>SKU management:</strong>one category, one code. All items of the same SKU have the same product barcode',
  'B7br4z': 'Number of days to stop selling',
  'B8xiJD': 'With The Socket',
  'BC74I9': 'Note',
  'BFz2A6': 'The current import declaration price is relatively high, and the commodity can be insured in the insured SKU management module, and the insured SKU will be provided with more refined management in the warehouse.',
  'BKKHqg': 'Registered Length*Width*Height(cm)',
  'BY90Z8': 'If a Seller fails comply with WIN.IT product registration policy, in the case of mismatched product information, restricted items, missing required documents, etc., WIN.IT reserves the right to refuse service.',
  'BfWmDr': 'Supplementary materials',
  'BgiBV1': 'Matters needing attention:{break} 1. Goods shipped in wooden containers must be accompanied by a fumigation certificate to prove compliance with quarantine regulations;{break} 2. Australia has regulations prohibiting the production, import and sale of clothing and consumer products containing carcinogens and asbestos.{break} 3. Fuel products (engines, lawn mowers, chainsaws, etc.) need to have the following relevant certifications (EPA, CARB, 97/68/EC or Australian product exemption number, one of the above), otherwise there will be a fine for recall risk.',
  'BhoBfm': 'Timeout temporary storage number',
  'Bkg7uQ': 'Main indicator',
  'Bm5GdP': 'Taiwan,China',
  'Bue+Ip': 'View and use "Personalized Template"',
  'C4HPJc': 'Successfully',
  'C5ShJS': 'Save Draft',
  'C5uin2': 'Update the declared value of exports from importing countries',
  'C7Cq4t': 'US',
  'CJA3gl': 'Place select the outbound package material',
  'CN+A8h': 'Whether to share inventory',
  'CNKrTB': 'Please select the person in charge of the product/European agent information',
  'CbJiR0': 'Box product packaging',
  'CcGGyt': 'Please select a country/area first',
  'CgkufA': 'A personalized template will be generated based on the following product characteristics. When importing products that meet the characteristics, non-compliance will result in registration failure',
  'Ch3B3M': 'There are a total of {total} records, and {successCount} has been successfully enabled',
  'ChzSZX': 'Modify battery information',
  'ClROa7': 'Upload a maximum of {maxCount} files,limited to jpg,jpeg,png,pdf format within 50M.',
  'Cwym4h': 'Submit',
  'D5ZkQe': 'Add Third Party NO.',
  'D6Hvvx': 'Battery energy WH = battery capacity AH * battery voltage V',
  'DWpV38': 'Unprocessed number',
  'DiLA5q': 'Currently, {num} products have been selected. Please select the country where registration needs to be added',
  'E2kRYi': 'Batch activation',
  'EFPHaV': 'Self',
  'EVTQjd': 'Please upload the physical batch information diagram',
  'Ebnrof': 'If you tick to add EAR information, the label will have the associated EAR information; otherwise the label does not have EAR information.',
  'F3ndvv': 'Delete Failed',
  'F7X0fu': 'Export all product information',
  'FKf3GC': 'Please enter the country of origin',
  'FMPuj8': 'SKU List',
  'FRtCeT': 'Send Back',
  'FTG2vb': 'Responsible Person Name',
  'FbM2/d': 'Excel bulk import',
  'FetaMe': 'AU',
  'G22f+9': 'The German Producer Responsibility Extended Packaging Act has come into effect on July 1, 2022.The regulations require that sellers who sell packaged goods to Germany must register with the German central management agency "Zentrale Stelle Verpackungsregister" to obtain a LUCID number, declare the volume and type of packaging of the corresponding goods and pay the corresponding fees. At the same time, the regulations are also clear. Fulfillment service providers and e-commerce platforms shall not provide services to sellers who are not registered as required by regulations.',
  'GDFkBa': 'British import and export and taxation are regulated by the same department (HMRC), as well as the implementation of British due diligence regulations and platform withholding and payment. It\'s strongly recommended that each seller should use their own VAT # and EORI # to do the importation in the name of their own company.',
  'GTt01+': 'SKU Link',
  'GdNyZk': 'Export Declared Value(USD)',
  'H/vKxr': 'Confirmed Weight(kg)',
  'H7BeZD': 'Export Country/Area',
  'HIRKi3': 'Suite product Maintenance',
  'HMxZwz': 'Information Type',
  'HWUi9z': 'Outbound packing info',
  'HnsXky': 'Any',
  'HxgJs9': 'According to the requirements of the " Regulation (EU) 2019/1020", from July 16, 2021, for goods with CE mark and manufactured outside the EU, it is necessary to ensure that such goods contain real and effective EU responsibility Person information and corresponding national language instructions. After the regulations come into force, it is illegal to sell CE-marked goods in the EU without an EU responsible person.',
  'I0f7tt': 'Confirm delete?',
  'I4GWHd': 'Real-time Dscan number',
  'I7cmTD': 'Product attribute',
  'INWrne': 'Goods carry labels',
  'IzXisV': 'Suite product packaging material',
  'JGDWfH': 'Ascan timely rate',
  'JILwsB': 'Operation Log',
  'JO4DwF': 'The description of the item cannot be vague words such as gifts, which may cause obstacles to customs clearance. In order to ensure smooth customs clearance, it is necessary to provide detailed and unambiguous product descriptions.',
  'Jalqk9': 'It is important for Sellers to enter proper product declaration value. WIN.IT is not responsible for any delay or customs withhold due to low value declared.',
  'Jddr2L': 'Commodities prohibited by British customs: For all imitation and counterfeit goods, goods with incomplete certification or identification, British customs may pursue legal responsibility.',
  'JvOkw0': 'SKU Package type',
  'KIwL6G': 'Timely delivery quantity',
  'KLNwDD': 'Limited to jpg,jpeg,png,pdf format',
  'KRVF+S': 'Please enter the print quantity',
  'KVd/IG': 'Confirmed Length*Width*Height(cm)',
  'KYjz/l': 'Please enter a number greater than 0, up to 2 decimal places.',
  'Keyqza': 'Country of Origin must choose',
  'KrHmK0': 'Please select the Responsible Person/European Authorised Representative information:',
  'Ksh8H4': 'Normal unlisted number',
  'LRuQNL': 'WEEE Category',
  'LWSLHa': 'Tips',
  'LxCyKX': 'Please upload',
  'LzaEIM': 'Go check',
  'M+7kjk': 'Go to settings preferences',
  'M0LDIV': 'Batch Properties',
  'M1h6SK': 'Packaging information of warehousing goods',
  'MJZFFa': 'Management method',
  'MPh7VW': '{num} draft products, complete information has been entered and is to be submitted for review',
  'MTpHsb': 'Maintain packaging information',
  'MUuzgH': 'The customs will have a 3-year prosecution period after import. In order to avoid tax repayments and fines caused by the under-reporting found by the customs later, it is recommended to declare the import declaration value truthfully.',
  'Mke7E0': ' It\'s strongly recommended that each seller should use their own VAT # and EORI # to do the importation in the name of their own company. ',
  'MllGRu': 'Shipping Party',
  'MmmpSu': 'Go check>',
  'MqnPY2': 'Standard Box wide(cm)',
  'MrgM6t': 'Export all product information',
  'Mwk+U+': 'Wrong delivery rate',
  'MxBCpe': 'Download incorrect data',
  'MxxEYf': 'Collapse',
  'MzuCgp': 'Import Declare Value',
  'N6tEuo': 'Choose the registered importing country',
  'NGs9sO': 'Go back',
  'NIfhB7': 'No product selected, please go to the product list to reselect',
  'NMg99l': 'Enable barcode value inventory',
  'NOtdIq': 'Upload instruction manual',
  'NUN0tG': 'New successfully added',
  'NXKJ/G': 'Standard Size(cm)',
  'Ndc8Tz': '{successCount} items have been successfully deleted.',
  'NnaTvD': 'Binding person in charge',
  'NoURe9': 'Data status',
  'Nw3DyH': 'Please ensure that there are no patterns or descriptions that infringe intellectual property rights, including copyrights, design patents, and well-known trademarks.',
  'O1baSg': 'Registered Weight(kg)',
  'O5zQhu': 'Enable batch management',
  'OA/GYS': 'Whether to collect package barcodes',
  'OnimtZ': 'Registered Length*Width*Height{break}Verify length*width*height',
  'OoH4Vn': 'Perfected',
  'OzxoGd': 'Outbound packaging modification',
  'P3OlMG': 'Please select the importing country/area first',
  'PAR7vC': 'Calculation of import duties and GST: Import duties are levied on the FOB price of the goods at the port of shipment, Goods and Services Tax (GST) is levied on CIF prices, and the declared import price must be declared at the fair trade price. Our company has the right to recourse for customs inspection, as well as repayment of customs duties, corresponding fines and other losses.',
  'PKJshZ': 'Please enter a number greater than 0, up to 4 decimal places.',
  'PMnXeY': 'To be submitted',
  'PUESE0': '{successCount} products have been successfully deleted,{failCount} failure,reason for failure: ',
  'PjkNQN': 'UK',
  'Q37+lZ': 'Please enter the shelf life',
  'Q7MQdK': 'Origin',
  'QCshfb': 'In order to avoid the return or destruction of the goods due to various problems after they are shipped to the UK port, the merchants are reminded to pay attention to the following problems:',
  'QUFY6d': 'HMRC will have a 3-year prosecution period after import. In order to avoid tax and fines caused by HMRC\'s later discovery of underreporting, it is recommended that the import declaration value be declared truthfully.',
  'QdYQx3': 'In order to avoid the return or destruction of the goods due to various problems after they are shipped to the German port, the merchants are reminded to pay attention to the following problems:',
  'QpxSsT': 'Timely ATTscan percentage',
  'QuQaaA': 'UN code',
  'QxhxD9': 'Submit from Monday to Friday{break} 00:00-12:00, and review will be completed before 18:00 on the same day{break} Submit from 12:01-24:00, before 11:00 the next day (natural day) Review completed{break} Saturday ~ Sunday{break} Submit on Saturday 00:00-12:00, review completed before 16:00 on the same day{break} Submit on Saturday 12:01-Sunday 24:00, Monday 11:00 The review will be completed before 00{break} The review will be completed before 24:00 on the next day (natural day){break}',
  'QxzrbX': 'Product saved draft successfully',
  'RFLMGm': 'Standard Box weight(kg)',
  'RSl8E8': 'Designated packaging material SKU',
  'RrD1hw': 'Description (Chn)/Description (Eng)',
  'RtFK89': 'Currently, the fixed price only supports the United States, and the platforms are Ebay and Tiktok. Please look forward to other countries (please contact the account manager to activate the fixed price permission)',
  'S25bPA': 'Normal undelivered quantity',
  'S2Dp+M': 'This notice does not exhaust all the situations that may cause customs return or destruction, and only states the frequently occurring problems. If the loss is caused by the above and unmentioned events and not caused by our company, our company will have the right to carry out recourse.',
  'SBagFp': 'Quick Print Barcodes',
  'SCsxgT': 'Please enter the number of days to stop selling',
  'SFGJw1': 'The modified information submitted for the current item is under review. Please check the product information to be reviewed in the update.{a}',
  'SGXH2R': 'Import Country/Area',
  'SX//Dm': 'Batch management type',
  'Seke8U': 'Normal undelivered quantity',
  'StEQQQ': 'Ascan number',
  'T6gsxx': 'The country you selected currently does not support last-mile delivery. Please download the specific system quotation to confirm the supported countries',
  'TPXs+A': 'Timely Ascan number',
  'TedMK6': 'This SKU must be accompanied by a paper manual in German',
  'TroLmA': 'Commodities prohibited by German customs: All imitation and counterfeit goods, products with incomplete certification or identification, German customs and local law enforcement departments will strictly investigate such products, in addition to facing product recalls, they may also be investigated for legal responsibility.',
  'TsDnUk': 'Hide preferences',
  'U9ILfl': 'Timely delivery rate (excluding exceptions)',
  'UH3LUp': 'European Authorised Representativ',
  'UKk9aQ': 'Please enter an integer',
  'UOhShp': 'Battery  package',
  'UQkIe2': 'Generate personalized template',
  'UaXAnK': 'Products are restricted from/into the warehouse, please handle them in time',
  'Uf/d6B': 'Normal Unascan Number',
  'Ura5sN': 'Only supports maintenance of published products',
  'VHPbrK': 'Verify length*width*height{unit}',
  'VJMEti': 'File data verification completed',
  'VKV22J': 'Enable Results',
  'VbRKGW': 'New importing countries in batches',
  'VppX7w': 'Normal undelivered fulfillment number',
  'W+R6B3': 'Supplement/confirm importing country information',
  'W01wC8': 'Product length(cm) x width(cm) x height(cm)',
  'WAfyY4': 'Import Declare Value(USD)',
  'WGAE7N': 'Number to be processed',
  'WQyw5k': 'Inner diameter(cm)',
  'WaaLFK': 'Germany related websites for reference{break}German anti-dumping and anti-subsidy query website:{url1}{break}{url2}{break}German Extended Producer Responsibility Packaging Act:{url3}{break}Market Regulation (EU) 2019/1020:{url4}',
  'WdQS7N': 'This notice does not exhaust all the possible situations that may lead to inspection, return or destruction and that may occur at Australian customs. It only states common problems. The company will have the right to pursue recourse.',
  'Wdmil2': 'Unfold',
  'X1F+7G': 'Submission failed, please modify and resubmit.',
  'X5Wxae': 'Display preferences',
  'XFd0Fa': 'Box product packaging material',
  'XGMo7a': 'Number of fulfillment contracts that have not been shipped out of the warehouse after timeout',
  'XJFtiF': 'With Three Plywood Or High Density Plate',
  'XnL5tl': 'Second Hand',
  'Xp/Q3h': 'Please select the management method',
  'XqPll/': 'Commodity Instructions require',
  'XuoVmX': 'Suite Product Information',
  'XxHAs0': 'SKU Qty',
  'Y/0R7Y': 'Number of standard pieces in the suite',
  'YKwdXz': 'Return Reasons',
  'ZFM0cj': 'Link audit status',
  'ZVh7Di': 'Too much data to fill in the template? Recommended to use personalized templates',
  'Zfm4bD': 'After selecting the batch attribute, you need to provide the corresponding batch information when placing the storage order. The inspection will verify the batch information of the product according to this attribute [except for the inbound batch management ], and the subsequent warehouse will carry out the warehouse operation and storage according to the batch attribute.',
  'ZgRLsG': 'Import Declare Value required',
  'ZmT1uG': 'High value(Charges vary)',
  'ZqCedb': 'uploaded',
  'ZvZ3JO': 'Electronic and electrical products must comply with the provisions of WEEE (EAR). For the list of products covered by WEEE, see the following website to confirm whether your products need to be registered with WEEE (EAR). If you do not register as required, the maximum fine is 200,000 euros.{url}',
  'aDf3/y': 'Is there any allergen',
  'aJTjri': 'Winit inbound product：{productName}',
  'aMjKQb': 'Single new addition',
  'aO1LOt': 'Step 1',
  'aXTw6o': 'unknown, please check whether the template or imported data is correct',
  'acIqwr': 'Model',
  'afAy25': 'When the outbound packaging category is "Winit standard packaging", if the "outbound packaging material type" is not specified, Winit will automatically match the appropriate packaging materials according to the priority of express bag, bubble bag and carton.',
  'ahaefV': 'China',
  'ahiPbf': 'SKU No.',
  'aveTGO': 'Error messages',
  'ax2mk0': '{text}',
  'b7E1fz': 'Please select the products you need to export',
  'bW7xAs': 'Whether the storage',
  'bi+JOO': 'When there are [x] days before the expiry date, it is forbidden to submit the standard delivery order, so as to prevent the buyer from receiving the product that has expired.',
  'c2fUse': 'Modify type',
  'cGY0iX': 'Please input Registered weight',
  'cJNSDx': 'View partition price',
  'cNVhxt': 'Batch update high value',
  'cQYNoa': 'Third-party SKU No.',
  'cSHhM6': 'UN label - phone number',
  'cTA59M': 'Number of unloaded goods after timeout',
  'cYYpNG': 'Battery type',
  'cfjOFN': 'Inbound and outbound packaging information',
  'cqZp4l': 'Dscan not counted after timeout',
  'cuPSNv': 'Box Product Information',
  'cul60h': 'Verify length*width*height(cm)',
  'd3ABzd': 'Should ATTscan percentage',
  'dOQj0E': 'Goods Weight(kg)',
  'dadBln': 'Number of timeout fulfillment orders',
  'dqi2SA': '{successCount} products have been submitted successfully,failed {failCount},Please complete the product information before submitting for review',
  'dsW/zv': 'Normal Dscan number',
  'e4q896': 'Batch binding person in charge',
  'eCjyf7': 'Normal outbound quantity',
  'eDxwA7': 'Batch update SKU links',
  'eNioNS': 'Authorization Succeeded',
  'eRBGSf': 'No data yet, click to add',
  'eUSpdN': 'More',
  'eef6wN': 'Registered Weight{unit}',
  'f3GjX/': 'The value is a positive integer ranging from 2 to 999.',
  'f9f9Kr': 'Size and weight information',
  'fKfc8J': 'To-do reminder',
  'fmBsCH': 'Operating content',
  'foXtVC': 'Product Status',
  'fr8qvK': 'File uploaded successfully, please wait for the data verification result',
  'fwQPTM': 'Failure result',
  'g+vrQp': 'All inbound packages do not have the following labels',
  'g+xiOs': 'The fumigation of wood products and wooden packaging needs to provide a fumigation certificate.',
  'g/fKXQ': 'Winit{break}August 2022',
  'g8RPWw': 'The modified information submitted for the current product has been returned, please process it in time.{a}',
  'gGMGjZ': 'Registered Length*Width*Height{unit}',
  'gLHALd': 'Food',
  'ggvI6Z': 'Select All',
  'glaaIG': 'Error Cause',
  'gyQd//': 'Number of unlisted items after timeout',
  'gzYOOP': '{icon}The products you registered will be maintained as soon as possible within {time},please wait patiently~',
  'h53sPj': 'Timeout unprocessed number',
  'h6p1Q+': 'Start Date',
  'h7w4pz': 'No Data',
  'h8bTqV': 'Not uploaded',
  'hElHo2': 'Print EAR information',
  'hShFQM': 'Batch Modify',
  'hYEDUA': 'Sellers should provide product information as detailed as possible. Any product image or web link should match up to the actual product.',
  'heSp6Q': 'Binding product manager',
  'hk5FKM': 'Packaging materials',
  'i4tQ/S': 'The input content cannot be greater than {max} characters',
  'i5Q88U': 'Returned SKU',
  'i5rp4m': 'All uncharged',
  'iC7OaE': 'Create box product',
  'iCg2nh': 'In order to improve registration efficiency, please first configure product preferences in [Personal Center-Service Settings-Preferences]',
  'iUcoKw': 'All unbranded',
  'ixHwoW': 'Update product information (general)',
  'iyu8lU': 'Associate WEEE information',
  'j2i5Dm': 'This notice does not exhaust all the situations that may cause customs return or destruction, and only states the frequently occurring problems. For the loss caused by the return and destruction events not mentioned above and not caused by our company, I The company will have the right to pursue recourse.',
  'j3YsUm': 'The URL must be valid before the order is reached the destination warehouse.',
  'j94Rtp': 'Please enter numbers, +, -, letters are not allowed, support 24 bits',
  'jCHgBE': 'Untemporarily stored number',
  'jCOU5w': 'Import declaration information',
  'jPqtQS': 'With Battery',
  'jb+IKU': 'Only supports label paper printing, and a single print cannot exceed 5,000 pieces. ',
  'jd+iFu': 'Customs recommended declaration value(USD)',
  'jl8oxj': 'Type of goods',
  'k84DAN': 'Only drafts, registered returns, and updated return status can be deleted',
  'kCh5Jz': 'Tip',
  'kS4Jbz': 'ATTscan rate',
  'kX1Ecr': 'Certificate',
  'l5jvRO': 'Inbound packaging information',
  'l6bu0+': 'quality guarantee period',
  'lCxJRw': 'Prompt processing number',
  'lHoE+P': 'Batch Add Third-party SKU No.',
  'lIIML6': '<strong>Shelf life management:</strong>According to the expiry time of commodity batches, the ones that expire first will be shipped out first, and batches near the expiry date are supported for early warning and sales ban. Products have a shelf life.{break} <strong>Production batch management:</strong>According to the production time of commodity batches, the ones produced first will leave the warehouse first. Products have no expiration date.{break} <strong>Inbound batch management:</strong> According to the inbound time of the batches of commodities in overseas warehouses, first in first out, Products have no expiration date.',
  'lSx3mU': 'Magnetic',
  'laZwLw': 'This box product contains x pieces of a single product',
  'loyE8B': 'Timeout ATTscan percentage',
  'lqnHUQ': 'Failed {failCount},reason for failure: {reason}',
  'lrwsA+': 'No barcode selected to print',
  'lzaCiy': 'Number of unlisted items',
  'm8y8Ah': 'Data certificate',
  'mM9rak': 'Number of unloaded goods',
  'mMJovn': 'Add certificate',
  'mMoNpI': 'Verify Weight(kg)',
  'mN/UxY': '<strong>Battery cell:</strong>The battery has only one cell, or multiple cells but are not packaged in series or parallel.{break} <strong>Battery pack:</strong>a combination of two or more battery cells packaged in series or parallel.{break} <strong>For example:</strong>for a mobile power supply that combines multiple 18650 batteries, select the battery pack; if multiple 18650 batteries are not connected in series/parallel and are only sold in multiple packages, select the battery core.',
  'mNrNBK': 'Quantity to be shipped',
  'mRshYx': 'Only compression packages in zip format are supported.',
  'mU2j8v': 'Batch upload German instructions',
  'mgCZHX': 'Not Ascan number',
  'mkAC6d': 'Timeout not Ascan number',
  'mnE1nk': 'There are still [x] days before the expiration date to send an email reminder, so as to adjust the sales strategy of the batch of the SKU in time.',
  'nDwIwd': 'Already Released',
  'nHRaHR': 'Print Barcode',
  'nIRket': 'Please drag or click to upload file',
  'nJIJx6': 'Unable to find data for the product. Please confirm if the product exists!',
  'nL/cut': 'New importing country',
  'nUqM8t': 'Go submit',
  'nVqR0D': 'DE',
  'naZmU6': 'With Log',
  'nn8pTx': 'Submission successful, please wait for staff review',
  'nr36zQ': 'Free of warehouse rent',
  'oHUyJP': 'Update SKU package type',
  'oIsUki': 'Supports doc or pdf formats, limited to 10MB or less',
  'oRsWj6': 'Prescribed time',
  'od3FGh': 'Commodities related to CPSC (Consumer Product Safety Association), such as toys and other commodities, need a test report issued by a CPSC-designated testing agency, and the products need to be affixed with corresponding labels as required. For details, please refer to the following link:{url}',
  'ohFmwm': 'Number of timeouts',
  'oiMpRX': 'According to local service regulations, the UN label needs to provide the corresponding contact number, example: +86-12311112222;',
  'ozUGJe': 'Set product shape',
  'p56EUO': 'Update product carrying label information',
  'p7fE35': 'Battery energy(WH)',
  'pIQ+WJ': 'Timeout Dscan number',
  'pYzaIX': 'Inbound Prohibited',
  'peveA/': 'Download personalized template',
  'pkIYyv': 'Standard Box high(cm)',
  'pzGkXS': 'Deleted data may cause incomplete international warehouse receipts (excluding global warehouse delivery) to be inaccessible. Please be informed',
  'pzwZ9y': 'cell/battery',
  'q0mwSH': 'Example diagram',
  'qAVsY3': 'Support batch update of product information for selected products',
  'qF98LW': 'A maximum of 500 pieces of data can be imported at a time',
  'qUKj7E': 'Copy',
  'qb91VW': 'Should Dscan number',
  'r1Qtd7': 'All without packaging',
  'r2gvAb': 'Import Results',
  'r2imrW': 'The customs will check with the quality supervision department whether the quality of the goods meets the relevant standards. Please ensure that all goods going to overseas warehouses in Germany must comply with the regulations of the German government departments. Once the customs or the local quality supervision department checks, they must be able to immediately provide the goods with the goods. Consistent, true and valid CE certificate or relevant certificates required by other government departments, otherwise the responsibility for deduction and fines caused by this shall be borne by the customer.',
  'r3V/O0': 'WINIT SCF Product',
  'r6h3uT': 'Operation failed',
  'rFlDQ6': 'Not Dscan number',
  'rG82gu': 'Export declaration information',
  'rLn5dB': 'More',
  'rMMK/m': 'Export current product list information',
  'rOhC+k': 'According to the import requirements announced by the Australian government, the goods imported into Australia must be affixed with the corresponding English product labels (name, brand, model, manufacturer information, ingredients, product description, origin, etc.), if the customs inspection finds that the product lacks English products labels, may face confiscated goods and fines. Please refer to the official link for detailed notice：{url}',
  'rXzI0V': 'Please select packaging type',
  'rd4gqB': 'Step 2',
  'ri851W': 'Don\'t remind me again',
  'rkOwDC': '{successCount} products have been successfully submitted',
  'rnq3gI': 'Deauthorization',
  's+FI1a': 'Please select the pageacking material type',
  's3uVOZ': 'File name specification in the compression package: commodity code & & & specification',
  's8V1Ln': 'With Powder',
  's9IA1X': 'Timely delivery rate (including exceptions)',
  'sHviTp': 'Previous step',
  'sNTEDM': 'The template data has a total of {totalCount} entries, with {successCount} entries imported successfully and {errorCount} entries failed',
  'saZBsM': 'Commodities involving medical devices require FDA registration certificate in the United States.',
  'saeFbf': 'File',
  'sgy8n9': 'Number of outstanding contracts',
  'snEEkg': 'Up to 500 pieces of data can be imported at a time.{a}',
  'sy8edt': 'Excel batch modification',
  't8Teof': '{num} barcodes have been selected,the total number of barcodes printed at a time must not exceed 5000',
  'tJx4Tw': 'Barcode Size',
  'tgduNy': 'Duplicate certificate selection',
  'tgzh55': 'All non-food',
  'th2jmN': 'Batch printing barcodes',
  'twj8Sm': 'Allergen',
  'u1qllb': 'Image size limit of 5M or less',
  'u98d/e': 'Export by importing the information required in the standard template',
  'uDKUFd': 'If the published product is modified and requires review information, the product information will not be updated until the review is passed',
  'uFoVy0': 'Expired',
  'uKB+1J': 'Number that should be put on the shelves',
  'uNCf4c': 'Unloading timely rate (including exceptions)',
  'uNolam': 'Place of import',
  'uabkfT': 'A total of {total} pieces of data, successfully invalidated {successCount}',
  'uiTJW+': 'Number of unloaded goods overtime',
  'undBgZ': 'Description (Eng)',
  'uqDSio': 'National announcements',
  'uqU3/A': 'Suite product packaging',
  'v+rZz+': 'Please select the type of instruction manual',
  'vG+1rL': 'Please do not exceed 50MB in file size. Please compress and upload',
  'vHFAJd': 'Product shape',
  'vOYTyV': 'Exception Qty',
  'vP5CrI': 'Export display information based on the current product list',
  'vSerbC': 'Import and export declaration information',
  'vbDYzP': 'WEEE type',
  'vg5G1j': 'Standard Box Length(cm)',
  'w/VsZL': 'Statistical unit',
  'w1cMGO': 'End Date',
  'w9U47g': 'Edit Suite Products',
  'wIiCxn': 'Are you sure you want to re-enable this item?',
  'wJ4QYJ': 'Please enter the underable weight',
  'wRcMxY': 'Does the European Authorised Representative information need to be supplemented or updated?<a>Go to edit</a>',
  'wY0zTb': 'Edit Box Products',
  'wcogSJ': 'Click to download "Standard Template"',
  'wd6jjx': 'Normal unstaged number',
  'wp3dhe': 'Are you sure to reactivate these products?',
  'wz0mVq': 'No erroneous data',
  'xADAFC': 'Timely unloading number',
  'xB2mDj': 'All outer packaging must have the mark of origin. If it is confirmed that it is made in China, there must be a "Made in China" mark.',
  'xGotZu': 'This link review status is only applicable to - WINIT Shipping - Germany & UK Deferred and E-Commerce Clearance, other products are not affected.',
  'xLTrlY': 'The product registration audit result doesn’t represent goods in customs clearance, transportation and warehousing are without risk.{break}The responsibility and disputes caused by the goods themselves or information errors, including but not limited to commodity customs clearance, trade, infringement and quality, shall be borne by the customers themselves. Thank you for your understanding and cooperation.',
  'xQYCD1': 'If the shared inventory is turned on, there is no need to specify the SKU type and the number of standard inventory SI pieces when shipping out, and the Winit system will automatically allocate according to the total number of single products in the shipping list.',
  'xeApVG': 'Products to be submitted',
  'xjFUOB': 'Registered importing country',
  'y1/0I4': '18+',
  'yG4nnB': 'Export failed for product barcode',
  'yMlPtn': 'Suite product details',
  'ybIMxw': 'Product submission successful',
  'yz3gHz': 'Product saved successfully',
  'z+8yDs': 'Real-time temporary storage number',
  'zCjZBU': 'Outer diameter(cm)',
  'zFDcg6': 'The exported list is the same as the standard template, and supports import and update through excel after modification.',
  'zG8yxE': ', failed {failCount}，reason for failure:',
  'zI1Wyd': 'Outbound packing info',
  'zf0KBc': 'Modification completed',
  'zubwCo': 'Number of outbound shipments over time',
  '0bGJDI': 'charged',
  'NoTiXs': 'nonfood',
  'PmAk6c': 'Total warehousing volume = volume of a single product (volume of a single product <{n}m³, then {n}m³) * inventory quantity',
  'YVWUH+': 'SKU personality template',
  'cLPzLe': 'with label',
  'ceUK9M': 'unlabeled',
  'ipVi6y': 'with packaging',
  'mdJrUd': 'Total storage volume <minimum storage volume {m}m³, then the warehouse rental fee will be calculated as {m}m³',
  'rghOE1': 'uncharged',
  '4jxBkZ': 'Timeout ATTscan number',
  'fVUxJR': 'Response ATTscan number',
  'hWDK0B': 'Real-time ATTscan number',
  '3MEyqn': 'Which city in China does the goods ship from?',
  'E2NwYO': 'Dscan Average (number of working days)',
  'EHTOHW': 'Ascan Average (working day hours)',
  'FTAz9m': 'Verify Weight{unit}',
  'wiO2eV': 'You have created a SKU, and the warehousing order can only be created after the SKU is approved', '0GibQM': 'Increase the first-way transportation cost',
  '10k6dI': 'Quantity of goods in delivery order',
  '5BwsBi': 'Domestic warehouse ships to overseas warehouses',
  '9kZAq1': 'Estimate',
  'EPXw7D': 'Special',
  'Krteov': 'Warehouse fee',
  'RisHP+': 'Peak season storage surcharge will be increased',
  'TZpo1e': 'Performance Fee Overview',
  'ZA2DsJ': 'First leg transportation cost',
  'aFUwPf': 'Specified service price inquiry',
  'h20CZ1': 'Estimated fixed price',
  'mYmfrE': 'Estimated overseas warehouse storage time',
  'ng05bx': 'Number of items purchased within a buyer\'s order',
  'r+WXwG': 'Domestic shipping city',
  'xWwXLV': 'General goods',
  'Dq/R41': 'If the volume of a single product is <{m}CBM, it will be charged as {m}CBM',
  'BR35ri': 'Outbound type',
  'Mk43Ju': 'This result is calculated based on the input parameters for sea freight transportation cost/air freight transportation cost. The actual order is subject to the following!',
  'OWX7o9': 'In which country is the product being fulfilled?',
  'VYvc1A': 'Estimated end-to-end fulfillment cost of a buyer \'s order',
  'iDWfFc': 'Order delivery time',
  'mR4Z9G': 'Fulfillment Cost Estimation',
  'nw+1Hz': 'Quantity of goods in the final delivery order',
  'vGNlLD': 'Authorized, please view information on the platform',
  '1RASRC': 'The size information you entered does not currently match the initial product. Please download the quotation to view or contact the customer manager for clarification.',
  '2UAyc8': 'Performance time limit: {start}- {end} working days',
  'A+bKfm': 'cm/kg',
  'C0sWNj': 'Change to \'{sizeType}\' calculation?',
  'PpG3NC': 'Winit first leg transportation cost',
  'U50aCL': 'Quickly create a receipt order',
  'WpcAaR': 'The size information you entered does not currently match the final product. Please download the quotation to view or contact the customer manager for clarification.',
  'kLR3/1': 'This fee is only a trial fee, and specific consumption will be subject to actual shipment.',
  'noAe6D': 'Estimated duration of overseas warehouse storage',
  'rD/rqe': 'Total expenses',
  'sYWXZa': 'If you need to calculate the final cost based on the determined address, please click on \'Specify Service Price Query\' and fill in the specific address for calculation. ',
  't3l5ML': 'in/lb',
  'xpf5RE': 'The size information you entered does not currently match the storage fee. Please download the quotation to view or contact the customer manager for clarification.',
  'g8S3b2': 'The above fees do not include handling fees for inbound and outbound shipments.',
  'wbTQL5': 'A single order supports a maximum delivery quantity of up to 10 items. Please enter the correct quantity',
  'aUe2XA': 'Advanced settings',
  'bQuDUJ': 'Only drafts and registered returns status can be submitted',
  '29YcX4': 'Refers to the transportation costs from domestic to overseas warehouses. If you use Winit inbound shipment service, please check this option',
  '9UxuCd': 'Calculate warehouse',
  'C9yrox': 'Fulfillment country',
  'F3YP+/': 'Please note: There will be an additional peak season surcharge during peak seasons.',
  'bkBXOL': 'I want to calculate the fees accurately',
  'iBahRB': 'The above trial costs are for reference only, and the actual costs are subject to system deductions.',
  'yo4o7l': 'If you need to specify a product or shipping address to calculate fulfillment fees, you can click this link to jump to the query.',
  '0WBg0k': 'Inbound processing fees',
  'VTxBYV': 'The product exceeds the size/weight limit, please fill in again. {lengthMin}{sizeUnit}≤length≤{lengthMax}{sizeUnit},{widthMin}{sizeUnit}≤width≤{widthMax}{sizeUnit}, {heightMin}{sizeUnit}≤height≤{heightMax}{sizeUnit}, {weightMin }{weightUnit}≤weight≤{weightMax}{weightUnit}, {densityMin}kg/m3≤density≤{densityMax}kg/m3',
  'G80Yfa': 'Outbound processing fee is included',
  'hrDPjg': 'Inbound and outbound processing fees are included',
  '/mrUV7': 'Customize',
  '0CBIls': 'Custom warehouse group name',
  '2kWiny': 'Custom warehouse group coding',
  '6CwNwM': 'Upload to draft',
  '8g7PU8': 'Add new product group',
  '9pc1MK': 'Shipping priority',
  'Bl3B+J': 'Product priority',
  'D/Yid+': 'Whether to enable',
  'HUgTwr': 'One must be selected',
  'Izo8nC': 'Buyer Partition',
  'KhGQV1': 'Single warehouse delivery strategy',
  'LTEd2f': 'Warehouse',
  'N33pTc': 'Add new warehouse group',
  'Ob9vJt': 'Product group list',
  'P0bLNx': 'Order batch upload settings',
  'PtFTAG': 'Allow multiple warehouse shipments',
  'QCXk/g': 'Whether to start',
  'U5iN47': 'Shipping strategy',
  'VaPlbo': 'Product group name',
  'Vo+Xz7': 'Product group code',
  'WcSEBf': 'It is prohibited to open multiple positions of the same SKU',
  'a7KRmz': 'Upload to Submitted',
  'g912oq': 'Importer and exporter configuration',
  'hT7MT5': 'Multi-warehouse shipping strategy',
  'izS7og': 'Standard',
  'jw88JB': 'Add new product',
  'n0YiRc': 'Warehouse group information',
  'ncq348': 'Priority',
  'pQfHnF': 'Intelligent recommended configuration',
  'xKEYMt': 'Edit product group',
  'ywJMgk': 'Category',
  'zthu91': 'Product',
  '/dtKXK': 'The input content cannot exceed 128 characters!',
  'A+/0HA': 'The selected product is duplicated',
  'EzNenN': 'Unenable this warehouse. The product [product name] under the product group [product group name] you have selected will not support recommendation. The system will automatically delete this product. Please confirm whether to deactivate it?',
  'P6bkBi': 'Unenable this repository?',
  'QLbJkZ': 'Warehouse group code',
  'XuDX2o': 'No data yet, please',
  'myrfJ/': 'To switch to another country, you need to reselect product groups. The system will clear the selected product groups. Please confirm whether to switch?',
  'pDx3hV': 'Please select product',
  'qZrzit': 'No products added',
  'rn5AwM': 'Please enable the warehouse first',
  'w3pzFa': 'This product code is already in use',
  'EMppKo': 'Products[{productGroupName}]under product group[{productNames}]',
  'LtGXYt': 'The product{productName}you selected already exists in the product group{productGroupName}, please modify it and then save{brack}',
  'o+GSTm': 'The product group code you entered already exists',
  'oCeXGU': 'Unenable this warehouse. The {content} you have selected will not support recommendations and the system will automatically delete this product. Please confirm whether to deactivate it?',
  'rtNipg': 'If you cancel the activation of this warehouse, the products under the product group you have selected will not support recommendation, and the system will automatically delete this product. Please confirm whether to deactivate it?',
  'XzxeM5': 'Search the product',
  'wI4k/a': 'Warehouse group list',

  'VJr0ui': 'Chargeable Weight (KG/CBM)',
  'B1xc4D': 'Account Name',
  'HoBJEe': 'Account ID',
  'ZQATNs': 'Document Type',
  'hzo2kV': 'Business Order Number',
  'dsROvR': 'Transaction Date',
  'vYbdwI': 'Transaction Type',
  'er7lkB': 'Amount ',
  'IAXzUL': 'Order/Warehouse Hire Date',
  'ZmP5ua': 'Main Order Number',
  '9yrgtf': 'Seller Order Number',
  '7hnqmZ': 'Package Number',
  'I0+bNm': 'Destination Warehouse',
  'zKjr6y': 'Product Name',
  'qJKFfY': 'Destination Country',
  'P/iomR': 'Logistics Zone',
  'e53tsC': 'SKU And Quantity',
  'MwjxBM': 'Weight (KG)',
  'nmj+AS': 'Billing Method',
  // '8ScwNO': 'To query and export historical data for the past 12 months, please contact our online customer service. ',
  'IqkgWZ': 'Keyword',

  'I7bO+W': 'Total Available Balance (USD)',
  'qGJjK8': 'Guaranteed Repayment amount (USD)',
  'ac+1ZB': 'Available Balance (USD)',
  'WPtJUd': 'Exchange Rate (to USD)',
  'jWa321': 'Available Balance ',
  'Gs6y7L': 'Frozen Amount ',
  'AkjhOp': 'Account Balance ',
  'D/ycuA': 'Payment ',
  '6XUyoX': 'Freeze Detail ',
  'KZsciT': 'Foreign exchange purchase/transfer ',
  'VJ35lD': 'Last Payment Date ',
  'r+gAzL': 'The outstanding amount of the issued bill is presented in USD at the floating exchange rate per day. Due to the exchange rate changes per day and the exchange rate used in the repayment direction, this amount is for reference only. Please refer to the estimated amount to be repaid for the actual repayment. overdue',
  '7RhTil': 'Estimated outstanding amount of bill(USD)',
  'j41fsS': 'Go To Repay',
  '+CjwvP': 'Repayment Evaluation ',
  'lR08XW': 'Order Amount Available ',
  'BV7zhA': 'Click to view',
  'ehedRS': 'bills are pending repayment. Please repay them in a timely manner before the last repayment date. If you fail to repay them in a timely manner, a late fee of 0.06% will be charged based on the overdue daily interest rate.',

  'oi8wFv': 'Order Amount Available USD',
  'rtyTG2': 'The amount available for placing orders in the account (displayed in USD at a daily floating exchange rate)',
  'oNrwxy': 'Available Balance USD',
  'KJ8nVz': 'Available Pending USD',
  'Ro2q9R': 'Total available and outstanding entries in all currencies (presented at a unified conversion to USD at a daily floating exchange rate) ',
  'Yy819n': 'Line Of Credit (USD) ',
  'jK4Nnf': 'First pass temporary amount (USD)) ',
  'qtAVwx': 'Out order number ',
  'ENWxyt': 'Consumption ',
  '5ISj3t': 'Winit Rebate ',
  'zpU3Yb': 'Gift Card deduction ',
  '9moHyC': 'Coupon deduction ',
  'HkZt6P': 'Delivery order ',
  'Aj4jXY': 'entry form ',
  'AJzkTP': 'Warehouse order ',
  'SDT4n4': 'Return order ',
  'hkowEP': 'Standard Claim Form ',
  'ZeCQE2': 'Overseas warehouse account',
  'IW8HMr': 'Overdue ',
  'YmfoQv': 'Charge late fees. ',
  'ItEF5s': 'Business discount ',

  '3FoZNl': 'Tracking query',
  'CCs6QA': 'Destination port',
  'CwBUk9': 'Order Submission Cutoff',
  'G47GIt': 'Scheduled Shipment',
  'NVsDWV': 'ETD',
  'RstqI4': 'Inspection Warehouse',
  'U+63ns': 'Shipping Method',
  'U0oOyg': 'OSWH lastmile lookup',
  'eITI+b': 'ETA',
  'moQ/pq': 'Inspection Warehouse',
  'nkbxtM': 'Enter tracking number for searching(<=30 number each time), seperate them by space, comma or line feed',
  'sIulVO': 'Shipment Receiving Cutoff',
  'sk3D+j': 'Logistics Plan',
  'y8Y856': 'Port of departure',
  'zolGw6': 'Has been over',
  '+pOhR+': 'File type',
  '/cqdKk': 'Download',
  '0OWEyT': 'After switching to single product management, third-party product barcodes cannot be added, and the maintained third-party product barcodes will be cleared. Are you sure you want to switch?',
  '2cnobD': 'File upload',
  '60lhcg': 'SKU[{code}]must ensure that paper instructions are carried with the goods. If you cannot provide them, the goods will not be shipped out of the warehouse. Contact customer service for details.',
  '9BNdhd': 'Only products with registration pending review, registration returned, published, update returned, and update pending review can upload files in batches',
  'B35fQu': 'After enabling the outbound and packaging service, you need to fill in the packaging information when registering goods, and the import template will also be changed accordingly (you need to download the import template again).{break}It cannot be turned off after being enabled. Are you sure you need to add packaging?',
  'HwyF+e': 'Enable delivery and packaging services',
  'IQB8CW': 'Add files',
  'KTL7xe': 'Only items in draft and registered return status can be deleted',
  'Lychr5': 'When the packaging category is [Winit standard packaging], the packaging material type cannot be [without packaging]',
  'M0Jk1q': 'Only for published products, barcodes can be printed',
  'MLkhBi': 'Skip, add importing countries for the remaining products',
  'P9HL7J': 'Only products that have been released can add new importing countries',
  'TLZkuQ': 'Select from file management',
  'UVc9ET': 'The file is insufficient and needs to be supplemented? <a>Go to edit</a>',
  'UduVZX': 'Select file',
  'X2PFlN': 'Only products whose supplementary types are all those of the product responsible person can be bound in batches',
  'XI/sng': 'Copy link',
  'XUIiyo': 'Only products whose supplementary types all have German instructions can be operated in batches',
  'do5UYM': 'Whether it is referenced by the product',
  'gL2wtJ': 'Submit results',
  'gLFXUo': 'The review failed, please maintain it again.',
  'hb/4W7': 'Local upload file',
  'r+E4Jq': 'Only products in draft status can be submitted',
  'r1IImU': 'Got it',
  'Jc2rPw': 'Please enter 0-30 characters',
  'qQPq6P': 'The Commerce Instructions link can have a maximum of 30 characters',
  'sRBJ5R': 'Supports files in JPG, JPEG, PNG, and PDF formats up to 50MB',
  '71F+U7': 'Upload a maximum of {maxCount} files',
  '7VOwCe': 'Reselect',
  'FFdW4c': 'Batch Maintenance German Instructions',
  'Tlz8ww': 'Maintenance German Instructions',
  'lQZq1z': 'Maintenance Instructions',
  'yySTyc': 'This SKU must ensure that paper instructions are carried with the goods, otherwise the delivery will be restricted. Please confirm whether to carry paper instructions?',
  'PCAxv5': 'Please log in to the main account to open it',
  'QZVGH2': 'The main account has not yet opened an',

  '+Bp/vI': 'Individual',
  '+EKnLz': 'Overdue payment will be returned to the original way.',
  '+GpSaa': 'Refunds over 90 days on FuYou Easy Pay, over 350 days on PayEco Easy Pay, and offline transfer refunds. The additional refund fees will be deducted according to the actual expenses incurred. Please refer to the actual amount received;',
  '+aB+94': '*Exchange Rate(USD)',
  '+aFDe8': 'Remittance Date',
  '+mn2aK': 'Payment Method',
  '/4F0HL': 'Credit Quota(USD)',
  '/BYjbl': 'Do you confirm this one stop open?',
  '/S2M/C': 'Transfer out information',
  '/VO4aK': 'Paying back debts in all currencies.',
  '/vwubC': '海外仓费用测算',
  '/zEZR9': 'Please select the wallet type',
  '0X1r6A': 'Processing Fee：',
  '1y/RY3': 'Amount To Be Repayment',
  '29Bujy': '4.Click to view payment instructions',
  '2dGT9s': 'Repayment estimate',
  '2ku/TP': 'and the account balance + deposit > 0, which can be consumed normally.',
  '2ygZv/': 'Card Type',
  '3BONOy': 'View',
  '3YANVl': 'You have successfully opened ISP account.',
  '3mOyjF': 'Select',
  '3sq/jr': 'First leg temporary quota limit(USD)',
  '43p9pl': 'You have not yet opened an OSWH account, functions available after you make an one-stop open:',
  '6cQmi+': 'If you need to use Fuyou to recharge, please ensure that the data file uploaded by the account subject is the latest version, otherwise you will not be able to complete the recharge to the account.',
  '4WnUuL': 'Bank Address：',
  '4YQfnV': 'You have successfully opened OWHS account.',
  '4hvYiT': 'Submit payment',
  '5P5/Mh': 'Payment amount cannot be greater than ',
  '5QTRWB': 'Dimension Weight(KG)',
  '6/ZybD': 'No outstanding or fully paid bills, no need for repayment estimation',
  '6K/a0B': 'Pause',
  '6pFnBP': 'Current available repayment amount',
  '77wjVR': 'for processing to prove that the payment subject and the WinIT account that accepts the payment are the same subject.Payments that are not certified for more than',
  '7R+2Zn': 'Available amount to be credited',
  '7TOxPh': 'Cnaps Code：',
  '7uCsR+': 'Amount',
  '82y49D': 'Source Account',
  '8i9KCx': '2.Between different accounts, support the conversion of any currency.',
  '9/IwWU': 'You have not yet opened an ISP account, functions available after you make an one-stop open:',
  '9JX759': 'Please enter a number greater than 0, up to 2 decimal places',
  '9bsH+T': '1.Offline payment orders usually take 1~3 business days to be credited.If you need to use the payment amount urgently, please use the online payment.',
  '9nOyKf': 'which is inconsistent with the registered name of the WinIT account!',
  '9ppYjb': 'Remarks: The amount will be used as a deposit within',
  'dMXzwA': 'Automatically grant permissions after submitting materials for review',
  'nT7ZVh': 'How to perform basic backend settings',
  'rl4uyx': '请先创建商品，商品审核通过后才能创建入库单',
  '9oZAA6': 'Account registration and management',
  '7yRO8w': 'How to calculate overseas warehouse expenses',
  'Aj8GCU': 'Product registration and management',
  'H7VDO0': 'How to register products',
  'Y1DU7Y': 'Basic settings of TEMU backend and Winit backend',
  'BB3JzJ': '【Submit proof】',
  'ux+6D/': 'Non-overdue bill b',
  'CN1Myp': 'PayPal, Airwallex, and Fuyou credit cards exceeding 90 days and offline transfer channels will be refunded based on the received amount, and the original payment handling fee will not be refunded; Other online channels will receive a full refund.',
  'CnJrhy': 'Click',
  'DkxKwM': 'Clear visit ISP consumption records and bills;',
  'EznDMN': 'Explanation of refund fees to be credited:PayPal, Airwallex, and Fuyou credit cards exceeding 90 days and offline transfer channels will be refunded based on the received amount, and the original payment handling fee will not be refunded;Refunds made online by Fuyou for more than 90 days, refunds made online by Yilian for more than 350 days, and refunds made through offline transfer. Any additional refund handling fees incurred will be deducted based on the actual expenses incurred. Other online channels will receive a full refund.',
  'FbGkhC': 'Payoneer account unbind successfully!',
  'FlqSrP': 'The amount to be credited is frozen by guarantee',
  'GJqMVO': 'Repayment currency',
  'HC2zVC': 'The bill has been paid off and no repayment is required.',
  'HP1Bh4': 'Available for transfer-out at the moment：',
  'HV+RrC': 'Option 1: Paying back debts in all currencies, the repaying sequence is 1234567(to not repay the unsettled bills in other currencies).',
  'HesHBG': 'Please enter the seller/s order number',
  'IFdU1p': 'Are you sure to unbind the Payoneer account?',
  'IIW5jM': 'Payment failed',
  'IRZDt1': 'Select',
  'Ic3VRb': 'Payment amount',
  'JVWd7i': 'Debit Card',
  'Jh+0Zh': '2.For the same bill, pay back the debt in the currency with balance added first, and then remaining debts via foreign exchange purchasing in the order from the largest amount to the smallest amount.',
  'K1GUT5': 'To be repayment',
  'KCVyDg': 'Transfer successful',
  'KPlzwS': 'Payment reminder',
  'KQ2i0E': 'Save and submit payment',
  'L/WfHi': 'Please select the transfer currency',
  'M7nstf': 'Payment order',
  'HYJRdP': 'Paying back only the debt in the currency with balance added',
  'MaPa8K': 'An account with a balance guarantees the repayment amount for the outstanding account, and the guarantee is uniformly converted to US dollars at the exchange rate on the day of guarantee. If the outstanding account is actually paid off, the amount will be automatically adjusted to 0.',
  'Mq7E3I': 'Refers to the remaining outstanding amount in the currency corresponding to the latest billing statement, which is not a real-time debt',
  'NwL8D2': 'Top-up & placing orders to use ISP products and services;',
  'OMT30j': 'How to submit materials to enable permissions',
  'P4kzRS': 'Payoneer will charge a transaction fee equal to the fee for withdrawals from your Payoneer Account. Please contact your Payoneer account manager if you have any objection. ',
  'PfZZIE': 'The minimum input amount is 0.01',
  'Pz9nMI': 'Payment channel processing, please check the payment status on the payment form every 1-5 minutes or so.',
  'Pzdaeh': '=Available balance * exchange rate. Due to exchange rate fluctuations, the available balance in USD also fluctuates dynamically with the exchange rate.',
  'QYZ9Zx': 'First leg temporary quota limits details',
  'RJiV2P': 'Open an account',
  'RY0kPp': 'Confirm repayment',
  'Ri66Qg': 'perform the repayment operation according to the priority of automatic foreign exchange purchase. After processing, the estimated amount to be repaid on the bill will be automatically updated.',
  'SLJmsv': 'After confirming the repayment, the system will ',
  'SPT6N5': 'The payment subject user name returned by the payment channel:',
  'Sq4y+b': '=Total amount to be credited-The amount to be credited is frozen by guarantee-Pending credit refund freeze',
  'StJL1v': 'Transfer-in Amount',
  'TBZp+D': 'To repay the outstanding balance in all currencies, please modify the Repayment Priority setting.',
  'TqsGZy': 'Please select payment account type',
  'U1a5b6': 'Please enter TrackingNo',
  'UIl1do': 'If your main account subject cannot make payments, please directly change the main account subject without registering a sub account. ',
  'UbVGIy': 'Repayment method：',
  'UdMGCn': 'Pending credit refund freeze',
  'UrwhFI': 'Paying back debts in all currencies',
  'Ut/pd3': '1.In the same account, support different currencies to convert to each other, not support the conversion of the same currency.',
  'VZZTLA': 'Quota detail',
  'VgiKkA': 'Available amount to be credited(USD)',
  'VxJpE0': '3.Explanation of refund fees to be credited：',
  'VzyupL': 'Account',
  'WAIPZ7': 'To ensure an smooth order placing, please recharge first.',
  'WKL0h2': 'Upload format support jpg, gif, png, jpeg, pdf, doc, xls, csv, docx, xlsx，and the file size cannot exceed 2MB',
  'WMHRvU': 'Please enter the payment amount, limited to 2 decimal places',
  'X4GxQb': '=Available amount to be credited*Rate(Convert to USD)',
  'XdbxuW': 'Processing Fee',
  'XfVGBl': 'Online payment',
  'Xgm4f8': 'Master account',
  'XjiQM6': 'Total available balance(USD)',
  'Yq7bo5': 'Transaction No',
  'YsDkfI': 'Todays exchange rate：',
  'Z5TkZp': 'How to register an account',
  'Z6Sgc7': 'Repayment',
  'Z7Qmhr': 'Total to be repaid',
  'a6ZOkV': 'Obtain the China Merchants Bank exchange rate at 3pm every day as the next days exchange rate. The China Merchants Bank exchange rate viewing address is',
  'aB10CI': '1.Pay pack bill debt as per the bill issuing sequence.',
  'aDobaI': 'Failed reaso:',
  'adagiy': 'Repayment Priority setting',
  'bOeriS': '=Available amount to be credited(USD)',
  'bhqbML': 'Multiple business order numbers are separated by English commas, supporting the search of 100 orders',
  'bmpsI4': 'Exchange Rate*',
  'c0L+yJ': 'To ensure an smooth order placing, please recharge first.',
  'csDC/0': 'Company Name：',
  'd8I+tD': 'If you have a recharge receipt to be credited, unbinding it may result in a refund failure.If not, please ignore.',
  'dMLnuv': 'Top-up & placing orders to use OSWH products and services;',
  'dde1iG': 'Transfer-in Account',
  'dgCSCT': 'Payment Account',
  'e0EBzw': 'Transfer-in Account',
  'eGcy2N': 'Receiving Account',
  'eLSgnP': 'Account Overview',
  'eRQHjK': 'Payment amount cannot be less than ',
  'eUvdyt': 'The Current Frozen Amount',
  'etbYTE': 'the file size cannot exceed 2MB',
  'f8hvof': 'Payment Account Type',
  'fLc+XS': 'Details to be credited',
  'gAJffR': 'Option 2: Paying back only the debt in the currency with balance added, the repaying sequence is 147.',
  'gDdy3P': '2.Explanation of refund fees to be credited',
  'gLueKi': 'Automatic Payment Priority',
  'gMHwLF': 'Please choose Card Type',
  'gTawBp': 'Available balance details',
  'hQllsy': 'Sub account',
  'hehTR6': 'Bind account',
  'ikHYS2': 'ISP Account',
  'ikulRv': 'There is currently no available balance, click to',
  'jCBjGq': 'Offline payment',
  'jZ73eo': 'Amount Received',
  'kV7zH8': 'opened an OSWH account',
  'kdB1AH': 'No payoneer account? ',
  'koaAco': 'Payment Channel',
  'l2g8wQ': '1.If the name of the payer does not match the registered name of our company, a refund will be automatically initiated on the 12th day.To avoid affecting your order, please use the same entity name for payment.',
  'l7f7r8': 'To repay the outstanding balance in all currencies, please modify the Repayment Priority setting.',
  'llD/i8': 'Please upload the attachment！',
  'm0y10W': 'Credit card',
  'm1RY2+': 'Transfer-out Amount',
  'mG5cQ0': 'Paying back only the debt in the currency with balance added.',
  'mMJ1Rl': '3.The minimum transfer amount of currency CNY/HKD is 0.1, and the minimum transfer amount of currency GBP/EUR/AUD/USD/CAD is 0.01.',
  'mhaWrg': 'Payment',
  'mvk8fk': 'Can avoid bill overdue：',
  'nHkdvI': 'Unsettled Bills c',
  'nKlulI': 'Cancel recharge',
  'nVdGLm': 'Transfer in information',
  'ordSAe': 'Corporation',
  'p0X04m': 'Wallet type',
  'pFzElE': 'Click to register',
  'qQO1Kx': 'Please select a payment channel',
  'qn8PaB': 'Case: If the user has Overdue bill a, non-overdue bill b and consumption bill c to be issued, which are occurred in sequence with debts in USD, AUD and GBP, and the debt amount in AUD is bigger than that in GBP. If the balance is added with sufficient USD.',
  'qsDvGz': 'Account',
  'qwYCNh': 'Beneficiary Bank：',
  'rCo8W8': 'Pieces',
  'rGARdg': 'Please select the remittance time',
  'sQo+08': 'Transfer-out Account',
  'tKr1pi': 'Quota allocation',
  'tb1UtE': 'The minimum input amount is 0.1',
  'ti7lc2': 'Payoneer currently does not support registering accounts in the following countries: Australia, Japan, Russia. Please use a Payoneer account registered in another country for authorized payment.',
  'uMgaXV': '2.If the name of the payer does not match the registered name of our company, a refund will be automatically initiated on the 12th day.To avoid affecting your order, please use the same entity name for payment.',
  'v5UE43': 'Total amount to be credited',
  'vv2W/D': 'Enabled ISP Account',
  'vy/OTR': '=Remaining Balance-Withheld Amount',
  'w0hdTL': '3.Our company resolutely implements the relevant provisions of the "Anti-Money Laundering Law of the People\'s Republic of China". If a refund is required after payment, it will be returned by the original path of the payment channel. Our company is obliged to report suspected acts of money laundering and false transactions to relevant departments and assist public security organs in providing evidence.',
  'wBFOVC': 'Account authorization',
  'wPdOYa': 'Clear visit ISP consumption records and bills;',
  'wm1m74': 'Please select the currency for transfer out',
  'wnNJYN': 'Credit amount The actual aomunt receipt shall prevail',
  'wq/8d2': 'Payment instructions',
  'wsJMPz': 'Transfer-out Account',
  'wxKEvn': 'Please bind account authorization',
  'xHiFxP': 'Bank Code：',
  'xOOX40': 'The amount of this payment will be',
  'xSePXT': 'Get more benefits and rebates.',
  'xch+qQ': 'Estimated repayment amount',
  'xsvWWt': 'Overdue bill a',
  'y9h4Ep': 'Payment',
  'yA6qzf': 'The bill can be overdue if debts in other currencies are not paid back via foreign exchange purchasing.',
  'yILY8H': 'Balance add succeeded',
  'ydgrO7': 'Only accounts that have been authenticated or have opened services can be used as payment initiation accounts.',
  'yfhtRM': 'Attachment',
  'ym4AWb': 'The balance of the corresponding currency in the current account, including the frozen amount.',
  'z1tAjb': 'The single currency outstanding amount here is only an estimated amount obtained after exchange based on the current exchange rate. Due to daily exchange rate fluctuations, please refer to the exchange rate on the day of repayment.',
  'T7vDas': 'Repayment Priority Settings',
  '+/mKIm': 'Send to port type',
  '+Haf5X': 'Estimated release time',
  '+KV1mF': 'Default delivery type',
  '+VZ9L9': '{warehouseName}{break}SI quantity/split ratio%',
  '+b49JP': 'New product',
  '+ouZSO': 'Number of packages in the pallet',
  '//BDmI': 'Exception area',
  '/1VwD2': 'Error message',
  '/3s7PF': 'Warehouse contact number',
  '/AhSAS': 'Under inspection',
  '/GAWbE': 'Domestic split original order number',
  '/HFG6y': 'Express tracking number only supports 6 to 40 digits in English and numbers',
  '/KZ2WA': 'Actual collection identification code',
  '/cQzqv': 'Please fill in a positive integer! ',
  '/crqpT': 'Deducted',
  '/kUXrS': 'View dump',
  '/lKNmz': 'SLA{a0}',
  '/pS13+': 'Please add invoice information',
  '0+4E11': 'Modification successful',
  '04Gdfx': 'Please add products first',
  '05s3bE': 'Reason for not being able to choose',
  '09Xv5V': 'Please select the exporter',
  '0Cs9O2': 'Empty package',
  '0LXLDR': 'Note: If you choose to add European code information, the label will have the associated European code information; if you do not choose, it will not have it',
  '0OjWgU': 'Collapse product information in batches',
  '0Q/VKe': 'If not filled in, it will be automatically generated after selecting the order and can be modified',
  '0Yqdvb': 'Create self-check form',
  '0eFd5u': 'In transit',
  '0n+GhK': 'The express delivery number is temporarily unavailable. Please confirm delivery first and provide it before the order arrives at the warehouse. ',
  '0oRCPJ': 'More addresses',
  '1+iXcF': 'Create appointment orders in batches',
  '148weM': 'Prepaid fee',
  '1AcjeR': 'Please select {field}',
  '1Cm5u2': 'Create an appointment',
  '1Fsq2f': 'The package serial number in the order is only viewed as a count and does not need to support scanning',
  '1SrwnE': '<span>Note: The above fees are estimated fees. The fee freezing time is: the domestic inspection warehouse inspection is completed/the direct shipment to overseas inspection is submitted. {break}</span> <span>If the available account balance is less than the system\'s estimated fee, the order cannot be submitted. Please ensure that the available account balance is sufficient before placing an order. </span>',
  '1Un03g': 'Exception status',
  '1Wvoid': 'Quick order',
  '1b90aB': 'Inspection method',
  '1eYE4O': 'Shelf difference quantity',
  '1f8TDn': 'Pick-up address',
  '1kQP8C': 'WINIT product',
  '2145JR': 'Termination details',
  '29nc3A': 'Actual weight (kg)',
  '2K4z2R': 'The identification code information cannot be empty! ',
  '2N21Ip': 'Preference name',
  '2Y/zPo': 'Total prepaid fees',
  '2f2ltn': 'The entire product is listed as defective',
  '2mmTtR': 'Please enter a number with no more than six decimal places',
  '2pylzZ': 'Multiple tracking numbers need to be wrapped, and a maximum of {num} is supported. Double-click to switch to a single query',
  '3FrfH2': 'Please select the delivery time',
  '3Jc4/0': 'Invoice declaration information',
  '3R6r9b': 'No, packing while inspecting',
  '3Tv9vo': 'Package barcode',
  '3U8Sns': 'Please maintain the departure time',
  '4/Afmm': 'Production date',
  '4/cfmf': 'Batch print package barcodes',
  '48ov53': 'If a set product/box product is selected, the quantity indicates the number of sets/boxes',
  '4AtBWc': 'Pickup type',
  '4JMVek': 'After switching, the existing packing list information will be cleared, and you need to re-import the packing list. Please confirm whether to switch? ',
  '4Y5o/o': 'Edit express delivery number',
  '4Z9Hsl': 'Please enter {field}',
  '4bqHG6': 'Pending approval',
  '4zXeKC': 'C package barcode number',
  '5AMYmr': 'Import declaration type',
  '5Hy2HW': 'Exception description',
  '5MwSDO': 'Confirm cancellation of <span>{mainOrderNo}</span> orders merge? After canceling the combined order, the first leg fee will be calculated independently. ',
  '5WkW6a': 'Domestic warehouse deduction quantity',
  '5ZVPiX': 'Value-added reservation',
  '5eNIMa': 'Pickup time',
  '5m+OgD': 'Add identification code',
  '5s/d5K': 'Associated adjustment order number',
  '64ulHJ': 'Charge Name',
  '66awCH': 'Refresh',
  '6EnlKE': 'Whether self-examination is exempted',
  '72NkSW': 'Update and close page',
  '7L70OD': 'Actual volume (CBM)',
  '7VvMbL': 'Delivery time',
  '7q/H5d': 'Remove odd numbers',
  '7tb4y9': 'Please maintain the container number',
  '8/zli1': 'To be reserved',
  '84F3+v': 'It is not supported to modify the recommended preference information for ordering. If you do not use this preference, please use other methods to place orders. Thank you! ',
  '87NQWt': 'Collect all',
  '8EFvsh': 'Indicates the actual quantity of the product on shelves or for inspection',
  '8N2XyN': 'Whether the main submenu',
  '8Nd7ys': 'Are you sure you want to go back to the draft? ',
  '8OKx0+': 'Support maintaining order list of customer packages',
  '8PwcJP': '[Place order | Inspect goods | Actual | Put on shelves]',
  '8RyGw7': 'Contact information',
  '8VaERm': 'Export the file into which you imported package information/product information, so that you can modify the original file and re-import it. ',
  '8aVf1s': 'Add identification code',
  '8yOIaG': 'Number of copies to print',
  '9F8Tn0': 'View fee details',
  '9Jdkl/': 'Total invoice amount (USD): {money}',
  '9U7C/w': 'Declared value',
  '9bK+VQ': 'Estimated arrival time (local)',
  'ABsoZh': 'Batch import customer packages',
  'ACzUlr': 'Do not provide and cancel the to-do',
  'ADgz1i': 'Please click here to download <url>Product Information Template</url>',
  'AIQmaJ': 'Continue to place an order',
  'ARAdzq': '(The time for goods to be put on shelves is {maxSla} natural days)',
  'B2Qpws': 'Order volume (CBM)',
  'B6fE/x': 'Unloaded',
  'B8oYdO': 'Split adjustment',
  'BQqOxZ': 'Cargo handling method',
  'BQrZ98': 'Batch print product barcodes',
  'BvRA7E': 'Total quantity',
  'ByDy2W': 'Chinese name of product',
  'ByyC+Y': 'Add express delivery number',
  'C8gyRs': 'Are you sure it takes effect? After taking effect, you can continue querying by filtering conditions. ',
  'C90Kr8': 'Container number',
  'CBNdcR': 'Yes, pending inspection: the packing list information has been determined, and the complete binding relationship between the package and the product has been entered during the order placement process. {break}No, packing while inspecting: The packing list information is not determined. Only the product information is filled in when placing the order. During the inspection, the APP is used on-site to bind the relationship between the product and the package. ',
  'CBhqWQ': 'Total number of skus:',
  'CJovuJ': 'Please select the export declaration type',
  'COLDy1': 'Processor',
  'CORiCX': 'Bulk',
  'CSKXy4': 'Quantity of good products on shelves:{a0}{break}Quantity of defective products on shelves:{a1}',
  'Ci0uZW': 'The package has arrived at the warehouse and there is an exception waiting for your operation. Please go to "Exception Information" to handle it. After the exception is handled, the warehouse will continue to put it on the shelves normally and the warehouse processing fee will be included. ',
  'CmFNm0': 'Partial arrival',
  'CykO0a': 'Is the draft sheet valid',
  'DLVpO9': 'Please note that after choosing to avoid self-inspection, the order will be automatically inspected after submission, and the box list information can no longer be modified',
  'DapT6x': 'The departure time has been maintained, please also maintain the container number',
  'E+NBXN': 'For mask products, please provide CE certification (Europe), and for medical mask products, please provide FDA certification (U.S.), otherwise the goods will be withheld from the warehouse. If it has been provided, please ignore it',
  'E7XGNI': 'HSCOOD',
  'EPU9xw': 'Please select an order with the same destination warehouse to create a reservation order',
  'EQ3QSv': 'Quantity Of Individual Items',
  'ESC6Yn': 'Package list',
  'EX2W4q': 'Confirm delivery directly',
  'EgNwCT': 'Please choose whether to specify the packing list first. ',
  'F8Cxjp': 'Full cabinet photo',
  'FBADnU': 'Inspected',
  'FDm4J5': 'Warehouse address:',
  'FMXIS2': 'Exception name',
  'FUpkCM': 'Exception order exists',
  'FUty4V': 'Target release time (local)',
  'FtPVQO': 'Configuration Preferences',
  'FvcItB': 'Deadline for receipt',
  'G0phnd': 'Edit warehousing order preference',
  'GAdpHS': 'Value-added',
  'GTx/vJ': 'Inspection data supports multiple imports. Each import will clear all historical inspection data of the current order, and the last imported data shall prevail. ',
  'Gqin8B': 'Transferred',
  'Gr4OaP': 'Sub-package barcode',
  'H+5XWJ': 'Export declaration type',
  'H/88FZ': 'Order status',
  'H1BfHj': 'Order has been placed',
  'H6fRPF': 'Third-party box number',
  'H74WHM': 'Quick self-test',
  'H7aOFH': 'To be updated',
  'HB0v/l': 'The logistics plan with the earliest estimated shelf time by default',
  'HEsWMo': 'Edit product',
  'HGZs22': 'Identification code',
  'HIB2bG': 'Please read <url>"Hair Straightening First Step User Manual" carefully. Winit does not bear any responsibility if failure to operate in accordance with regulations leads to additional fees, delays in receiving and putting goods on shelves, etc.! ',
  'HQNu2M': 'Total number of packages:',
  'HclFq/': 'Please enter a number with no more than two decimal places',
  'HeBDj3': 'View historical exceptions',
  'Hh4Skh': 'Tag file',
  'Hi/cDm': 'Merge sub-orders',
  'HjCmpq': 'Dial number',
  'Hps8qJ': '{warehouseName}{break}SI quantity|number of packages',
  'HxabgS': 'Product size (cm)',
  'I8h0ir': 'Place an order again',
  'IKLUiW': 'Support order list for creating appointment orders',
  'IQcPaX': 'Actually collected express delivery number',
  'IX2QXb': 'Total number of items:',
  'Ib2hT8': 'Reservation warehouse',
  'IeO0m8': 'Estimated arrival time',
  'IpFfcK': 'Voucher photo',
  'IqBF9S': 'The custom box mark barcode posted on the outer package of the package must support scanning and identification and must be unique within the WINIT system',
  'J/7xTf': 'Whether the packing list is clear',
  'J01u91': 'Default delivery type',
  'J8dULN': 'Box number',
  'JISjDR': 'Box mark style',
  'JT2B6+': 'There are differences in listing',
  'JhQ/Jm': 'Summary quantity {break}SI quantity|Number of packages',
  'JloVFv': 'Support maintenance of sailing time order list',
  'JoFqsi': 'No such permission! ',
  'K8uL5W': 'Warm reminder: If the customs detains or inspects goods due to this problem, the costs, liabilities and other risks incurred must be borne by the customer. ',
  'KB4dfq': 'Goods received',
  'KBc/G+': 'Quantity on shelves',
  'KGzTFK': 'Please fill in a number greater than 0, with a maximum of 3 decimal places',
  'KQ5tz8': 'cost estimate',
  'KRrlyx': 'The relationship between the express tracking number and the package cannot be determined. Please enter and save the express tracking number of this order in the table below. (Multiple saves will automatically remove duplicates and perform additional processing)',
  'KVkKPj': 'Actual release time',
  'Keyhlo': 'cost',
  'KwEmp3': 'Batch upload identification code',
  'LIyazS': 'Updater',
  'LbBp8z': 'Termination quantity',
  'LbzjeJ': 'Confirm delivery',
  'LpjYFr': '<title>Warm reminder:</title>{break}<span>Please pay attention to correctly selecting the importer of the order. The system will record the product information of the order in transit based on the importer information. Wanyitong will The British Customs and Excise Department (HRMC) requires the importer to provide the importer\'s in-transit, in-warehouse and out-of-warehouse information. </span>',
  'LqWKF0': 'The order information changes and the estimated cost changes. If necessary, please go to <url>Order Details</url> to view the latest estimated cost. Click the order details hyperlink to go to the details page. ',
  'Ls1X2Z': 'Processed',
  'M0EUx8': 'Expand more',
  'M7XhhM': 'A+package barcode number',
  'MHVja0': 'shipping place',
  'MNhsuy': 'Actual production date',
  'Ml6cXJ': 'Select the order to be copied',
  'MntjRj': 'The delivery method of this order is express delivery and there is no packing list. Please provide the identification code information. Winit will identify the order based on the identification code information',
  'Mp5/Kf': 'Order information',
  'N25MSc': 'Reservation status',
  'NUm1lw': 'Shipping supplier',
  'Nnflg8': 'Because only whole package splitting is supported, the results may be different, please check the final results',
  'NxRF/D': 'B package barcode number',
  'O2GkC8': 'Reservation successful',
  'O2w7aQ': 'Please select the Wint warehousing product first and then create a self-inspection order',
  'O78/NO': 'Customer',
  'ONp4Fs': 'Warm reminder: Re-uploading will clear the originally imported information',
  'OOa7/r': 'Add sub-order',
  'OPMsMJ': 'Exception creation time',
  'OW95UK': '<span>If you specify the delivery time, please select the correct delivery time. If you do not know the delivery time yet, you can use the delivery time calculated by the system by default. Thank you! </span>',
  'OXu/wN': 'Whether the master order',
  'ObFFIO': 'Order time',
  'OtbHOY': 'The identification code can be up to 128 characters',
  'PcnKff': 'Signature information',
  'PiyAfP': 'Reservation type',
  'Q0IJ2Z': 'Express company',
  'Q58yf2': 'Default recommended',
  'QYstE7': 'The merged master order is the warehousing order {orderNo}, and the master order cannot be replaced after the merge. ',
  'Qjs1ZE': 'Photo of the receipt',
  'QreDuh': 'Exception reservation',
  'Qzs7rS': 'Order track',
  'R6Haep': 'Initiate transfer',
  'RAwLcV': 'New warehousing order',
  'RMaTq1': 'Whether the lead seal is abnormal',
  'RWKKkV': 'Batch maintenance package barcode',
  'RlYLsE': 'Expense description',
  'RuIqtm': 'The interface did not return data and the file generation failed',
  'S/8L6Q': 'Whole cabinet',
  'SGFD07': 'Whether to participate in allocation',
  'SLK/K9': 'Total label barcode = package quantity ',
  'SM5IQ2': 'Batch import express tracking number',
  'SSOUy/': 'Update and go to next step',
  'STnfmz': 'Total number',
  'SU88Fc': 'Number of packages',
  'SUm34B': 'Overseas unloading time',
  'SYsndp': 'Please ensure the accuracy of the imported data, otherwise it will affect the credit rating of your account. ',
  'SlzHdq': 'Please select at least one order before submitting',
  'Sn2I9N': 'The total number of packages placed in the current order is {estimatePackageQty}, {shelvePackageQty} has been put on the shelves, {lostPackageQty} has been lost, and {stopPackageQty} has been terminated. Please confirm whether all have been put on the shelves? After the operation, the remaining {remainingPackageQty} packages will be automatically terminated and cannot be recovered',
  'Sne4x8': 'Add warehousing order preference',
  'SqE6Xs': 'Origin',
  'T4IvBW': 'Third-party encoding',
  'TBbEyx': 'New submission',
  'TH1ziY': 'Arrived',
  'TKdhhF': 'Value-added information',
  'TLgurL': '<span>If the pickup type is "WINIT door-to-door pickup" and the pickup address is a non-free collection area, please refer to the WINIT overseas warehouse price card for charging standards. If there is no quotation for the price card, please consult WINIT customer service first. Quotation.</span>',
  'TTRtNs': 'Total invoice amount (USD): {invoiceMoney}',
  'TXukVl': 'The associated order number indicates the corresponding original warehousing order or new warehousing order in the value-added order related to the warehousing order. Only display the associated order numbers in accepted, warehouse processing, warehouse processed, and completed value-added orders',
  'TbuyGo': 'Customer order number',
  'Td1kBU': 'Associated order number',
  'Thj8cY': 'Yes, pending inspection',
  'TlN+E+': 'If a set product/box product is selected, the quantity indicates the number of sets/boxes',
  'TlmivL': 'Inbound order settings',
  'TmeS4t': 'Winit',
  'TpnoPg': 'Warehouse phone number:',
  'TqOQZ7': 'Actual cost',
  'TuZEiB': 'Inspection quantity',
  'U5YRJc': 'Cancel inspection',
  'URH0xP': 'Reservation order number',
  'UTgFmZ': 'Package weight (kg)',
  'UjxKxu': 'terminate',
  'UzUKJU': 'Maintain Importer',
  'V/Q/MF': 'Cancel all',
  'V3EgJJ': 'The container number should be four capital letters + 7 digits, please check and submit',
  'VdzlrR': 'Please click here',
  'VgoWxA': 'Winit fee',
  'VhKC/g': 'Add one by one',
  'ViVCdK': 'Launch completion time',
  'VvQxun': 'Lost',
  'W5OmHx': 'Inbound order number',
  'W60tFR': 'Order Date',
  'WGM/sd': 'Print package barcode',
  'WPq6RS': 'Export imported information',
  'WVa6Gz': 'A+',
  'WeJSWO': 'Whole cabinet type',
  'WntfLd': 'Domestic warehouse information',
  'Wq3cD+': 'Whether the loan value is high',
  'WqyrgN': 'Partially available',
  'Wy9Mf2': 'Today',
  'X1YR3n': 'Return to draft',
  'XA+N8d': 'Edit package',
  'XBalI+': 'Actual product batch number',
  'XCMy9u': 'Please select a courier company',
  'XFFD/P': 'View product information in batches',
  'XLlfn6': 'Feedback value added',
  'XOzvJn': 'Enter two characters and the system will automatically match the SKU',
  'XauMax': 'Edit dump',
  'XnTAmU': 'Actual expiry date',
  'Y0Vai9': 'Actual barcode value',
  'YEHu7B': 'length, width and height',
  'YII2+w': 'Expiration date',
  'YncPzL': 'If you choose to use this value-added service, when a single product inventory of a SKU in the warehousing order is put into the warehouse in package A and meets the box rules of the SKU product box, it will automatically be converted into box product inventory and put on the shelves. ',
  'YqBDBe': '<title>Warm reminder:</title>{break}<span>For non-Winit shipping orders in the UK, please provide complete import customs declaration documents before the goods arrive at the warehouse. If valid customs clearance documents are not provided, Yitong has the right to ban the order from the warehouse based on the due diligence requirements of the British Customs and Excise Department (HRMC) for the warehouse. Thank you. </span>',
  'YrPv/S': 'Number of storage modes',
  'Z3nsrC': 'Please select the item to delete!',
  'Z7aHkZ': 'Freeze node',
  'ZOZfwr': 'Your current order information will be automatically saved to the draft order {orderNo} for you. Please confirm whether to cancel? ',
  'ZTlBmE': 'Inbound order number:',
  'ZfgKqB': 'Please <url>click here</url> to download the packing list information template. ',
  'ZlNu8o': 'If the pickup type is "WINIT door-to-door pickup", and the pickup address is a non-free collection area, please refer to the WINIT overseas warehouse price card for charging standards. If the price card does not have a quotation, please consult WINIT customer service first to obtain a quotation.',
  'ZpXeP3': 'Estimated arrival time',
  'a03CGi': 'Including photos of lead seals, unboxing photos, and photos of moisture and water',
  'a2fLkA': 'Please select the identification code type',
  'a5E0Ng': 'Sub-package overseas scanning time',
  'a5l3By': 'Please enter 0-100, up to two decimal places',
  'a7NkIa': 'Deadline for placing orders',
  'aB+BJ/': 'Use packing list information to generate declaration',
  'aDBVmD': 'Express tracking number',
  'aMiNon': 'delivery method',
  'agQLWz': 'Association adjustment type',
  'av2paB': 'Need information from customers',
  'avQKT6': 'Please enter a positive integer',
  'b6ccYv': 'A total of {a0} products available, {a1} unavailable <a2>Expand products that cannot be selected</a2>',
  'b9JmDO': 'Cancel delivery',
  'bEG5tG': 'Download batch upload identification code template',
  'bGVE1B': 'Batch maintenance of customer parcel codes',
  'bOqVvl': 'Please enter the express delivery number',
  'bccJSU': 'Package weight',
  'beiLZA': 'Pack list information cannot be empty! ',
  'bjzFIC': 'Estimated delivery time',
  'bpSdwX': 'Number of unpalletized packages',
  'btRxj0': 'Cost information',
  'btmsJu': 'Terminated',
  'c2hDMK': 'To determine the relationship between the express delivery number and the package, please download this order template, import and upload. (Multiple imports support updates)',
  'c2y2qR': 'Import express tracking number',
  'cNQ0gh': 'Download the template, import and upload (for the relationship between the express delivery number and the package that has been determined)',
  'cQMY2E': 'Are you sure you want to delete it?',
  'cS931W': 'Declaration of Chinese product name',
  'cY3iEX': 'Cancel transfer',
  'coU8Jk': 'Number of items',
  'ct6g4c': 'For the order you initiated to terminate, if the order package reaches the overseas warehouse, it will be intercepted and unable to be put on the shelves. It will be temporarily stored in the exception area and additional temporary storage fees will be incurred. Are you sure to continue the termination? ',
  'dASZuG': 'Submit and confirm shipment',
  'dCFfNa': 'The delivery method of this order belongs to the whole container, please maintain the departure time! ',
  'dF+aMA': 'Whether it is affected by moisture or water',
  'dGF8Sn': 'Edit identification code',
  'dOBmL8': 'Save and confirm delivery',
  'dQD3ZJ': 'Inspection status',
  'dfIz/T': 'Upload express delivery number',
  'dpcPCu': 'Estimated cost',
  'dssjRY': 'Declared value (USD)',
  'e1d/Ws': 'The above fees are estimated fees, and the actual fees will prevail. ',
  'e8cbAb': 'Warehouse name',
  'eOIKED': 'Verify size (cm)',
  'eelCv6': 'Clear all',
  'el0Kz3': 'Estimated delivery method',
  'enLtM3': 'Deduction node',
  'ex+IzV': 'Verify Weight (kg)',
  'f36rK/': 'Please select the importer',
  'f69V6p': 'Signature Time',
  'f6CeZ+': 'Please enter the non-A+ package barcode number',
  'fC2QjX': 'Maintain Exporter',
  'fDddkK': 'Main Order Number',
  'fEWKZV': 'Product batch number',
  'fQXTj6': 'Express information',
  'fWEyf9': 'All available',
  'fZDGEe': 'Signature',
  'fmXbdW': 'HSCODE',
  'fuDs1B': 'Exception arrives in warehouse',
  'g9bh34': 'English name of product',
  'gB3QVh': 'Package level',
  'gSmKzH': 'Billing weight (kg)',
  'gmG+u8': 'Lost quantity',
  'gsVL49': 'Dear customer, hello! {break}<desc>According to a recent notice issued by the U.S. Customs and Border Protection, the import of cotton products (products produced in whole or in part using this cotton) from the Xinjiang Uyghur Autonomous Region in China is prohibited. Since most of Chinese cotton is grown in this area, products containing cotton imported from China may be detained or prohibited from entry. For details, please check the notification link from the U.S. Customs and Border Protection. </desc>{break}<url>Click the link address</url>',
  'h5VsBC': 'Ordinary appointment',
  'hJbAF7': 'Pack list information',
  'hOPDPX': 'Whether to confirm delivery',
  'hPJkFk': 'Pick-up address',
  'hYC7rP': 'The information you changed will involve the adjustment of the order structure, and the box list information will be cleared by default. Please confirm whether to adjust? ',
  'hZHPZo': 'Please select Winit warehousing product!',
  'hkVN9x': 'Please confirm whether the order has been fully inspected. The order information cannot be modified after the inspection is completed. ',
  'hl1rBH': 'Inbound order identification code',
  'hvGSWe': 'Inspection warehouse/shipping place',
  'hxJVQJ': 'Declared unit price (USD)',
  'i6uYTF': 'After switching, the existing packing list information will be cleared. You need to re-import the packing list. Please confirm whether to switch? ',
  'iEwi00': 'The delivery method of this order belongs to express delivery, please maintain the express delivery number! Winit will obtain the logistics track based on the express delivery number. ',
  'iJRlKo': 'warehouse address',
  'iL72fa': 'Double-click to switch to batch query',
  'iMfa45': 'Support order list uploading express delivery number',
  'iT2mOO': 'Do you want to confirm the failure? After expiration, you can continue to query by filtering conditions. ',
  'iYbZ9o': 'Declared unit price (USD)',
  'iZK+78': 'Original order number',
  'jDrbVr': 'The warehouse receipt inspection status is in inspection/inspection completed, modification is not allowed! ',
  'jESlL9': 'Nearly {days} days',
  'jF4g5j': 'Please select non-A+ package products for printing',
  'jJzjJ7': 'To be inspected',
  'jOFy6Z': 'Only when abnormal situations occur, there will be corresponding photos, including abnormal tray pictures, abnormal package pictures, etc.',
  'jSb67m': 'Shipping plan',
  'jcMe0a': 'Please select at least one order',
  'ji5/jU': 'This preference cannot be recovered after being deleted. Are you sure you want to delete it? ',
  'k3gNi8': 'Identification code information',
  'k3gVMn': '<title>Warm reminder:</title>{break} <span>1. Please specify the destination warehouse for BC parcels</span>{break} <span>2. The system will divide A according to the warehouse proportion Class parcels are automatically split and support self-adjustment. After confirmation and submission, the system will automatically split into multiple orders</span>{break} <span>3. If you want to affix the parcel barcode uniformly, please print the parcel barcode before submitting the order. ;After submission, labels must be printed and labeled separately according to the split order</span>',
  'kMMJmC': 'The packing information is subject to the package information imported from your order. If adjustments are needed, please re-import the order package information before completing the self-inspection. ',
  'kVZ7cV': 'Cancel merge',
  'khjSsg': '<title>Warm reminder</title>{break}<span>When placing a warehousing order, we will automatically bring out your preference information based on the warehousing order preference you set to improve your order placement Efficiency</span>{break}<span>Preference setting steps:</span>{a0}',
  'klLCMR': 'Deduction quantity',
  'ksgpo6': 'The declared value of each express delivery receipt cannot be greater than {max} US dollars, please change the declared value or split the shipment',
  'kuDo/J': '{field} cannot be empty',
  'kyVVoP': 'Sail time',
  'lNQLAr': 'Unable to provide express tracking number. ',
  'mLsoqa': 'Feedback',
  'md3nxV': 'Please select at least one sub-order before submitting',
  'myc/4W': 'Whether it is A+ package',
  'nHbUPX': 'Single product transfer box product',
  'nLwKh5': 'Preference name cannot be empty',
  'nhwDW2': 'Please select a project',
  'niU4F4': 'Package serial number',
  'nnZ5Oj': 'If the identification code type is a courier order number, you need to fill in the corresponding courier company; if the identification code type is a warehouse order number, you do not need to fill it in, and the system will fill it in automatically. ',
  'ntW28d': 'Identification code type',
  'nyrsly': 'If the order data is checked, the template will be filled in according to the selected order, if not checked, an empty template will be downloaded',
  'o4Vv1R': 'Please fill in the information! ',
  'o7iVPm': 'Package size (cm)',
  'oNsmAy': 'Package information',
  'oOZt0C': 'Signature type',
  'oPxsc7': 'Print order barcode',
  'oxmeg2': 'Product weight (kg)',
  'p0QER/': 'Illegal behaviors include but are not limited to the following: {break} ① Logistics documents such as direct-shipment first-leg package manifests/waybills/bills of lading/invoices are not filled in in accordance with Wanyitong\'s self-initiated first-leg requirements, and contain WINIT or other WINIT employee\'s name and other words {break} ② Direct shipment is not a payment mode in which the consignor bears taxes (DDP, DTP, F/D, etc.); {break} ③ Abnormal status of the warehousing order: direct shipment self-inspection into the warehouse The order is not in transit, and the order sent directly to overseas for inspection is not placed;{break} ④The direct shipment of the first-way warehousing order (non-express delivery) does not make an appointment for delivery to the warehouse/does not deliver the warehouse according to the appointment time, etc."',
  'p7k/3V': '{num} records selected',
  'pDE/NS': 'Please add products',
  'pNlKO3': 'child',
  'pPLFGM': 'Warehouse name:',
  'pPxUIG': 'Please check the order',
  'per6Wc': 'Deduction time',
  'pfdzsY': 'The earliest pick-up time is selected by default',
  'pmnxx5': 'Domestic warehouse deducts goods',
  'pwc6NQ': 'Add preference',
  'pxcOgS': 'Please click to download <url>Multi-SKU type warehousing box list information template</url>{break} (applicable to customers who have activated the set/box product whitelist or barcode value management whitelist)',
  'qALFFF': 'Print packing list',
  'qCkP6I': 'Multiple order numbers need to be wrapped',
  'qIXpnS': 'Unrecognized',
  'qLA8ku': 'Please check the orders with the same destination warehouse',
  'qO/UNZ': 'Sla',
  'qU/PvG': 'Route',
  'qlYzaa': 'Place an order now',
  'qsBMLq': 'Sub-package number',
  'r9PIIM': 'Only one box of product can be added to the same package',
  's3X4br': 'Signature order number',
  's6jr9x': 'A package barcode number',
  's9gMG0': 'Please click to upload the file',
  'sC2Q9O': 'Sail time',
  'sD68ps': '<title>Warm reminder:</title>{break} <span>Intelligent domestic split PSC order, after submission, the system will automatically split it into multiple orders according to the rules. If there are any changes after placing the order, please Make modifications in the split sub-order</span>',
  'sDg3+u': 'Order weight (kg)',
  'sU6jlq': 'Number of inventory units',
  'sZhuDU': 'Customer package barcode',
  'snyKle': 'Please click to download <url>Multi-SKU type warehousing box list information template</url>{break} (applicable to the activated set/box product whitelist or barcode value management whitelist/batch management whitelist /Wanyilian customers who are exempt from self-inspection whitelist)',
  'sziYw4': 'Batch maintenance of parcel barcodes',
  'tGh90c': 'Must be greater than 0, less than or equal to {maxMoney}, with a maximum of 2 decimal places',
  'tZ+xcf': 'Processing time',
  'tZE20T': 'Order quantity',
  'txh7Ok': 'This order method does not currently support the storage of this type of goods',
  'u0n0TG': 'Total volume (CBM)',
  'uEX5d+': 'Winit order number',
  'uX7sD/': 'Storage date',
  'uhRzgM': 'Package length*width*height',
  'usAYZQ': 'Supports up to {num} queries',
  'ux8iYZ': 'Abnormal photo',
  'v+ZpZ/': 'Quantity of product (SKU)',
  'vNKRrK': 'Quick order navigation',
  'vOJVtM': 'Temporarily confirmed delivery',
  'vPrigA': 'Order source',
  'vY9yDh': 'Warm reminder:',
  'vkZ8aE': 'The update will be completed after the packing list information is imported successfully. Please confirm whether to update? ',
  'vp+HUi': 'Personal ordering preference',
  'w00px3': 'Are you sure to cancel the cross-docking? ',
  'whKaxL': 'Please enter the identification code',
  'wk5u+s': 'Import failure record',
  'wyM+iH': 'Declaration of English product name',
  'x+J841': 'Stock level',
  'x3GvYe': 'If you use this value-added service, after the warehousing order is put into the warehouse, the entire product will be put on the shelves as defective products in the defective product area. ',
  'xNeD5U': 'Cancelled',
  'xZo6jh': 'Inspection completed',
  'xjO4wW': 'Adjust',
  'yE+gNd': 'Inspection type',
  'yGaq41': 'Only supports printing on label paper, no more than {maxBatchPrint} can be printed at a time',
  'yM40CJ': '<span>If the packing list information changes, the system will recalculate the split results</span>{break}<span>The following data only includes A and A+ packages</span>',
  'yPL67T': 'Reservation code',
  'yQkOEi': 'Winit warehousing product',
  'yufptr': 'Sla unit',
  'yvm8n2': 'Already available',
  'yzEJ6Q': 'New package',
  'zE6N7L': 'Exception',
  'zEP9We': 'To print the barcode <a>Click here</a> to enter the order details. ',
  'zEcTCR': 'Clear all',
  'zGN0WZ': 'Batch import departure time',
  'zKkAh7': 'Domestic warehouse delivery quantity',
  'zXfo9H': 'The expected delivery method of the order is whole container/bulk cargo, please make an appointment before delivery <url>Click to make an appointment for delivery</url>',
  '+K2mxF': 'View bound products',
  '+as26z': 'Bind product',
  '/9BA4E': 'If not filled in, the actual collection by winit shall prevail. Please pay attention to the number of days that the shelf life of the product is prohibited from sale',
  '/XXHj8': 'Note: The above is the FNSKU information synchronized by removing the order number. Please bind the Winit product code first. ',
  '1a4I+M': 'Batch maintenance of third-party package barcodes',
  '216TEI': 'Address:',
  '3/5ReX': 'Save and close',
  '5JPEEe': 'After unchecking, the current product information will be cleared. Please confirm whether to uncheck? ',
  '7MMXPF': 'The express delivery number is temporarily unavailable. Please confirm delivery first and provide it before the goods arrive at the warehouse. ',
  '7zzDTz': 'Whether the boxing information is clear',
  '8NvecW': 'Add product line',
  '8QanX6': '[Yes, pending inspection]: The packing information has been determined, and the binding relationship between the package and the product can be directly entered during the order process. {break}[No, pack while inspecting]: Packing information has not been determined. Only fill in the product information when placing an order. Scan and bind the relationship between the product and the package during inspection. ',
  '9T27Yk': 'Total prepaid fees: {allmoney} {currency}',
  '9vGfC2': 'The order information has changed and the estimated cost has changed. If necessary, please go to <url>Order Details</url> to view the latest estimated cost. ',
  'CcQbSa': '{name} is not signed, <url>Please click the link to sign</url>',
  'CqRSDm': '{warehouseName}{break}SI quantity | split ratio %',
  'CwyC8y': 'Please select {field} first',
  'F3jPfS': 'Contact:',
  'FGaAuD': 'Please enter the removal order number, multiple line breaks are supported',
  'I0iNxa': 'Get product details',
  'I1W1lj': 'For products under shelf life and production batch management, if not filled in, the actual collection by winit shall prevail. Please pay attention to the number of days that the shelf life products are prohibited from sale',
  'IKtkLx': 'Contact number:',
  'K3TeL/': 'Pending',
  'N+5Ddk': 'Please enter your Amazon store account number',
  'NHsSAb': 'Country:',
  'O5JvNY': 'Remove order number',
  'OtByF3': 'For products that have enabled barcode value management, the barcode value is required. In the same package, products of the same SKU type and the same inventory unit standard quantity (if any) must have the same barcode value',
  'POaD2E': 'To use the current Winit product, you need to sign a customs clearance agreement first. <url>Please click the link to view the signing method</url>. ',
  'PV1cTK': 'Please enter a number with no more than three decimal places',
  'PfOCPu': 'Collect express delivery number',
  'b6OX/n': 'Copy order',
  'bLlEAh': 'The display format after search is: product code-product name-specifications [SKU type-number of standard parts in stock units (if any)]',
  'bjURnX': 'The outbound and packaging service is not enabled',
  'dSHhYW': 'Customs declaration information',
  'dXNw7m': 'Winit product code',
  'ekm5RV': 'Email:',
  'fuj7WB': 'Import third-party package barcodes in batches',
  'g6XoUD': 'For full container orders, please promptly maintain the order [departure time] in Wanyilian after the goods leave the port, otherwise it will affect the order delivery appointment!',
  'gECtkR': 'Operation location',
  'hZIYSK': 'Total cost:',
  'hdaFx9': '<url>How to fill in the delivery method? </url> {break}Bulk cargo: For truck delivery of parts/pallets that are not full containers, you must make an appointment before sending to the warehouse; {break}Full container: The international transportation method is only for full containers, and you must make an appointment before sending to the warehouse; {break}Express delivery: No appointment required',
  'iiRPff': 'Whether to synchronize Amazon removal orders',
  'kFZ6Sy': 'Winit shipping: refers to the entire time limit from the domestic warehouse to the overseas warehouse when the goods are put on the shelves; {break}Seller direct delivery: refers to the time limit for the goods to be put on the shelves after they arrive at the overseas warehouse',
  'l0+dWr': 'Third-party package barcode',
  'm0/5Lx': 'Batch upload packages',
  'mhM8WV': 'Checking the option to synchronize Amazon removal orders will clear the product information. Please confirm whether it is checked? ',
  'rFRyfW': 'Supports maintaining order list of third-party package barcodes',
  'sFLVr4': 'You can view it after submitting the order',
  'ubfSYP': 'Batch upload products',
  'vWP3K2': 'Please click to download <url>Import template</url>',
  'vsSpHk': 'Add next',
  'vtcir0': '<url>How to fill in the international shipping method? </url>',
  'wY/k9X': 'If not filled in, the actual collection by winit shall prevail',
  'xD3QFO': 'Fees information <span> (the actual deduction amount may be inconsistent with the estimated amount, the actual deduction amount shall prevail)</span>',
  'xMUB1N': 'Amazon store account',
  'y52KzK': 'No more reminders within 30 days',
  'yvyrt3': 'Rebind product',
  'zOwd77': 'Intelligent domestic split PSC order, after submission, the system will automatically split it into multiple orders according to the rules. If there are any changes after placing the order, please modify it in the split sub-orders',
  'gjldFJ': 'Courier tracking number after interception',
  'jgK8RF': 'Print Certificate',
  'NpkuXN': 'Whether to synchronize Amazon removal orders',
  'TwvSPX': 'Source',
  'x51qTM': 'Courier tracking number before interception',
  'RGuxf+': 'When printing more than {maxNumber} label barcodes at a time, please go to the export center to download the file',
  'mG/n2r': 'To use the current Winit product, you need to sign a customs clearance agreement first. To sign the operating document, please <url>click the link</url> to view it. To provide the customs clearance agency agreement, please <url2>click the link</url2>.',
  'S14cUE': 'Used for package counting and identification, easy to paste corresponding package labels, scanning is not supported',
  'lD8xXw': 'Subject to the actual amount received',
  'RJP6qH': 'Verify weight',
  'aRhAJi': 'Verify size',
  'pE1TYn': 'Package size',
  'xGK0dH': 'Overseas warehouse receipt information',
  'azlx3A': 'Overseas warehouse receipt information<span> Please note: Please be sure to fill in the shipment according to the following [Contact Person] and [Address] information, otherwise it will affect the warehouse receipt processing. Thank you for your cooperation. </span>',
  '6dK+q1': 'Print pick-up notification',
  'Gh7kDk': 'Domestic warehouse receipt information',
  '3yxbjy': 'Warehouse phone number',
  '0nfqFU': 'Please enter the business order number',
  'GwOy47': ' day ',
  'thQW+8': ' day ',
  '9n8bNu': 'In payment',
  '8PS/Vj': 'Waiting for posting',
  '/jiyIp': 'Total amount',
  '7NqucZ': 'Switch to 【Custom】, the selected configuration in 【Standard】 will be cleared, please confirm the switch?',
  '8YBttT': '{zone} has expired',
  'GXynBY': 'Switch to 【Standard】, the selected configuration in 【Custom】 will be cleared, please confirm the switch?',
  'MVnxEB': 'View warehouse group',
  't041qm': 'Products cannot exceed {recommendMaxProductCount}',
  'zn3DrJ': 'SKU cannot be split and shipped from multiple warehouses.',
  'znH959': 'Edit warehouse group',
  '2Ydaow': 'Date format applicable by country',
  'Amn7e1': 'Please enter the batch date format',
  'HPr7xm': 'Please provide the date format on the product, and the physical date will be collected and checked based on this format after arrival at the warehouse',
  '2A0aBn': 'Import Declare Value',
  'Mg5eiu': 'Batch date format',
  'qB04Og': 'Upload a schematic diagram of batch information on physical objects',
  '/earsF': 'Total expenses details',
  'FVI3+2': 'Please select {fieldName}',
  'Ms1ITn': 'Price',
  'VVcSSC': 'Zone price estimate',
  'ruoc98': 'Zone',
  '1t+pdo': 'Barcode value (FNsku)',
  '9qb/fX': 'After checking this service, the courier tracking number on the package will be collected for you, and the relationship between the courier tracking number and the package barcode will be displayed on the warehouse receipt. ',
  'ACbtGO': 'If you select a pickup date and cannot select a pickup time period, please choose another date, thank you! ',
  'BkIerX': 'After this warehousing order is submitted, the removal order and product information cannot be edited again. Please confirm that the information is correct before submitting. Thank you for your cooperation! ',
  'JWCoTB': 'The following fees are estimates, and the actual charges will prevail. ',
  'SYvcgF': 'Remove single operation instructions',
  'ZXB19i': 'A maximum of 10 numbers can be entered to remove the order number',
  'o9M0aX': 'If you have not authorized your Amazon store account, please <url>click the link</url> for authorization. After the authorization is completed, the automatic synchronization and removal order setting needs to be turned on. Please <url2>click the link</url2> to turn it on. ',
  'xXyarK': 'Quickly register products',
  'y7R4i8': 'A total of {a0} products are available and {a1} are unavailable <a2>Expand unavailable products</a2>',
  'yVvA0A': 'Please select [warehousing order number] for the identification code type. Amazon will automatically synchronize the express order number for you after removing it, so there is no need to enter it manually. ',
  'xHe3ea': 'The barcode value is the FNsku information synchronized through Amazon removal order number. Please fill in and bind the Winit product code of the corresponding product.If you have not registered the product yet, please register the product first and then perform the binding operation. Please give me this translation.',
  'Q1REvd': '<span>Note: The above fees are estimated fees. The fee freezing time is: the domestic inspection warehouse inspection is completed/the direct shipment to overseas inspection is submitted. {break}</span> <span>If the available account balance is less than the system\'s estimated fee, the order cannot be submitted. Please ensure that the available account balance is sufficient before placing an order. </span>',
  'pKedas': '<strong>Item management:</strong>one item, one code. Each single product sold has only one globally unique single product barcode.{break}<strong>SKU management:</strong>one category, one code. All items of the same SKU have the same product barcode{break}<strong>Example:</strong>{img}',
  'v1nBi8': 'Please enter the batch date format',
  'xR0TDl': '<strong>without outer packing</strong>:without any packed goods.{break} Do not support bare goods out of storage, bare goods please maintain out of storage packaging{break} <strong>sale package</strong>:The packing with which the goods leave the factory.{break}Goods for sale packaging, and high value, do not support direct delivery,please maintain outgoing packaging{break} <strong>logistics package</strong>:The packing of goods can support delivery.{break}Goods for logistics packaging, support for direct delivery, can not maintain packaging.{break} <strong>Example</strong>：{img}',
  '08FD55': 'Reissue invoice',
  '0mUTze': '+Current Payment',
  '1Thrlh': 'Proof of Delivery refers to a document or record signed by the recipient after the delivery of goods, used to prove that the goods have been delivered on time, in good condition, and have been signed for.',
  '2HVDUM': 'Billing Template',
  '3I1qk6': 'Set up receiving email',
  '6W0m3g': 'Please check the billing details before submitting',
  '73GscL': 'Download Statement',
  '7gBBpn': 'Billing Template Settings',
  '7hsSLH': '=Estimated total remaining outstanding(USD) - guaranteed amount(USD)',
  '9HN07h': 'Data has been exported. Please go to Bill of Custom to download the data. It may take some time if the data volume is large..',
  '9TKbuS': 'Combination Bill',
  '9zz9ZO': '=Previous balance+current payment+current income - current expenditure',
  'A6Op4y': 'The remaining outstanding balance of each currency is displayed in real-time exchange rate converted to US dollars',
  'AZj+tf': 'Generate Statements',
  'Agccw2': 'Tips{break} 1.Support custom customer name format and custom invoice address;{break} 2.Support for custom payment accounts;{break} 3.The generated electronic invoice does not support changing the customer name and address again.{break}',
  'BHp1I1': '=Current Repayment Amount - Repaid Amount',
  'CVEBvE': 'Bill Type',
  'D61vFu': 'Customer Name Format',
  'D9OL3m': 'Refers to the total consumption expenses of the current billing statement',
  'DNxAOh': 'Beginning Balance',
  'EuwSjA': 'To ensure the completeness of the billing details data, please submit the download application after 9:00 am on the billing day',
  'Fm/6zF': 'Download Billing Details',
  'GCMCkP': '-Current Expenditure',
  'JVXLNs': 'Generating {text}, please try again later',
  'K2nEHB': 'Guarantee repayment',
  'KGWfZy': 'There is no {text} for the current accounting period',
  'KZIm0Q': 'Download Invoice',
  'LyL2IF': 'After successful download, the billing details file will be sent to your email. Please accurately enter the receiving email.',
  'MI4Snx': 'Bill',
  'MLkOlx': 'Days Overdue',
  'MfytXC': 'No arrears',
  'N2BWAQ': 'Is invoicing done by currency',
  'NLMRo3': 'Please check the file type before clicking OK',
  'O7Eu2j': 'Example',
  'PVWng2': 'Voucher File',
  'Pg9Rpj': '=Remaining Repayment Amount',
  'Q5w/fU': 'Current Repayment Amount',
  'Rxln8B': 'Generating file, please try again later',
  'SNNgc9': 'The range not be greater than 31 days，And can not choose Today',
  'U2D3GT': 'Support payment currency',
  'UIxU1v': 'Overseas Warehouse Bill',
  'VDNJ1O': '-Repaid Amount',
  'VqHQ0G': 'Estimated Total Remaining Amount(USD)',
  'W4h+L/': 'Download',
  'XEpI/L': 'Outstanding',
  'XQVNb1': 'Billing range',
  'biRBp6': 'If you need to customize a billing template (chargeable service), please contact sales or customer service.',
  'cMgr3G': 'Issue invoice',
  'dH6HXW': 'An account with balance but no outstanding balance guarantees the repayment amount to the outstanding account',
  'dgSE4n': 'Export Bill List',
  'e8F20V': 'Choose Yes, one invoice per currency. Select No, only one invoice will be issued for all currencies.',
  'fLrdaK': 'Separate Bill',
  'gATNz6': 'Issue invoice',
  'gCCsj6': 'Statement Of Custom',
  'hT0UeC': 'Global template',
  'hzb2RD': 'The amount to be repaid on this billing statement. =Current expenses - current income+outstanding amounts from previous periods',
  'iiJJ9Q': 'Download Credential File',
  'ilUGfb': 'Guaranteed Amount(USD)',
  'k6WL09': 'Set up receiving email',
  'kpqLgd': 'Please select the billing details (for reference only, actual billing shall prevail)',
  'l7612M': 'Download Billing Details',
  '3xw2pa': '=Current recharge amount (recharge amount - recharge handling fee)+current foreign exchange transfer in - current foreign exchange transfer out',
  'pOpm5W': 'Archive date get exception',
  'pRnE4N': 'There is no voucher file for the current accounting period',
  'qVilOl': 'Tip: Please download the file and decompress it before opening it normally',
  'qkVFdo': '+Current Income',
  'sJ4LRj': 'Custom template',
  'sP9NPq': 'Equal to the ending balance of the previous billing statement',
  'tbHHxh': 'ISP Bill',
  'tyeviX': 'Actually paid off',
  'uM3JdF': 'Self pickup signature file',
  'v5/qhM': 'Bill Status',
  'vkMWl1': 'Download Account Statement',
  'vwIDLR': 'Invoice Address',
  'wEsN/D': ', and will take effect on the next billing day',
  'wkJVRb': 'Billing Day',
  'wngIz/': 'Please select an overseas warehouse billing template, and the change will take effect on the next billing day',
  'xFfCkV': '=Ending Balance',
  'xf4Cok': 'Due to the large amount of billing details, it is expected to take 1-3 hours to complete the download.',
  'xjL8gr': 'The billing template has been changed to',
  'xsgE1x': 'Refers to the total revenue from rebates, business discounts, recalculated refunds, and other expenses in this billing period',
  'HgHOzH': 'Combination',
  'IZLNsL': 'Select Billing Details',
  'JsuXOm': 'Separate',
  'OQMV/1': 'Calculate the repayment amount on and after the current billing date. If payment, rebate, or recalculated refund data are included on or after the current billing date, the amount will continue to be updated until the bill is actually paid off and no longer changes.',
  'l217Ij': 'Please fill in the correct email',
  'kCUOZc': 'Estimated Minimum Outstanding Amount (USD)',
  'Pm2h+6': 'Please select a file type',
  'KRm37t': 'Guarantee repayment refers to using the balance of an account with no outstanding debts to guarantee repayment to the outstanding account, temporarily avoiding overdue bills',
  '/+6Tlk': 'No refund',
  '/Ppy4h': 'Transaction Time',
  '1976aM': 'Gomepay',
  '2Kxmmo': 'Transfer in',
  '2zFaPz': 'Bestpay',
  '30EC+P': 'Application Time',
  '3I0TSX': 'Submit proof',
  '4hcFAe': 'Electronic receipt successfully received',
  '4zuYYE': 'Exchange Purchase Rate',
  '5+bLlU': 'Batch export failed',
  '5vhDlk': 'Payment subject username',
  '6JSgZS': 'Purchase Record Of Foreign Exchange',
  '6K/bMl': 'PayEco Easy Pay-New',
  '8RMxkK': 'Thaw',
  '9h6CQ0': 'Confirm the operation?',
  'AmlBt7': 'Decrease in amount to be credited',
  'C0unZT': 'Payment method',
  'CiDzns': 'Transaction Name',
  'DCknXQ': 'PayEco Easy Pay-Old',
  'EFfAoQ': 'PayEco',
  'EH123B': 'Lakala Pay',
  'Ewl2Oe': 'Received an electronic receipt',
  'GCRkX0': 'Transfer-out Account Name',
  'HRMFFC': 'Payment/Remittance Date',
  'IYQMcP': 'Transfer-in Account Id',
  'IugZez': 'payoneer',
  'JZ/pPr': 'Failure feedback',
  'JjMaCQ': 'FuYou Pay',
  'Maoscw': 'Online payment receipt',
  'NSzPbt': 'Transfer out',
  'OQovFR': 'Document No',
  'Omkcu0': 'Received receipt',
  'OrfTjz': 'Payment Date',
  'P3OAHZ': 'Remittance Date',
  'PczLtN': 'WorldFirst',
  'UQsx/X': 'AIRWALLEX',
  'VCMN8h': 'Deduction',
  'VCcwE6': 'Transfer-out Currency',
  'VGUUOs': 'Refund status',
  'WjALRF': 'Change Payer',
  'XWzXar': 'Transfer-out Account Id',
  'XkQfZs': 'Offline payment receipt',
  'bNGPYA': 'Freeze Or Not',
  'cA1Ws2': 'Transfer-in Account Name',
  'cNbG7k': 'Download electronic receipt',
  'eHCi/8': 'Posting Date',
  'fFCfj0': 'Audit Opinion',
  'fmLMom': 'paypal',
  'gbprFA': 'EBC Pay',
  'gspCjo': 'Increase in amount to be credited',
  'jrDkH0': 'Freeze the amount to be credited',
  'n1BMn0': 'Exchange Purchase Time',
  'nTUBhV': 'Review Notes',
  'olossh': 'Credit Quota',
  'qAYUi5': 'Transfer-in Currency',
  'sgoT1L': 'System credit',
  'tnA6LP': 'Full Refund',
  'v0uPwE': 'Repayment Method',
  'vPm/tD': 'Unfreeze the amount to be credited',
  'yEiEuN': 'Initialization',
  'zkp5Gj': 'The cash balance of the corresponding currency in the current account',
  'cOfpGZ': 'Offline top-up for financial account',
  'sbK/du': 'Partial Refund',
  'tBCWIa': 'Offline top-up collection account',
  '/LN0dz': 'Submit materials of certification',
  '06ydEC': 'Renaming materials issued by industry and commerce/public security organs',
  '0WyKK9': 'Credit Quota Detail',
  '1Be2tl': 'There is no reallocation quota this time!',
  '2XlYQy': 'On-Line-payoneer',
  '2dR8L8': 'Fixed amount long-term adjustment',
  '3BpBXg': 'Add Payer',
  '4usBT3': 'Currency Type',
  '5A94rW': 'First leg temporary quota limits details',
  '6YVRXw': 'The information you submit needs to supplement the hidden part based on the desensitization card number returned by the bank,For example: 6222 * * * * 1314, write and fill in: 622200001314',
  '6c9bAh': 'Payment channel return card number',
  '6iq4+V': 'Payer maintenance',
  '7J3yRf': 'Please complete the anonymous information',
  '7kLsHL': 'Priority setting of currency for automatic purchase and transfer of foreign exchange for ISP accounts',
  '82wYZO': 'Please enter an number from {min} to {max}.',
  '9sWKE8': 'Priority setting of currency for automatic foreign exchange purchase and transfer for overseas warehouse accounts',
  '9xdXiy': 'Support 200 arbitrary characters',
  'ARUtA1': 'Service charge modification',
  'B7sWL9': 'Credit granting processing fee(day)',
  'ByGlnw': 'I confirm that the above information is true and valid, and strictly comply with the relevant provisions of the anti money laundering law of the people \'s Republic of China. At the same time, I agree that after the account is successfully established, my history to be recorded will be transferred to this account wallet. I confirm that I have agreed and know the above contents.',
  'C31gUe': 'Account group quota information',
  'CaL1j5': 'Fixed quota opening',
  'Dk/nSd': 'Customer available status',
  'DnvIjJ': 'The bill is overdue and suspended',
  'EP3hY+': 'Winit account',
  'FN2KJv': 'Temporary quota expires',
  'Gl93ta': 'Business Registration Certificate',
  'GyK2ns': 'Credit account ID',
  'HTyEWD': 'Water Bill Attachment',
  'I5P0tH': 'Adjustment value(USD)',
  'JUra4d': 'expire',
  'JnSTBq': 'Is Temp Quota',
  'K2AUa1': 'Total quota',
  'KYUIZR': 'Bills paid off',
  'LSMhE9': 'Overdue fees(day)',
  'LVcITT': '-Used quota',
  'MTRndr': 'Original Order Information',
  'MXGoMs': 'Quota ratio',
  'N+aVj3': 'Personalized setting',
  'P0+Vn4': 'Existing quota',
  'R/khAR': 'Type of proof material',
  'SCtQJF': 'Deferred repayment',
  'SWt3dI': 'Temporary quota expiration time',
  'T8zx3Y': 'Registered Payer (English)',
  'UH1oUV': 'Offline-transfer payment',
  'UpsVgV': 'Quota currency',
  'Uz5q4D': 'Total quota information',
  'UzfgD8': 'Only show the credit change information after 2018.03.22',
  'VZcKf/': 'Enabled',
  'WDhkia': 'If the current subject has not registered a sub-account, please go to register a sub-account first, and submit the relationship certificate after the sub-account verification is passed!',
  'XNwxfY': 'On-Line-paypal',
  'Xv6Zt3': 'Temporary adjustment of fixed quota has expired',
  'XvglP0': 'Credit account name',
  'ZbuQhO': 'Automatic system recovery',
  'aCHUPv': 'Submit proof of relationship',
  'aKhgRz': 'Temporary adjustment of fixed quota',
  'ahpaj8': 'Account group',
  'aoySH5': 'The bill is overdue and suspended',
  'c+HGJC': 'Repayment Priority',
  'c8pyCO': 'Credit effective time',
  'cRkUwN': 'Overdue bill',
  'e2EuFU': 'Screenshot of payment channel account information',
  'exDDgb': 'Reset after adjustment',
  'f9UHPd': 'Full name',
  'fP/5jz': 'Original Payment Record',
  'fhs4vd': 'Quota sharing',
  'fxBfjX': 'Signed',
  'g0Ks/u': 'The sum of the re-allocated sub-account quota has exceeded the total quota, and submission is not allowed!',
  'hh028b': 'Not signed',
  'hjFT+i': 'Sub-account signing',
  'jryv+i': 'Disabled',
  'ldrfDm': 'Fixed quota expires',
  'mWrcQ+': 'Actual Information',
  'ms8jKv': 'Adjusted temporary quota limit(USD)',
  'mx4b6E': 'Quota expiration date',
  'p6R2U5': 'Temporary quota effective time',
  'pmdXFO': 'Registered Payer (Chinese)',
  'pxlLW/': 'Provisional quota opening',
  'qoUX1p': 'The fixed amount long-term adjustment has expired',
  'sLaJS7': 'Payment Channel',
  'sxulyn': 'Reallocate quota',
  't9Zbku': 'Register Payment account',
  'vFLRB0': 'Sub-account quota agreement sign status',
  'vePxOp': 'Normal',
  'vrGnEX': 'Anonymous information filling verification',
  'w6ND0+': 'Supplementary verification payer information',
  'wzdVDX': 'Review time',
  'x/gO31': 'Master-child relationship proof status',
  'xSPqpc': 'The information you submit needs to supplement the hidden part on the basis of the desensitization name returned by the bank,For example, 张* can fill in: 张三, but not: 李四',
  'xWutar': 'Whether it can be allocated',
  'xqOuVQ': 'automatic foreign exchange purchase and transfer currency priority',
  'yTqIuo': 'Credit expire time',
  'yqSzWz': 'Quota effective date',
  'zYHOkU': 'Full Card NO',
  'zcNWAZ': 'Actual Payer (Chinese)',
  'zmRPq1': '=Remaining quota',
  '/KdHB0': 'Please select the actual payer',
  '9cS3L3': 'Import only supports jpg, jpeg, png, pdf, file size less than 5M',
  '3YpJS6': 'Upload materials',
  'BEAP5q': 'Please upload the materials!',
  'GOarWl': 'Please enter your full name',
  'MJttIP': 'main',
  'UKRYgR': 'The file size needs to be less than 5M',
  'lcVvbr': 'Please enter the complete card number',
  'r/V4bn': 'Proof materials that are consistent with the subject can only upload up to five files, and the ID photos must be clear, complete, and non reflective',
  '07XnFn': 'Transfer Payment',
  '4168zc': 'Overseas warehouse freeze transaction details',
  '9Y//gQ': 'Effective time of guaranteed repayment amount',
  'F2CUgO': 'Offline',
  'K6sGHx': 'Channel',
  'OrTfWA': 'On-Line',
  'ZT1qr1': 'Tips{break} 1. If you need to search and export historical data from 12 months ago, pls contact our staff.',
  'ZWTiom': 'Fulfillment Quota',
  'Zr9Dss': 'Lose',
  'b2xoKS': 'Account ID',
  'bE8OQ2': 'After redistribution, the quota left to the master account cannot be less than the used quota of the master account!',
  'kqFivl': 'Details of guaranteed repayment amount',
  'lDtEGy': 'Payoneer',
  'osNaFE': 'FuYou Easy Pay',
  'sfnAcf': 'Add',
  'y6RlMb': 'PayEco Easy Pay',
  'E8ZNSd': 'Quota auto adjustment',
  'VPky+K': 'No credit',
  'XA24ZP': 'Quota adjustment',
  'nzAb/p': 'Basic credit',
  '0+2kI2': 'PayPal, Airwallex, and Fuyou credit cards exceeding 90 days and offline transfer channels will be refunded based on the received amount, and the original payment handling fee will not be refunded;Refunds made online by Fuyou for more than 90 days, refunds made online by Yilian for more than 350 days, and refunds made through offline transfer. Any additional refund handling fees incurred will be deducted based on the actual expenses incurred. Other online channels will receive a full refund.',
  '32FSGv': 'The amount will be used as a deposit within',
  'JY6Tha': '（Drag to change sorting）',
  'g2OLbW': 'Explanation of refund fees to be credited:',
  'tAmjwH': 'Remarks: ',
  '/pYzfM': '1. System will generate fulfillment bill automatically on 1st of each month,and generate ISP bill on Monday per week. If there are bills generated after the above dates, pls contact our staff.{break} 2. If you need to download historical bills before 2021.12.31, pls contact our staff.{break} 3. System only offer e-invoices for the bill generated after 31th, Jul,2017, and theres no manual invoice provided. For the customized bill and bills before 31th, Jul,2017, we dont offer e-invoice, contact Winit Corporation Online Customer Service if needed.{break} 4. If you need to generate a custom bill from three months ago, pls contact our staff.{break} 5. 2018-02-04 After the upgrade "current expenses" is divided into "current expenditure" and "current income." 2018-02-04 The "current costs" of previous bills are shown only in the "current expenditures" column.{break} 6. Only bills generated after June 2023 support downloading billing details.Only supports downloading billing details for the past 6 months. If you need to export data from 12 months ago, please contact online customer service.',
  'yI753E': 'Situation description',
  'L3hqUI': 'Do you want to enable this configuration now?',
  'T65PYY': '{text}expired',
  'Yh7u3v': 'Intelligent recommendation ordering refers to the system automatically calculating the optimal shipping solution (combination of warehouse and delivery method) based on the buyer\'s address, delivery method, overseas warehouse inventory, and configured shipping strategy when a customer places an order, and then automatically shipping according to the optimal solution.{break} Note: {break} - - If the order is a package order, it supports recommended shipping warehouses and delivery methods, but does not support splitting to multiple warehouses for shipping{break} - - If the order source is "platform synchronization" and the e-commerce platform is "AliExpress" or "TIkTok",it supports  recommended shipping warehouses and delivery methods, nor does it support splitting shipments to multiple warehouses{break} - - If the customer specifies a batch of goods when placing an order, it does not support recommending the shipping warehouse and delivery method, nor does it support splitting the shipment to multiple warehouses货{break} - - If the recipient type of the order is "FBA warehouse to VC order" or "FBA warehouse to non VC order", it supports recommended shipping warehouses and delivery methods, but does not support splitting to multiple warehouses for shipping{break} - - If the order includes value-added services that do not allow splitting, it supports recommending shipping warehouses and delivery methods, but does not support splitting to multiple warehouses for shipping{break} - - The pre-sale order has no inventory in stock and does not support recommended warehouses and product shipments{break}',
  '3Y7klw': 'Error message',
  'EP+LXH': 'Multiple order numbers need to be separated by line breaks or commas. A maximum of {num} numbers are supported. Double-click to switch to a single query.',
  'aqlBZQ': '(Preparing for delivery：The delivery will be arranged according to the service prescription. Please wait patiently.)',
  'z6C48a': 'Multiple courier numbers need to be separated by line breaks or commas or semicolons.',
  'vtc2Bz': 'You have not selected a product group. Please select at least one record before saving.',
  'H3MIdb': 'Data has been exported. Please go to Bill of Custom to download the data. It may take some time if the data volume is large..',
  'bv8fp+': 'Batch export transaction details',
  'yg+WfY': 'No data',
  'DeRAMA': '1. Only the payment order system that was payed successfully after 2017.01.01 will provide electronic receipts and will no longer provide manual receipts. Historical payment orders prior to 2017.01.01 do not support electronic receipts. If you need to get a receipt, please contact Winit sales representative.{break} 2. Offline payment orders usually take 1~3 business days to be credited.{break} 3. Due to regulatory requirements, the amount to be credited will be automatically refunded on the 12 day after payment and returned to the original way. Please ensure that the corresponding account has sufficient balance for deduction, otherwise it will affect the order ！{break} 4. Description of refunding service charge on waiting for posting: Paypal,Airwallex,Fuyou credit card for more than 90 days and offline transfer channels will refund according to the amount received, and the original payment service charge will not be refunded; Refunds over 90 days on FuYou Easy Pay, over 350 days on PayEco Easy Pay, and offline transfer refunds. The additional refund fees will be deducted according to the actual expenses incurred. Please refer to the actual amount received; Other online channels will be refunded in full.',
  'Rel6LS': '1. To query and export historical data for the past 12 months, please contact our online customer service. ',
  'drKhD7': '1. If you need to search and export historical data from 12 months ago, pls contact our staff.{break} 2. Credit fee, overdue fee, the minimum charge amount in currency CNY/HKD is 0.1, and the minimum charge amount in currency GBP/EUR/AUD/USD/CAD is 0.01.',
  'nVnqxu': '1. The priority of the currency to be transferred out for auto foreign exchange purchasing can be set. In case of the ending balances of multiple currencies are ＞0 during repaying via auto foreign exchange purchasing, such priority will be adopted to repay the debts in other currencies automatically. {break} 2. The debts will be repaid via the amount transferred in as per the amount in the original currency from large to small.{break} 3. Purchase foreign exchange time, pre-charge account, automatic purchase of foreign exchange every morning; quota account, automatic purchase foreign exchange of the morning after the last repayment date of the bill.{break} 4. The minimum transfer amount of currency CNY/HKD is 0.1, and the minimum transfer amount of currency GBP/EUR/AUD/USD/CAD is 0.01.',
  '8ScwNO': 'If you need to search and export historical data from 12 months ago, pls contact our staff.',
  'aRdrxL': '1. When making payment, if the user name of the payment subject returned by the payment channel is inconsistent with the name of the WinIT account that accepts the payment, the payment amount will be deferred to the account.{break} 2. Please upload relevant materials according to the prompts within 12 Days to prove that the payment subject and the WinIT account accepting the payment are the same subject. Overdue payment will be returned to the original way.',
  'eocwkf': 'Please click to upload the file',
  '2BWMJO': 'Staff',
  '5gvduE': 'Enterprise certification information/company annual report (scanned copy/photocopy/photo/screenshot are acceptable)',
  '7q44jI': 'Household registration book/marriage certificate (scanned copy/photocopy/photograph are acceptable)',
  '7wqEOF': 'The same month',
  '8C681+': 'I have read and agree',
  '9NStpL': 'Proof of Relationship - Friends & Non-immediate Relatives (Signatures from both parties)',
  'Dvsk2S': 'Proof of relationship - the same group or actual controller (both sides tap the official seal)',
  'FTcmHB': 'Next month',
  'GKmXYb': 'Next week',
  'IDhXnO': 'Please check',
  'K6KFx2': 'Accept',
  'TRJ2m9': 'Belong to the same group or the same ultimate controller',
  'bO/2Dn': 'Monday of every week',
  'iW2zML': 'Immediate family members (spouse, parents, children)',
  'ijzBKx': 'The 1st and 16th of each month',
  'kEnOJX': 'The third week',
  'ljo7wL': '1st of every month',
  'lz37HI': 'friend or non-immediate family member',
  'mb1NTL': 'The fourth week',
  'qbyohT': 'Quota Agreement Signing',
  'tAGBJe': 'Social security certificate/labor contract (scanned copy/photocopy/photo/screenshot are acceptable)',
  'vAuGZ8': 'The second week',
  '/6gyil': 'Reset to default',
  '8TJtfD': 'Download attachments',
  'QxCYIy': 'The default sequence of fulfillment accounts for foreign exchange purchasing is as follows: USD → CNY → HKD → GBP → EUR → AUD. For example, if the ending balance in USD and CNY is ＞0, the debts in other currencies will be repaid via auto foreign exchange purchasing in USD, and the debts not paid off will be repaid via foreign exchange purchasing in CNY continuously. ',
  'WnGw42': 'There are no billing details in the current bill',
  'iyWSE7': 'I have read and agree to the',
  'n1Vx1f': 'The information you submitted is inconsistent with the information returned by the bank. For example, 张* can fill in: 张三, but not: 李四.',
  'qEIdoZ': 'Agreement on Quota Granting',
  'v/il0E': 'Guarantee Agreement',
  'KofsN/': 'Shareholder\\Legal person\\Director',
  'G85A7S': '1. If the name of the payer does not match the registered name of our company, a refund will be automatically initiated on the 12th day.To avoid affecting your order, please use the same entity name for payment.{break} 2. Explanation of refund fees to be credited{break} <a2>PayPal, Airwallex, and Fuyou credit cards exceeding 90 days and offline transfer channels will be refunded based on the received amount, and the original payment handling fee will not be refunded; Other online channels will receive a full refund.</a2> <a2>Refunds over 90 days on FuYou Easy Pay, over 350 days on PayEco Easy Pay, and offline transfer refunds. The additional refund fees will be deducted according to the actual expenses incurred. Please refer to the actual amount received;</a2> 3. Our company resolutely implements the relevant provisions of the "Anti-Money Laundering Law of the People\'s Republic of China". If a refund is required after payment, it will be returned by the original path of the payment channel. Our company is obliged to report suspected acts of money laundering and false transactions to relevant departments and assist public security organs in providing evidence.{break} 4. Click to view payment instructions <a1>Payment instructions></a1>{break} 5. If your main account subject cannot make payments, please directly change the main account subject without registering a sub account. {break}',
  'nEoXwk': '1. Offline payment orders usually take 1~3 business days to be credited.If you need to use the payment amount urgently, please use the online payment.{break} 2. If the name of the payer does not match the registered name of our company, a refund will be automatically initiated on the 12th day.To avoid affecting your order, please use the same entity name for payment.{break} 3. Explanation of refund fees to be credited:{break} <a2>PayPal, Airwallex, and Fuyou credit cards exceeding 90 days and offline transfer channels will be refunded based on the received amount, and the original payment handling fee will not be refunded; Other online channels will receive a full refund.</a2> <a2>Refunds over 90 days on FuYou Easy Pay, over 350 days on PayEco Easy Pay, and offline transfer refunds. The additional refund fees will be deducted according to the actual expenses incurred. Please refer to the actual amount received;</a2> 4. Click to view payment instructions <a1>Payment instructions></a1>{break} 5. If your main account subject cannot make payments, please directly change the main account subject without registering a sub account.{break}',
  'v2HOxg': '1. In the same account, support different currencies to convert to each other, not support the conversion of the same currency.{break} 2. Between different accounts, support the conversion of any currency.{break} 3. The minimum transfer amount of currency CNY/HKD is 0.1, and the minimum transfer amount of currency GBP/EUR/AUD/USD/CAD is 0.01.',
  'Rg50kB': 'The default sequence of ISP accounts for foreign exchange purchasing is as follows: CNY → HKD → USD → GBP → EUR → AUD.',
  'K/XBN5': '1.Support custom customer name format and custom invoice address;{break} 2.Support for custom payment accounts;{break} 3.The generated electronic invoice does not support changing the customer name and address again.{break}',
  'qZjKi5': 'Support custom customer name format, invoice address, and payment account',
  '/HG2Ex': 'Add SKU',
  '5qxgHV': 'Please select the SKU to add',
  '8N9CHd': 'Strategy priority: Custom strategy > Global strategy',
  '97Ezg6': 'Set sales reference period',
  '9jy52o': 'Strategy type',
  'EhpZRc': 'Add SKU to 【{name}】 strategy',
  'EwSqIq': 'The SKU in the strategy will be automatically cleared after expiration. Are you sure you want to expire it?',
  'G12/1D': 'Support up to 500 SKU codes',
  'GsiqV5': 'View all {num}',
  'H2OXqK': 'Recommended settings: For single products, use the sales data from the past 4 weeks; for bundled products, use the data from the past 6 weeks; for boxed products, use the data from the past 8 weeks.',
  'Hxs6Qn': 'List',
  'IUpc6p': 'Click to go to',
  'JLuSaS': 'Add automatic zeroing strategy',
  'K5qzOu': 'Global strategy',
  'LS1Plr': 'Shared inventory automatic zeroing strategy',
  'LU1GKG': 'The associated strategy warehouse of the SKU overlaps with the current strategy warehouse, so it cannot be added',
  'MHg1rP': 'Edit successful',
  'MWfQTj': 'Global strategy cannot be expired',
  'MjhYfS': 'The strategy has expired and cannot add SKU',
  'Mxj3rv': 'Select the average weekly sales volume in the past X weeks',
  'NxN2H3': 'Add strategy',
  'PGRHGF': 'Removal successful',
  'PMcYxK': 'SKUs in the strategy',
  'VJaooL': 'Set shared inventory automatic zeroing strategy',
  'We/I3N': 'No SKU added',
  'Wf1RuS': 'Are you sure it will take effect?',
  'X/lLj9': 'Associated strategy',
  'cjZbLG': 'In the recommended setting scenario, if the average weekly sales volume of a single product in the past 4 weeks is 100 units/week, the average weekly sales volume of bundled products in the past 6 weeks is 5 sets/week, and the average weekly sales volume of boxed products in the past 8 weeks is 2 boxes/week; then when the available inventory of a single product is less than 100 units per week and the available inventory of bundled products or boxed products exceeds 5 sets or 2 boxes, the system will automatically trigger the splitting of bundled products or boxed products to ensure that the available inventory of single products for the next week is at least 100 units.',
  'cz1Je0': 'Please enter Chinese, letters, or numbers',
  'd9QEcp': 'Applicable warehouse',
  'e6JvoK': 'Strategy name',
  'fMbkSR': 'There are unfinished Inbound orders or inventory, and switching to shared inventory is not allowed!',
  'lYOl5J': 'SKUs in the 【{name}】 strategy',
  'lfSY4h': 'Invalid successfully',
  'nel6io': 'This strategy is to avoid the impact on the order processing efficiency caused by unpacking due to insufficient inventory of single products in the outbound process. Winit will adjust the inventory in advance based on the automatic zeroing strategy!',
  'nxeBGd': 'Example:',
  'pfdh/O': 'Added successfully',
  'sIBroV': 'Edit automatic zeroing strategy',
  'u9m/ZU': 'Note: Statistics are based on standard outbound orders and self-pickup orders, excluding abnormal outbound data such as transfers and destructions',
  'vzfWmX': 'Effective successfully',
  'wx/TF7': 'Are you sure it is invalid?',
  'ySdsnX': 'Please select the items to remove',
  'zqbS5z': 'Valid',
  '2gRKLj': 'This account is currently not configured with a global strategy for automatically breaking down shared inventory. In order to not affect the efficiency of subsequent order shipments, please configure the global strategy for automatically breaking down shared inventory before registering shared inventory box products or suite products! {a} configure',
  '4heyxi': 'You have not signed {name}.The first-leg type cannot be selected as direct shipment by the seller.<url>Please click the link to sign!</url>',
  'dnCZn1': 'You have not signed {name}, and inspection type cannot be selected as self-inspection by the customer.<url>Please click the link to sign!</url>',
  'BDNpYQ': 'No, packing while inspecting (inspection method: new self-inspection)',
  'ROVd94': 'Yes, pending inspection (inspection method: old self-inspection)',
  'TImPz+': '【Yes, pending inspection (inspection method: old self-inspection)】：the packing list information has been determined, and the complete binding relationship between the package and the product has been entered during the order placement process. {break}【No, packing while inspecting (inspection method: new self-inspection)】：The packing list information is not determined. Only the product information is filled in when placing the order. During the inspection, the APP is used on-site to bind the relationship between the product and the package. ',
  'MB2LgI': 'Please select an address first!',
  'VuUe2t': 'Please select an ISP billing template, and the change will take effect on the next billing day',
  'fijT/3': 'The length, width and height of a single product A+ package or box product do not need to be filled in, and the system will default to the verified size or registered size of the corresponding product; if the length, width and height are filled in, the system will take the filled information as the basis. The length, width and height information of a single product A/B/C package is a required item.',
  '+ON0XV': 'Volume',
  '2ud0Ps': 'Registered volume{unit}',
  '3Sf2xZ': 'After deleting specification, please only enter the sku code (specification is not required) when using it, confirm to delete?',
  '8nvAOf': 'Only published SKUs with specifications can batch delete specifications',
  'LI0QcI': 'Verify volume{unit}',
  'Mit5WO': 'Only published SKUs can be invalidated',
  'ZjVhvB': 'Import Tariff Rate',
  'aiBGBs': 'Delete successful',
  'bgMh+d': 'After deleting specification, please only enter the sku code (specification is not required) when using these, confirm to delete?',
  'fyQGOQ': 'Batch deletion of specifications',
  'lZO/p4': 'SKU [{code}] has information pending for review, and is not allowed to be invalidated for the time being!',
  'qgAEcy': 'The existing draft or review returned information of SKU [{code}] will be deleted simultaneously. Do you confirm the invalidation?',
  'y/WY+Q': 'Delete Specification',
  '0/JiLr': 'Cancel cause',
  '0IvHRh': 'Business document number',
  '4Mjvd8': 'Batch No',
  '4eHs8/': 'Viewing batch information',
  '4uRbsZ': 'Batch Date',
  '7uzUWe': 'VAS description',
  '8L1Vo2': 'Length（CM）',
  '96Mzoq': 'Completed',
  'AmjYIb': 'Partial completion/return reason',
  'DUdram': 'Tracking Information',
  'E+q8Ix': 'Fee',
  'E64+fz': 'Service requirements',
  'LRFh5P': 'Parcel infor',
  'U17oU+': 'Trajectory',
  'fRZHbx': 'Width（CM）',
  'foMY4M': 'Value-added invoice number',
  'l0mW6t': 'Latest update time',
  'myoSWy': 'Volume（CBM）',
  'n0ENBy': 'Cancel successfully',
  'rv/Usx': 'Value-added service name',
  'sp7nZt': 'Height（CM）',
  't223jZ': 'Completion time',
  'tBRn1O': 'Value-added service code',
  'uV7dt+': 'Service efficiency',
  've8HCy': 'Weight（KG）',
  'z0iqAA': 'Value-added product',

  '0G9X0v': 'Number of goods to be picked up',
  '0hxzxw': 'View abnormal pictures',
  '1I0n5S': 'New product specifications',
  '1sIR79': 'Pickup voucher',
  '356QM5': 'View value-added details',
  '4MHR84': 'New single product barcode',
  '5FbBko': 'Abnormal object',
  '67aNgO': 'New package barcode',
  '7je90N': 'New product code',
  '85WD1d': 'Standard number of new product inventory units',
  '92ekDt': 'Value-added results',
  'En+SYV': 'Abnormal termination',
  'Fp8Tez': 'Processing',
  'GBUVRa': 'New product SKU type',
  'GuCNNs': 'Actual packaging material',
  'HUsRbx': 'Container information',
  'JTcOXu': 'X/Y, X represents the number of value-added orders issued, and Y represents the actual number of completed items',
  'K7fvln': 'New third-party product barcode',
  'KB9hTa': 'New third-party package barcode',
  'LltneG': 'New third-party single product barcode',
  'Pnfg9a': 'Change product packaging quantity',
  'QaDES9': 'New inventory order number',
  'QbqTeH': 'Shelf method',
  'QoasKf': 'Standard number of inventory',
  'RjHfgY': 'Quantity of goods to be picked up',
  'SS6m7z': 'Pending self-pickup',
  'YlP2qM': 'Cancellation time',
  'b0ZfpV': 'All orders',
  'd/Js41': 'New product barcode',
  'hdZRSS': 'Quantity of product identification',
  'iGo2n+': 'Quantity of labels',
  'lGy6FF': 'Reason for cancellation failure',
  'pHN8Vk': 'Quantity of destroyed packages',
  'sNXLd2': 'Third-party single product barcode',
  'IqSvUm': 'Estimated time of completion（local）',
  'RsyScM': 'Canceling',
  '/lOLnU': 'Supporting battery or pure battery',
  '08x8yY': 'Category',
  '3LDpVN': 'Are you sure you want to abandon updating these product information?',
  '6a7FnP': 'Abandon update',
  '8qMa5b': 'Are you sure you want to abandon updating this SKU information?',
  '9N69Wd': 'UK',
  'KY1hUt': ', If you have any questions about the audit results, please provide explanations and resubmit!',
  'S+maKB': 'DE',
  'TKMdbN': 'The types of certificate data required for product categories are as follows, subject to the audit results:',
  'c+Tzsj': 'Cosmetics',
  'czdURM': 'US&AU',
  'gJpxi9': 'ALL',
  'inZ2fY': 'US',
  'jSrT6A': 'Chemicals',
  'qlcOmV': 'Bulk abandon update',
  'vzV/vh': 'German AC products',
  '3ShLsH': '1. MSDS + transport identification report issued by the factory; or MSDS issued by the testing company, product images',
  'C2Lc0y': '1. MSDS + transport identification report issued by the factory; or MSDS issued by the testing company; 2. CPNP registration + product images',
  'Hc/VCq': 'FDA registration information, product images',
  'UBGvU5': 'MSDS and product images issued by the testing company',
  'YYUhWG': 'EMC test report, LVD test report, ROHS test report, German manual, product images',
  'bIygCY': '1. MSDS + transport identification report issued by the factory; or MSDS issued by the testing company; 2. SCPN registration + product images',
  'qxXnHH': 'MSDS, UN38.3 test report, product images',
  '5WtgqL': 'Actual number of loose boxes',
  '77ijwJ': 'Actual number of pallets',
  'ge0k/G': 'Are all pallets packed',
  '8glgCt': 'This winit warehousing product does not require {field}, and the original customs declaration method has been cleared by default. ',
  'SnK9qH': 'import customs declaration',
  'WEOLvF': 'export customs declaration',
  'fKCBMw': 'import/export customs declaration',
  '6SHbN1': 'Type of importer/exporter',
  'QBmXie': '<bold>IMPORTANT NOTICE TO MERCHANTS USING WINIT’S AUSTRALIAN WAREHOUSES</bold>{break}{break}1.This is an IMPORTANT NOTICE AND UPDATE for merchants sending goods to Winit’s Australian warehouses in Sydney and Melbourne. Failure to understand and comply with Australian trade and customs law may result in your goods being seized by Australian Border Force (ABF) officials, you being liable to pay the applicable duties and goods and services tax (GST) and potentially you being subject to financial penalties. By placing an inbound order, you acknowledge that you have read and understood this notice and will ensure that you comply with Australian trade and customs law.{break}{break}<bold>MERCHANT’S RESPONSIBILITY</bold> {break}2.As provided in Winit’s Supply Chain Management Service Agreement (Service Agreement) and User Manual, when importing goods into Australia, it is the responsibility of the merchant to: {break}(a)\accurately complete and lodge the relevant Import Declaration or Self-Assessed Clearance Declaration (Import Documents);{break}(b)declare the true and correct value of the goods in the Import Documents; and{break}(c)pay the applicable Australian duty and taxes in relation to the goods.  {break}{break}<bold>MERCHANTS UNDERVALUING GOODS IN IMPORT DOCUMENTS</bold>{break}3.Winit is aware that ABF is investigating and taking action in relation to the undervaluation of goods imported into Australia in merchant’s declarations, and therefore the under-payment, or non-payment of applicable duties and GST (Duty and Tax Avoidance Conduct). {break}4.ABF has detected instances of merchants using e-commerce fulfilment centres such as Winit’s warehouses in Australia, to engage in the Duty and Tax Avoidance Conduct, particularly in instances where merchants use the Self-Assessed Clearance Declaration for goods valued at less than AU$1,000. ABF is actively monitoring goods sent by merchants to Winit’s Australian warehouses to detect the Duty and Tax Avoidance Conduct.{break}5.The Duty and Tax Avoidance Conduct is illegal and can result in:{break}(a)the goods being seized at the Australian border by ABF;{break}(b)future goods imported by the merchant being detained at the Australian border by ABF; and{break}(c)ABF issuing a demand to you, or taking other steps, in relation to any unpaid or underpaid duty and GST, and possibly you being liable for financial penalties. {break}6.If ABF informs Winit that merchants have engaged in Duty and Tax Avoidance Conduct, Winit may refuse to accept delivery of goods from the merchant and may close the merchant’s account.  {break}{break}<bold>DOCUMENT RETENTION</bold> {break}7.Under Australian trade and customs law, any person who imports goods into Australia must retain copies of all commercial documents that come into that person’s possession relating to the goods imported or their carriage to Australia for a period of five years following the import. ABF can request production of these documents and if a person fails to comply with ABF’s request, they may be liable to a financial penalty .{break}8.The commercial documents retained must include documents substantiating the value of the goods imported and the declarations made in the Import Documents.{break}9.To assist their compliance with Australian trade and customs law, most importers use a system of scanning and storing the commercial documents electronically, with a specific file maintained for each individual item imported into Australia. {break}{break}<bold>ENGAGE A LICENSED CUSTOMS BROKER</bold> {break}10.As set out in the Service Agreement and User Manual, Winit does not arrange customs clearance of goods into Australia. Merchants should engage a licensed customs broker to assist them when importing goods into Australia to ensure that merchants comply with Australian trade and customs law. A list of licensed customs brokers in Australia can be found here: https://www.abf.gov.au/licensing/brokers/brokerages.{break}11.As provided in the Service Agreement and the User Manual, Winit is not, and must not be listed as, the ‘importer’ or the ‘consignee’ of the goods in any Import Documents. A licensed customs broker can assist merchants to accurately complete the Import Documents. Failure to accurately and correctly complete the Import Documents may result the consequences set out in paragraph 5 above.',
  'kkSJOW': 'Overseas local customs clearance: outbound order value-added customs clearance purpose; first-leg customs clearance: inbound order first-leg customs clearance purpose',
  'CXgGuD': 'The imported country/region [{country}] has pending data for review, and does not support updating the exporting country!',
  'YDqiDF': 'When the exporting country/region is the United States, only the United States can be selected as the importing country/region.',
  'U76H/p': 'Product editing, United States is not allowed to be selected as the importing country/region.',
  'l98JzC': 'Not agree',
  'q/ghwH': 'Confirm',
  'dbqk8C': 'System notification',
  '4vbg3w': 'Product registration failed',
  'TrLI6T': 'Reasons for Inbound prohibited :',
  'c8JvVZ': 'Reasons for direct shipment only :',
  'cwEnUp': 'Return Reasons :',
  'sEWD9z': 'Product submission failed',
  'NzT9mX': 'Submission failed',
  '+DQSwD': 'Single order outbound packaging method',
  '+Ex1Ub': 'Upload order',
  '+MCCzw': 'Initiate Return',
  '+nHJ/w': 'Cost savings',
  '/Cq3eP': 'Platform Order No',
  '/dU+JR': 'On-Time',
  '1+N/2B': 'Upload label file correspondence',
  '1/ktAg': 'Upload BOL',
  '1ES4Cj': 'Discount',
  '1IlqrQ': 'Default palletizing standard',
  '1ZZ4wT': 'Delivery Failed',//派送失败
  '1dw1ka': 'Upload package label',
  '2AuwQx': 'Outbound Order No.',
  '2EGeQe': 'The order number is allowed to repeat',
  '2zxhhz': 'Return manual destruction',
  '3I/ms8': 'Address Correct',
  '4/kwLe': 'Batch Cancel',
  '434sTE': 'View standard instructions',
  '47Gtdd': 'Example image',
  '4w2WuG': 'Winit Tracking No.',
  '50IN3Z': 'You need to download the template file and fill in the relationship between the commodity code and the third-party code.',
  '65FwA5': 'Return Information',
  '6aJQnL': 'Operation method',
  '6hkcCU': 'There are differences in commodity of European Authorized Representative labels are all the samelabels',
  '6vtXkE': 'There are differences in commodity of English Authorized Representative labels are all the samelabels',
  '773k6g': 'The original ordering programs',
  '7B6nt3': 'Value-added services in the warehouse',
  '7cPWC5': 'Reason modification',
  '7jzaZI': 'length width height(cm)',
  '7lKqi+': 'The labels of English Authorized Representative are all the same',
  '8J8XY/': 'Distributor',
  '8hMZxs': 'Material collection',
  '8rR3Jg': 'Carrier',
  '8wDxhI': 'Packaging specification',
  '9ptMBm': 'WINIT package barcode',
  'B2Cv/r': 'Designated SKU group palletizing standard',
  'B5ATQM': 'The label files are different',
  'B5nx/K': 'Attach package labels',
  'BHFoDf': 'Upload multiple files and provide correspondence with packages',
  'Byb5tg': 'Upload multiple files and provide mappings to labels',
  'C09zE5': 'Delivery Status',
  'CMfUc1': 'RMA No.',
  'D0wNcl': 'Order with an address verification failure may cause the delivery to fail, and DHL will be charged an additional fee. We recommend correcting the address before submitting order.',
  'D2yFUI': 'Platform SKU ID',
  'D3cmbL': 'Order warehouse',
  'DYSv18': 'Download packing details',
  'Dnvmrb': 'According to your order information, no customs clearance transportation method was matched. Please contact customer service to report the problem.',
  'Drd4Cm': 'SKUs without a designated group palletizing standard will default to this standard for palletizing.',
  'DshrUk': 'Upload UK Authorized Representative information',
  'EIMaiD': 'Import Backstage',
  'EoGXO0': 'Inventory Type',
  'EzuXw/': 'Item ID',
  'FVDTCu': 'Upload EU Authorized Representative information',
  'G/EhYP': 'Recommended ordering programs',
  'GpT0/r': 'Distribution Platform',
  'H2Ir0k': 'You need to upload each package label to post packages. Please download template after uploading packages and enter sheet file name corresponding to each package in template!',
  'HODeyW': 'Note：The insured amount indicates the amount insured against the specific declared value goods. As example if the insured amount is 100 RMB, the declared value of the goods is 100 RMB.',
  'HPuNoQ': 'Result',
  'IlMZBb': 'Upload sheet',
  'IpEZ8l': 'Total',
  'IwvlMe': 'Pre-sale Status',
  'J0D5h+': 'Date From',
  'JIUNqP': 'Registered company name',
  'JRKRJu': 'Download packing details template',
  'JiY83H': 'When the consignee type of the current order does not allow over-pallet, selecting allow over-pallet is not supported.',
  'KAnh4T': 'Import draft order number',
  'KW8qOm': 'Select template',
  'LWJl4z': 'The SKU of the current order has a preset group palletizing standard, and the warehouse will palletize according to the preset standard.',
  'Lfctnu': 'You need to download template and enter relation between goods code and UK Authorized Representative label.',
  'MZImmT': 'The first number of parcel label',
  'MuoKTV': 'ASN tag number',
  'Nde41V': 'Valid DE Address',
  'O635R5': 'Tracking No. Upload Status',
  'OOnFav': 'Company Add',
  'OVPYND': 'Rejected',
  'OgVdYL': '12 digits and above (only numbers or letters)',
  'OinASF': 'Place OutBound Orders',
  'OmRJNz': 'Standard outbound - normal template (import draft order number)',
  'OtBOYx': 'Pallet dimensions requirements',
  'PrLo66': 'Allow over-pallet',
  'Q/v5qb': '【Upload file.】Please upload a single label file that can be directly printed, avoiding placing multiple barcodes in the same file. The uploaded file should be suitable for directly pasting on a single item/package label.',
  'Q4u6Eq': 'City',
  'Q6JH65': 'Voided',
  'Qqgk1C': 'Arrive Plan Datetime',
  'RR2OQ+': 'Note：The insured amount indicates the amount insured against the specific declared value goods. As example if the insured amount is 100 USD, the declared value of the goods is 100 USD.',
  'RSe9dd': 'The maximum order amount is taken from the maximum available balance in the account whose consumption country is the country of warehouse or ALL. If you have any questions, please ask customer service.',
  'RfJMgc': 'Automatic destruction of bad debt customer',
  'RyXQqJ': 'Upload time',
  'SOKtWI': 'rebate',
  'ThdPvz': 'Upload pallet label',
  'UIunAN': 'Total',
  'USh36q': 'The outbound order has not yet uploaded the tracking number',
  'UV/rmz': 'Download the template file and fill in the relationship between the commodity code and UPC code.',
  'UWp5me': 'Suggestion Address',
  'UhA9nk': 'Package label number',
  'VjGXk1': 'Upload label code',
  'VwfsyG': 'Service Name',
  'WffqIr': 'Invalid VAT frozen inventory self pickup',
  'WpEGiG': 'Assigned',
  'WpcKmi': 'View the generated file',
  'XCM1oC': 'All ASN tags are the same to upload one file',
  'YAhd/V': 'Latest Track',
  'YLFxSN': 'Number of SKU (total/completed)',
  'YTCWoO': 'Email',
  'YhQ2ey': 'Sheet',
  'Yrb5u4': 'Specify the date of outbound',
  'Z/p3Wh': 'Fee Name',
  'Z6QOHS': 'greater than 0,can not be greater than available stock',
  'ZIfuAh': 'Upload label',
  'aQiOXp': 'Shipping Warehouse',
  'acNis3': 'Manual Order',
  'aob7LP': 'Estimated pickup time',
  'aq6K5m': 'Tracking No./BOL',
  'aqYzZC': 'View uploaded files',
  'as2D1h': 'You need to download template and enter relation between goods code and FNSKU code.',
  'beZa6n': 'Upload goods label. You need to provide goods label and matching relation between goods and uploaded file. Please download matching relation template!',
  'bijCNG': 'Order has been voided',
  'cAZy20': 'Template Import',
  'cgL+Sv': 'Package status',
  'coQgJF': 'Zip Code',
  'cz74rV': 'Off Shelf Service',
  'd7oELP': 'Upload third-party shipping label ',
  'dCjlw2': 'On-Time',
  'dzTL7Z': 'Compound order outbound packaging method',
  'e/x7rA': 'merchandise type',
  'eDbSh9': 'Guaranteed',
  'fKxbAs': 'Cancellation result',
  'fPKUBh': 'Upload ASN tag',
  'fexDv7': 'Pre-sale',
  'gM923M': 'Pallet materials',
  'gtaRBw': 'Select common address',
  'gw9jMp': 'Dimensions',
  'h+L5Oa': 'All label files are the same',
  'hIYnem': 'Matching relation template',
  'hnxwdw': 'Delivered',//派送完成
  'iEYp1K': 'Please enter the master tracking number in case of several numbers for one order with several sheets and please provide a pdf file to upload sheet.',
  'iroH6Z': 'Outbound Finished',
  'j2CnJn': 'Pallet standard grades name',
  'jC5cJ9': 'Please pay attention to whether the order has packaged before you pick up the goods. If not, please contact the online customer service.',
  'jMku/A': 'Upload matching relation',
  'jOOJ20': 'wGD Validation',
  'k3HTaT': 'Suit Code',
  'k6VOTr': 'Buyer ID',
  'kXUpBC': 'Shop ID',
  'kjhfZH': 'Atuo Destrroy',
  'kugx4v': 'Please enter product code or double click to select product.',
  'kvwSlC': 'Platform transaction number',
  'kw/r4N': 'Standard Outbound - Common template (supports a variety of value-added services)',
  'l9XE8F': 'Approved',
  'lnucNJ': 'Tracking No.',
  'm3thhL': 'Service process',
  'mR+AbS': 'Template',
  'njGJyr': 'Electronic Business Platform Information',
  'nnawzy': 'Original Currency',
  'nz5vIk': 'To be confirmed',
  'oG8Hy3': 'submit add text',
  'ouOOBA': 'Carrier',
  'p37xrN': 'The labels of European Authorized Representative are all the same',
  'pBvQw4': 'Upload commercial invoice',
  'pR+nKi': 'One file Upload parcel label',
  'pafbPl': 'Upload packing details',
  'pam1F6': 'Upload label file',
  'qK21Mm': 'Nor-order',
  'qVEbQk': 'Batch import of SKUs',
  'qXqspx': 'Group palletizing standard name',
  'qeijb+': 'Upload matching relation between label and package',
  'qm8Kc8': 'Warehouse Processing',
  'qznrTS': 'Self-pickup Address Information',
  'r4ktet': 'ASN code',
  'sM4Kbb': 'Personal information',
  'sb1vdX': 'In Transit',
  'svNhj4': 'The delivery time of the recommended program',
  't4OrzR': 'SKUs',
  'tRKFpY': 'The delivery time of the original program',
  'tj9cGr': 'Billing Product',
  'tqI0pC': 'Pallet Standard Grades',
  'uAWnfm': 'E-commerce Platform',
  'uYKziw': 'Number of packages (total/completed)',
  'ucXEJT': 'Export The List',
  'uh/9ZL': 'Order Product',
  'upDufj': 'Product Information',
  'v04auv': ' To ',
  'vJKdss': 'Consignee type',
  'vKCjcc': 'Sender VAT Owner',
  'vMg/7N': 'API',
  'wQZP1z': 'Failed',
  'wQzRtS': 'Unassigned',
  'wYm9QK': 'SKU Details',
  'wehBYg': 'Fill in the cross-border/cross-region delivery, the filled amount will be evenly distributed to the goods and an invoice will be generated',
  'wurdpg': 'Instructions',
  'xU66C0': 'After-trip value-added services',
  'xvn3Wk': 'Import order information',
  'y6KQu/': 'Upload tracking number',
  'yMdx29': 'You need to download template and enter relation between goods code and EU Authorized Representative label.',
  'yTQ3Wj': 'Are you sure to print the seleted label?',
  'ycrCub': 'Please fill in the reasons for invalidation.',
  'yt+3Z8': 'Pallet name',
  'z4OEaB': 'Receiver VAT Owner',
  'zdrSdM': 'Items',
  'ze81cw': 'To paste the ASN label, you need to fill in the ASN code and upload the label file.',
  'ztnKvN': 'To attach a package label, fill in the package label number and upload the label file.',
  '+Dyoci': 'Estimated temporary storage completion time (local)',
  '+d+5RN': 'Upload SKU label--UPC',
  '+sAXDI': 'Account group balance',
  '/2tze7': 'The information you are currently filling out has not been saved. Switching to another type of outbound system will clear the information you have entered. Please confirm if you want to switch?',
  '/b6CMw': 'Click here to upload',
  '02l0Ae': '1. Only support standard outbound orders that require value-added supplements; {break} 2. Orders placed in batches on the current page do not support smart recommendations; {break} 3. The warehouse for the uploaded orders must be the same. If there are orders with different outbound warehouses, please submit them separately; {break} 4. Please upload the batch template file first (not more than 200 orders at a time), then submit the value-added service, and click confirm after all uploads are successful. {break}',
  '0OkKZE': 'Out of all inventory',
  '0SA8N+': 'Specified packing only supports type A packages for single SKU or bundled SKU. That is, each package can only contain 1 type of SKU',
  '0fFyLn': 'PickUp-Third-party Label',
  '15E/3/': 'Total {total} orders selected this time, printed successfully {successCount} orders, printed failed {failedCount} orders.',
  '1ECAGD': 'Import only supports PDF format files',
  '1mMngo': 'Change the SKU in stock to another SKU, and deduct the inventory of the original SKU through this service',
  '2Lpdn9': 'If it is a third-party label {a}',
  '2RLkKp': '<fw500>Template Update</fw500>, supports filling in SKU information vertically on all Sheet pages',
  '3fzzUW': 'Provide self-pickup outbound service, after the self-pickup order is submitted successfully, you can schedule to pick up the goods from the warehouse at the specified time.',
  '3zOUmJ': 'Sub-order information',
  '40CuD+': 'Uploader',
  '4Jxo1m': '<fw600>Fill in tips</fw600>, {break} 1. If there are multiple SKUs in the same order, please fill in multiple lines of SKU information, and fill in the same customer order number in the corresponding column [Customer Order Number]. The order information corresponding to the SKU information must be consistent. {break} 2. Do not fill in SKU information on #Sheet1 and #Sheet2 at the same time. If you have fewer SKUs, it is recommended to fill in SKU information on #Sheet1. {break} 3. If you have more SKUs, it is recommended to fill in SKU information on #Sheet2, and the SKU information should include the corresponding row number of the order. {break} 4. When using the "Standard Outbound-Platform Special Template", if the platform is "ebay", the SKU information * must fill in Item ID, * Transaction ID, * Platform Seller ID. {break} 5. Please upload XLSX format templates, up to 50,000 data entries, file size limit of 5M, if the file is too large, please split it into multiple files and upload them in batches. {break}',
  '4NtVJg': 'Warm reminder, additional value-added services will not be included in the new order. If you need value-added services, please reselect them in the new order.',
  '4SHLfn': 'Batch import task number',
  '50OvR9': 'Need to download the template file and fill in the label information for each package. (Generated file as shown above)',
  '5GSF64': 'The system only provides data export with a time period of {maxDates} days',
  '5S5tsO': 'File size limit within 5M',
  '5gxemz': 'Provide third-party label outbound, after the self-pickup order is submitted successfully, you can schedule to pick up the goods from the warehouse at the specified time.',
  '5t/r6A': 'Expected outbound date (local)',
  '5xs1cX': 'The number of SKU codes exceeds the maximum limit of {num}, please adjust',
  '62zELz': 'Please select the type of outbound',
  '66A+Ni': 'Sub-order outbound warehouse',
  '6IbkK3': 'Click to download the template',
  '6LYgjW': 'Please check the value-added services on the left',
  '7G93qx': 'Please upload the XLSX format template with filled-in SKU information',
  '7uCeyn': 'The Winit product you selected does not belong to the Winit Guaranteed Delivery optional service or cannot be delivered within the specified time of Winit Guaranteed Delivery. Do you want to continue placing the order?',
  '8PVXv+': 'Platform Order ID',
  '8VqvlV': 'Price (original currency)',
  '8rs/NL': 'Outbound orders have been generated (batch number is {taskNo}), click the confirm button to go to the page of all orders to view the orders you uploaded.',
  '97k+rx': 'Add a row',
  '9DFxej': 'Sub-order [{orderNo}] generated automatically due to overdue return, does not support cancellation.',
  'AD6FxO': 'Number of label types',
  'Al/UXu': 'Unable to recognize tracking numbers based on the label file you uploaded. Please confirm if the uploaded file is correct?',
  'B6jIUx': 'Add common address',
  'BNXm17': 'Package size',
  'BlWytY': 'Please enter a number greater than 0, with up to 2 decimal places',
  'CPoCuB': 'Platform information',
  'D8w/qv': 'View platform information',
  'DJGKP5': 'Import only supports XLSX format files',
  'DJqEEW': 'Please follow the instructions below to select the file type and upload a PDF file: {break} 1. If the order sequence matches the package label sequence, use "Upload Package Label in One File" to upload a multi-page package label file. After uploading, Winit will match the order sequence and package label according to the template table rows. {break} 2. If the order sequence does not match the package label sequence, upload multiple package label files and match them with the order and package label files. {break}',
  'DLzlsg': 'Cancel the current value-added service',
  'DXzi63': 'Container number',
  'DrOmcS': 'View single SKU information',
  'EenrW5': 'An order has been generated as a draft (batch number is {taskNo}), click the confirm button to go to the page of all orders to view the draft order you uploaded or submit the draft order.',
  'EnI5P6': 'Are you sure you want to proceed with this operation?',
  'FTlLKH': 'Batch SKU ordering settings',
  'FVM5pZ': 'The following times are based on the local time of the operation location',
  'Frjn9M': 'Select other products',
  'GB5SuZ': 'The total outbound quantity must be equal to the platform outbound quantity',
  'GRMbmN': 'Set',
  'GaK/Vr': 'Outbound time (local)',
  'GstMVP': 'Batch import SKU template',
  'HHNWe8': 'Need to download the template file and fill in the relationship between SKU codes and EAR labels. (Generated file as shown above)',
  'HWAcVU': 'Third-party logistics company name',
  'HhXur8': 'Receiving information',
  'Hxrofw': 'Failed to verify country, state/city, postal code. You can <url>click here</url> to query.',
  'I2h+Kv': 'Modify order information',
  'I5rvby': 'If it is a regular self-pickup {a}',
  'IUBOYb': 'Outbound palletizing service',
  'IWDyfz': 'Batch upload of outbound orders with value-added services',
  'IkoWrk': 'You have not selected any SKUs, please choose SKUs',
  'IshHqQ': 'Paste SKU labels',
  'J/jch8': 'Please follow the instructions below to select the file type and upload a PDF file: {break} 1. If all orders correspond to the same ASN label, upload a one-page ASN label file and fill in the ASN number. {break} 2. If orders do not correspond to the same ASN label, upload the matching relationship between orders and ASN labels, and upload the label file. {break}',
  'JEUHWo': 'Total price',
  'JMPE8r': 'Pallet',
  'JWp1+n': 'Cancel this value-added service will clear the service requirements and value-added files. Are you sure you want to cancel?',
  'KJGutH': 'Service code',
  'KUggdg': 'Dimension input rules: Length = longest side, Width = second longest side, Height = shortest side',
  'KvSBDO': 'This time a total of {total} orders were exported, {successCount} successful, {failedCount} failed, {obtainingCount} in progress.',
  'L2yN1f': 'Friendly reminder: The above fees are estimated by the system. The final charges are subject to actual deductions; all fees are directly paid by the user and do not accept third-party payments on behalf of.',
  'LFVWAz': 'Click here to download the "Standard Outbound-Platform Special Template"',
  'LSjXDT': 'Sub-order number',
  'LcEeSH': 'Total (original currency)',
  'Lmn5aa': 'Note: {break} 1. Only support third-party label direct outbound business; {break} 2. Please upload the batch template file first, then upload the third-party single, and click confirm after all uploads are successful; {break} 3. When uploading a third-party single, you need to upload the relationship between the file name and the seller order number. {break} 4. Third-party singles only support uploading PDF format files {break} 5. Please upload XLSX format order templates; {break} 6. Up to 200 orders can be imported, with a file size limit of 5M. If the file is too large, split it into multiple files and upload them in batches; {break}',
  'N2QSRJ': 'Orders with failed "Field Verification" in the selected orders cannot be submitted',
  'NDBcfT': 'Upload successful',
  'NF8SKF': 'Specified batch',
  'NKvk/k': 'Orders need to be updated to "Temporary storage completed" status before supplementing the file information',
  'NRCc5i': 'Customize my value-added settings',
  'NlQvfL': 'Before|After correction',
  'Nqqyky': 'Box',
  'NwDD+7': 'Platform buyer ID',
  'O2zmfw': 'Winit estimated delivery before  {time}',
  'OXLLOk': 'Shipping VAT',
  'OjkedZ': 'Selected {allNum} orders{break} Passed verification {successNum} orders{break} Verification failed <span>{failNum}</span> orders{break} Not supported verification {noNum} orders{break}',
  'OydMwQ': 'View SKU group pallet standards',
  'QG3yCE': 'Download failed orders',
  'QPWEgx': 'Click here to download the "Destruction Outbound-General Template"',
  'QfncnO': 'Provide Winit overseas warehouse self-pickup service, after the submission is successful, you can arrive at the Winit overseas warehouse at the specified time for self-pickup.',
  'QuMfBo': 'Cost-effective solution recommendation',
  'RMTT8J': 'Enter the name of the in-warehouse value-added service',
  'RrGMSk': 'Go to draft orders',
  'Rrp9mD': '1. If the goods do not belong to the transshipment scenario, please select the recipient type as "buyer\'s order"; {break} 2.For transshipment goods belonging to the following scenarios, please select the corresponding recipient type: {break} Scenario (1), Amazon Seller Central account replenishment to Amazon warehouse, please select "FBA transshipment-non-VC order" {break} Scenario (2), Amazon Vendor Central account replenishment to Amazon warehouse, please select "FBA transshipment-VC order" {break} Scenario (3), if there is no need to change the SKU label and the recipient is not Amazon warehouse, please select "transfer to third-party warehouse"',
  'Sd/K3d': 'Pick-up delivery - third-party label service',
  'SmNURf': 'If you do not need these value-added services, please uncheck them. After cancellation, the system will no longer recommend them to you when placing an order',
  'TE9fLA': 'Switching template types will clear the data you have uploaded. After clearing, you will need to re-upload the data. Please confirm if you want to switch?',
  'TNZK2r': 'Require offline Value-added service  ',
  'TZSi0K': 'The tracking number identified from the label file you uploaded [{a0}] does not match the tracking number you entered [{a1}]. Please confirm if the uploaded file is correct?',
  'TfqsbO': 'Germany address verification result',
  'Til6hA': 'Providing point-to-point logistics activities from Winit overseas warehouse to the buyer\'s hands',
  'TthmIg': 'Shipping vouchers support only {max} orders at a time, it is recommended to print in batches',
  'TwZVBu': 'Summarized in USD based on the order date exchange rate, the amount also changes dynamically with the exchange rate fluctuations',
  'TzYmJV': 'Please select Winit products',
  'U/VC1c': 'Confirm submission of the outbound order?',
  'U5Oz18': 'Order {orderNo} printed successfully',
  'Uz8jF0': 'Switching file types will clear the information you have entered. Are you sure you want to switch?',
  'VECjAW': 'Failed to get file address!',
  'VSoODL': 'eBay+',
  'VVoTD/': '(Total imported {totalCount} items, successful {successCount} items, failed {errorCount} items)',
  'VgYd5U': 'Template for tracking number and order',
  'VtILvi': 'Recommended',
  'W4m4yi': 'Total number of entries',
  'W9/gSX': 'Place an order for a specified batch.',
  'WM1Y0D': '{0} supports only amounts greater than {1}{2}, and less than or equal to {3}{2} for insurance amounts, with a maximum of 2 decimal places. Please re-enter the amount.',
  'XOto+a': 'Insufficient account balance, current balance: {amountTotal} USD, estimated order amount: {amount} USD, please make payment before placing the order',
  'XRKL56': 'If it is a platform order {a}',
  'XLw/TB': '1. Only XLS and XLSX format templates are supported {break} 2. Each file supports uploading a maximum of 5000 items, if more than 5000, please split into multiple files for batch upload {break} 3. File size limit is 5M, if the file is too large, please split into multiple files for batch upload {break} 4. Imported items that already exist will overwrite the quantity of existing items after import',
  'XaUufT': 'Latest outbound time',
  'Y7VuWC': 'If it is a non-platform order {a}',
  'YML81t': 'If you have inventory in these warehouses, you can save {span}',
  'YO3xxT': 'Total imported {num1} items, successfully validated {num2} items, validation failed {num3} items',
  'YSCxEM': 'Submit individually',
  'YW7cc3': 'Receiving VAT',
  'YXI1uR': 'You have already imported this file, please confirm if you need to re-import?',
  'Yb+UzV': 'Estimated wait time {predictTime} seconds, you can fill in value-added information after the order validation is completed, please wait!',
  'YmKEHX': 'Batch print shipping vouchers',
  'YpIZck': 'Total outbound quantity',
  'Zf9p2v': 'Batch select items',
  'ZxY3ke': 'If the selected order is in the outbound confirmation stage, successful cancellation may incur order cancellation fees; {break} If the selected order is in picking or picking completed stage, successful cancellation will incur order cancellation fees and re-shelving fees. Once cancelled, it cannot be undone. Are you sure you want to cancel this order?',
  'a5CPqJ': 'Click here to download the "Self Pick-up Delivery-General Template"',
  'a88xyg': 'Product/Service',
  'aHUIrW': 'The recipient type is about to be updated, you need to clear all your value-added service files.',
  'ardfyD': 'For third-party label outbound orders, WINIT needs to assist in delivering to the specified last-mile service provider, this template can be used. {break} - This template supports value-added services limited to: outbound packaging. Other value-added services require offline provision of value-added service forms.',
  'bW1e0R': 'Please select items',
  'bs99RG': 'Recipient\'s detailed address',
  'bxPEv+': 'Need to download template file, fill in the relationship between SKU code and English Authorized Representative Label (Generated file as shown above)',
  'byhnay': 'SKU group palletizing standard',
  'cgj8zj': 'Order information is about to be updated, you need to clear all your value-added service files.',
  'crlcm2': 'Label information',
  'd3djw9': 'Earliest outbound time',
  'dDAdR6': 'Need to download template file, fill in the relationship between SKU code and FNSKU code. (Generated file as shown above)',
  'df0DoP': 'Service status: <span>{serviceStatus}</span>{break}Target delivery time, {targetDeliveredTime}{break}Actual delivery time, {actualDeliveredTime}{break}Expected outbound time, {targetOutTime}{break}Actual outbound time, {actualOutTime}',
  'dsvRaJ': 'Need temporary storage',
  'e/yYiE': 'Export (new)',
  'e4+j3h': 'If you need more value-added services {a}',
  'eCH8u3': 'Please select a valid date range!',
  'eQQPv4': 'Estimated time (minutes)',
  'fAPVId': 'Upload failed (items)',
  'forWFG': 'Failed to get export file address!',
  'fsfYE2': '1. Warehouse address and pick-up time will be provided after the order is packaged, please pay attention to the main contact person\'s email or check on the order details page; {break} Upon receiving the notification email, pick up with the outbound order number and pick-up code at the warehouse; {break} For orders in the US region picked up by a trucking company, it is recommended that the seller confirm with the trucking company in advance and provide the BOL file to the warehouse before pick-up. If the pick-up person refuses to pick up due to the warehouse not having a BOL, the related costs incurred will be borne by the seller. {break} 2. Self-pick-up orders can only be picked up after packaging is completed. If the pick-up person arrives at the warehouse early and causes emptying, the related costs will be borne by the seller. {break}',
  'fulsyY': 'You have changed the SKUs in the order, you need to reselect value-added services, please confirm if you need to make changes?',
  'g+Qwn3': 'Cost details',
  'gGL07o': 'Please enter SKU codes, enter multiple SKUs on separate lines, support up to {num} SKUs',
  'gj4PmC': 'No support for cancellation',
  'hJmdHo': 'The maximum number of orders that can be operated simultaneously is {max}',
  'hQUDGa': 'IOSS No.',
  'hTuIlj': 'Total outbound quantity must be greater than the specified batch outbound quantity',
  'hjjUgn': 'Each time supports submitting a maximum of {maxNumber} orders, you have selected {number} orders, please reduce the quantity.',
  'itTkxY': 'Click to download template file',
  'jKQAn/': 'Importer/exporter information',
  'jldSIC': 'Package label matching relationship template file',
  'jq07Ch': 'Total number of orders: {totalCount}; Orders validated: {checkNum}',
  'jv0mRc': 'Duplicate file name, please choose again!',
  'kHi2k4': 'Please enter last-mile value-added service name',
  'klH6bS': 'Packaging material code',
  'ktkm2G': 'Click here to download the \"Standard Outbound-General Template\"',
  'l+Ey3+': 'The above fees are estimated by the system, the final charges are based on actual deductions.',
  'l/eBoQ': 'Destruction/SKU shelving',
  'lWoH/C': 'Occurrence time',
  'lYy9nF': 'Pallet code',
  'lcs8Cl': 'End date must be after start date!',
  'lyzr6E': 'Double-click for batch query',
  'm17b5x': 'Set as common address',
  'm5sTom': 'Discounted price',
  'mPGkgC': 'Pick-up delivery - Self-pick-up service 1.0',
  'my5+MV': 'Incorrect email address format!',
  'n1fRuF': 'Sub-order',
  'n4Uj59': 'Platform store ID',
  'o4DYG7': 'Length Width Height (cm)',
  'oH6SVx': 'Only third-party logistics self-pick-up is supported, self-pick-up with pallet outbound must meet the minimum order volume of 0.96CBM {break} After placing an order, submit the "Outbound Add/Change Product or Single Item Label" value-added service, provide the third-party logistics company label information (express label/BOL, etc.) {break} After completing value-added service for self-pick-up orders, please pick up before 24:00 on Day2 (value-added completion day is Day0), storage fees will be charged starting from Day 3, storage fee charging standards are detailed in the "Value-added and Exception Service Pricing" {break}',
  'oHHxMC': 'Orders [{orderNo}] automatically generated due to overdue returns, cannot be cancelled.',
  'oK0S4l': 'Transaction ID',
  'oXly2z': 'Sign relevant agreements',
  'ozL2c6': 'ASN label matching relationship template file',
  'p9SD4i': 'Total sales amount',
  'ptBWFQ': 'Auto add packaging',
  'pw6nJB': 'Original price',
  'pzINE7': 'Outbound SKU Suiting',
  'qC5Rts': 'Pick-up and delivery - Self-pick-up temporary storage service',
  'qKXRjL': 'Common address',
  'qnPvi9': 'Export (old)',
  'r/YGTN': 'Value-added file',
  'rDmhRB': 'Timeout',
  'rTOYrN': 'Click here, can still save for you',
  'sGF/mQ': 'Total (original currency)',
  'sIZFs0': 'Platform outbound quantity must be equal to total outbound quantity',
  'sWzcHw': 'Total order sales amount',
  't3/i/R': 'Value-added service settings',
  'tE8T0+': 'The current product is not available due to "{error}" reasons, please select other products or cancel value-added service [{serviceName}]',
  'thGDHR': 'Multiple order numbers need to be separated by line breaks or commas, support up to {num}, double-click to switch to single query',
  'tzzE+T': 'Please enter correct information',
  'u96JkE': 'We provide you with a custom preference value-added service setting function, you can choose different value-added service contents according to your needs. After setting the preference options, please remember to click the "Save" button to ensure your preference settings take effect.',
  'uaFgSD': 'Date range cannot exceed one month!',
  'ukQdI7': 'Reason for download failure',
  'vHQASu': 'Delivery time efficiency (days)',
  'vY4wOI': 'SKU Standard {break} Qty',
  'vtFAqc': 'When modifying product [{pscName}], the system shows that the selected value-added service [{vasName}] is not supported. Modifying will clear the selected value-added services, you',
  'vvIwaz': 'Order number {orderNo} verification failed, reason: {msg}',
  'weVvn9': 'Fill in platform information',
  'wftiJ6': 'Up to 50,000 data entries can be imported, with a maximum file size limit of 5MB. If the file is too large, please split it into multiple files and upload them in batches',
  'x34SYE': 'Upload and submit',
  'xBSsPx': 'Destroy unsold SKUs in Winit overseas warehouse to reduce seller inventory and warehousing fees',
  'xKfDzT': 'Total cost savings',
  'xNdC7g': 'Choosing the wrong platform will result in the inability to enjoy the protection policy of certified warehouse shipping. For example, if it is actually an eBay order but "eBay" is not selected, eBay will not recognize that the order is shipped from a certified warehouse',
  'xi9ohN': 'Shipping VAT Owner',
  'xt+0Wf': 'Container type',
  'y3Vt3x': 'Self-pickup outbound upload template',
  'yPxAoX': 'After the successful placement of a destruction order, warehouse rental charges will stop being calculated after 2 working days',
  'ya6vKV': 'Enter code to search...',
  'ymeo/a': '{a}',
  'zY9LUW': 'This function supports users to batch select value-added services and upload label files, such as attaching SKU labels or EAR labels',
  '85cRES': 'The ordered goods include DG goods. In order to meet the supplier\'s requirements, the system will automatically create a value-added service of [check and subsidize DG labels] and charge the corresponding value-added service fees. Please check the value-added services and related fees in the order details after placing the order.',
  'EJp6Wx': '<fw600>Filling tips</fw600>: {break} 1. If there are multiple SKUs for the same order, please fill in multiple rows of SKU information and fill in the same customer order number in the corresponding column [Customer Order Number]. The order information corresponding to the SKU information must be consistent{break} 2. Do not fill in the SKU information in #Sheet1 and #Sheet2 at the same time. If you have fewer SKUs, it is recommended to fill in the SKU information in #Sheet1{break} 3. If you have more SKUs, it is recommended that you fill in the SKU information in #Sheet2. The SKU information must contain the row number of the corresponding order{break} 4. Please upload the XLSX format template. A maximum of 50,000 data items can be imported, and the maximum file size is 5M. If the file is too large, please split it into multiple files and upload them in batches{break}',
  'IvZQuR': 'Please enter the product code. If you want to enter multiple products, please enter them in a new line. You can enter a maximum of {num} products. Double-click to switch to a single query.',
  'ad/9Ry': 'Maximum orderable amount',
  'tmQnHt': 'Since you have selected the value-added service [{vasName}], the charge amount for the last-mile product has changed. Please confirm whether you want to view the changes?',
  'bIB2Zm': 'Actual quantity completed',
  'w17jPW': 'Order packaging materials',
  '3xLqg9': 'Width(cm)',
  'OlONZd': 'Height(cm)',
  'WGqv+Q': 'Length(cm)',
  '+mYTzz': 'In the product [{prductName}] after you switch, you are only allowed to select one of the value-added services [{vasName}] that you have selected. After switching, the system will clear the selected value-added service and the entered service requirements. Please confirm whether to switch?',
  '0GUHhL': 'Please fill in at least one line of package details!',
  '0NMf6s': 'Create a value-added order',
  '2AochY': 'Quantity of goods',
  '3LM8lU': 'Please fill in at least one line of product details!',
  '5MxYVI': 'Total amount of account group',
  '6KBoID': 'Clear?',
  '9U9po2': 'The customer specifies the product SKU and quantity, the warehouse will unpack the outer packaging and sales packaging of the product, take photos of the bare goods and individual items, and provide 1 outer box barcode (taken before unpacking), 1 product barcode photo, and 3 to 4 actual product photos (product overview, product details, etc.);{break}Note: Regardless of the quantity of the product, only one set of identification photos will be provided for the products in the same package.',
  '9j7Ejw': 'Upload attachments',
  '9sdcoI': 'Create a new inbound value-added order',
  'DjpAUg': 'Add all page products',
  'FqKI0m': 'The display format after search is: Product Code-Product Name-Specification [SKU Type-Standard Quantity of Inventory Unit (if any)]',
  'G0LOPQ': 'view image',
  'H4GzP7': 'Value-added object',
  'Iu8t4K': 'Service deadline(Working Days)',
  'JZ3djF': 'Please select the order warehouse first',
  'KD95AN': '1. Only XLS and XLSX format templates are supported{break} 2. Each file can only support up to 5,000 products. If the number exceeds 5,000, please split it into multiple files and upload them in batches{break} 3. The maximum file size is 5M. If the file is too large, please split it into multiple files and upload them in batches{break} 4. If the imported products already exist, the number of the original products will be overwritten after import.',
  'KtSFd3': 'Please select the value-added option information you need!！',
  'N47jAg': 'Create a new in-stock value-added order',
  'O8jTMP': 'Please enter the product code. If you have multiple products, please enter them in a new line. You can enter a maximum of {num} products.',
  'QcZ2zI': 'After checking, the current product details will be cleared and all products in the order will be automatically brought out.',
  'QvJcOP': 'Value-added product information',
  'RFAVvS': 'Customers do not need to select specific packaging material specifications. The warehouse will select appropriate packaging material specifications based on the actual size and weight of the goods. Please check the value-added details results for details.',
  'RNIttq': 'After checking the box, the current package details will be cleared and all packages in the order will be automatically taken out.',
  'UjkhyX': 'You have added product information. If you need to switch to unspecified products, the system will automatically clear the added product information. Please confirm whether you need to switch to unspecified products! After the customer confirms, this button switches to the off state, and the system simultaneously clears the product list and adds the SKU',
  'Vsr+82': 'Uploading file...',
  'WrVyB2': 'Selecting value-added according to the product level means that customers only need to select specific products under the incoming order, without importing packages, and the system will automatically associate the corresponding packages.',
  'XM3VPI': 'Package Details',
  'Xy2gME': 'Abnormal details',
  'YhoqBY': 'Whether to specify a single product',
  'YiuYrp': 'Select value-added products according to the package',
  'b4xwkc': 'Add the selected products on the current page',
  'etdYDz': 'View the product details of the measurement weight',
  'fSD6JL': 'Create a new value-added order',
  'fmfcfE': 'Total number of products',
  'gbv1sQ': 'Import results: A total of {totalCount} items were imported, {successCount} items were successfully verified, and {errorCount} items failed to be verified',
  'hTBwMe': 'Label type',
  'hh1Cwv': 'Whether to specify batch',
  'iOKwId': 'Create a new outbound value-added order',
  'ieevJF': 'The product [{prductName}] that you are switching to does not support the value-added services you have selected [{vasName}]. After switching, the system will clear the entered service requirements. Please confirm if you want to proceed with the switch？',
  'kQ18bf': 'View identification images',
  'kS86D/': 'Product description',
  'lV0eI9': 'Check all the packages in the order to automatically display the package details of the order (excluding packages that have been terminated, lost, draft, unloaded, partially put on the shelf, put on the shelf, or put on the shelf in the abnormal area).',
  'nc5Ajp': 'Please check the product information you need to delete',
  'oLcSdY': '1. Only XLS and XLSX format templates are supported{break} 2. Each file can only support up to 5,000 items. If the number exceeds 5,000, please split it into multiple files and upload them in batches{break} 3. The maximum file size is 5M. If the file is too large, please split it into multiple files and upload them in batches{break} 4. If the imported products already exist, the number of the original products will be overwritten after import.',
  'ofdSOM': 'Confirm Add',
  'rtucPA': 'Check all items in the order to automatically display the item details of the order. The item quantity does not include the withheld quantity, lost quantity, terminated quantity, and put on shelf quantity.',
  'sOnCAV': 'You have added product information. If you need to switch to a specific product, the system will automatically clear the added product information. Please confirm whether you need to switch to a specific product! After the customer confirms, this button switches to the on state, and the system simultaneously clears the product list and adds the SKU',
  'stloSU': 'Clear',
  't0telM': 'Measurement quantity',
  'u/Qpw8': 'Selecting value-added according to the product level',
  'wV4yyB': 'Please select the product you want to order!',
  'xKfgtc': 'Please select the Winit product that needs to be ordered!',
  '0hMVUW': 'Check all items in the order',
  'qbGfXL': 'Check all the packages in the order',
  'HBVOSn': 'When choosing to change product packaging as a value-added option, you must select product level - subsidize the original SKU barcode or product level - replace the new SKU barcode.',
  'vCj0xW': 'When choosing to change product packaging as a value-added option, you must select product level - subsidize the original SKU barcode.',
  'IFrTuT': '1. Only supports uploading XLS and XLSX format templates{break} 2. Each file supports uploading up to 500 products. If more than 500 items are exceeded, please split it into multiple files and upload them in batches{break} 3. File The upper limit of size is 5M. If the file is too large, please split it into multiple files and upload them in batches{break} 4. The product list will be updated with the latest imported product information',
  'Rc/YFn': 'Measuring the quantity of a single product',
  'bowBV5': 'Upload tag correspondence',
  'yIwIol': 'Product Description',
  '/lVXii': 'The file format you imported is incorrect. Please import a file with the suffix {accept}.',
  'F0UzrE': 'Please click the [Batch Add] button to import the product barcode',
  'o3sNed': 'Whether to specify a single product barcode',
  'ajg6I7': 'If the value-added goods are changed, the system will clear the service requirements and value-added documents corresponding to the entered value-added options. Please confirm whether to modify?',
  '2JJnID': 'When the value-added object changes, the system will clear the service requirements and value-added files corresponding to the entered value-added options. Please confirm whether to modify it? ',
  'Fgj4rD': 'The value-added service you have selected, [{vasName}], only supports randomly selecting one item from the ordered goods in stock for size and weight measurement. You can click on "View Size and Weight Measurement Product Details" in the requirements of the [{vasName}] service to view the details of the measured products.',
  'BmD3S6': 'Side',
  'wbIglz': 'Front',
  'xHvzLQ': 'Back',
  'cFgopv': 'The above is an example',
  '1sTzME': 'Note: Billing will stop after delivery confirmation (2 working days after order submission within the cut-off time, 3 working days after order submission after the cut-off time).',
  'DQ9abk': 'Pallet height limit (cm)',
  'DXNP2o': 'Pallet weight limit (kg)',
  'HaLIN3': 'Maximum number of pallet layers',
  'K741JW': 'Number of single-layer packages',
  'MBR1/w': 'Batch information',
  'U7gMvw': 'For post-order services (warehouses obtain delivery labels from suppliers after packaging is completed), the barcode of the physical package will be displayed; for pre-order services, the virtual package number of the system will be displayed. ',
  'ZDFgJ+': 'Estimated|Actual',
  'hBWthA': 'Your product is out of stock in this warehouse. Please restock before placing an order or change to another warehouse for delivery',
  'j3jXuq': 'The available balance is taken from the largest available balance in the account whose consumption country is the country of shipment or ALL. If you have any questions, please ask customer service. ',
  'l/kT2w': 'Download Amazon packing list',
  'm4c9L2': 'Group pallet standard-product classification',
  'onH0MX': 'The ordered products include DG products. In order to meet the requirements of the supplier, the system will automatically create a value-added service of [{name}] and charge the corresponding value-added service fee. Please check the value-added service and related fees in the order details after placing the order. ',
  'yLU9ZT': 'Latest track:',
  'uk/z4W': 'You have not signed the 3.5 version of the supply chain management agreement and cannot place an order. Please <url>click the link</url> to sign before placing an order! ',
  'SELVtF': 'The outbound quantity is greater than the available inventory, please modify',
  'eEpHfM': 'Set',
  'LpECFr': '<fw600>Filling tips</fw600>: {break} 1. If there are multiple SKUs for the same order, please fill in multiple rows of SKU information and fill in the same seller order number in the corresponding column [Seller Order Number], and the order information corresponding to the SKU information must be consistent{break} 2. Do not fill in the SKU information in #Sheet1 and #Sheet2 at the same time. If you have fewer SKUs, it is recommended to fill in the SKU information in #Sheet1{break} 3. If you have more SKUs, it is recommended that you fill in the SKU information in #Sheet2, and the corresponding seller order number must be filled in the SKU information{break} 4. When using the "Standard Outbound-Platform Special Template", if the platform is "ebay", the product information *Required Item ID and *Transaction ID, *Platform Seller ID{break} 5. Please upload the XLSX format template, up to 50,000 data can be imported, and the maximum file size is 5M. If the file is too large, please split it into multiple files and upload them in batches{break}',
  '11sq5D': '<fw600>Filling tips</fw600>: {break} 1. If there are multiple SKUs for the same order, please fill in multiple rows of SKU information and fill in the same seller order number in the corresponding column [Seller Order Number], and the order information corresponding to the SKU information must be consistent{break} 2. Do not fill in the SKU information in #Sheet1 and #Sheet2 at the same time. If you have fewer SKUs, it is recommended to fill in the SKU information in #Sheet1{break} 3. If you have more SKUs, it is recommended that you fill in the SKU information in #Sheet2, and the corresponding seller order number must be filled in the SKU information{break} 4. Please upload the XLSX format template, which can import up to 50,000 data items, and the maximum file size is 5M. If the file is too large, please split it into multiple files and upload them in batches{break}',
  'SJr/PB': 'eBay Transaction ID',
  'XAs3Tz': 'eBay Item ID',
  'O5Xpbm': 'Inventory details in value-added processing',
  'Ot1Uz8': 'Value-added processing',
  'KgnTRo': 'Express Note',
  '0uVfj+': 'Batch date [{batchDate}] product batch number [{batchNo}]',
  'B10A4u': 'The batch date [{batchDate}] product batch number [{batchNo}] corresponding to the product code [{merchandiseCode}] specification [{specification}] does not exist. Please modify it before placing the order. ',
  'BOUAuk': 'Product code [{merchandiseCode}] specification [{specification}] product grade [{merchandiseGrade}]',
  'G/6Nal': 'Product code [{merchandiseCode}] specification [{specification}] barcode value [{barcodeValue}] does not exist. Please modify it before placing the order. ',
  'OOKwuL': 'Delivery quantity',
  'hG1yrq': 'Only positive integers <= available inventory quantity are allowed',
  'iBWZUW': 'Available inventory is insufficient, please modify before placing an order. ',
  'mYXlzB': 'Barcode value [{barcodeValue}]',
  'K6oqA6': 'How to create a new outbound order',
  'JbYw2T': 'Insufficient inventory, SKU code: [{merchandiseCode}], specification [{specification}], SKU grade [{merchandiseGrade}]',
  'RLYGF8': 'Only products that have been updated and returned can be batch abandoned for updates',
  '/U1cNQ': 'Login Mailbox',
  '1axc5j': 'Account Login Log',
  '3YYAIP': 'Login Time',
  'yBaWS7': 'Inbound label features',
  'bFBzZ6': 'The inbound label features refers to the labeling feature of your actual package. Please select according to the actual situation! ',
  'Ya9ARR': 'In the [Sea Freight FCL 100% A+ Package] scenario, <red>each FCL can only correspond to one inbound order</red>. Please do not create multiple inbound orders or place the goods of one inbound order in multiple cabinets.',
  'bZZ7HX': 'Special business scenarios for warehousing',
  'ZkEwxh': 'Package Lable File(batch)',
  'k5tKw4': 'Pallet Lable File(batch)',
  'svkYiG': 'Upload file label correspondence relationship',
  'vJHNAb': 'SKU Lable File(batch)',
  'yyCms8': 'Order Lable File(batch)',
  '+oGSwv': 'Verification result: Address error confirmed by carrier.',
  '2gCQ22': 'Address accuracy verification',
  'MRrqU5': 'The shipping address you provided has been verified by the carrier as "address error". It is recommended that you correct the address before placing an order. Using an incorrect address may result in failed delivery of the package, as well as incur address verification/correction fees.',
  'XpGvSQ': 'Address accuracy verification result',
  'b5PSBI': 'The following is a suggested address, please confirm with the recipient before using.',
  'x8DYRv': 'Address verification exception, please contact customer service for assistance.',
  'A/vtZJ': 'Verification result: Address confirmed by carrier as correct.',
  '7l6zxJ': 'Pop Announcements',
  'OTY7H9': 'This entry label feature only supports SKUs that meet the following conditions for ordering:{break}1. SKU management method = merchandising management;{break}2. SKU product package type = A+ package;{break}3. Whether to collect package code when SKU is shipped out = No;{break}4. SKU batch management type ≠ shelf life management/production batch management;',
  '9JvAYe': 'Due to selecting the value-added service of "{vasName}", the fee and packaging dimensions for the final leg of the product have changed. Please review the updated information.',
  'Og4xZy': ' Scheme verification failed',
  'P+RbEx': ' Current statistical value (excluding current order):',
  'VZm9tI': ' Current order value:',
  'e1mqpb': ' warning value:',
  'C3m66g': 'Please enter the same password again',
  'FKnMw9': 'Confirm password',
  'Pdx/YD': 'password',
  'ViVQNi': 'role',
  'cHq4Ya': 'Sub account management',
  'gsk33w': 'reset password ',
  'hzZoDq': 'Role selection',
  'mxnPQs': 'Are you sure you want to delete this sub account?',
  'EMs8M0': 'Export error file',
  'D/UEIs': 'Pay now',
  'xJrIYj': 'Inspection Method',
  '10wVQz': 'The ending value of the order item quantity cannot exceed 9999',
  '4Ci0HB': 'Packaging category',
  '5F2n3z': 'Outbound packaging rules',
  '6EIwDL': 'Edit rules',
  '720Q8J': 'View rules',
  '8huAxo': 'Add rules',
  'BCUZhM': 'Packaging rules',
  'D5PNZX': 'Change the warehouse system will clear the selected applicable products, and you will need to re-select the applicable end products. Please confirm if you want to switch?',
  'FLwmFx': 'Applicable',
  'I7l7ML': 'Applicable products',
  'QuBYs8': 'Maximum cargo type per order',
  'Wm6V6+': 'Number of items per order',
  'cfh9l+': 'Packaging rules',
  'fSrVg2': 'When you change to [{name}], the system will clear the products that have already been added. Please confirm if you want to make this change.',
  'g1o9oC': 'Applicable last-mile products',
  'iKvNmh': 'When you trigger the WINIT composite packaging restriction rule when placing an order, does WINIT allow for attempting to add a cardboard box for outbound shipment?{break} <radio></radio>{break} <span>Note: The WINIT composite packaging restriction rule refers to the "WINIT Overseas Warehouse Storage Last Mile Price List Last Mile General Warehouse Operation".</span>',
  'qDfdJy': 'The product is no longer valid, please delete.',
  'qwf9Nq': 'Product [{winitProductName}] already exists, please do not duplicate.',
  's1TEO4': 'The end value input for the number of single items in an order must be greater than or equal to the start value',
  'tbiToK': 'Applicable conditions',
  'yJT89v': 'Please add product',
  'Caegz9': 'Maximum package size for orders: TM > T240 > T120 > T50 > T25',
  'Ot+gGB': 'When packaging is not specified on the order and packaging is not specified on the SKU, you can choose to maintain packaging rules here. After maintenance, the system will package according to this rule.',
  'TLFHiO': 'The value after summarizing the number of items in the order{break} Note:{break} -The SKU type is "set product", and the number of items is equal to the number of standard boxes in the inventory unit multiplied by the number of sets{break} -The SKU type is "box product", and the number of items is equal to the number of standard boxes in the inventory unit multiplied by the number of boxes{break} -SKU type is "single product", number of items=number of pieces{break}',
  'lvDzTm': 'Please confirm if you want to save?',
  'eQfOBk': 'You have set the rules for adding packaging when shipping out in the preferences. The system has added packaging according to the set rules. If you do not want to add packaging when shipping out, please disable the rules in the preferences.',
  'Z4U9y+': 'Check the attachment',
  'uY05bw': 'No packaging specified',
  'cYiz82': 'Second-class Cargo Type',
  's9YTfW': 'Piece Type',
  'sPfnYX': 'First-class Cargo Type',
  '2+PyVI': 'ompanies that do not have import and export qualifications and can conduct local trade and procurement.',
  'UnEWFb': 'sed for overseas customs clearance and overseas warehouse in and out purposes.',
  'c5Nj/U': 'Used for first-leg customs clearance and export declaration.',
  '/XIGWB': 'Customers registered for UK normal customs clearance can choose this customs declaration method. DE Customers can provide VAT+EORI number and choose to register for general customs clearance.UK direct shipment deferred importer registration chooses normal customs clearance.',
  'XJzSbr': 'that do not have import and export qualifications and can engage in local trade and procurement. Customers without EORI number who do not use our first leg to register for German LUCID can also choose this customs declaration method. They do not need to fill in the EORI number, but must provide the VAT number.',
  'dSTziS': 'Your Wanbili account fees have been overdue for more than 30 natural days. We have marked this account as a bad debt customer in the system and processed your inventory according to the agreement. If you have any questions, please consult sales or customer service.',
  'wRwbQA': 'When using the customer\'s own importer for import customs clearance, tariffs are paid, but VAT is not paid for the time being. UK importers applying for this customs clearance method need to send a \"UK tax agent\'s letterhead declaration letter\" to the designated email address (you can consult sales to open it), upload the \"PVA application letter\", "in and out of storage authorization agreement" and \"PVA declaration letter\".',
  'lCh5Kb': 'Reminder for Bad Debt Customers',
  'WgC6Gs': 'Exporting in progress, you can check it later in "<url>Export Center</url>"',
  '42AeNT': 'With Powder',
  'GCht0S': 'Support SKU to specify inbound package type',
  'GDVEVI': 'With Magnetism',
  'Fm+Ssn': 'The instructions for Support SKU to specify inbound package type are as follows,please read them carefully before opening them.<url>"View Operation Guide"</url>{break}{break}Are you sure you want to activate Support SKU to specify inbound package type?',
  'z0PUTp': 'Once enabled, it is supported to specify the storage package type for SKU.',
  '++UdMT': 'Estimated maintenance completion time',
  '+LILpx': 'Specified time limit',
  '0QchEc': 'An additional day of maintenance time will be added for every 200 product tasks in the future',
  '6ybLAG': 'Selected {x} maintenance tasks, {y} of which are overdue, and {z} are not overdue',
  '7BlR/x': 'The existing draft or maintenance return information for product [{code}] will be deleted simultaneously. Do you confirm the invalidation?',
  '8mYf5w': 'Whether to turn on?',
  '8qzVqS': 'Expedited maintenance',
  '9qDeNq': 'Winit with similar submission time will be merged into one maintenance task based on the same link products!',
  'BZjeOY': '≤200/day',
  'FP7zbE': 'Registration tasks submitted between 00:00 and 24:00 will be completed before 18:00 the next day (working day)',
  'IeOpzM': 'No operable maintenance task number',
  'L6GHh6': 'Expedited maintenance submission failed',
  'Lnr2xY': 'Only products that are pending maintenance, registration returns, released, update returns, and updates to be maintained can be batch uploaded',
  'N7+Dp2': 'Task number',
  'OMd2yU': 'Please select the products that need urgent maintenance and submit!',
  'OeLJXG': 'Submit from Saturday 00:00 to Sunday 24:00, and complete maintenance before 18:00 on the third day (natural day)',
  'QR4q16': 'Express conditions are not met',
  'SNpV1H': 'Submit for expedited delivery',
  'UEJHOb': '[{x}] maintenance tasks have been selected',
  'UTPKAA': 'Saturday to Sunday',
  'V4yQzj': 'Whether to close',
  'VgW/4b': 'Submit registration date',
  'XyFive': 'Only registered products to be maintained can be expedited for maintenance',
  'Zbdxq5': 'Submit from 12:01 to 24:00, and complete maintenance before 12:00 on the third day (natural day)',
  'abtEse': 'This maintenance task has been expedited!',
  'cAoMRy': 'Product [{code}] has information to be maintained, and it is not allowed to expire for the time being! ',
  'g2t/yp': 'Product registration task quantity',
  'j9fgJe': 'Monday to Friday',
  'k28aoI': 'Task category product quantity',
  'kVa+IR': 'Print barcode',
  'o1jOma': 'Batch expedited maintenance',
  'qqc3Vv': 'Tip: Maintenance of "untimed" tasks supports a maximum of {totalQuantity} items per time, limited to {singleQuantity} times/month [{remainingQuantity} times remaining this month]',
  'qrgvkO': 'Statutory holidays (China)',
  'rKcJu1': 'Registered products will be maintained within {time}! ',
  's5Fwma': 'Maintenance time limit',
  'uYmUBT': '00:00-12:00 Submit, maintenance completed before 18:00 the next day (natural day)',
  'v0kTyH': "Starting from August 31, 2024, the product registration template will add 'with powder' and 'with magnetism' information entry. Please download the new template to submit product registration information!",
  'wGnRfF': 'Maintenance task number',
  'wNzGut': 'If the published product needs maintenance information, the product information will be updated only after the maintenance is passed',
  '0/uZ2D': 'The remaining outstanding amount of bills that have been issued is displayed in USD according to the repayment currency, and fluctuates with the daily exchange rate. Due to daily exchange rate fluctuations and different exchange rates used for different repayment currencies, this amount is for reference only. Please refer to the estimated outstanding amount for actual repayment.',
  '25Iz53': 'Remaining Repayment Amount',
  'fBDO16': 'Transfer-out Account ID',
  'sZYtw3': '1. Only standard outbound orders requiring value-added services are supported.{break} 2. The bulk order page does not provide intelligent recommendation functionality.{break} 3. Please make sure to fill in the customer order number, as this is a required field.{break} 4. All uploaded orders must select the same warehouse. If orders involve different outbound warehouses, please submit them separately.{break} 5. A maximum of 200 orders can be imported at a time, with a file size limit of 5M. If the file is too large, please split it into multiple files and upload them in batches.{break} 6. Operation steps: Upload the bulk template file first, then submit the value-added service, and finally confirm the order.{break}',
  '6uYvTI': 'Associated third-party barcode quantity',
  'GoNHt2': 'Associated product specifications',
  'Gr8TCE': 'Please upload the label file first!',
  'Hh/ZWd': 'Value-added Order Number',
  'NuOfGy': 'Associated product barcode type',
  'OnpWLD': 'Associated inventory unit standard quantity',
  'PMOlhJ': 'Associating third-party barcodes is used when the barcodes of goods received by the warehouse cannot be recognized. In fact, it is the third-party product/single product barcode of the customer. The customer can send the value-added to associate the third-party barcode and send it to the warehouse for listing!',
  'T89W3a': 'Download file',
  'UfoHwU': 'Order number type',
  'V9S9uv': 'File name [{name}] is repeated, please reselect! ',
  'cO5UFq': 'Associated SKU type',
  'ggcKT8': 'Third-party barcode',
  'giMLRM': '{eventNo} abnormal order number does not exist',
  'm34H3v': 'Unique Identification Code',
  'oijERP': 'Associate abnormal order',
  'rl5zz3': 'File size cannot exceed {maxSize}M!',
  'vEYQZT': 'Order number',
  'vEuIg5': 'Type of Identification Code',
  'wmnWea': 'Associated product code',
  '6EEpFW': 'If you need to delete the label file, the corresponding relationship of the original label file will be deleted at the same time. Please confirm whether to delete it?，将同时删除原标签文件对应关系，请确认是否删除？',
  'XaZQMp': 'If you need to re-upload the label file, the original label file correspondence will be cleared. Please confirm whether to re-upload?',
  'Ds9qr8': 'Abnormal information: The third-party product barcode has not been registered, so the added value cannot be choosed!',
  'uS1tJ+': 'X/Y, X represents the number of goods ordered for destruction, and Y represents the number of goods actually destroyed',
  'RC/HA7': 'Check that the relevant content has been entered for this value-added service. Lowering the quantity will clear the corresponding information. Confirm whether to clear it?',
  'VX99e/': 'Quantity of goods destroyed',
  'khx6h/': 'This atom only supports abnormal single entry delivery!',
  '7eLyWG': 'Please select the sku to be deleted',
  'QUMHES': 'Label code',
  'cErjIB': 'Restore default product information',
  'fn6TWE': 'Continue to create a value-added order',
  'nM2tb2': 'Save for processing',
  'x8lXXz': 'Reset successful',
  'Dg4vC0': 'Quantity of items ordered',
  'G5g/iN': 'X/Y, X represents the number of items ordered for destruction, Y represents the actual number of items destroyed',
  'XbQUq7': 'Quantity of items destroyed',
  'xBu6OX': 'Quantity of items completed',
  'f2lZyL': 'X/Y, X represents the number of labels issued, Y represents the number of labels actually completed',
  '/BhYUx': 'Handle method',
  '4jItZi': 'VIP customization indicators',
  'jw6ytD': 'Report',
  '0iQEVl': 'Synchronize main inventory',
  '2Zx7sc': 'Current data acquisition time 2024-01-01 14:00:01 Data is for preview only',
  '3Pjapv': 'Please ensure that all products connected on TEMU have been assigned organizations and inventory. Products that are not assigned organizations will default to {num} inventory, which will affect platform push orders and other operations{break} There are currently {count} products with a current organization inventory of {count}. Please process as soon as possible. {link}',
  '3tpUnz': 'If you need to adjust the inventory allocation of goods, please modify it in [Inventory Management-Organize Inventory]',
  '4Aiv9I': 'Current data acquisition time 2024-01-01 14:00:01 Data is for preview only, only the Winit products and corresponding platform products that have been matched are displayed',
  // '4u63Ch': '推送平台商品SKU在所选组织的总库存；多个组织将汇总库存',
  '6wHk32': 'No reminder',
  '8GCFT0': 'Synchronize platform',
  '8GRnN/': 'Winit products',
  '8PygXr': 'Whether to synchronize inventory',
  '99t1qc': 'Support platform-by-platform allocation of organizational inventory: help you lock the platform  and prevent overselling',
  // '99t1qc': 'Support platform-by-platform allocation of organizational inventory: Help you lock platform inventory to prevent oversold',
  '9n4qMZ': 'Synchronize inventory type',
  'Ca63SP': 'Platform synchronization update guide',
  'EiExyD': 'Support more new platforms to synchronize inventory: Add Temu, AliExpress platform inventory synchronization configuration',
  'GP4y0X': 'Real-time synchronization after inventory changes',
  'HR1sZX': 'Preview synchronization data',
  'IWTIB3': 'If you need to adjust the product matching relationship, please modify it in [Platform Synchronization-Product Matching]',
  'J2ZoaX': 'Platform Shop',
  'JyARXC': 'Winit Product*Quantity',
  'M271K5': 'Synchronize inventory rule configuration',
  'MRcDmq': 'Synchronize organization inventory',
  'MTYOZl': 'Go to modify',
  'O6aX6h': 'Currently there are {X} stores that have not been assigned to organizations. Please deal with them as soon as possible. (Stores involved: {platformAccountList}) {break} {XXX} store matches multiple organizations, does not support inventory synchronization, currently has {num} products, current organization inventory quantity is {count}, please process as soon as possible {link}',
  'OsWrOU': 'Please select the specified product',
  'Oyp6Ar': 'Specified store & warehouse',
  'Q5Q+On': 'Specified country',
  'QIhVr/': 'If you have any questions, please contact customer service',
  'R2VEw4': 'Inventory synchronization page optimization',
  'RcwF2N': 'Please select the rule status',
  'SG7Fui': 'Multiple product names need to be wrapped or separated by English commas, support up to {num}, double-click to switch to a single query',
  'WZS4/k': 'eBay platform synchronizes every xx minutes',
  'YTTk6E': 'Please select a rule name',
  'YXJ9aP': 'Synchronize rule',
  'ZlfiBd': 'Specify product',
  'b2W4L8': 'Update successful',
  'cNOkF1': 'Enabled',
  'czv8e1': 'Site',
  'dno1/E': 'Please select platform and inventory rules first',
  'fAuz9u': 'Preview inventory data',
  'fj7l5p': 'Please select synchronization rule',
  'g6zRLA': 'Scheduled synchronization',
  'hAqYO7': 'Synchronizing organizational inventory currently only supports selecting regions. If you need to synchronize the total inventory of several warehouses, please allocate it in the organization inventory',
  'iPtOqD': 'Automatic delivery and synchronization after ordering',
  'iYsMdD': 'Please select a specific country',
  'jVHk8u': 'Store name',
  'jqPOW5': 'Original eBay inventory configuration rules: Move to this page for management. If you have historical configuration rules, the data will be migrated together',
  'k214kS': 'Multiple product codes need to be wrapped or separated by English commas. A maximum of {num} is supported. Double-click to switch to a single query',
  'lYWbGM': 'Your product is out of stock in this warehouse. Please change to another warehouse to place an order',
  'nM5rsV': 'Estimated synchronized inventory quantity',
  'o+Tex7': 'Wanyitong Overseas Warehouse',
  'qdXN6d': 'Select product',
  'sH8P2N': 'Disabled',
  't4qfmz': 'View rule introduction',
  'tyq1B+': 'Please select a specific store',
  'ua9R+2': 'Please select the synchronization inventory type',
  'wR9gzr': 'Only synchronize platform products that have completed product matching',
  'xciusM': 'Specified store & warehouse & product',
  'xiHXtm': 'Specified store',
  'yt9qAF': 'Please select the synchronization platform',
  'ywHog2': 'Rule status',
  'wgY9RU': 'Switching the synchronized inventory type will lose the store and product data specified in the current list. Are you sure you want to switch?',
  'kAV6Pj': 'Support platform-by-platform allocation of organizational inventory: Help you lock platform inventory to prevent oversold',
  'mtLIlD': 'Specified product & warehouse',
  'quEI1p': 'To prevent misoperation and the time it takes for the switch to take effect, the synchronized inventory type can only be switched once within {time} hours. Please operate with caution.',
  '8zd1Pr': 'The switch limit has been reached (can only switch once within {time} hours), please do not operate frequently. If you need to switch the inventory type urgently, please contact customer service to apply, thank you for your understanding',
  'QJCj/0': 'Current data acquisition time {time} Data is for preview only',
  'yce93p': 'Current data acquisition time {time} Data is for preview only, only the Winit products and corresponding platform products that have been matched are displayed',
  '6fCl6i': 'Exchange Rate',
  'pKN5uW': '1. Obtain the China Merchants Bank exchange rate at 3pm every day as the next days exchange rate. The China Merchants Bank exchange rate viewing address is {link}. The exchange rate only displays data from the past 7 days.{break} 2. The outgoing currency refers to the currency with a balance, and the incoming currency refers to the currency with a debt. For example, when recharging USD to repay GBP debt, the exchange rate of the outgoing currency being USD and the incoming currency being GBP on the same day will be used for calculation.',
  'BB2ikr': 'Repayment Batch Number',
  'C3Ij5H': 'Exchange rate date',
  'C8HnT4': 'Repayment bill',
  'WZqpxv': 'ISP has returned the details',
  'a7wxBc': 'Repayment amount',
  'rGtSfL': 'Repayment time',
  'th1faz': 'Repayment Details',
  'xqS13l': 'Overseas warehouse has returned details',
  '1IlxVZ': 'Exchange rate inquiry',
  '1bpn0q': 'Guaranteed exchange rate',
  'E1eMGw': 'Guarantee record',
  'I/X6Uf': 'Guarantee amount',
  'QbDRWw': 'Original currency',
  'feZnQf': 'Guarantee currency',
  'q5d3vL': 'Guarantee period',
  'r6xKrc': 'Original currency amount',
  'CzKUXO': 'Select',
  'Ebq99k': 'Select',
  '1prDIo': 'Select [One file Upload parcel label], you need to ensure that the order of package labels in the file is consistent with the order of packages in the packing list, Winit will label according to this order.',
  'F8jfp0': 'Support uploading multiple files with multiple pages, if a single file contains multiple pages of labels, you also need to fill in the page numbers of the corresponding PDF files, Winit will label according to the specified file and page numbers.',
  'XZRhcb': 'Select [All ASN tags are the same to upload one file], you need to ensure that the order of package labels in the file is consistent with the order of packages in the order template, Winit will label according to this order.',
  'neUz85': 'Upload files and provide corresponding relationships with packages',
  'pFLKkN': 'Select [One file Upload parcel label], you need to ensure that the order of package labels in the file is consistent with the order of packages in the order template, Winit will label according to this order.',
  'ybewHv': 'Only support uploading single-page files, all labels for the objects being processed are completely the same.',
  'zALpCW': 'Select [Upload multiple files and provide correspondence with packages], you need to fill in the corresponding relationships between each package and the uploaded file. Support uploading multiple files, if a single file contains multiple pages of labels, you also need to fill in the page numbers of the corresponding PDF files in the relationships, Winit will label according to the specified file and page numbers.',
  '2DrbeP': 'Third-party single service',
  'dj20MF': 'Self-pickup service 1.0',
  'tDSpP/': 'Self-pickup temporary storage service',
  '06OsEH': 'Packaging Weight{break}(KG)',
  '47d8N1': 'Unique Identifier Code Type',
  '7B53IP': 'Packaging Outer Diameter Size{break}(CM)',
  '9BM1R0': 'Unique Identifier Code',
  '9zDqZw': 'Packaging Standard Size{break}(CM)',
  'EVT5uf': 'You can <url>click on the link</url> to register a new product, issue a new SKU barcode for replacement, and resubmit for value-added services',
  'NGH30T': 'Value-added service: {serviceName} only supports a single product. The SKU of the product you selected in the first step of ordering is not a single product SKU. Please modify.',
  'Pyomlx': 'Packaging Inner Diameter Size{break}(CM)',
  'Ziq7lV': 'Packaging Material Product Code',
  'j6ntB1': 'Custom Packaging Product Barcode',
  '/FB7Vp': 'Product Code Within Product Group',
  '/PTxEF': 'Enable Warehouse Group',
  '/yffaD': 'Disable Organization Inventory',
  '00Xv+h': 'Bound Automatic Allocation Rules',
  '05DQ6l': 'Platform Store Information',
  '07tt8s': 'View More Records',
  '1+y1bf': 'Designated Allocation when Ordering (Coming Soon)',
  '1TVzx6': 'Organization Inventory {break} Available Quantity',
  '1ukyO/': 'No Products Added',
  '2DPEbO': 'Import/Export Content',
  '2FYaur': 'Select Return-to-Stock Organization',
  '2Hmmtv': 'Organization Code/Organization Name',
  '2UCGrz': 'Unbound Automatic Allocation Rules',
  '2sTxi7': 'Warehouses in Warehouse Group',
  '3/8rtJ': 'Transfer Inventory Quantity',
  '33DNab': 'Supports up to {num} Internal Product Codes within the group',
  '3nUEa0': 'Export Initialization Template and Data',
  '3ny3on': 'To-Be-Shipped Inventory',
  '3yklXZ': 'Ordered Products',
  '4++SnE': 'Select Insufficient Public Inventory Handling Method',
  '5Qc7Hj': 'Character length not exceeding 24 digits',
  '6iBjmn': 'Organization Code [{x}] already exists in [{y}]. If [{z}] needs to be used, the organization name must remain consistent. It is recommended to select an existing organization code for adding!',
  '6tZ/1+': 'Close?',
  '74azmI': 'Files are incomplete and need to be supplemented? <a>Go to edit></a>',
  '83SQTp': 'Note: After creating a warehouse group, API/ERP will return inventory information within the warehouse group according to the main warehouse. In addition, the priority of warehouse group configuration is higher than the original priority of enabling warehouse cluster management and cross-warehouse cluster management!',
  '8IM/VX': 'Switching the ordering country will clear the selected warehouse and ordered product list. Please confirm if you want to switch?',
  '8PwA5e': 'Inventory Settings',
  '8qMOuZ': 'No valid organizations exist within the corresponding country, <a>go to process>></a>',
  '9Ai3+n': 'Note: Deleting this platform store will no longer apply to this organization inventory, which may affect subsequent orders and inventory synchronization for this platform/store. Are you sure you want to delete?',
  '9GOQAZ': 'Inventory Management Dimension',
  '9pkAz+': 'Automatic Allocation Rule:',
  '9qbR0x': 'Switching the ordering country will clear the selected warehouse. Please confirm if you want to switch?',
  'A1UnPb': 'View Allocation Strategy',
  'AqXCTK': '<url>Download Bulk Order Template</url>',
  'B8z1Yk': 'Organization (Order Fails if Organization Inventory is Insufficient)',
  'BEPP+g': 'To-Be-Shipped Inventory Details',
  'BUSFFP': 'All Products',
  'CaVbi3': 'Continue Adjustment',
  'CpPFKX': 'Undifferentiated Store Management',
  'EO9v0T': 'Edit Product Within Product Group',
  'EYW63V': 'Allocation Method',
  'F4fn5Z': 'Select Whether Defective Products are Usable',
  'FhAaey': 'Show Recent 30-Day Change Records',
  'Fsizc+': 'Transfer Out Organization/Name',
  'GEQM/h': 'Import/Export Status',
  'GxLLvQ': 'The organization inventory for country [{countryCode}] has not been initialized, adjustments are not allowed. Please perform inventory initialization first!',
  'H4yCmH': 'At least one platform store information is required',
  'HBuPwU': 'Duplicate Organization Codes within the same country are not allowed',
  'I37xbU': 'Please fill in',
  'IP+jXQ': 'Store',
  'IbZi+n': 'Duplicate selection of the same platform and store is not allowed',
  'IrP5Xx': 'Select Insufficient Organization Inventory Handling Method',
  'IxwwdH': 'In-Store Process',
  'J1wj7m': 'All organizations within the country must be invalid to allow closure, and all invalid organization information will be cleared after closure.',
  'JESDBu': 'Allocation after Shelves',
  'K5FdtU': 'Outbound Settings',
  'KGyDeG': 'Organization Management Mode',
  'KeIHG5': 'Supports up to {num} Product Codes',
  'KsARVE': 'Inbound Process',
  'L+bkwA': 'Return-to-Stock Organization',
  'LiMe6f': 'No Product Group Specified',
  'Lntzil': 'Organization [{countryCode}] has not been set up or allocation strategy setting is incomplete. Please set up before initializing!',
  'Lv0XhX': 'Global rules for country {nationStr} have not been set up completely. Please complete before saving!',
  'MNXVRx': 'Enable Organization Inventory',
  'MWwpe1': 'Select the countries to enable',
  'MZdgiP': 'Frozen Quantity',
  'Ma8dWp': 'Specify Part of the Products',
  'MarGpd': 'Insufficient Public Inventory Handling Method',
  'Mj9ynL': 'Total Available Inventory',
  'MnS8fr': 'Batch Order Organization Inventory Adjustment',
  'O9gLkH': 'Document No.',
  'OT5/ik': 'Warehouse Group Name Duplicate',
  'Oxs/IJ': 'Unable to trace processing method',
  'P+K6Pr': 'Allocation Strategy Setting',
  'P0CKu+': 'Organization Details',
  'P6pH0T': 'Organization Code',
  'PEIjVj': 'Add Organization',
  'PQbeYX': 'Product Group Code',
  'PkS0w0': 'Country-Organization Management Mode List',
  'QHMibT': 'To-Be-Shipped Quantity',
  'QavrS/': 'Rule Name',
  'R0kxbt': 'Organization Inventory Adjustment Order',
  'R1AWra': 'Receiving Organization/Name',
  'RDgk5M': 'Global Rules',
  'RbyWkB': 'Applicable to Some Organizations',
  'RkMw3V': 'Applicable Allocation Strategy Details',
  'S1VEI4': 'Enable Organization Inventory?',
  'SiZzRo': 'Select Product Group',
  'THHVjx': 'Add Custom Automatic Allocation Rule',
  'Ta3sML': 'Product Group Name',
  'TqfG+H': 'Not Enabled, Cannot Edit',
  'UXFmnr': 'Available Changeable Quantity',
  'VCUzC7': 'No duplicate selection of countries allowed',
  'Vcz4jn': 'Setting Successful',
  'W3MKCX': 'No Product Groups',
  'WDuBaK': 'Organization Code/Organization Name',
  'WVYZTQ': 'Add Products within the [{name}] Product Group',
  'WiIsHg': 'Order Type-Operation',
  'Wv1lPZ': 'Allocation Strategy',
  'XhO5Xk': 'Add Platform/Store',
  'YpfZ65': 'Close Organization Inventory?',
  'YrE9ZY': 'Note: Allocation is executed at 0:00 local time daily!',
  'Z6z+qp': 'No, Exclude from Organization Inventory',
  'ZYpfKh': 'Automatic Allocation Needed?',
  'ZYwocN': 'Allocation Ratio',
  'ZiIw56': 'Edit Organization',
  'ZtafHE': 'Organization Name',
  'a3i5lR': 'Note: After setting defective products as usable for inventory initialization, changes are not supported!',
  'aV9FJR': 'Closure Successful',
  'ab9zcP': 'Select Add',
  'aoVhjJ': 'Go to Organization Management Page',
  'bi2QaT': 'Please select inventory organization',
  'cAOQZZ': 'To be set',
  'cvLQUR': 'Applicable to all organizations',
  'dKd38j': 'Please select the untraceable processing method',
  'e5yrxb': 'The quantity of outbound is greater than the available quantity of inventory in the organization, please modify',
  'f3Q3B+': 'Support Chinese, English, numbers and basic symbols!%-,./',
  'fByLAS': 'Final Available Inventory',
  'fKDEpS': 'Support up to 500 product codes/product barcodes',
  'fX8PsS': 'Initial inventory',
  'frT5lF': 'Yes, consistent with the good product',
  'fxJ2A4': 'Edit global rules',
  'g5duw8': 'Can defective products be used',
  'greiLB': 'The sum of all organization ratios must not exceed 100%',
  'h9Zi8A': 'Edit products within the product group of 【{name}】',
  'hD/l+2': 'Operation type',
  'iEr7Yj': 'Public inventory',
  'iPUZTb': 'Ratio',
  'iRUm9e': 'The product group has not been set up yet, you can save the rules first and then add or go to add immediately >>',
  'iw8JBy': 'Multiple product codes within the group need to be separated by line breaks or commas, supporting up to {num} items, double-click to switch to single query',
  'jFV/PS': 'If automatic allocation is not enabled, the products will default to be shelved in the public pool. Once enabled, the inventory in the public pool will be automatically allocated to the applicable rules configuration organizations.',
  'k4R4oN': 'Multiple codes need to be separated by line breaks or commas, supporting up to {num} items, double-click to switch to batch query',
  'kFWSjf': 'Change time (Beijing time)',
  'kTal8c': 'Business document',
  'lGIYNy': 'Recent organization inventory flow',
  'lH5CEc': 'I am aware of the usage scenarios of the warehouse configuration and confirm that I need to use this function!',
  'lfUbAE': 'In effect',
  'm2P0jx': 'Can\'t find the store? <a>Go to add></a>',
  'mA6taV': 'Note: Insufficient inventory will be rounded down, and excess inventory will be allocated to the public pool.',
  'mNQ9rR': 'Final Available Inventory',
  'njWfGp': 'Confirm removal?',
  'oUf21w': 'Only support English, numbers and basic symbols!%-,./',
  'ob2lzc': 'Manual allocation',
  'pAVVEX': 'Batch order',
  'pSgnf3': 'Platform',
  'poqfFR': 'Not allowed to select organizations repeatedly',
  'qN+r40': 'Double-click to switch to batch query for product codes within the group',
  'qT4N0f': 'Allocation node',
  'qwiW4l': 'Initial available inventory',
  'rj1FnG': 'The transferable inventory quantity is: {realUsableQty}, insufficient inventory',
  'rkGaTC': 'View products within the group of 【{name}】',
  's1JabS': 'Ordering country',
  'sHewIU': 'Public ',
  'sXYWIe': 'Allocation ratio setting',
  'satd2e': 'View flow',
  'sgSypa': 'Switching will clear the data already added in the following list, continue?',
  'stFVYC': 'Applicable allocation strategy',
  't8rE2T': 'The in-stock inventory of the organization does not include temporary RM code inventory. If defective products are set as unsellable, they are not included in the defective product inventory.',
  't9BcSt': 'Create organization inventory adjustment order',
  'tIUEDk': 'Warehouse group name',
  'tjYf78': 'Opened successfully',
  'tzxFFx': 'Enter product code',
  'v013Hs': 'Retrieve goods lost in the warehouse',
  'v58RVX': 'Please select the applicable country first',
  'vY86r/': 'Add product group',
  'vYSfcl': 'Insufficient inventory handling method for organization',
  'wfMiN1': 'Organization',
  'wl0SFW': 'Inventory organization',
  'wuECGB': 'Please enter an integer from 0 to 100',
  'xNrgSc': 'Transferable inventory quantity',
  'xaJbmp': 'If closed, automatic allocation will not be carried out, but the original allocation rules will continue to be retained, continue?',
  'xwLj+1': 'Not in effect',
  'xzpkgM': 'Return Inbound process',
  'y7IuXR': 'Edit automatic allocation rules',
  'yq0Wfa': 'Switching ordering countries will switch the order product list, please confirm if you want to switch?',
  'yt82oq': 'Automatic allocation rules have been bound and cannot be deleted!',
  'yuDBWt': 'Automatic allocation product group configuration',
  'ywvM6Z': 'Applicable Product Group',
  'zSagJu': 'Management dimension',
  'zbMJYb': 'Winit adjustment order No.: {docNo}',
  'zhvmkQ': 'Please select allocation node',
  '7c7h29': 'Please select Non-outbound consumption inventory processing method',
  'EeSMVF': 'Product Group already has a custom strategy and cannot be added!',
  'Feb0g4': 'Please select Non-inbound product plus inventory processing method',
  'Fufjof': 'Check if the strategy is set up, <a>go to process>></a>',
  'WICKWi': 'Merge query warehouse',
  'bK//gf': 'Non-inbound product plus inventory processing method',
  'cV0Yy/': 'Non-outbound consumption inventory processing method',
  'ckk76H': 'Goods lost, damaged, frozen, or value-added out of the warehouse in abnormal out-of-stock scenarios.',
  'ctKGBq': 'After opening organization inventory, you can split the same inventory of Winit to different organizations (platform, platform store, team/channel) for use. Please continue to select the corresponding management mode for the country.',
  'xTLIgG': '<fw600>Operation Instructions</fw600>: {break} 1. After successful initialization, orders will be allocated and frozen according to the initialized inventory. If the organization inventory synchronization to the platform is enabled, the corresponding organization\'s inventory quantity will be synchronized to the platform! {break} 2. Except for designated organizations allowed to use the public pool, public pool inventory is not available for orders from other organizations! {break} 3. When importing, all SKUs must be complete. If there are missing SKUs that are not imported, the import will not be successful! {break} 4. If there is no current inventory, there is no need for initialization. The inventory will be automatically updated as initialization completed. {break}',
  '39J8D8': '<strong>Platform inventory management</strong>: Applied to split the same inventory for different platforms or stores, the corresponding platform inventory synchronization supports synchronization according to the allocated organization, and platform information must be provided for outbound orders.{break} <strong>Team channel management</strong>: Applied to split the same inventory for different teams and channels, the organization code must be provided for outbound orders, and it is mutually exclusive with platform push orders and ERP push orders.',
  'CL3sbp': 'Applicable Product Group',
  'RfaPml': '<strong>Warehouse level</strong>: Organizational inventory is synchronized with physical inventory, managed based on specific warehouses.{break} <strong>Country level</strong>: Organizational inventory is aggregated by country based on physical inventory, without the need to allocate organizational inventory to warehouse dimensions, managed by country for inventory management.',
  '5yWDeS': 'Batch order failed',
  'gmmv7o': 'Line {index}: {msg}',
  'E2W8HL': 'The available quantity of the organization\'s inventory includes the available quantity of the inventory organization selected by the order and the available quantity of the public pool inventory.',
  '+0tDgG': 'Move to this page for management. If you have historical configuration rules, the data will be migrated together',
  '2IQ4IG': 'Original eBay inventory configuration rules: ',
  '5Jcaq4': 'NEW',
  '8fL2iW': 'eBay platform synchronizes every 30 minutes',
  '+RzevE': 'No: No organized inventory',
  '9nxpUA': 'Expected synchronization of inventory data',
  'HxQTfu': 'The inventory synchronization page is updated as follows:',
  'eqriiv': 'Help you lock the platform inventory and prevent overselling. The platform inventory management is temporarily open to invitation only. Please contact customer service to apply for permission to use it. ',
  'KOB/Zk': 'Add Temu, AliExpress platform inventory synchronization configuration',
  'i0lbH+': 'Support platform-by-platform allocation of organizational inventory:',
  's2CUA7': 'Support more new platforms to synchronize inventory: ',
  't2iHNJ': 'Update',
  'ud1Gl4': 'If you have any questions, please contact customer service ~',
  'LNkhHz': 'Please ensure that all products connected on {platform} have been assigned organizations and inventory. Products that are not assigned organizations will default to 0 inventory, which will affect platform push orders and other operations.',
  'FiJma7': 'Help you lock the platform inventory and prevent overselling. The platform inventory management is temporarily open to invitation only. Please contact customer service to apply for permission to use it',
  'VZ+X/o': 'You have not yet enabled the organizations inventory permissions. Please first enable the organizations country permissions in [Personal Center-Preferences-Inventory Settings]',
  '0gq9mO': '{platform} platform does not support deactivating inventory rules',
  'dWyauH': 'Aliexpress(osc)',
  'U2xihl': 'The current page of eBay inventory rules has been upgraded, and the historical configuration data has been moved. Please move to the inventory synchronization rules page to view',
  'cUg6/f': 'Go',
  'jAdq2h': 'eBay platform does not support deactivating main inventory rules. If necessary, please delete the rules in the list',
  '+gYY+c': 'Partition level Delivery rate in N days',
  '/LCltR': 'Hour',
  'E/bqbL': 'Denominator (actual number of packages shipped): the actual number of packages shipped within the statistical time range; {break}Number (number of Ascan packages): the number of packages with Dscan within the denominator. ',
  'IIyGq5': 'Ascan rate',
  'd1o3FQ': 'Delivery rate in N days',
  'qYx2dy': 'Denominator (actual number of packages shipped): the actual number of packages shipped within the statistical time range; {break}Number (number of Ascan packages): the number of packages with Ascan within the denominator. ',
  'reAu6u': 'Calculation unit',
  '9wjUe/': 'Ascan timely rate & average time consumption & Ascan rate',
  'mrJoJE': 'Dscan timely rate & average time consumption & Delivery rate in N days',
  'utwdg2': 'Destination partition group',
  'b6im02': 'Denominator (actual number of packages shipped out of the warehouse): the number of packages actually shipped out of the warehouse within the statistical time range; {break}numerator (number of Dscan packages): the number of packages with Dscan within the denominator range. ',
  '1la4o2': 'Length*width*height{unit}',
  '2s/F3l': 'Enable barcode value inventory management',
  '2z0biH': '#With Log',
  '3XiN1k': '#Chemical Products',
  '5XYPrq': '#High value(Charges vary)',
  '6gT400': '#With Three Plywood Or High Density Plate',
  'BKTNSa': 'Registered Length*Width*Height/Verify length*width*height',
  'BuWYZW': '#Second Hand',
  'FhjmzP': 'Is there any allergen',
  'HGjBIi': '#Magnetic',
  'Kmi2zT': '#Food',
  'My7yVH': '#18+',
  'Ob+lrT': '#With Powder',
  'P8thZa': '确定生效? 生效后会立即调整库存查询方式，仓库组内仓库的库存均按主仓返回',
  'PMBp0w': '#With Liquid',
  'RnLp7c': 'Registered volume/Verify volume',
  'VsgmEm': '仓库组内所有仓库的库存会合并至主仓显示与查询',
  'X0e6vT': '#With Battery',
  'Y2Iwjt': '{tip}',
  'e11fjP': 'Volume{unit}',
  'emULBJ': '#With The Socket',
  'gsPTjg': 'Standard Box Length*Width*Height(cm)',
  'j2GBkQ': 'Is it confirmed to be invalid?',
  'kqV2cw': 'Weight{unit}',
  'nrVjq9': '#Packaging materials',
  'rfo4U+': 'Registered Weight/Verify Weight',
  'vv0hh3': 'collect package barcodes',
  'wS3w6e': '#Returned SKU',
  'xsTk6Z': 'physical batch information diagram',
  'RJC56U': 'Please enter the main order number',
  'Vm6LvY': 'Warehouse [{warehouseName}], SKU code [{merchandiseCode}], specifications [{specification}] inventory has changed. The goods that are prohibited from being shipped out can only be picked up once. Not all available inventory has been shipped out. Please transfer all inventory to the same organization and re-add it.',
  '+vP+SG': 'AliExpress-direct (overseas hosting) November 24 promotion',
  '/cApcc': 'Amount to be locked',
  '0GjTAr': 'Completion status',
  '14g/Lr': 'AliExpress-direct (overseas hosting) exclusive inventory activity has started, welcome to participate!',
  '2N4FZ4': 'Remaining quantity of locked inventory',
  '7C32RF': '《Platform Lock Inventory Agreement》',
  'CYi8IL': 'Completed',
  'DMwUe3': 'Participate immediately',
  'JMtGcm': 'Please read the agreement first',
  'K4E4Fa': 'Lock inventory balance',
  'KrzXJz': 'AliExpress (overseas hosting)',
  'LMtxPc': 'Please enter the product code, support batch query',
  'P3HDvw': 'Lock inventory changes',
  'QFscDZ': 'I have read and agreed to{a}',
  'QxyKF1': 'Activity',
  'ULjwS9': 'View Guide>',
  'WigRjw': 'The activity will start on {date}, please come on time to participate and complete the lock',
  'XqcI4W': 'Activity Time',
  'YFUi1Q': 'Locked Amount Change Log',
  'gQ4+K1': 'Date',
  'ggwfF0': 'Push Status',
  'm5TFEu': 'AliExpress-direct (Overseas Trusteeship) Lock Inventory Activity Import Template',
  'stTlh/': 'Dear merchants: To participate in the AliExpress overseas hosting exclusive inventory activity configuration, AliExpress will provide up to 30% of the value of the goods in advance for merchants and products that meet the rules based on the number of exclusive inventory items. For specific rules, please check the relevant announcement on AliExpress. {break}{break} Note the prerequisites for use:{break} 1. Organization inventory management needs to be enabled,{a1}{break} 2. A unique organization needs to be created for the AliExpress (Overseas Trusteeship) platform, and the corresponding number of merchants needs to be allocated to the organization,{a2}{break} 3. Authorize AliExpress (overseas hosting), {a3}{break} 4. Platform synchronization inventory rules, AliExpress (overseas hosting) platform rules switch to organization management, {a4}{break}',
  'x4lQTo': 'Dear merchants: AliExpress will provide advance loan benefits of up to 30% of the value of goods each time for merchants and products that meet the rules based on the number of exclusive inventory items. For specific rules, please check the relevant announcement on AliExpress.',
  'xxEkqr': 'Active version',
  'zNyLRU': 'Unfinished',
  '/MUt5x': 'Enable Warehouse Group Inventory',
  '58hly4': 'Explanation:{break} 1. After creating a warehouse group, when using Open_API (including integration with ERP systems) to query inventory by merging warehouses, the inventory of all warehouses within the warehouse group will be merged and returned. It does not support querying inventory by individual warehouses within the warehouse group.{break} 2. The priority of warehouse group configuration is higher than the priority of original warehouse cluster management and cross-warehouse cluster management.{break} 3. The inventory query of Winit opc will not be adjusted.',
  'YF0J+L': 'Confirm effective? After it takes effect, the inventory query method will be adjusted immediately. The inventory of all warehouses within the warehouse group will be merged and returned according to the merged query warehouse!',
  'lBsCBG': 'I understand the usage scenarios of warehouse configuration and confirm the need to use this function! (<span>Special note: </span>After creating a warehouse group, when using Open_API (including integration with ERP systems) to query inventory by merging warehouses, the inventory of all warehouses within the warehouse group will be merged and returned. It does not support querying inventory by individual warehouses within the warehouse group.)',
  '19b/CI': 'I understand the usage scenarios of warehouse configuration and confirm the need to use this function! (<span>Special note: </span>After creating a warehouse group, when using Open_API (including integration with ERP systems) to query inventory by merging warehouses, the inventory of all warehouses within the warehouse group will be merged and returned. It does not support querying inventory by individual warehouses within the warehouse group.)',
  'hBk4PW': 'Explanation:{break} 1. After creating a warehouse group, when using Open_API (including integration with ERP systems) to query inventory by merging warehouses, the inventory of all warehouses within the warehouse group will be merged and returned. It does not support querying inventory by individual warehouses within the warehouse group.{break} 2. The priority of warehouse group configuration is higher than the priority of original warehouse cluster management and cross-warehouse cluster management.{break} 3. The inventory query of Winit opc will not be adjusted.',
  'kjT4OO': 'After you switch the inspection type, the current inspection data will be cleared. This clearing is irreversible. Please confirm whether to switch?',
  'IzLc7g': 'Rolling back the draft order will cancel the appointment order you created. If you continue to submit the draft order, please recreate the appointment order after submission!',
  'hopP4K': 'The file was not uploaded successfully',
  'HKRVa7': 'Read and agree to sign',
  'O1bX+T': 'Read and agree to the update',
  'q9tc4Z': 'WINIT Overseas Warehouse Commercial Terms Supplementary Agreement',
  'u9tp6T': 'Supply Chain Management Service Agreement',
  'hWtisa': 'New order listing information',
  'R+0iVI': 'Download the value-added result image',
  'rZWk1i': 'Batch order upload settings:{break} Currently, the default setting is to save the uploaded orders as "draft" status.{break} You can choose to "upload and submit directly" by checking the option. In the batch upload page, you can choose to save the uploaded orders as "outbound confirmation in progress" status, so you do not need to submit the orders again after uploading.{break}',
  'Ozl3ur': 'Go to the submitted orders.',
  'TDChQE': 'Set up my upload preferences',
  'WAEEkr': 'Self-pickup temporary storage and outbound (import draft order number).',
  'XUIX90': 'Submitted',
  'a18vC6': 'If it is a self-pickup temporary storage service {a}.',
  'atrzHq': 'Self-pickup temporary storage outbound (supports multiple value-added services).',
  'hn8/F1': '"1. Only outbound orders that require supplementary value-added services are supported.{break}2. Orders placed in batches on the current page do not support intelligent recommendation.{break}3. The warehouses of the uploaded orders must be the same. If there are orders with different outbound warehouses, please submit them in multiple times.{break}4. Please upload the batch template file first (no more than 200 orders at a time), and then submit value-added services. Click confirm after all uploads are successful.{break}',
  'lVaxXz': 'You have selected the value-added service of [Packing by Specified Quantity of Commodities] at the same time. Please upload the packing details first, and then download the template of [Other Parcel Labels or Documents]. The system will automatically fill in the package serial number to avoid duplicate filling.',
  'm3TyPy': 'If it is a three-party waybill service {a}.',
  'gcULbV': 'This feature supports users to batch select value-added services and upload tag files, such as attaching product labels or attaching European agent labels, etc.{break}This feature provides self-pickup service, and after the self-pickup order is successfully submitted, users can schedule to pick up the goods at the warehouse at a specified time.',
  '0kI3dV': 'Waiting for customer confirmation',
  '2G6+VQ': 'The actual quotation shall prevail. Please confirm the quotation after the review is completed.',
  '7Yargg': 'Item',
  'Kh+jB9': 'The value-added object has changed, and the added product information will be automatically deleted. Are you sure you want to make the changes?',
  'Yx+rpK': 'Confirm quote',
  'cTokzx': 'View quote',
  '+7FoE0': '1. When the value-added object is a SKU, specific SKU information must be specified for the value-added.{break}2. When the value-added object is a single item, specific single item information must be specified for the value-added.{break}3. When the value-added object is other, there is no need to specify SKU or single item information for the value-added. Please provide specific value-added requirements when selecting value-added service products in the next step.',
  '5lK4bN': 'Only supports {fileType} format',
  'rCHoyP': 'Additional explanation',
  'uwmfN9': '1. When the value-added object is a SKU, specific SKU information must be provided for the value-added service.{break}2. When the value-added object is a package, specific package information must be provided for the value-added service.{break}3. When the value-added object is an order, there is no need to specify SKU or package information for the value-added service. Please provide specific value-added requirements when selecting value-added service products in the next step.',
  '+YI1XG': 'Sales Reference for Single Product',
  '+eP0EZ': 'Use Third-Party Product Barcodes',
  '/s++ei': 'Please carefully check whether the maintained third-party product barcodes are correct. If there are binding errors or omissions, it will lead to incorrect inventory allocation, inability to recognize during inbound, and other anomalies, resulting in unnecessary costs.',
  '11POth': 'Package Code Required for Outbound Collection',
  '2riisj': 'Risk Warning',
  '3mZDwG': 'Single-Time Split Demand',
  '6zMjBQ': 'Sales Reference for Suite Products',
  'CprVCI': 'Is Package Code Required for Outbound Collection',
  'LHXw9T': 'Meet the Future',
  'PN92Iq': 'Confirm Import Without Errors',
  'QdyY3D': 'Enter at least 2 characters, double-click to switch to batch query',
  'WjHtF1': 'Is Physical Barcode Consistency Check Required for Inbound',
  'XF2kX7': 'Set Single Disassembly Demand',
  'd9/BRG': 'Sales Reference for Box Products',
  'gP0n6A': 'Starts with',
  'hOA76J': 'Equals',
  'nMoMXh': 'Is Physical Barcode Consistency Check Required for Inbound',
  'unwvr3': 'Please enter a positive integer ≤52',
  'y5s4nK': 'Enter at least 2 characters',
  'yHzId3': 'Whether To Use Third-Party Product Barcodes',
  'zkVUHd': 'Maximum of {num} queries, double-click to switch to single query',
  'JuNzF9': 'This preference setting default value will be referenced by individual registration pages and registration templates, please choose according to the actual business scenario!',
  'XKSryg': 'Default is no verification required. If you choose "Verify consistency of third-party package code with third-party product code", an value-added service order will be automatically generated for this product each time an inbound order is created, for checking the consistency of the third-party package code and product code during the warehouse inbound shelving process [additional handling fees apply], and if the verification does not match, it will be intercepted for shelving. (This feature requires application through the account manager)',
  'gdOugC': 'Assuming the current configuration is as follows:{break} Setting the average weekly sales reference period: Single product [last 4 weeks], box product [last 8 weeks] {break} Total sales of single product customers [last 4 weeks]: 100 units, then the average weekly sales volume is 100/4 = 25 {break} Total sales of box product customers [last 8 weeks]: 40 boxes, then the average weekly sales volume is 40/8 = 5 {break} Setting the future demand to be met: Meet the demand for the next [5 weeks], i.e. {break} Demand for single product: 25 * 5 = 125 pieces {break} Demand for box product: 5 * 5 = 25 boxes {break} {break} When the available inventory of single product is <125 pieces, and while maintaining the minimum demand of 25 boxes for box products, automatic disassembly will be triggered to meet the demand of 125 pieces for single products.',
  '0jyrwS': 'Number of fulfilled contracts',
  '3ABpBR': 'Number of shipments',
  '4jTYjW': 'Number of cargoes unloaded',
  '5nUP7h': 'Number of Dscan completed',
  'JLEpKl': 'Number of Ascan completed',
  'awHDKA': 'Number processed',
  'hHhj5t': 'Number put on the shelf',
  'rR8IIy': 'Number temporarily stored',
  'g2+Qaz': 'Timely fulfillment rate',
  '0VyNFr': 'Number of overdue unfulfilled orders and not outbounded',
  '2VBdzB': 'Number of unfulfilled outbounded',
  '3IT9O4': 'Number of fulfilled outbounded',
  'fWuU1S': 'Number of unfulfilled contracts and not outbounded within the time limit',
  'kFqoD8': 'Outbounded',
  'vYm9gA': 'Not outbounded',
  '6sRGhD': 'Date to be shipped out (local time zone of overseas warehouse)',
  'yCcbFa': 'Denominator: within the target delivery date range, the number of non-draft/customer-voided/Wanyitong voided/failed to capture orders that should be delivered and fulfilled; {break}numerator: within the denominator range, the actual delivery date <=Number of packages on the target delivery date;{break}Formula: Delivery fulfillment rate=Number of fulfilled deliveries/(Number of fulfilled deliveries+Number of unfulfilled deliveries+Number of unfulfilled deliveries over time);{break} Note: The data is not a cumulative value and needs to be viewed in conjunction with the date. {break}For example, in 20241028, the number of contracts that should be fulfilled is 10, which means that the number of packages that should be shipped out of the warehouse on 20241028 is 10 (excluding the data that should be shipped out before 20241028). The same applies to other numerical fields. ',
  '0/oh6t': 'All packages use the same label. You need to upload a file of one package. Do not upload duplicate files.',
  'LOpyZ0': 'Upload a file of a single item. (Do not upload repeatedly.)',
  'P1jrho': 'All single items are labeled with the same label. You need to upload a file of one single item. Do not upload duplicate files.',
  'SDVcmX': 'Multiple multi-page files are supported for upload. If a single file contains multiple pages of labels, you also need to fill in the page number of the PDF file in the corresponding relationship. Winit will label according to the specified file and page number.',
  'h5KDJr': 'Upload a file of a package. (Do not upload repeatedly.)',
  'vYrliL': 'Upload a file. (Do not upload repeatedly.)',
  '/8alR4': 'Consistency',
  '6Fz+Ci': 'Collected third-party product barcodes',
  'EeMYcH': 'Whether the collected barcodes correspond to the products',
  'RENO/4': 'Collect barcode qty',
  'YN26Xr': 'Inconsistency',
  'a+1Vch': 'Example of collecting barcode',
  'nSVlEa': 'The product barcode corresponding to the collected third-party product barcodes',
  'u/mLpO': 'Reasons for inconsistency',
  'wGe4Z6': 'Collected third-party package barcodes',
  'wuRf4t': 'Whether barcodes have been collected',
  'xevV+W': 'View example image',
  '+3xFjg': 'Recommendation successful',
  '+LWuuv': 'Single warehouse recommendation result',
  '+oQtIQ': 'Outbound quantity',
  '/KORqN': 'Recommendation failed',
  '1ORJ7h': 'After upgrading to version 2.0, it will not be possible to roll back to version 1.0. Please confirm whether you want to continue upgrading?',
  '1Tn8rf': 'Inventory',
  '1ktbT6': 'Note: After upgrading to version 2.0, the optimal recommendation plan will be automatically selected for shipment.',
  '1rSNtA': 'Warehouse groups can be custom configured.',
  '1v9PKl': 'Explanation of differences between intelligent recommendation version 1.0 and 2.0:',
  '4kQRdF': 'Customer order NO./Order NO.',
  '7KBSXt': 'Originally ordered product',
  '7eKHJK': 'Cost minimization > shortest delivery time. {break}Strategy priority cannot be adjusted.{break} <red>Only single warehouse recommendation is supported.</red>',
  'AvnTVw': 'After switching from version 1.0 to version 2.0, the system will be initialized with the warehouse group recommendation strategy configuration according to the above 2.0 functions. You can customize and modify it at any time according to your needs.',
  'BnTyyZ': 'Inventory quantity',
  'E5PxaL': 'View log',
  'EaCNoe': 'SKU information',
  'FbO006': 'Original order warehouse',
  'GjDYjH': '"GFS" in version 1.0 is equivalent to "platform synchronization" in version 2.0.',
  'Lwij7I': 'The warehouses in the intelligent recommendation area of version 1.0 do not support custom configuration.{break} Version 2.0 can custom configure warehouse groups, and configure the corresponding shipping warehouses within the warehouse groups.{break} For example: US_GROUP (USWC2 Warehouse, USWC Warehouse, USTX Warehouse).',
  'MP5s1M': 'Recommended or not',
  'Nj/NFB': 'Group {num}',
  'Pi9Eo4': 'item',
  'RgJnNO': 'API order placement, batch upload,<red>GFS</red>',
  'TLmjdM': 'Warehouse combination',
  'WZhBnF': 'Set warehouse group inventory management rules',
  'XDe/3j': 'Shipping cost',
  'YGCSHM': 'Version 1.0 does not support custom configuration of recommendation channel groups.{break} Version 2.0 can set up intelligent recommendation channel groups according to different scenarios.',
  'Z/43fI': 'Reasons for non-recommendation',
  'ZGp72g': 'Recommendation result',
  'aCoNjU': 'Recommendation channel group',
  'aY0yyd': 'Warehouse priority',
  'c9diHK': 'Log information',
  'cIkOY/': 'Recommended product',
  'e9Qio7': 'Multi-warehouse recommendation result',
  'egHHtR': 'Current version 1.0',
  'fJSAuQ': 'Version 2.0 adds strategies on the basis of the original 1.0 strategy: {break} <red>Strategy 1: Prioritize shipping from warehouses with more inventory</red>{break} <red>Strategy 2: Customize the shipping order of warehouses</red>{break} The newly added strategies are mainly to solve the scenario of screening the optimal solution when the service cost and timeliness are the same. It can be shipped according to <red>prioritizing shipping from warehouses with more inventory or shipping according to the custom order of warehouses</red>',
  'iH0v1D': 'The order placement time cannot exceed one month!',
  'j3KqJP': 'Explanation of differences',
  'k8kDSD': 'View barcode value information',
  'mEBtRM': 'Support custom configuration',
  'mwckV9': 'API order placement, batch upload, <red>platform synchronization</red>',
  'n82G+/': 'Support on and off',
  'nMv4yf': 'US region, German region, Australian region',
  'nbwDiz': 'Recommended warehouse',
  'pvjx2D': 'If you need to manage inventory by warehouse group dimension, click here and you can enable "warehouse group inventory" management.',
  'rpKkGh': 'Version 1.0 supports users to choose whether to automatically use or not use the recommendation scheme when there is a recommendation scheme.{break} Version 2.0 automatically selects the recommendation scheme by default.',
  'rsqXJf': 'Recommended application area',
  'tV+NM4': 'View recommendation strategy configuration',
  'uVM8Tm': 'Intelligent recommendation log',
  'wlvXCw': 'Lowest service cost > shortest delivery time > <red>prioritize shipping from warehouses with more inventory > customize shipping order of warehouses</red>{break} Strategy priority supports custom adjustment{break} <red>Support multi-warehouse combination recommendation for shipping</red>',
  'wxm+/v': 'Upgrade to version 2.0 immediately',
  'ySJxcg': 'Number of warehouses',
  'yqUlmI': 'Recommendation strategy',
  'zITEeG': 'Intelligent recommendation for order placement means that the system calculates the optimal shipping plan (combination of shipping warehouse and shipping method) based on the configured shipping strategy according to information such as the buyer\'s address, shipping method, and overseas warehouse inventory when the customer places an order, and then ships automatically according to the optimal plan. {break} Note: {break} - If the order is a bundled order, the recommended shipping warehouse and shipping method are supported, but shipping to multiple warehouses is not supported. {break} - If the order source is "platform synchronization" and the e-commerce platform is "AliExpress" or "TikTok", the recommended shipping warehouse and shipping method are supported, but shipping to multiple warehouses is not supported. {break} - If the customer specifies batch products when placing an order, the recommended shipping warehouse and shipping method are not supported, and shipping to multiple warehouses is not supported. {break} - If the consignee type of the order is "FBA transfer - VC order" or "FBA transfer - non-VC order", the recommended shipping warehouse and shipping method are supported, but shipping to multiple warehouses is not supported. {break} - If the order contains value-added services that do not allow order splitting, the recommended shipping warehouse and shipping method are supported, but shipping to multiple warehouses is not supported. {break} - Pre-sale orders without inventory in stock do not support recommended warehouses and product shipments. {break} - Since address-related additional costs are not estimated when placing an order, it may lead to deviations in the recommendation results.',
  'pi6nIY': 'Current version 2.0',
  'YpNkdi': 'The exported file is empty',
  'NsbeKg': 'Not recommended',
  'TWIxab': 'Orders from Shein and TEMU platforms will be pushed using the "WanYiLian-Platform Synchronization" feature. However, due to platform restrictions, the smart recommendation feature will not be effective.',
  'tSF35A': 'You currently do not have access to the Intelligent Recommendation Product Group. Please contact the business manager to enable this feature before using it.',
  'SQH+7B': 'This configuration information is the configuration details at the time of placing the current order and is used as the basis for analyzing and recommending results.',
  '4F7a+n': 'Is Last leg air transport DG',
  'DX+dxO': 'Is Warehousing DG',
  'Shg80a': 'Special attributes',
  'UIUy5F': 'Is Last leg land transport DG',
  'j2Iqat': 'Is Special chemical products',
  'MdMQ5M': 'The minimum value must be greater than {min}',
  'QpT+5u': 'Cancel value-added',
  'sowY5O': 'Reason for failure',
  'AzxCLr': 'Material',
  'U93D1X': 'The online Chinese description is for reference only. Please enter the actual declaration information in English!',
  'WeeDMu': '<span>*</span>',
  'Z8bjlD': 'The online Chinese description is for reference only. Please enter the actual declaration information in English!{break}<url>Click to view the filling example</url>',
  'h0QYf0': 'Please enter English letters, English symbols, and Arabic numerals!',
  'dWtldt': 'Brand',
  'uuoDDb': 'Usage',
  'KXalXC': 'It is recommended that the declaration information be controlled within {maxNumber}, and the total invoice amount cannot be greater than {maxMoney} US dollars{break}The online Chinese description is for reference only. Please enter the actual declaration information in English!{break}<url>Click to view the filling example</url>',
  '22iXWV': 'Resend {count}',
  '5pf2is': 'Verification Code',
  '91yqs1': 'New Phone Number',
  'ChJyT9': 'Original Phone Number',
  'EKMBnU': 'Change Phone Number',
  'KZfKJ8': 'Bind Phone Number',
  'MogvGG': 'Bind WeChat by scanning QR code',
  'N9hObN': 'Bind WeChat Account',
  'TdGnHP': 'Confirm Binding',
  'Z88MpV': 'Email Account Password',
  'gH3BP7': 'Account Security',
  'h+HlJu': 'Invalid phone number format!',
  'jy7d7Z': 'Email Account',
  'jyEJqj': 'Bind Phone Number',
  'lQSztD': 'Binding Successful',
  'uWwmzm': 'Phone Account',
  'wPtgoF': 'Are you sure you want to unbind?',
  'xC3qW/': 'Unbind WeChat Account',
  'zusrxt': 'Cancel Binding',
  'Ji9Dwg': 'Please fill in a number between 0 and 9999.99, with a maximum of 2 decimal places',
  'nuHfsV': 'Upload product declaration value',
  'NTYH7r': 'When uploading packages in batches, if there is package information, the table will overwrite the original data. If it is actually a new package, please add the package information based on the original upload table and then upload it or add it individually, otherwise the package information will be overwritten, please note!',
  'XPznM5': 'Go to product maintenance',
  'evvpFz': 'Please fill in a positive integer less than or equal to 2000! ',
  'qv9EKm': 'Already aware, please do maintenance after placing the order',
  'S150lQ': 'Cannot start with B/b +19 digits',
  'XdZmSP': 'Please enter digit, letter, minus or underline,and a box number less than 50 characters in length',
  '0AGMjg': 'Please select status',
  '1dHd/u': 'Selected product: {break}{codes} {break}Not associated with GPSR information, not allowed to select!',
  '4q7aWj': 'Go to add>>',
  '5IblI+': 'Manufacturer name',
  '6up8TB': 'Available template printing size【',
  '76VQlq': 'Please enter GPSR name',
  '7Qb7zk': 'Label area',
  '7nyFdZ': 'Please enter name',
  '8OkSrg': 'GPSR information',
  '97FBSp': 'Please provide warning information in the appropriate language according to the sales area as needed{break}Example: Warnhinweis: Nicht geeignet für Kinder unter 36 Monaten.',
  'AyW7zz': 'Required warning compliance environmental protection label',
  'BSpSco': 'Please select merchandise manager',
  'BU3zeG': 'Manufacturer',
  'BrBTkB': 'Based on the submitted information below, I/our company  declare: All information is true, and any liability and consequences resulting from false information will be borne by me/our company',
  'CT8MBi': 'Composed of GPSR information for a certain type of product, used to associate SKUs that require GPSR information and print related GPSR information labels.',
  'DPAxH+': 'Edit manufacturer',
  'F/D7pU': 'Label selection',
  'FPNaML': 'Manager details',
  'GpDYex': 'Add manufacturer',
  'IhWPTD': 'Print generic GPSR label',
  'KXmxRR': 'Please enter GPSR information name',
  'KreuRF': 'The above combination print information is not applicable for this size',
  'NVPitr': 'The selected content is too much, this template size [{curSize}] cannot be fully printed, please adjust the template content or size before continuing to add! {enSize}',
  'QP3qdO': 'Based on the submitted content below, I/we declare:{break} 1. For each item for which I/we are responsible for the EU, {break} a. The item/its packaging or accompanying documents are marked with the name and contact details of the EU responsible person, including postal address{break} b. The EU responsible person has a declaration of conformity (or performance declaration) and has the right to access relevant technical documentation to prove compliance{break} 2. If there is any change in the EU responsible person of I/we, you will be notified{break} 3. The information is true. Any liability and consequences caused by false information will be borne by me/our company',
  'QTIMTf': 'Please select template print size',
  'S55u79': 'Bulk associate GPSR information',
  'SB/wkv': 'View bound manager information',
  'SOyOXk': 'Custom warning words',
  'ShuBcR': 'Please select manufacturer',
  'T6MpaR': 'Please select GPSR information',
  'TXtNAs': 'Template print size:',
  'UYhyhR': 'This product GPSR template + product barcode label combination is not suitable for printing in this size!',
  'W8/2Ef': 'Associate GPSR information',
  'WgR9Ik': 'Manufacturer details',
  'WkR4ou': 'Print GPSR label',
  'X943SP': 'GPSR information name',
  'X9Hi81': 'Edit manager',
  'Y0VbfF': 'Click to download',
  'YcHiPZ': 'No corresponding supplier information, {a}',
  'bbSyMZ': 'Add GPSR information template',
  'diPqGv': '《Batch Print Barcode Template》',
  'glkuPy': 'Product barcode area',
  'hWeYWy': 'Batch print file',
  'iFeo32': 'Please select type',
  'k3QotQ': 'EU agent information',
  'kUWb/8': 'Merchandise manager area',
  'lJoEc8': 'Cannot input Chinese',
  'lSOSkG': 'Ends with',
  'loKQx9': 'Not exceeding 5000 in a single time',
  'mpknBY': 'Custom warning language area',
  'n4VyL8': 'Only support printing generic GPSR labels here, if you need to print product barcode information at the same time, please go to product management to associate GPSR information and print in the corresponding product list!',
  'nwIvZ2': 'GPSR, the General Product Safety Regulation, is a regulation established by the EU to strengthen product safety, aimed at ensuring that all products sold on the EU market are safe to protect the health and safety of consumers.',
  'ppwk5Y': 'Template print size',
  'rA3Nmf': 'Only products where all supplementary types are GPSR information can be bulk associated',
  'sIy67M': 'Contains',
  'vKMx9x': 'Edit GPSR information template',
  'w8+5lq': 'Other print items',
  'xp/GZy': 'View associated GPSR information',
  'yFmk5P': 'Please supplement the GPSR information of the merchandise first',
  'ylF0LP': 'Need to supplement or update GPSR? <a>Go to edit</a>',
  'zGpUl0': 'Merchandise manager & manufacturer basic information',
  'zqMDyD': 'Manufacturer information area',
  'GNCFjw': '{dot}Only support label paper printing, the number of prints in a single print must not exceed 5000, please scan after printing for testing.{break}{dot}If you choose to add GPSR information, the label will have the associated GPSR information; if the product is not associated with GPSR information, printing is not allowed.{break}{dot}If you choose to add ODA information, the label will have the associated EU agent information; if not selected, it will not have it.',
  'MjfT9F': 'The Manufacturer is no longer active, please make a new selection.',
  'UehsMU': 'The Responsible Person is no longer active, please make a new selection.',
  '3uYLxS': 'Supports files in JPG, JPEG, PNG, PDF and ZIP formats up to 50MB',
  'AUuPe6': 'Enter at least {num} characters, double-click to switch to batch query',
  'FeVrJ/': 'Upload a maximum of {maxCount} files,limited to jpg,jpeg,png,pdf,zip format within 50M.',
  'xo2gDa': 'Print GPSR information',
  'yxW56v': 'Limited to jpg,jpeg,png,pdf,zip format',
  'vXqrEQ': 'The current single item management does not support printing GPSR information combination labels.',
  '3F0pn+': 'Germany new warehouse',
  '3Kr6md': 'UK warehouse 1',
  '3Z/8DA': 'Australia Sydney warehouse',
  '4G7TmF': 'Select report month:',
  '5eIZb1': 'Outbound SI',
  '5knorD': 'USGA warehouse',
  'Ahfns/': 'Fund details for each age group of the warehouse',
  'CpC3w/': 'Ranking',
  'Cx/ZfQ': 'Western United States (Pacific Time Zone)',
  'DlNvpw': 'Quantity of outbound orders',
  'FMFuuk': 'Last months inventory of SI quantity',
  'GP2sjg': 'SI quantity',
  'HQ4HZg': 'Custom Clock',
  'I7qN1w': 'part.1 Performance consumption data',
  'JkcfsV': 'Australia Melbourne warehouse',
  'K83Hze': 'Click to jump to the far left',
  'KD3+MN': 'UK',
  'LfkgD6': 'AU',
  'NWSZS8': 'Promise of first and last leg consumption (after discount)',
  'PaWMTl': 'Performance Analysis Report',
  'SZC9VK': 'Proportion of outbound orders on each platform',
  'VG2CwF': 'Click to jump to the far right',
  'VahHdx': 'USNJ2 warehouse',
  'WWLGJO': 'part.2 Inventory analysis',
  'YJ9vOe': 'USTX warehouse',
  'YMgB69': 'The number of SI units in stock this month',
  'YuT9+d': 'US West warehouse 1',
  'Z44f6M': 'Inbound SI',
  'ZgIeSx': 'link relative ratio',
  'ZwLbdd': 'Belgiums Musk Dragon Warehouse',
  'a6CV9N': 'UK warehouse 4',
  'cmmHPa': 'US East (Eastern Time Zone)',
  'dOsMrX': 'Funds in stock last month',
  'dn5c7I': 'Central Europe',
  'er80XZ': 'UK warehouse 3',
  'eyNX6K': 'account for',
  'fFmC7w': 'Outbound SI quantity',
  'gLz/8S': 'US East warehouse 3',
  'iVp3lO': 'Last months outbound order quantity',
  'l9xczl': 'Secondary Category',
  'ngVved': 'Actual first and last mile consumption',
  'oAUHli': 'In stock funds refer to the declared value of goods',
  'olJJPB': 'World Time',
  'r/enn9': 'SI details for each inventory age group',
  'rYrCyO': 'Consumption amount',
  's24SFP': 'Total order quantity',
  'sS5Zjv': 'Compliance rate',
  'suyKfo': 'US West warehouse 2',
  'udjnTi': 'US Central  (Central Time Zone)',
  'vETCLF': 'Funds in stock this month',
  'vgNCKm': 'DE warehouse 1',
  'vwrLKd': 'Proportion of SI in stock last month',
  'w3QnSZ': 'Outbound Ranking',
  'xAHzLe': 'Proportion of SI in stock this month',
  'xbdSiX': 'part.3 Outbound category details',
  'zWZfR1': 'Canada Toronto warehouse',
  '+x9sKw': 'US West',
  '3u3Azm': '{num}month',
  'ATI8nz': '{warehouse}: {warehouseLabel} city: {city}',
  'AzRGCX': 'Germany',
  'jxIf3M': 'US East',
  'GBO8/I': 'Germany warehouse',
  'HoMqWj': 'UK warehouse',
  'dG1S3v': 'US West warehouse',
  'h3EF1T': 'US East warehouse',
  'oXc3m5': '1. If you need to search and export historical data from 12 months ago, pls contact our staff.{break} 2. Credit fee, overdue fee and extension fee, the minimum charge amount in currency CNY/HKD is 0.1, and the minimum charge amount in currency GBP/EUR/AUD/USD/CAD is 0.01.',
  'FY4EWV': 'Other warehouses in the warehouse group',
  '0GyUPW': 'Appointment Email',
  '1XXFUz': 'Billing Value',
  '1mj4G9': 'Price Change Reason',
  '5+hBLi': 'Order Weight',
  '6qeH3F': 'Estimated Number of Pallets',
  '9f5t0B': 'Order Volume',
  '9m6tTe': 'Final Quotation (The actual number of pallets will affect the final final cost, subject to the actual deduction amount) </span>',
  'BOsZa4': 'Target Delivery Method',
  'EBLjD7': 'Final Quotation',
  'ETE5vQ': 'Supplier quotations fluctuate, please confirm the quotation in time. The time taken for outbound value-added operations and the actual number of pallets will also affect the actual amount',
  'FmPO/g': 'Pallet will be temporarily stored and then a specific date will be specified',
  'Gm0Npz': 'Other remarks',
  'OLzg0F': 'Unit price',
  'OPRrfY': 'Number of pallets',
  'QcRv4P': 'Vehicle requires GPS',
  'RS2s4f': 'Tracking number/voucher number',
  'RrpKm0': 'Unit price effective until date (local)',
  'Si3Ovb': 'Billing unit',
  'UgqSWZ': 'Billing rate',
  'VS3QW3': 'Estimated last-mile cost',
  'VSq34r': 'Download delivery note',
  'ZV6B7N': 'This fee is used when the amount of other fees is calculated. {break}For example, usually, fuel surcharge = last mile delivery fee * billing rate',
  'ZVG0lB': 'Exceeding the estimated number of pallets',
  'aWgms2': 'Added Value Pending Conformation',
  'iKD60I': 'Exceeding the estimated pickup time',
  'ihg37s': 'Depending on the cost item',
  'j3vF3/': 'Insured currency',
  'lYkQcO': 'Actual last mile fee',
  'lbJx3W': 'Need to insure from the supplier',
  'mF9qHK': 'Order quantity',
  'oXkCM6': 'Actual supplier',
  'rCk9U1': 'Insured amount',
  'rjZWF2': 'Create a new value-added order',
  'sgapu/': 'Appointment phone number',
  'sgmkqg': 'Specify vehicle model',
  'xcPr5G': 'Need assistance in booking delivery',
  'yvvayC': 'Specify supplier',
  '+Iqggx': ',Please go to <a>Appointment Order Management</a> to make an appointment for delivery',
  '4F2DLS': 'No appointment for delivery',
  'BHIZbJ': 'Please select an order',
  'BqJJ9L': 'No appointment has been made',
  'C5EziP': 'Appointment has been made',
  'IToNB2': 'Do you want to clear the to-do items for query! ',
  'MpeG4C': 'Waiting to submit an appointment for delivery',
  'PLcKBI': 'Unloading method',
  'Q6plNw': 'No appointment required',
  'QEmJpC': 'Appointment delivery time (local)',
  'Ry3L12': 'Add a new appointment order',
  'TvlAb1': 'Number of appointments',
  'V6neT7': 'Waiting for delivery',
  'ZhMON/': 'Select an order to be scheduled',
  'h4VFpW': 'Unable to create an appointment order, please check and re-create the appointment order! ',
  'hdgxlJ': 'Waiting for scheduled delivery',
  'jOywIg': 'No data for export yet',
  'q/YRnn': 'Actual unloading time (local)',
  'sLxRLg': 'Appointed unloading time (local)',
  'wQCAYD': 'Number of packages',
  'x+RSYW': 'Creation date',
  'xbSzZ3': 'Actual delivery time (local)',
  'f0PSge': 'Only reservations can be made based on the delivery method of the order: reservations for bulk goods are made for bulk goods, reservations for full containers are made for full containers, and reservations cannot be made for express delivery. If the delivery method of the order is incorrect, please return the draft, change the delivery method and product again, and then make a reservation.',
  'XfySEr': 'Inbound order booking status',
  '+1z4qs': 'Outbound Package: After the goods are putaway in warehouse, multiple SKUs can be combined into one single product when it needs to be shipped. Only available for 2C inventory.',
  '/YG20j': 'Please enter the commodity group name',
  '16H+KU': 'Length of commodity suit(cm)',
  '1yjVbf': 'commodity group',
  '3uBogm': 'Keep up to 4 decimal places',
  '4g0F/w': 'suit disposable weight(kg)',
  '6tylb+': 'EXcel batch new addition',
  '7FKIiN': 'Duplicate with Corresponding commodity code',
  '7b3ENM': 'Suit',
  'AF0IfM': 'commodity in the group',
  'AKAQkU': 'SKU No. within the group/commodity group',
  'CoJ9Ff': 'suit packaging',
  'CxmT/4': 'Video of the suit',
  'DlZIxf': 'Commodity Group:To reduce the number of maintenance of the product group relationship, it’s available to maintain multiple SKUs of the same Commodity Set to one Commodity Group. For example, multiple colors of the same product correspond to multiple SKUs, and the SKU of each color can be maintained as one Commodity Group.',
  'EI0jby': 'SKU No./commodity group name',
  'HGxg7z': 'High of commodity suit(cm)',
  'JJsTcc': 'Schematic diagram of the suit',
  'JWHXq+': 'suit infomation',
  'KX7tJL': '<red>Up to 5 pictures can be uploaded, limited to jpg, gif, bmp, png format within 5M</red>',
  'N52RjX': 'inwarehouse suit',
  'NLUeF8': '<red>Upload up to 3 videos, limited to avi, dat, mpg, wmv, asf, rm, rmvb, mov, flv, mp4 formats within 50M.</red>',
  'NcFJGy': 'Whether to fill in when placing an order',
  'ONEZAE': 'Outbound Commodity Group Configuration',
  'OT8ish': 'commodity group/sku',
  'OvAUQP': 'The commodity already exists, please do not add it again',
  'PIOZgH': 'suit business category',
  'PdjukP': 'When the group attribute is a group package or a group package with commodity, you can fill in the discarded weight (disposable weight refers to the weight of the discardable portion of the package when the product is assembled)',
  'Qy13lF': 'Associated GPSR',
  'RLjqtw': 'Width of commodity suit(cm)',
  'RnXcAk': 'suit packaging/commodity in the group',
  'TZNHjJ': 'Add the content of the group',
  'W7HwCn': 'commodity group name/SKU No.',
  'argxjt': 'Corresponding commodity code',
  'brD+uB': 'View the commodity in the group',
  'eEjnyp': 'outbound suit',
  'eQuhOe': 'Whether it is filled in when placing an order means that the commmodity needs to be included in the order when placing the order, otherwise the outbound group cannot be carried out',
  'ebDqUr': 'The commodity code corresponding to the set',
  'fJMACQ': 'GPSR information name can have up to 128 characters.',
  'iCtpFf': 'Combination in warehouse: After the goods are put into the warehouse, multiple SKUs can be combined into one SKU in warehouse and putaway for sale. Only available for 2C inventory.',
  'jogDbB': 'The maximum number of printed GPSR information combination labels is {num}',
  'lpeIQF': 'tips: group packaging is the package in the group, only one of this product is allowed in each group.commodity group is one of the commodities in the group, which can be any commodity in the commodity group or commodity group.',
  'm0ZYt5': 'SKU No. within the group',
  'nRqQiw': 'There is a duplicate SKU No. in the suit Contents.',
  'nqSBOq': 'commodity barcode in the group',
  'qFYiaJ': 'The video format is restricted to avi,dat,mpg,wmv,asf,rm,rmvb,mov,flv,mp4',
  'taxXcG': 'Add new outbound suit',
  'uyKP5R': 'Suit Cname',
  'vKXaA5': 'Video size limit is 50MB.',
  'vP/Azq': 'Can only enter [capital letters] [Chinese characters] [lowercase letters] [numbers] [ - ] [ _ ] [ ( ) ] [ + ] [ / ] [ @ ] [# ] [ . ]',
  'xrXaSi': 'suit Contents',
  'yMCuMW': 'Add outbound group',
  'EZYGd+': 'Batch download POD files',
  'jwJ5aJ': 'Download POD files',
  '2BYfGC': 'Is the platform synchronized?',
  '6+1lpt': 'Platform settings',
  '7mS1Ef': 'See the operation guide for details',
  'Far31d': 'Please enable or add the e-commerce platform you are currently using. After enabling, it will control the drop-down selection and page display of the Wanyi Lian platform.',
  'L7rr8k': 'Platform code',
  'NP8ydP': 'Enable platform',
  'fmU8aC': 'Are you sure you want to disable it?',
  'gR5+1a': 'Are you sure you want to enable it?',
  'tpXKt6': 'Add platform and enable it',
  'uIa3Sy': 'Add platform',
  'zMawsp': 'Platform name',
  'drA1F1': 'Cant find the platform? Please contact customer service to add it',
  '2xD9pN': 'Month-on-month with {mount}',
  '80c2cB': '{mount} Month Quantity of outbound orders',
  '7OyNT9': 'Transparency Plan Label',
  'EArTq/': 'Not allowed',
  'RlFIEF': 'required',
  'RuKykW': 'Maximum order size/piece size',
  'i0tMJ3': 'Maximum order cargo type: TM>T240>T120>T50>T25{break}You can choose to set rules by cargo type or piece type',
  'kdNFDD': 'Maximum order',
  'lXbQ5s': 'You have selected the value-added service [FBA Transparent Plan Label], this value-added service does not support selection',
  'utBCZV': 'Transparent plan label and FNSKU label mixed label',
  'HPEdSt': 'Judgment Rules for the Largest "Cargo Type" of Orders: TM > T240 > T120 > T50 > T25.{break}Judgment Rules for the Largest "Package Type" of Orders: Oversized Package > Large Package > Medium Package > Small Package.{break}You can choose to set rules according to the cargo type or the package type.',
  '06l+Qj': 'Hello! When the longest side of the product you submitted is <15 cm or the second longest side is <10 cm, even if the product already has logistics packaging, it will be subject to additional packaging due to supplier transportation requirements (details of additional packaging fees will be charged upon shipment). To avoid additional packaging fees, it is recommended to adjust the packaging requirements of the product before entering the correct dimensions! If you agree to the additional packaging upon shipment, you can proceed to the next step.',
  '0m04KS': 'After the cancellation, the adjusted amount of insurance will not take effect, and it will take effect according to the original amount of insurance. Do you want to confirm it?',
  '0y8Vak': 'Only support label paper printing, the number of prints in a single print must not exceed 5000, please scan after printing for testing.',
  '10skDr': 'Re-insurance',
  '2yoQvT': 'The current operation is irreversible, please confirm if you want to update to SKU_management!',
  '3g9GU1': 'Add schematic diagram',
  '5FCj3u': 'Confirm re-insurance?',
  '5Kcusw': 'Full-suite | FCL:',
  '5ZDwkw': 'Please select the SKU\'s invoice and other relevant certificates to upload, and Winit related staff will review the relevant information.{break}<red>Upload 5 pictures, limited to jpg,gif, bmp,png format.</red>{a}',
  '6XWJXx': 'Cancellation of insurance',
  'A+35EB': 'Limited to jpg,jpeg,png format',
  'AE/KxE': 'Single pcs:',
  'B/XWT5': 'Adjust the insurance amount',
  'Ctsw2n': 'Print file generation settings',
  'H/jbhZ': '1.The insured amount of each item in the product box of the same country box or each item in a suite of product suites cannot exceed the insured amount of a single product!{break}2.If the standard number of products in a box or suite multiplied by the insured amount of each item in the box or suite exceeds the limit amount for the whole box | the whole suite, the premium will be calculated according to the corresponding upper limit insured amount!',
  'HJOdSI': 'Audit information',
  'K45CNn': 'Schematic diagram type',
  'KL1vOZ': 'mixing storage',
  'KbCL0r': 'product owne',
  'Kej6Gd': 'Video Preview',
  'LVH+YI': 'Insurance status',
  'OgT+gu': 'Generate one file for all SKUs',
  'P53D0s': 'Adjusted Sum Assured',
  'Q0aPTI': 'Please input purchase amount/pcs (USD)',
  'QnShZR': 'Without currency, insurance is not supported',
  'SIXvYZ': 'Box Product Insurance Amount /  each pcs in the box',
  'UFIIqK': 'Sub account name',
  'V5LbEg': 'Purchase amount/pcs (USD)',
  'YNWh/C': 'Confirm cancellation of insurance?',
  'YgLev7': 'Available suites/boxes',
  'a71RUr': 'Incoming Inventory Details',
  'aaEmj4': 'limited to jpg,jpeg,png format within 50M.',
  'aaJRtO': 'Insurance limit amount',
  'be/PB3': 'This date is the date of the batch information corresponding to the SKU, and the nature of this date is determined by the batch attribute. For example, if the batch attribute is production date + product batch number, then this date is the production date; if the batch attribute is expiration date + product batch number, then this date is the expiration date.',
  'd1RUKj': 'SKU certificate information',
  'd2MeTl': 'Add SKU schematic diagram',
  'de5n5v': 'Existence of the same country',
  'fOXNzj': '{dot}Only support label paper printing, the number of prints in a single print must not exceed 5000, please scan after printing for testing.{break}{dot}If you choose to add GPSR information, the label will have the associated GPSR information; if the product is not associated with GPSR information, printing is not allowed.',
  'gneoey': 'Single product insurance amount/ pcs',
  'gzDYf6': 'The SKU has pending review information in [{codes}], do you want to submit an update?',
  'lLL5ZK': 'Insured amount of suite product / each pcs in the suite',
  'lUtVXk': 'SKU information schematic diagram',
  'luyAlN': 'submission review time',
  'mQq9vE': 'Please enter a number greater than 0 and keep up to two decimal places',
  'mRtDqK': 'In way inventory',
  'nLDE+V': 'Original effective insurance amount',
  'o0wl3e': 'Add insurance',
  'pVTl/X': 'Batch attributes | Date | Product batch No',
  'pa/Hpb': 'Number of suits/boxes in the warehouse',
  'qm6h2z': 'Insurance information',
  'v742LV': 'Generate separate files for different SKU',
  'wDqNy1': 'Example',
  'wI3FWu': 'Please upload purchase invoice',
  'ye/rJU': 'Purchase invoice',
  'zrIs7T': 'Latest update time',
  'X1t/M7': 'Subsidized package barcode',
  'ZAOv9w': 'Actual shelf entry order number',
  'b2UFEI': 'Should be put on the shelf entry order number',
  'dIycQ5': 'Actual subsidy package barcode',
  'Numk8A': 'Associated Winit order number',
  'cpUlyA': 'Associated value-added order number',
  'DxKC20': '[{serviceName}] must also select the value-added option: [{serviceName2}]! ',
  'Z0Afjw': 'Entering the warehouse - Subsidize the package barcode',
  '017M9b': 'Check Info',
  '83aOrM': 'Claims Creation Time',
  'CczxbC': 'Delivery Exception Type',
  'DMYki0': 'Claims Status',
  'FCcD/q': 'Feedback',
  'KkBukn': 'Claims Type',
  'NYJgJy': 'Claims No.',
  'O96nxS': 'Exception Duration',
  'PIqc3E': 'Check Creation Time',
  'bwU822': 'Shipping Warehouse',
  'c9Nk2X': 'Check Status',
  'dM3hXJ': 'Check NO.',
  'goV7bs': 'Place',
  'hCubz5': 'Recent Trajectory',
  'no4CjP': 'Claims Info',
  'uP/M2r': 'Time',
  'w39FKP': 'Status',
  '4xS0E4': 'Outbound order',
  'OiVSUE': 'Minimum charge',
  'WX6HP8': 'Invalid, please delete this file and re-upload!',
  'nQPn4+': 'Invalid, please re-upload!',
  'aePiuD': 'Certificate has expired',
  '/KxreR': '库存准时率',
  '2MYr1m': 'Login',
  '3S5WCT': 'Mobile Phone Login',
  '4/Lg7X': 'Please enter login password',
  '9UZxwP': 'Please enter verification code',
  '9z252s': 'Scan to register',
  'I1vr0V': 'Reset Password',
  'KBVp8X': 'Please enter mobile number',
  'MmsEyp': 'Register',
  'OQBMaY': 'Email Login',
  'Rdb33f': 'Scan to login',
  'SWlncS': 'Schedule Warehouse Delivery',
  'VaYh5v': 'Remember Password',
  'X3Qw1f': 'Please enter mobile verification code',
  'Xjfb5m': 'Privacy Policy',
  'YpskxZ': '出库准时率',
  'b/9R1T': 'Bind',
  'd8FaCq': 'Step1 Scan to login',
  'fxYWiK': 'Please enter email',
  'gI0VX4': '准时投递率',
  'guGupZ': 'Scan successful',
  'ngd7Ys': 'Please enter image verification code',
  'oIbf2X': '上架准时率',
  'tLW3W3': 'Mobile Number',
  'uQXjs5': 'Step2 Account Binding',
  'x3dFer': 'Please enter password',
  'xsqOlT': 'WeChat Nickname',
  '1ursGp': 'Login Password',
  '3izfxn': 'WeChat is already registered, please do not register again',
  '6B5YBg': 'Login Method',
  '8Je/Zh': 'Registration is successful after successfully binding the phone number',
  'B6Yy/p': 'Supports quick login with WeChat',
  'BWtB9B': 'Enter a password consisting of 6-32 alphanumeric characters',
  'DQMC7I': 'The two password entries do not match',
  'DiCHhn': 'If you already have an account, please click the button to bind the existing account',
  'GqhYph': 'WeChat Login',
  'Hdrh6x': 'Please enter the contact person\'s name',
  'IBJ0+K': 'Your account has not been bound to a WeChat account. To provide you with more convenient services, please bind WeChat as soon as possible. <btn>Bind Now</btn>',
  'KIo76D': 'WeChat Registration',
  'L78Ltd': 'Change Phone Number',
  'L7gdr+': 'Which country\'s overseas warehouse are you currently using or plan to use (multiple selections allowed)?',
  'NfKGF1': 'Set Email',
  'O04mT0': 'Used to receive messages and verify identity (such as password recovery, changing security settings, etc.)',
  'ORpvGU': 'Set Phone Number',
  'QK5ud3': 'Account Verification',
  'R9+P8F': 'Congratulations on successful email registration~ {break} Please go to your email {email} to activate your account',
  'RXIzb7': 'Activate Email',
  'T8JunI': 'Please choose to register or bind an account',
  'UpWtER': 'Congratulations on successful WeChat scan code registration~',
  'V5pGxT': 'Basic Settings',
  'VGdghS': 'I have read and accepted <a1>User Registration Agreement</a1><a2>Privacy Policy</a2>',
  'WZ8gJI': 'What is your current annual sales volume in RMB?',
  'XOaAVQ': 'The password required to log in to the Winit account',
  'XfP+fO': 'No account, register a new account',
  'Z9M13R': 'The length of the email input cannot exceed 50 characters',
  'ag8LxW': 'Not Set',
  'auukQC': 'No Winit account found corresponding to the current WeChat ID, please choose:',
  'b9caeM': 'Please enter the password again',
  'bdjhF3': 'Used to receive messages and verify identity (such as password recovery, changing security settings, etc.), binding will support login with phone verification code',
  'cRkjTF': 'Change Email',
  'dMPyxp': 'Follow the official account: WINIT万邑通',
  'eGMWPi': 'Enter the homepage after ({count}S), <url>Click to jump to the Winit homepage immediately</url>',
  'eMnHfD': 'Email Registration',
  'f+xVln': 'Please enter the confirmation password',
  'fpHtD6': 'The account modification application has been submitted, you now need to go to the new email to activate the account',
  'g4luE6': 'Already Set',
  'g7ZZYG': 'Incorrect email format',
  'idr0Yi': 'Congratulations on successful email registration~',
  'lJ5T1S': 'Resend ({count}s)',
  'lkvxCD': 'Please read and accept the agreement',
  'o9sQv+': 'Verify Immediately',
  'p6bh5v': 'Account Password',
  'qiM7Bf': 'WeChat Scan Code',
  'sPM43N': 'Go to Email',
  'trTcmQ': '(You can log in with your phone number after successful registration)',
  'uQ97fV': 'Already have an account, go to bind the account',
  'uWZTJg': 'Learn More/Enjoy More Convenient Services',
  'yzVtH/': 'Bind Existing Account',
  'zDhp9Q': 'Email already exists, please log in directly',
  'zdjQOh': 'Please select Country/Region',
  'kYuuSo': 'Follow Official Account',
  'i+upx7': 'Account binding',
  'jIh+uu': 'New login email',
  'kXaBbd': 'Follow Success',
  '4cBjcA': 'you now need to go to the new email to activate the account',
  '+CITvc': 'Please enter the change Date',
  '/CmSdr': '<red>Please provide a complete operation video, upload up to 1 video, limited to avi, dat, mpg, wmv, asf, rm, rmvb, mov, flv, mp4 formats within 100M.</red>',
  '/DtX+8': 'Cost Type',
  '21rG2o': 'Submission date',
  '3YV16S': 'Video size limit is within 100M.',
  '3pgC7n': 'Cargo transfer out',
  '79mGuc': 'RMA',
  '8ME8Ww': 'Export Details',
  '8PETXp': 'Transfer Inbound',
  'ClOQBe': 'After Inventory',
  'Cs5PyX': 'Upload up to 1 video.',
  'DH94cn': 'Ending inventory quantity',
  'F1kRoj': 'classification inventory details',
  'GQcXjn': 'Quantity change',
  'HWx2E7': 'In the past year',
  'J6Ocmq': 'Waybill',
  'Jz34C6': 'Need to collect the physical barcode for outbound storage',
  'L8O+eh': 'Average daily sales in the last 7 days / Average inventory in the last 7 days',
  'M3MF3I': 'Upload up to 5 images.',
  'MhOy8s': 'Enter at least {num} characters.',
  'NQQAuQ': 'Transfer Outbound',
  'O6N9fg': 'Average daily sales in the last 15 days / Average inventory in the last 15 days',
  'OXAH2B': 'Change record',
  'Ore518': 'Warehouse DOI/Country DOI',
  'PmTJ7o': 'If the collection service is selected, Winit will collect the corresponding package barcode or third-party package barcode at the outbound stage. After the collection is completed, customers can query the information in the outbound list. Please confirm that there is a corresponding collectible package barcode on the physical goods, otherwise warehouse exceptions will occur.',
  'Qxf3/K': 'Single product bar code import',
  'SDYfIP': 'Max Date Range [365]',
  'SmVbZ0': 'Details of inventory to be destroyed.',
  'WHZ769': 'Inventory details in stock.',
  'WsHvnq': 'Total Quantity',
  'XllRKa': 'Max Date Range [92] Without Sku Code/Product Barcode or Document No.',
  'ZRBxht': 'Warehouse DOI',
  'bQOgOx': 'Change Date',
  'dnJRgq': 'Warehouse rental date',
  'eu0qY9': 'Warehousing Charge Document No.',
  'fSrpzL': 'Billing dimension',
  'h+EgTN': 'Inventory details in lost confirming ',
  'i2eYXn': 'Maximum inventory quantity',
  'l/rrRH': 'Direct Shipment',
  'lXOK3F': 'Minimum inventory quantity',
  'lZ2LVa': 'Average daily sales in the last 30 days / Average inventory in the last 30 days',
  'o0NSNd': 'Trade Date',
  'oMimBZ': 'Classification adjustment',
  'vKjKIG': 'Please enter the warehousing Charge Document No. or Warehouse Rent Date',
  'wFphH6': 'Tips: Dear customers, the inventory flow data only supports querying the data of the past year.',
  'x9DBul': 'Inventory details in occupied Inventory',
  'xgiTGk': 'Cargo transfer',
  'GoU/8N': 'Return items temporarily stored and not processed.',
  'Y6FUe2': 'Query records from the past 15 days.',
  'AvNm7S': 'Time to be released (local time)',
  'vbxo3L': 'Actual release time (local time)',
  'vkhDdQ': 'X/Y, X represents the issued value-added quantity, Y represents the actual completed quantity',
  'wwoYQh': 'Value-added quantity',
  'hqz2lG': 'Order priority',
  '9HYp2Y': 'Supplementary certificate',
  'FgvNQH': 'Please select the items that need supplementary certificates first!',
  'GM7I33': 'Items with pending supplementary certificates',
  'Ne2nfi': 'Batch supplementary certificates',
  'OKnjZ+': 'Download supplementary product certificate template',
  'XDYV1L': 'File size should not exceed 10M, please compress before uploading',
  'e5PZ02': 'Support jpg, jpeg, png format files within 10M',
  'kROGK4': 'Batch supplementary certificates',
  'x3pfcJ': 'Please delete invalid certificates!',
  '08hJjN': 'Allow packing',
  '150bCw': 'Maximum value must be greater than minimum value',
  '1jI2sy': 'Select package A, and package A+ is allowed by default',
  '29czDg': 'Only numbers greater than or equal to 0 and with 2 decimal places are allowed, please modify',
  'EHHXgx': 'Maximum value',
  'EsJkLt': 'Shipping country',
  'F3dI0f': 'Minimum value must be < maximum value',
  'G8A2UL': 'Packing limit',
  'HHJhh7': 'Package type',
  'OZDdKy': 'Size input rule: length = longest side, width = second longest side, height = shortest side',
  'PMguPq': '{name} Only numbers not exceeding 9999.99 are allowed to be entered. Please modify it.',
  'RDvOwC': 'Package',
  'WZX4M+': 'Select B/C package, and A and A+ packages are allowed by default',
  'YIsl98': 'Minimum value',
  'ZEg+9J': 'Packing rules',
  'fQudGk': 'Packing method',
  'g9sUca': 'Package packing',
  'kLsmQn': 'Outbound packing rules',
  'nVsYMb': 'View WINIT default packing limits',
  'w0kW9n': 'Function Description: Users can formulate corresponding packing rules here based on the receiving rules of e-commerce platform warehouses or third-party warehouses when orders are transferred for warehousing. For example, according to business characteristics such as order types, consignee types, and shipping countries, the goods to be shipped out can be sorted and packed into boxes. Meanwhile, restrictions can also be imposed on the size and weight after packing. The system will automatically complete the sorting and packing of orders according to the rules set by users, so as to meet the receiving requirements of e-commerce platform warehouses or third-party warehouses and effectively improve the compliance degree of goods entering the platform warehouses.{break}Note: When the system fails to match the packing rules configured by you according to business characteristics such as order types, consignee types, and shipping countries, the warehouse will, by default, use WINIT\'s packing rules to verify whether it meets the shipping standards during the packing process. ',
  'LR8Ac+': 'Estimated Outstanding Warehouse Rent for Bad Debt Period (USD)',
  'JK3Fr7': '*This outstanding amount is not included in the bill amount{break}Bad Debt Period：{startDate}',
  'hGLhSe': 'Sub-order status',
  '5VL8XQ': 'Change time',
  '/ZyLUT': 'Due to supplier terms and conditions, only the data for orders placed in the past 60 days are displayed here.',
  '4uSKD4': 'No Check Info',
  'KraNAc': 'No claim Info',
  'ZsFmm2': 'Last journey exception details specification',
  '96sxGJ': 'Conditions for bundling into sets',
  'MlJAC5': 'Is it allowed to bundle multiple sets within the same order for shipping',
  'xz7u99': 'Multiple sets are represented as 2 sets and 2 sets or more;{break}if configured as "yes", when ordering 1 item A, if it matches this set relationship, it will be processed as a set and shipped out. When ordering 2 items A, if it matches this set relationship, it will be processed as 2 sets. {break}If configured as "no", when ordering 1 item A, if it matches this set relationship, it will be processed as a set and shipped out. When ordering 2 items A, it is not allowed to be processed as a set, and will be handled as regular packaging.',
  '+6+Mt4': 'Recalculated  date',
  '237gsE': 'Pure battery',
  '2IVSMv': 'Amount after discount',
  '3RFPFO': 'Export inventory data for each warehouse in the country by SKU',
  '3U2acT': 'Up to 500 overseas warehouse storage fee orders can be searched, separated by commas or line breaks',
  '5AvkeD': 'Is it Insured SKU',
  '5EM4lg': 'Location type',
  '5NdmWL': 'Warehouse code',
  '6q/POx': 'non-battery',
  '9DHCGM': 'Recalculation notes',
  'Divclz': 'with High value',
  'DsCXA9': 'Storage Age(day)',
  'EPZLEX': 'Billing Volume(CBM)',
  'GOfCC1': 'Deduction status',
  'KcgraU': 'Is the minimum charging volume',
  'Mjamj2': 'Total volume in waybill(CBM)',
  'NlO+UH': 'Warehouse Storage Document Detail',
  'OJzUfZ': 'with return goods',
  'OLcvb/': '#Card Products',
  'ObUQSf': 'Export SKU country-level inventory',
  'Oj70/T': 'Is it chemical product',
  'PwmGND': 'It only supports within one month for export data，Please reset the query date range!',
  'QdThDC': 'Is it dangerous goods',
  'URG50E': 'Amount before discount',
  'UnOS5e': 'After recalculation - Amount after discount',
  'ZZrYbK': 'Is it special chemical product',
  'ZZsYN+': 'Contained in equipment',
  'a40x/v': 'Palletize or not',
  'dM/4Cc': 'Inventory quantity is merged by SKU + country, without displaying warehouse',
  'dTWKpE': 'Current receipt amount',
  'etS3Fs': 'Before recalculation - Amount after discount',
  'fBupdr': 'Export SKU warehouse-level inventory',
  'fWVI6Y': 'Packed with equipment',
  'g+8vyF': 'with mixing storage',
  'gbXvkj': 'Shelf Time',
  'lRACZW': 'Card Products',
  'murDIe': 'Battery type',
  'o9bDiv': 'Whether batch management',
  'pO9v22': 'Waybill number',
  'qG6wc3': 'NotMaintain',
  'r9bIiC': 'Third party commodity barcode quantity',
  'rvynV4': 'Is it Food',
  'tbKn4n': 'Plan note',
  'uESwgc': 'Unit price after discount',
  'vYSK/8': 'Outbound self-pickup rent order',
  'vl8z5u': 'Storage Age',
  'x/6PQh': 'Product volume',
  'xr1IiE': 'temporary storage date',
  'z3yq8L': 'Storage age range',
  'K0MNn8': 'Please switch the main account [{account}] to query the warehouse rental details of the bad debt period ',
  'N+Y3oq': 'Specifications exist, do not support updates',
  'zz036a': 'Check all the packages in the order to automatically display the package details of the order ；',
  '9BSdQ4': 'You have not activated the A+ package exemption from self-inspection permission, and the inspection type cannot be selected = customer self-inspection. If you need to activate it, please click the Activate Inspection Exemption button to activate it, thank you!',
  'laNzSC': 'Activate permissions',
  '6U0Oxp': 'Address type',
  'Ku6RiZ': 'Not verified',
  'cMFt3E': 'Address verification result',
  'dg3g5T': 'Check passed',
  'lO4mGQ': 'Check failed',
  'TWmlF4': 'Set my platform',
  'ZGO+QQ': 'Add card to delivery',
  'bawz6H': 'Card name',
  'grKzYm': 'Card code',
  'i+vMLC': 'When you cannot find the e-commerce platform you want to select in the current drop-down menu, please click here to set your commonly used e-commerce platform. ',
  'nU2zG1': 'Number of cards',
  'tbT5Ro': 'Check the number of cards',
  'llaKUX': 'Winit Link Tongtool ERP User Guide',
  '8h34cM': 'Master Account',
  'NS6ZAt': 'Sub Account',
  'PQlTrS': 'Customer Code',
  'W7TAOd': 'Please enter your nickname',
  'fuyuYG': 'Enter up to 50 characters',
  'r2nMKU': 'Account Nickname',
  'tTpIu1': 'The file size cannot exceed {max}MB',
  'dXaoDL': 'Actual completion time (local)',
  'oyw7Aw': 'Estimated completion time (local)',
  'mDab9A': '1、Only support label paper printing, the number of prints in a single print must not exceed 5000, please scan after printing for testing.{break}2、When selecting "Generate separate files for different SKUs" in the "Print File Generation Settings", the file name will be named according to the printed [SKU code]. Since file names do not support characters [\ / : * ? " < > |], these characters will be automatically ignored when generating the file name. Please pay attention to verify the barcode information to prevent mislabeling.',
  '+vbk++': 'Use the same label for all items',
  '7cXxXG': 'Use different labels for different items',
  'Jc5Kpb': 'Use different labels for different packages',
  'YJXDjo': 'Use the same label for all packages',
  'nYNtaU': 'Only allow [Capital letters Lowercase letters  Numbers   - _   (  )  +  /   @ #   .  *  ], please standardize the barcode format.',

  '+cSl6d': 'Netherlands',
  '+hC0sk': 'This condition only applies to eBay orders',
  '+tkLmV': 'Shop Status',
  '/fO7DP': 'Submit Order Directly',
  '0UNp8j': 'eBay',
  '0VccOb': 'Platform Account',
  '0qLmhP': 'The value entered must be greater than 0',
  '16whGa': 'Order Total Amount Range',
  '18gNnd': 'If there are existing synchronized or shipped orders for this account, disabling it will cause issues such as tracking number upload failure. Are you sure you want to disable it?',
  '1RqymR': '{platform} Authorization',
  '1wUKTi': 'Order Product Size = Sum of all product sizes in the order{break}Overseas warehouse delivery: Verification of length, width, height, volume, and weight of WINIT products that have successfully matched',
  '2qD539': 'Authorization Agreement',
  '4LK/OL': 'Set Shipping Rules',
  '5XgRM0': 'The value entered must be greater than or equal to 0',
  '8m5tda': 'Egypt',
  '9w+ho+': 'Account',
  'A4xIfz': 'Priority cannot be empty',
  'BE87UA': 'Order Packaging Method',
  'DjVTN+': 'Are you sure you want to delete the selected items?',
  'Dm9v6u': 'Minimum value cannot be greater than maximum value',
  'Eul4yJ': 'Italy',
  'FGIg8D': 'Seller VAT',
  'G6SgR8': 'Buyer\'s Paid Shipping Fee Range',
  'Gel0iY': 'Basic Information',
  'HHF8c2': 'Temu (Cooperative Warehouse)',
  'Ha+zt2': 'Amazon',
  'IDWBGn': 'Are you sure you want to enable it?',
  'Ij1E2t': 'Add Authorized Store',
  'JIWrkV': 'Canada',
  'JPVi93': 'Open Account Station',
  'Kc/Zlj': 'Authorization Expiration Time',
  'L0LvY4': 'The system prioritizes matching rules with larger numbers.',
  'MIDhcI': 'Select Conditions',
  'MyB1Vf': 'Saudi Arabia',
  'P3nNds': 'WINIT-SKU Code',
  'QRUdeg': 'Mexico',
  'R+nmnO': 'Recipient Information',
  'RclhRU': 'Expired',
  'S5OXfB': 'Are you sure you want to disable it?',
  'SnFLvY': 'Authorization Time',
  'Sq+iw6': 'Read and agree to the above content',
  'Ulf4Sq': 'India',
  'V2qOuC': 'Days until expiration<span>{remainingTime}</span>',
  'V3B10z': 'Order Products Include',
  'VWX2nS': 'This WINIT product requires the buyer to go to the Winit warehouse to pick up the package, please be informed!',
  'WeINul': 'Order Product Restrictions',
  'YMjT8q': 'Singapore',
  'Z4sh+T': '1. Binding multiple ERPs to {platform} stores may result in duplicate order shipments. It is recommended to authorize only one ERP for order shipment. {break}2. When canceling orders or processing returns and refunds on {platform}, please check if the Winit orders support cancellation. Any losses caused by unauthorized order cancellations will be borne by you.',
  'Zyc92J': 'Rule Priority',
  'aNVBIV': 'France',
  'bl+MC2': 'Buyer\'s Paid Order Total Amount',
  'cDfqJs': 'After deletion, this account will not be able to synchronize orders. Are you sure you want to delete it?',
  'd7IajO': 'Prime Order',
  'dO1aKB': 'Buyer\'s Paid Shipping Fee',
  'dtAVnP': 'Overseas Warehouse Delivery',
  'fp4MWN': 'Japan',
  'fvYPww': 'Recipient Information (Country/State/City/Zip Code)',
  'h70zPD': 'Spain',
  'hYtLJi': 'Shipping Type',
  'i18r6F': 'Selected Conditions',
  'iKSa2y': 'Order Processing Method',
  'iKXJaG': 'Manual Order Review Required',
  'lYtwbc': 'Authorization',
  'm8gGy1': 'Address Restriction Verification',
  'mB5/6q': 'Reauthorize',
  'mKU5ai': 'Order Products',
  'me24Kc': 'Please select at least one item',
  'mmpcKu': 'Buyer\'s Paid Shipping Fee is within',
  'nlsRat': 'Please select at least 1 item',
  'oIkTDz': 'eGD Order',
  'odP40n': 'Please enter a positive integer greater than 0',
  'r1bZdF': 'Order Package Product Size (Length/Width/Height/Volume/Weight)',
  'tJ/j09': 'To get your Client ID and Client secret, <url>click here</url>',
  'tZXPgK': 'Order Product Size = Sum of all product sizes in the order',
  'u+irD5': 'Store Type',
  'uxKWjC': 'Orders require manual review when Ontrac address verification fails',
  'vVkHR3': 'Buyer\'s Selected Shipping Method',
  'vcSBZu': 'Brazil',
  'wYVAbQ': 'Order Package Product Size',
  'wiNgJe': 'Store URL',
  'xaWTdZ': 'Winit Order Product Size (Length/Width/Height/Volume/Weight)',
  'yCUO83': 'Length/Width/Height/Volume/Weight',
  'yXiaSw': 'PlentyMarket',
  'z4ZNAd': 'Shipping fee paid by e-commerce platform buyers, not WINIT shipping fee',
  'zDbzKc': 'Order Total Amount is within',
  'zmKE3v': 'Winit Order Product Size',
  'zrmbIW': 'Recipient Company Name (English)',
  '+6dbt0': 'Sold date',
  '+TDdi+': 'Synchronize Tracking No.',
  '+g75jZ': 'Change content',
  '//LABL': 'Unmatched',
  '/QzWr8': 'shippingServiceName',
  '/WN1qt': 'Request end time',
  '/XA51t': 'No valid store',
  '/YGKRs': 'Order submission date',
  '/cWiGy': 'Please enter an integer greater than or equal to 0',
  '/i/2WU': 'Estimated cost (USD)',
  '/swJ78': 'Is the [E_BAY_MOTORS] site selected by default? ',
  '/uC9lN': '{count} items have been shipped successfully',
  '/wP4kI': 'Return to the list of failed shipments',
  '/wYx9N': 'Upload immediately after obtaining the tracking number',
  '/ykFIr': 'Total order price',
  '07ZsMQ': 'Please select the return and listing processing method',
  '0BxjIA': 'Please check the content to be deleted',
  '0NOsL9': 'Manual synchronization',
  '0O3sQ4': 'Product display that cannot be selected',
  '0XzF3X': 'Automatic synchronization of orders',
  '0lgQh9': 'Batch cancellation',
  '17OOxd': 'ShippingServiceName',
  '1DZFGW': 'Batch cancellation',
  '1E3TXK': 'Cancel the order successfully',
  '1Eo3x5': 'Please authorize the store first! ',
  '1O2B7E': 'The delivery address you filled in was verified by the carrier as "wrong address". It is recommended that you correct the address before placing the order. {break} Placing an order with an incorrect address may result in package delivery failure and address verification/correction fees',
  '1ZCq9j': 'Outbound packaging method',
  '1oMwGL': 'Release',
  '1pa/Sg': 'If the verification of country, state/city, and zip code fails, you can {a} query. ',
  '1yjaIa': 'Do not automatically upload Tracking No',
  '229O38': 'Fill in the recipient\'s name',
  '2E1kQr': 'For the current delivery method channel product, it is recommended that you check the ontrac address verification. When placing an order, verify whether the address is correct. This will reduce the address verification surcharge caused by address errors to a certain extent and increase the success rate of successful delivery',
  '2RN82t': 'Return to modify',
  '2WagLU': 'When submitting the shipment, if the German address verification fails, the order needs to be manually reviewed <Text>(both automatic and manual shipments will check this restriction)</Text>',
  '2dAmhv': 'Expected delivery date',
  '2wdW7g': 'Go to register',
  '2zl+/I': 'Seller',
  '34Wlc/': 'Cancel the delivery date',
  '36KE9A': 'Fill in at least 1 item. If you need to add multiple regions, you can add them one by one. The country, state, city, and zip code of the next order must be exactly the same as the configuration to match',
  '36s7cj': 'There are products in the editing state, please save first',
  '3RV/HR': 'View the successfully shipped orders',
  '3Wv3pF': 'Tracking No.',
  '3iHW4o': 'Click to view <url>How to get your token</url>',
  '3tg6DW': 'Platform SKU',
  '3v6pY0': 'Order delivery',
  '47mZrU': 'Product details',
  '49sNcx': 'Sale Price',
  '4da9dh': 'Whether to specify the range',
  '4fIBvJ': 'Stop selling',
  '4kkEGQ': 'View shipped orders',
  '4nzYdh': 'Save for manual review',
  '4qleTw': 'Synchronize now',
  '4zxOXq': 'Amazon store ID',
  '5/Py96': 'Merge orders with different recipient information',
  '5/Rszn': 'Ignore',
  '5G9UiG': 'Update date',
  '5MorV+': 'Only allow return orders for orders with the status of not placed and failed order, please reselect! ',
  '5UknIB': 'Platform synchronization will not synchronize the winit tracking number to the ebay backend',
  '5av8fQ': 'Please select a date',
  '5c9FcU': 'Combined delivery',
  '5jKlmp': 'Automatic delivery rule description',
  '5oiTur': 'Synchronize the number of goods',
  '5rsaEc': 'Warm reminder{break} Please configure the Amazon channel carefully. Configuration errors may result in abnormal situations such as failure to obtain Amazon delivery orders. Please check your Amazon account carefully as follows:{break}1. The configured last-mile delivery supplier account must be consistent with our warehouse address{break}2. The configured ShippingServiceId (channel code) overseas associated winit channel code will be applied to subsequent shipments{break}3. The associated Wanyitong channel must be accurate (the channel code corresponding to the WINIT last-mile account and your own last-mile account is different)',
  '5zNZSS': 'Platform synchronization operation guide',
  '61Sghw': 'Consignee Street 2',
  '67F4wY': 'The current country/product does not support detailed address verification',
  '6EcXeL': 'Not shipped',
  '6ct4bd': 'Your Token',
  '6fpQZR': 'Check available inventory',
  '6gb4KN': 'Note: Both automatic and manual shipments will verify this limit; logistics costs include outbound handling fees, last-mile delivery fees and other surcharges',
  '6qwXpP': 'Batch withdrawal',
  '6xd6//': 'Please enter any 1 to 30 characters',
  '73tyqj': 'Confirm order splitting',
  '79bjkh': 'Title + Surname',
  '7McuUb': 'Item Location',
  '7Md/OB': 'Failed to match the delivery rule {count} {break}',
  '7ZWZR1': 'Recently 3 days',
  '7gbiqq': 'Confirm to cancel the order split',
  '7jV4Ao': 'Edit and ship from overseas warehouse',
  '7mpTuJ': 'Wish currently only supports the last 7 days. If the time range is large, multiple calls to obtain orders are required. ',
  '7oHrmx': 'Platform product barcode',
  '7srZ22': 'Order at current address',
  '81twis': 'Return to pending review list',
  '8Dhcm2': 'Declaration value rule description',
  '8GyebP': 'Are you sure you want to delete the selected products in batches? ',
  '8UQNUB': 'The following products already exist, no need to add them again',
  '8Yf49r': 'Go to match',
  '8jOBpY': 'The input value must be greater than or equal to 0, and retain up to 4 decimal places',
  '94xxej': 'Consignee\'s house number',
  '98jk2k': 'You have not bound any account yet, please click <a>Bind account</a>',
  '9A5e/t': 'Order abnormality reason',
  '9Hmbk+': 'Address verification',
  '9Vmjl1': 'Do you need the system to synchronize Tracking NO. to the platform',
  '9ht+nd': 'Quick selection',
  '9xYxPs': '*The above fees are estimated by the system, and the final charges are based on the actual weight or volume of the goods shipped. Some fees cannot be estimated, such as address-related surcharges: residential surcharge, address verification surcharge, etc.',
  'A+Qk3q': 'Outbound products',
  'A0KE+Q': 'Original order',
  'A7QEW1': 'By setting automatic synchronization order rules, matching goods and automatic delivery rules, automatic upload tracking number rules, or order information replacement rules, the system will process platform orders according to the set rules',
  'AAcLUC': 'When submitting shipment, declare the value automatically calculated rules',
  'AEEoPg': 'Please select the goods to be confirmed',
  'AFmlFB': 'CarrierWillPickUp',
  'AGCxbg': 'Outbound tracking number',
  'AapBMy': 'Platform SKU',
  'Ah+hNu': 'Country is different, no order merging allowed',
  'AjQYZ+': 'Set inventory synchronization rules',
  'Ak5IcG': 'China Post Collection',
  'Akqn+S': 'Are you sure you want to replace the address information? {break}Original address: {oldAddress}{break}New address: {newAddress}',
  'Apabzu': 'Use ReturnLabel',
  'AqNc7V': 'Platform binding',
  'AswY/M': 'Address update',
  'B0s28p': 'Note: Only synchronize products with seller-SKU maintained in Tiktok background',
  'BGblXM': 'Input characters and the system automatically matches SKU',
  'BgZm0W': 'The input value must be greater than or equal to 0, and retain up to 6 decimal places',
  'C+Uxzp': 'Retain up to 6 decimal places',
  'C0XdtD': 'Address verification limit',
  'CBne5X': 'Synchronize inventory',
  'CHw3qK': 'No conditions set yet',
  'CQLU7A': 'eBay delivery method',
  'CSYChb': 'The quantity cannot be greater than the available inventory',
  'Ci0Gz7': 'Synchronize Tracking NO.',
  'Ck0FS5': 'Place order',
  'Cm99+l': 'Synchronization failed',
  'CqjwTi': 'Cancel order',
  'Cr2Er3': 'Country city postal code verification',
  'Cr5YTm': 'Submission successful, please go to the pending review page to view details',
  'D76Z0a': '(Default display of the latest 50 records)',
  'DMJmu1': 'Platform price',
  'DTDZKK': 'Note: Returns cannot be returned to DEBR2, and choosing to return to the original warehouse will result in the inability to upload the tracking number',
  'DXA+RX': 'This step must be configured, otherwise the return tracking number cannot be successfully uploaded',
  'DZ3tLQ': 'Order status statistics',
  'DgbZbl': 'Upload node',
  'DgtsPS': 'Product synchronization time range',
  'E6sBKv': 'Not supported',
  'EII/T2': 'WINIT standard packaging',
  'EMN/3N': 'The following merged items in your merged order are different. Please check whether the merged information is accurate. If the information is incorrect, please modify or cancel this merge. ',
  'EYeeM/': 'Package size: length * width * height (cm)',
  'EjwiL7': 'Batch cancel order',
  'En+MQY': 'Delivery failed {count} orders',
  'EnXH4I': 'Only pending delivery/delivery failed/pending review order operations',
  'EnmuEU': 'Product barcode value is repeated',
  'EptF2N': 'Seller ID is different, order merging is prohibited',
  'F+TH2y': 'Surname + Name',
  'F0/hCF': 'Title + Surname + Name',
  'FERBzi': 'Detailed address verification failed, reason: {info}',
  'FJb1Tn': 'Only pending delivery/delivery failed order operations',
  'FLVSid': 'Token has been deactivated. All functions such as order push, link building, and bid delivery have been invalidated',
  'GA2pu4': 'Do you need the system to update the platform\'s inventory for you',
  'GCx4WP': 'Please select the conditions and set them on the left',
  'GHgc0Z': 'Match the product and place the order automatically',
  'GM17E7': 'Shopify uniquely identifies the ID of the product under the order, which is used to confirm the delivery to the Shopify platform. If you add the product manually, there will be no such information',
  'GP5t2w': 'View the original order product',
  'GcJVRw': 'Orders that do not meet the automatic delivery rules will remain in the undelivered list. ',
  'GeOOM8': 'This operation is disabled for prime orders! ',
  'H635Bj': 'Return winit product',
  'HESoIq': 'Order processing rules',
  'HYFiGn': 'Return to the list of pending shipments',
  'HZFFbs': 'Specify return PSC',
  'HeCAli': 'User ID',
  'HizwI7': 'Synchronize records',
  'HkNxGk': 'Synchronizing',
  'Hm4LpH': 'Unmatched status operations only',
  'Hn2pQb': 'Seller VAT',
  'Hy6d0p': 'Recipient company is not Chinese',
  'I3d4Gk': 'Variation SKU',
  'I7S1fN': 'Do you need the system to match products for you, match shipping rules, and automatically place orders for shipment',
  'IHWpGJ': 'Add split order',
  'IdgYMG': 'Please enter information',
  'IexirJ': 'Automatically synchronize removal orders',
  'IzzAhc': 'Token has been used by {platform} platform',
  'J0Ixtg': 'Successfully matched {count} shipping rules, including',
  'JFnjqm': 'Additional shipping items',
  'JLs16Y': 'Declared value is used for international delivery <Text>(cross-border customs clearance, for example: German overseas warehouse delivered to France)</Text> and invoice printing',
  'JNgnyH': 'Automatic delivery verification results',
  'JTWY/n': 'Amount of goods excluding tax on e-commerce platforms',
  'JUvp6d': 'Order failed',
  'JYmlWa': 'Return warehouse',
  'Jdb9OB': 'Seller\'s order number, double-click to switch to multiple queries',
  'JezdzU': 'Please select a warehouse first',
  'K27qop': 'Export all',
  'K7rEg4': 'Order log',
  'KC5nMg': 'Add next one',
  'KQr9Qy': 'Shipper',
  'Kl42ZO': 'Please fill in a number greater than or equal to 0, and keep up to 2 decimal places',
  'KsxYm8': 'Product release time',
  'L6OOWH': 'Tiktok non-US regional orders do not support splitting by SKU quantity',
  'Lechn7': 'Merge orders',
  'LgOGwZ': 'Do you need the system to synchronize Tracking NO. and return Tracking NO. to the platform <Text>(upload only after obtaining the delivery tracking number and return tracking number at the same time)</Text>',
  'LkEeD0': 'Quantity that can be split',
  'Lo+WTc': 'Seller delivers by himself',
  'LoPdId': 'Please select the order first',
  'LzQ0Lw': 'Confirm to delete? ',
  'M3GU+Y': 'Winit delivery order number',
  'MIpscV': 'After synchronizing the order, when Winit\'s estimated logistics cost is greater than the set value, the order needs to be manually reviewed {break} <Text>(Both automatic and manual delivery will check this limit; logistics costs include delivery handling fees, final delivery fees and other surcharges)</Text>',
  'MNIlmV': 'The time range cannot exceed 7 days, please reselect',
  'MYg06i': 'Product Inventory Token',
  'MYkSIE': 'Batch Confirmation',
  'McIP0t': 'Product Price',
  'McrsRy': 'The platform order address is detected to be inconsistent with the address information submitted on the current page (order: {orderNolistStr}). Do you need to use the latest platform address to place an order? {break} If you have edited the address, you can place an order using the current address. ',
  'Mg0AQc': 'Cancel order splitting',
  'MsI/sQ': 'Platform price: 0<fillable data (2 decimal places) ≤ 100',
  'N17kGs': 'Winit estimated logistics cost is greater than (USD):',
  'N4+kjM': 'Hello, Winit has completed {platform} overseas warehouse certification!{break}{break}The first step, please read the authorization agreement and agree to the authorization to obtain information{break}The second step, supplement Winit\'s account information on the {platform} platform{break}{break}After the operation is completed, the {platform} platform will obtain your overseas warehouse related information and push order and product information',
  'NDWefD': 'Return destination warehouse',
  'NtMJWV': 'Synchronization completed',
  'O/h+jI': 'Do you need the system to synchronize Tracking NO. to the platform<Text>(upload after obtaining the tracking number)</Text>',
  'O06joR': 'Automatic delivery failed/abnormal information',
  'OXsNWP': 'Batch delivery',
  'OeDSof': 'Please select the synchronization time first, and then operate the export. {break} The synchronization time range supports up to one year. If the time span is large, please query in batches and then export. ',
  'Oo2KiB': 'Submission success {successNum}, submission failure {failNum}. ',
  'Ozld0E': 'Platform account and site',
  'P9tr6t': 'Fulfillment hours',
  'PBGuz3': 'Poland',
  'PBjcAH': 'Platform product status',
  'PO2HVG': 'Return order',
  'PvtavC': 'Platform product name',
  'Q7ENee': 'Close guide',
  'QI6Ef9': 'Platform product specifications',
  'QKEWl2': 'Import matching',
  'QMaIOh': 'Priority (execution order from large to small)',
  'Qbz3hj': 'Bookstore',
  'R/w0JS': 'Total price of goods',
  'RIGInR': 'Successful delivery of {count} orders',
  'RMDKuM': 'Upload when the package is shipped',
  'RWLdD9': 'Please select 2 to 20 orders to merge',
  'RY1yFe': 'Void return order',
  'Rrqg+Z': 'Remove authorization>',
  'RsiyM6': 'By matching the platform products and WINTI products, a matching relationship between the two is established. The subsequent synchronization order delivery will process the actual delivery products and quantities according to the matching relationship',
  'S39LBS': 'Note{break} 1. A single import supports a maximum of 3,000 data items. Please import in batches. {break} 2. Currently, only batch matching of unmatched platform products is supported. After importing, it will automatically confirm that the matching has been completed. {break} 3. If there is a platform product that needs to correspond to six or more WINIT products, the import is not supported yet. Please complete the matching manually. {break} 4. For Shopify and Wish platform store accounts, please fill in the store ID. For details, see Account Management. {break}',
  'SFPZaI': 'Order range',
  'SMwamU': 'Associated winit channel code',
  'SPja2U': 'Order synchronization rule description',
  'SVtGPL': 'Reason for order processing failure',
  'SdW6D2': 'Synchronize {platform} products',
  'Sda2Eq': 'Please save the product being edited first',
  'Sr3ung': 'Prefix',
  'Srv1tz': 'Set automatic return rules',
  'T/rcpD': 'Token is not used by {platform} platform yet, please go to the platform to bind and complete authorization in time',
  'THApeX': 'Manual matching',
  'TL7VCA': 'Buyer delivery method',
  'TVU/FV': 'Merge item',
  'TfyJrx': 'Consignee',
  'Tiq/oz': 'Unspecified Query Item',
  'TqtWP4': 'Are you sure to withdraw? ',
  'U+SXZR': 'Only waiting for confirmation',
  'U0/tzD': 'Before merger',
  'U7Ceox': 'Logistics cost limit',
  'U8Pz8g': 'IOSS stands for One-Stop Service for Imports, which is a service provided by the EU to reduce the pressure of customs clearance for low-value goods and simplify related procedures. {break}1. From the UK to the EU, IOSS NO is required according to the channel requirements. Such as DPD',
  'UAX0mp': 'WINIT Collection',
  'UWXTRM': 'Currently, only OTTO and PLentyMarket platforms need to configure return rules, and the configuration of other platforms is invalid',
  'UjYJFb': 'Only cancel the delivery order operation',
  'UnMDmI': 'Please enter a number',
  'UsHCy4': 'Splitting orders for delivery',
  'VVeUFY': 'For the time being, the order status flow data for the past 3 months is counted at most, and the number of orders after splitting or combining orders is counted',
  'VchMSg': 'Please set the recipient email replacement rule before enabling it',
  'VoFDc0': 'Automatic synchronization',
  'VuHi5g': 'Please enter 12 digits or more numbers or letters',
  'WElSYV': 'Edit delivery',
  'WN8E36': 'Winit product code*quantity',
  'WNHZoW': 'Amazon',
  'WNLBrz': 'Products need to be registered in WINIT for product data management and to establish links with platform products',
  'WQKhi4': 'You have not yet bound any account, please click {a}',
  'WUjg/Y': 'View failed delivery orders',
  'Wdn3bR': 'Submission success {successNum}, submission failure {failNum}. <br/>Failed import data and failure reasons <a>Click to download file</a>',
  'WonkyG': 'Recipient phone number is empty, replace',
  'WtVOWa': 'Synchronize order',
  'X+pVqZ': 'Integer length cannot exceed 10',
  'X7hfpR': 'Waiting for manual review',
  'X84Qes': 'Outbound order information',
  'XC4iyK': 'Please edit the product and add the barcode value',
  'XIqLuH': 'Order packaging material type',
  'XKNWZ0': 'No conditions have been set yet, and all orders will be defaulted. ',
  'XSkCPJ': 'Last updated time of order',
  'Y1GIwR': 'You can enable the platform as needed, and you can authorize the store after the platform is enabled',
  'Y6c2bc': 'Order delivery token',
  'YHGW8s': 'Enter at least 2 digits',
  'YOKKP9': 'Please select the product to be cancelled',
  'YPwzdO': 'View the cancelled delivery order',
  'YUC7c3': 'Seller customized order number',
  'YfisbY': 'DeliveryExperience',
  'Yq2JvZ': 'Each eBay account can only request synchronization once every 5 minutes!',
  'YycnMl': 'Are you sure to enable it? ',
  'Yz3osq': 'Synchronized',
  'Z12huF': 'Recipient information is prohibited from exceeding 10,000, please delete and submit',
  'ZDBa84': 'Store authorization',
  'ZKTxLl': 'Latest address order',
  'ZPrnCX': 'Please select conditions to define the order range',
  'ZSQdnW': 'You have not authorized the store yet, please select the platform first and then add an authorized store~',
  'ZbMlwg': 'winit channel name',
  'ZcEOKe': 'Get',
  'Zd3tQ1': 'Only orders with the status of unordered and failed orders can be cancelled, please reselect! ',
  'ZmVDi/': 'Value-added service options',
  'ZphZQT': 'Platform synchronization will upload the tracking number to the eBay backend immediately after it is generated, and synchronize the tracking number to the eBay backend again when the package is shipped',
  'Zu7b47': 'Your operation will unbind the platform product ID: {platformItemId} matching relationship. Please confirm! ',
  'a1lp3z': 'The following is a recommended address. Please confirm with the consignee before using it',
  'a1xnWp': 'Go to settings',
  'aQCUfC': 'Seller ID',
  'b/xWVl': 'Split quantity',
  'b0To7i': 'Warehouse and winit products of the outbound order',
  'b0fqEV': 'Shipping information',
  'bAi39D': 'On sale',
  'bBDPB+': 'Execution completed',
  'bT3oxz': 'No order placed',
  'brIRvh': 'Matching status',
  'bt6uNU': 'Promised latest delivery time',
  'c8Qmll': 'The split quantity must be a positive integer greater than 0 and cannot be greater than the split quantity',
  'cC9GYY': 'After synchronizing the order, configure the recipient name filling rule',
  'cLWCG2': 'The platform synchronization will synchronize the tracking number to the eBay backend when the package is shipped',
  'cee+ea': 'Please enter a decimal or integer',
  'cjf5im': 'Total order amount',
  'd7t1vH': 'Set automatic delivery rules',
  'dL7/Cj': 'Confirm the merger',
  'dOHXx8': 'Are you sure you want to withdraw these orders to pending delivery? ',
  'dRv2q5': 'Synchronize time',
  'dUKR8B': 'Recipient email replacement',
  'dlf0KO': 'State',
  'dn8dx4': 'Warehouse of the outbound order',
  'dxKF+V': 'Synchronize order shipment',
  'e++uU2': 'Buyer email',
  'eM8arj': 'Add product',
  'eMX0XN': 'Platform Carrier',
  'eN8cMr': 'Re-order',
  'eZqSrm': 'Only pending order operation',
  'ehBnJY': 'Priority must be an integer greater than or equal to 0',
  'f5iZGp': 'US region',
  'f7E98A': 'Currency',
  'fNjlMU': 'Consignee State',
  'fO5GuU': 'Delivery failed {count}',
  'fSGNZz': 'Belgium',
  'fSMR28': 'Order quantity',
  'fSloUl': 'You can synchronize the paid but unshipped orders on the platform to the pending delivery status by manually syncing or turning on the automatic sync rules. You can manually issue an overseas warehouse delivery order, or automatically issue an delivery order after matching the automatic delivery rules',
  'fbyUZc': 'Synchronizing, please check back later',
  'fem61w': 'Return tracking number',
  'fv+irj': 'Or',
  'fvi6kx': 'When the recipient\'s phone number is empty, it will automatically be replaced with the configured phone number to place an order',
  'g98DW3': 'European zone',
  'gIYz64': 'Is Prime',
  'gQakVR': 'You have marked the shipment in {platform} and cannot ship again. You can go to {platform} to confirm; click the button below to jump to view the cancellation of the shipment order. ',
  'gT+x6j': 'Do you need to update the order information synchronously: recipient information, notes <Text>(only the undelivered status will be updated)</Text>',
  'ggZsT6': 'Information authorization agreement',
  'gnb/Dv': 'Discount amount',
  'h8NAxo': 'Payment time',
  'hJNaRw': 'Platform warehouse and channel',
  'hb7p0K': 'Do you need the system to match products for you, match the delivery rules, and automatically place orders for delivery <Text>(Only synchronize products with seller-SKU maintained in the Tiktok background)</Text>',
  'hboJsJ': 'Add recipient information',
  'heFsnp': 'Synchronize authorized stores',
  'hf/k0S': 'Billing volume: single product volume accumulation (CBM)',
  'i/tHnC': 'The original platform order has been split into the following orders. After canceling the split order, the following split orders will be merged together (can be split again after merging)',
  'iAgwMn': 'Buyer information',
  'iC2h7q': 'Only pending confirmation or matched status operation',
  'iSBznD': 'Please select Winit product first',
  'iSi/Y2': 'Set return rules',
  'icjeQH': 'Single add',
  'ihL77X': 'Are you sure you want to batch confirm the selected products',
  'j54HZ6': 'It will expire soon, please reauthorize',
  'jCDWTA': 'Are you sure you want to cancel the delivery of the following order? ',
  'jCc8SG': '{platform}：{value}',
  'jM4EZZ': 'This token is only used in {platform} binding authentication warehouse',
  'jNSZhB': 'Synchronization method',
  'jSChCD': 'Read and agree to <url>《Authorization {platform} Query Agreement》</url>',
  'jdWfuo': 'The store name cannot exceed the maximum of {max} characters',
  'jmJUwg': 'The product channel has been updated. Please update the product channel configured in the automatic delivery rules or reselect the product channel to place an order. Thank you for your cooperation. ',
  'jumY2+': 'Planned return quantity',
  'k1SuG1': 'Replace with:',
  'k3KmwO': 'After successfully submitting the overseas warehouse delivery order, the return order will be automatically created at the same time',
  'k4V29T': 'Order quantity',
  'k5K6Yt': 'After merging (modifiable)',
  'k6yicO': 'Do you guarantee the order',
  'kGU7zi': 'Please enter a number and keep two decimal places',
  'kpSBU0': 'Click here',
  'kw4Idh': 'Submitted to the manual review {count} order',
  'l1E5Kc': 'Do you confirm to cancel the shipment? ',
  'lXd3or': '{platform} platform does not have a valid authorized account, please complete the store authorization first, {a}',
  'lcVkcM': 'Confirm to cancel the return order? ',
  'ljCEOy': 'Automatically update order information',
  'lkf5xf': 'Seller VAT number, you need to register the importer first [Personal Center-Service Settings-Exporter/Importer Management-View-VAT Information-VAT] {break}1. For orders from the UK to the EU and from the EU to the UK, whether it is required or not depends on the channel requirements {break}2. For orders that are not required by the channel, such as orders shipped from the UK, you can fill it in',
  'lliahm': 'More settings',
  'm15yzY': 'Please enter any character from 1 to 128',
  'm7WXxa': 'Shipping time',
  'mF20Qh': 'Shipped',
  'mIbw6U': 'Consignee company (English)',
  'mIw63f': 'Your operation will confirm the platform product ID: {platformItemId} matching relationship. Please confirm! ',
  'mKK9WT': 'Only orders with the status of already placed can be voided, please reselect! ',
  'mSoKQe': 'Set order delivery rules',
  'mmi+vH': 'Delivery product information',
  'n0Xfv5': 'Suffix',
  'n0kndm': 'Confirm to cancel the return? ',
  'nHit3N': 'Please select the winit product to return',
  'nLUS2T': 'Multiple seller order numbers are separated by line breaks or English commas, and a maximum of {num} are supported. Double-click to switch to a single query',
  'nQ+LR9': 'Use Return label',
  'ndq6Ec': '{count} pending review',
  'ngk71+': 'Return Winit product',
  'o4g7EG': 'Order details',
  'oR7wAu': 'Split order',
  'odb5gY': 'Product update time',
  'oibt/1': 'Value-added service items',
  'oud2NS': 'Sold time',
  'p6hoaM': 'Shipping date',
  'p8ioIZ': 'Reason for failure of automatic shipment verification',
  'pLhC09': 'The delivery address you filled in was verified by the carrier as "wrong address". It is recommended that you correct the address before placing the order. {break} Placing an order with an incorrect address may result in package delivery failure and address verification/correction fees. ',
  'pQhPvh': 'Company (English)',
  'pjDaex': 'custom Label',
  'pqJzJ3': 'Are you sure you want to batch uncheck the selected items? ',
  'prz34V': 'Do you need to automatically synchronize and obtain the detailed data of the removed order items and the tracking number information of the removed order?',
  'pyWapc': 'Shipping warehouse',
  'pztUhO': 'Batch import matching',
  'qWV6JF': 'After synchronizing the order, when Winit\'s estimated logistics cost is greater than the set value, the order needs to be manually reviewed',
  'ql8RgO': 'You need to log in to the OTTO backend and configure the return routing code / routing ID information',
  'qo/NLW': 'Quantity shipped',
  'rOme4B': 'ShippingServiceId',
  'rPf5tI': 'Prime orders and non-prime orders need to be shipped separately. Please check carefully and re-ship. ',
  'rUBnXV': 'Are you sure to deactivate? After deactivation, all functions of the platform such as order push, connection, and standard delivery will be invalid. Please cancel the authorization on the platform before deactivating',
  're1+gV': 'Please select the return warehouse',
  'rhr13R': 'Submit order',
  'rtGwlf': 'Contains value-added services',
  's+OaHz': 'Packaging materials',
  's7H+Ea': 'Original delivery warehouse',
  'sH465R': 'The country, state, city, and zip codes of the order information must all match successfully to pass the verification {break} Only import recipient information that is different in (country/state/city/zip code)',
  'sLcGyn': 'View configuration instructions',
  'sNnZ4Y': 'Delivery failed',
  'seO722': 'Please set the calculation rules before enabling',
  'slMFds': 'Winit products of the delivery order',
  't5QiVF': 'Order processing',
  't9JxrU': 'You have not bound any account yet, please click <url>Bind account</url>',
  'tXGo6k': 'Request start time',
  'tcek4x': 'Detailed address verification',
  'tiQ2lL': 'Self-shipping',
  'tiReS9': 'Configure return carrier information',
  'toZ02P': 'Shipment successful',
  'tr8ieB': 'Nearly 1 day',
  'trwfSO': 'Please select the products that need to be split and shipped first, and then add the split order',
  'tx3VXW': 'Synchronization time range',
  'u7KD5S': 'There is at least one product in the main order, please split it again',
  'u7ocgU': 'After synchronizing the order, the recipient\'s mailbox replacement rule configuration',
  'uAu2Dr': 'The input value must be greater than or equal to 0, and retain up to 2 decimal places',
  'uB9dmc': 'The current account does not have <strong>{menuName}</strong> menu permission, please contact the main account to enable it',
  'uDkDxI': 'Product range',
  'uK/6iw': 'Return shelf processing method',
  'uLupxE': 'Do you need the system to automatically synchronize orders to the order list',
  'uRbIR3': 'Confirm authorization',
  'uiMchU': 'Buyer IDs are different, and order merging is prohibited',
  'v1KiUu': 'Winit product details',
  'v3+E+w': 'Winit return order number',
  'vAgZTZ': 'Order has been split',
  'vBf++D': 'Please verify the country, city and postal code first',
  'vDASuh': 'The recipient information already exists, please do not add it again',
  'vH/+mg': '{count} orders have been selected. Do you want to re-execute the automatic delivery rules for the selected orders? ',
  'vOev4X': 'Platform order details',
  'vWi3Vl': 'Confirm to cancel the order? ',
  'vcHJ25': 'Required items only support English and numbers',
  'vfp0r9': 'Are you sure you want to withdraw the following order to pending delivery? ',
  'vg7n2N': 'Product Matching',
  'voSiwO': 'Consignee Street 1',
  'vrfKdo': 'Platform Parent SKU',
  'vvpREo': 'Rematching Rules',
  'w1k3VB': 'Cross-border Store',
  'w2H7cS': 'Platform Sub-SKU',
  'w9f6F7': 'Return Order Status',
  'wazdM3': 'Order Update Time',
  'wiyRvq': 'Please check the product and confirm the quantity of the product first',
  'xFL39V': 'Freight',
  'xJtYaX': 'Authorization Information',
  'xK+WAG': 'Seller\'s Promised Delivery Date (Beijing Time)',
  'xMN2jr': 'Splitting Order',
  'xRG5/O': 'Order amount',
  'xRbMLs': 'Set rules',
  'xcXdOz': 'Set order matching rules',
  'xjgdRa': 'Please select the order to cancel',
  'xoqs73': 'No recommended address',
  'xrEY+m': 'Shop account',
  'y27XLJ': 'Matched',
  'y8FQY+': 'Buyer delivery category',
  'yCEYqm': 'Successful order splitting, please check the order splitting information in Unshipped-Splitting and Shipping',
  'yDkttN': 'City postal code verification is not supported in the current country',
  'yVcad6': 'Successful submission of overseas warehouse delivery order, and creation of return order at the same time',
  'yeFbaK': 'Go to the platform to view',
  'yqcSAM': 'Number of synchronized orders',
  'yz+0WG': 'View pending orders',
  'z4UtzG': 'The current address verification result is not passed. It is recommended that you confirm with the consignee and choose the recommended address to place the order',
  'z54KMO': 'After splitting the order, if any of the split orders has been shipped, it cannot be withdrawn. Split orders do not support combined shipment',
  'z6dNPk': 'Order abnormality',
  'zFjwI6': 'Product code*quantity',
  'zWGfdT': 'Confirm withdrawal? ',
  'zZW2wr': 'After completing the authorized store, you can operate the relevant functions of the corresponding platform in the platform synchronization system: synchronize orders, synchronize products, upload tracking numbers to mark shipments, etc.',
  'zk7SMq': 'Please split the order first',
  'zygLEO': 'Order creation time',
  '+O4tBd': 'Cancel Order',
  '7LJCdw': 'Cooperation Warehouse Docking',
  'FQtWyC': 'Regular Docking',
  'Tmj1qg': 'Priority cannot exceed maximum {max} characters',
  'ks/AJB': 'Regular docking cooperation platforms: {platform} etc.',
  '6nPEWw': 'Synchronous Inventory Rules Explanation',
  'bMei6Y': 'Cooperative warehouse docking mode platform: {platform} etc.',
  'ezoUFi': 'Regular docking cooperation platform: {platform} etc.',
  'fbUD56': 'Some platforms support setting order processing rules, please refer to the platform operation guide for details. The operation needs to be completed in the platform merchant background',
  'rhY6/6': 'After completing the authorized store, you can get the corresponding token. You need to complete the authorization operation in the platform merchant background',
  'txPox+': 'Match the platform products and WINIT products to establish a matching relationship between the two. The operation needs to be completed in the platform merchant background',
  'Fil2JU': 'View {platform} operation guide',
  'gb6L3E': 'After completing the configuration operation, the platform will automatically synchronize the order and automatically issue the delivery order. {break} Note: This type of order will not be displayed in the platform synchronization menu. If the order is successfully issued, please check it in the delivery order module. If the order is abnormal, please correct it in the platform backend and push it again. Some platforms have different operations, please refer to the platform operation guide for details',
  'SLH3v0': 'If the fee is set to 0, the restriction rules will not be judged. If manual review is required, please set a value greater than 0',
  'LnpBHN': 'Time limit marker',
  '+F2ixr': 'The Timeliness Mark refers to the timeliness guarantee service applicable to an order, which is related to the WINIT Product or value-added service selected for the order. For specific details, please refer to WINIT\'s product definitions.',
  '8A3iSu': 'The 1 e-commerce platform ID you set [{winitItemSku}] issued [{winitItemQty}] [{winitItemName}]{break}',
  'u1MvPk': '1. The system will automatically generate overseas warehouse bills on the 1st of each month and ISP bills on Mondays. If the bill has not been generated by this time, please contact customer service.{break} 2. Independent bills and electronic invoices can be issued if the current expenses minus current income are not zero.{break} 3. After February 1, 2025, under invoice compliance management, invoices shall not be issued when the total amount of advance invoices and subsequent invoices exceeds the cumulative consumption amount to date.{break} 4. For inquiries regarding invoices and billing matters, please contact our online customer service.',
  'XVpiwO': 'BC package barcode number',
  '+/g10t': 'Sales Platform for Outbound Order',
  '/2o3AV': 'Seller ID',
  '0dJ1P8': 'Physical SKU Code',
  '0djqyQ': 'Please ensure to maintain return tracking numbers before goods arrive at the warehouse; otherwise, goods may risk being classified as unclaimed.',
  '0rwflq': 'Is Return Label',
  '11Fc73': 'Inspection Result: Defective',
  '1UKfTS': 'Inventory for returned goods ({originalMerchandiseSerno}) no longer exists and cannot be associated. Contact customer service if needed. Upon confirmation, the status will update to Completed. Proceed?',
  '1b6W7N': 'Sub-Outbound Order Number',
  '1qoi3T': 'Images',
  '2L6ati': 'Return',
  '2LDGUc': 'Auto-Destruction Timeframe',
  '2hr1of': 'Photography Template Type',
  '2ll590': 'RMA Number',
  '2smMkx': 'Return Processing Time',
  '3QNffE': 'Processing SLA',
  '3pTMyj': 'Sender Information',
  '5IfCJO': 'Enter numbers greater than 0 with up to 4 decimal places',
  '5hMlW2': 'Notice:{break} (1) Products must be registered and approved before creating return orders.{break} (2) For SKU-managed goods, maintain third-party barcodes in Product Management before arrival.{break} (3) For SI-managed goods without initial barcodes, maintain third-party barcodes in Inventory Management before arrival.{break} (4) Goods without scannable barcodes will be processed per no-barcode exception policy.',
  '5n9upP': 'Product-Level Custom Photography Template',
  '68BAPH': 'Value-Added Service Order',
  '68cqkQ': 'RM Code',
  '6pLkXQ': 'State/Province',
  '6vnHwd': 'Enter SKU code (fuzzy search supported)',
  '7/Gips': 'Processing Comments',
  '799kEA': 'Modified Time',
  '7P6gF1': 'Order Created Successfully',
  '7UH/y2': 'Confirm Submission',
  '7hpKK4': 'After SKU association, warehouse will replace RM labels with SKU M-labels and relocate to sellable inventory.',
  '7iUz69': 'Sellable Processing Method',
  '8Dirwm': 'Auto-Destruction Time',
  '8TwOhb': 'Is Empty Package',
  '8cDIeY': 'Winit provides non-RMA return services to streamline unforecasted returns and facilitate timely inventory processing.',
  'A+jWI7': 'Creation Type',
  'A63PcF': 'Temporary Storage Time',
  'AICkca': 'Custom Photography Template',
  'AlOOoT': 'Minimum 1 image, maximum 15 template images allowed!',
  'B6Z4Gq': 'Express Return Address',
  'BDCdKO': 'Defective Processing Method',
  'BQ2Et0': 'Select Associated Product',
  'BWdJmA': 'Maintain the following Winit Return Center address (with unique Return ID) in your sales platform\'s return address or provide to buyers for warehouse recognition.',
  'BnGVAl': 'Unloading Tracking Number',
  'BvC0EG': 'Customer Order Creation',
  'C72hoh': 'Ensure complete return address and label information',
  'C8dc7/': 'Add Return Tracking Number',
  'CeXPpD': 'Insurance Coverage',
  'D1zVXx': 'Photos Maintained',
  'DBKT4U': 'Supplier',
  'DBrCz6': 'Customer Return Tracking Number',
  'DdDnkx': 'Return Center Warehouse Address',
  'Dgc9tF': 'Sender Name',
  'DlRW4A': 'Non-RMA (Unforecasted) Return Guide',
  'ECxCyh': 'Corresponding Processing Method',
  'EqPEoU': 'New Copied SKU Code',
  'F+1Ly6': 'Original Unloading Tracking Number',
  'F97OGz': 'Failed to query outbound order with number: [{orderNo}]',
  'FCSu4h': 'Return Quantity',
  'FRKa5V': 'Warehouse Remarks',
  'FTSLqN': 'Postcode【{postCode}】has no available pickup dates!',
  'G66ewv': 'Category',
  'GbI2f+': 'Actual Photography Quantity',
  'GmWdlP': 'Inventory for returned goods ({skuCode}) no longer exists. No destruction needed. Status will update to Completed upon submission. Proceed?',
  'HcO8E9': 'Sender Name',
  'HuoMXG': 'Product-level policies default to order-level strategies but can be modified. Product-level policies take precedence.',
  'HyER60': 'Associated Product Information',
  'ILbEkr': 'Register New Product',
  'IOP/vU': 'Outbound Qty | Returnable Qty',
  'IsemUS': 'Error Row Number',
  'Jpz9XQ': 'View Value-Added Return Info',
  'Kf7UU1': 'Defective Processing Method',
  'Kv61+4': 'Delivery Supplier',
  'KwuNUe': 'Batch Processing',
  'LZMJSc': 'Physical Identification Barcode',
  'NTRE6D': 'View Value-Added Return Order',
  'NcB8kv': 'Maintenance Method',
  'OAUF/v': '(4) RMA returns must be submitted before goods arrival, otherwise may be deemed unclaimed.',
  'ODaCbS': 'Delivery SLA',
  'ON6UqU': 'Temporary Storage Barcode',
  'OeMOhC': 'CAUTION: If RM code dimensions/weight exceed associated product specs, target product specs will be updated!',
  'P0LBOd': 'Process',
  'PozUc+': 'Returned',
  'QBKGFh': 'Batch Attribute-Date-Production Batch',
  'QYLVrI': 'Note: Batch maintenance will clear historical photo templates. New templates will take effect.',
  'Z+MCSG': 'Notice:{break} Returns without ID or scannable barcodes will be classified as unclaimed.{break} <font>Use Winit Return Label or RMA services for better processing.</font>',
  'Qgy4xA': 'Product Return Policy',
  'R/Mgye': 'Reminder: Re-uploading will clear existing product info',
  'R1WVaq': 'Use Winit Return Label Service',
  'RCHqIg': 'Package Dimensions [L*W*H Weight]: {length}cm*{width}cm*{height}cm {weight}kg',
  'RHHueZ': 'Enter Return Quantity',
  'RdnRuz': 'Package Dimensions & Weight',
  'RgICGS': 'Selected Associated SKU',
  'Rl/75p': 'Return Label',
  'SdbY82': 'Sub-Outbound Order No.',
  'SopSUH': 'Sellable Processing Method',
  'T0dYfd': 'Return Tracking Number: 6-60 characters (letters/numbers/symbols)',
  'T29xwd': 'Value-Added Service Order No.',
  'T9MdWR': 'Valid for UK & DE only. Applies to all SKUs in order if selected.',
  'USFimD': 'Ordered Qty | Actual Shelved Qty',
  'UTeJqS': 'Original Tracking Number',
  'VN6BbB': 'RM Code Weight',
  'VgURQV': 'Temporary Return Processing',
  'WZUGRX': 'Require Dimension Measurement',
  'X7zovx': 'Return Sub-Outbound Order No.',
  'X9Kqav': 'Inspection Result: Sellable',
  'XDxd9e': 'Actual Shelving',
  'Y1zy+s': 'Warehouse will destroy returned goods.',
  'ZEB0yN': 'Original product is batch-managed but associated product is not. Confirm association?',
  'ZTSz4Y': 'Product code does not exist. Associate existing products or register new ones.',
  'a381GD': 'Pending Return Tracking Number',
  'a4hXYh': 'Receiving Warehouse',
  'bNrg6s': 'Return Item Barcode',
  'bg+pto': 'RM Code Dimensions',
  'c9TJu9': 'Enter numbers greater than 0 with up to 2 decimal places',
  'cEA4zF': 'Modifier',
  'cYlsil': 'Custom Template',
  'd9R845': 'Return Policy',
  'dgvdrA': 'SKU Code for Physical Barcode',
  'dr93it': 'Download Label',
  'e0QLxL': 'Template Photo Quantity',
  'eV1I2k': 'Return Reason',
  'eZPZ8+': 'Destruction Outbound Order No.',
  'eihkgE': 'Temporary Storage Info',
  'fRQ7Hv': 'Scan Identifier',
  'fcWN+y': 'Winit Capture',
  'flwayn': 'Sub-Outbound Order No.',
  'g2+Ax2': 'Sender Details',
  'gwfFoI': 'After SKU association, RM labels remain and goods move to defective inventory.',
  'hGqR3l': 'VAT Owner',
  'hsQeVV': 'Total Cost (USD)',
  'i3I/pa': 'Pending Maintenance',
  'i8C1qO': 'RMA return addresses must include RMA number (provided post-order creation).',
  'iJHRJg': '(5) AU Warehouse returns use POBOX addresses (AU Post only). Contact CS for other carriers.',
  'j91Q75': 'SKU [{searchText}] spec [{specification}]{status}. Use alternative SKU!',
  'j9u2yH': 'Customer Remarks',
  'kICF+A': 'Winit Order No.',
  'kMLdYw': 'Order Remarks',
  'kPaZ+K': 'Reset to Outbound Order Recipient Info',
  'keDN3D': 'Return Order Strategy',
  'l62Oqo': 'Pickup Date',
  'lCL7h7': 'Processing Fee',
  'loevIq': 'Winit Products & Cost Estimation',
  'mLt8j5': 'Return Completion Time',
  'mlgAHz': 'Associated Product Code',
  'mrYK6Z': 'Return Product Images',
  'nKLIK1': 'Associate Product',
  'nq2M/N': 'Enter new SKU code for return maintenance purposes',
  'oGfEgE': 'Return quantity cannot exceed returnable quantity',
  'p4wQ31': 'Unable to provide/Cancel request',
  'pAhBaD': 'Product Name (CN/EN)',
  'pGYuf8': 'Specifications',
  'pLESa/': 'Winit Return Center auto-creates return orders upon owner identification',
  'pSpGmB': 'Warehouse Value-Add Processing',
  'qExiwC': 'Invalid email format',
  'r4aetI': 'Winit Captured Tracking No.',
  'rFU4fG': 'Estimated Completion Date',
  'sNUB3N': 'Pending Customer Action',
  'sVETw+': 'Return Photography Template',
  'stoffA': 'VAT Owner',
  'sy+pv5': 'Email',
  't7FHVM': 'Confirm cancellation?',
  'tGXMLl': 'Return Unit Quantity',
  'ts37H5': 'VAT/EORI',
  'uADqqT': 'Return Product Info',
  'udsQe8': 'Photo Timestamp',
  'v/3ZQu': 'Winit Outbound',
  'vFVpcn': 'Unpublished',
  'vH85CS': 'Non-Winit Outbound',
  'vW2S+F': 'Defective inventory cannot be shipped with sellable goods in same order',
  'w1PwZD': 'Basic Sender Info',
  'wBTrH2': 'Preferred Pickup Address',
  'wfl9ZM': 'Winit Order Number',
  'xCdMfz': 'Optional (UK & DE only). If specified, overrides system VAT rules.',
  'y0wTBC': 'Buyer',
  'y9b1P7': 'Maximum {maxCount} template images allowed',
  'yJeaIT': 'Winit Return Center will process per non-RMA return policy',
  'yWr1bK': 'Winit Template',
  'ywoyKz': 'Declared Value (USD)',
  'zDk1Nv': 'Maintain Winit Return Center address in sales platform return settings',
  'zJv/fs': 'Create Return Order',
  'zVNDbm': 'Custom product-level templates take priority over client-level templates. Client-level templates differ from standard Winit templates in pricing.',
  'zYCqK9': 'Dimensions (L*W*H/cm)',
  'zh/BWz': 'Pickup Information',
  'QhLnYY': 'Modify Log',
  'IoOUi9': '[{confirmListCode}] in the order is a defective product. Do you confirm that the return warehouse has received the physical product? Click \'Direct Shelf-Good Product Shelf\' to add good product inventory. Click ‘Confirm’ to continue!',
  '8rukt0': 'Received',
  'WSk/X1': 'Automatic destruction when stopped',
  'eJlU8R': 'View template pictures',
  'AKFq1O': 'Latest push time',
  'UdTynn': 'Note:{break} 1. Inventory information will be synchronized to eBay only for eBay accounts that have been enabled in [Account Management]. You can go to [<a0>Account Management</a0>] to check the status of your eBay account;{break} 2. This page only displays information about bound products. If you have not bound them, please go to [<a1>eBay Certified Warehouse Product Management</a1>] to bind them;{break} 3. There are inventory and product size and weight restrictions for pushing certified warehouse products. For details, see <a2>Operation Instructions</a2>;{break}',
  'rrWpjk': 'Latest reasons for not pushing',
  '96PAzm': 'Submission success {successNum}, submission failure {failNum}. {break}Failed import data and failure reasons <a>Click to download file</a>',
  '3w/ZXS': 'No record (single item not in stock or corresponding operation information automatically archived after exceeding 2 years)',
  '5CPQd8': 'Current item status',
  '8VJJbj': 'For single product, it is the verified volume of the single product; for boxed set product, it is the verified volume corresponding to the boxed set product',
  'OpKDTp': 'Are you sure you want to switch to [Yes, consistent with good products]?',
  'RYj/xc': 'Number of boxes/sets in stock for box products or set products',
  'RydShn': 'Item barcode operation log information',
  'WHQp3W': 'Number of boxes/sets',
  'Xm1pt6': 'Regular product',
  'uZU8sk': 'In the scenario of automatic grouping for outbound orders (multiple sets indicate 2 sets or more); {break} If configured as [Yes], when ordering 1 item A, and it matches this grouping relationship, it will automatically be grouped for outbound; when ordering 2 items A, and it matches this grouping relationship, it will be automatically processed as 2 sets; {break} If configured as [No], when ordering 1 item A, and it matches this grouping relationship, it will automatically be grouped for outbound; when ordering 2 items A, it will not be allowed to be processed as a set, but will be handled as a regular package.',
  '8sL5pg': 'Data update',
  'HhrjUl': 'Denominator: Within the range of the target delivery date, the number of packages that should be shipped out of the warehouse and are not drafted/voided by the customer/voided by Wanyitong/voided by failure to capture the order; {break}Numerator: within the range of the denominator, the number of packages with the actual delivery date <= the target delivery date.',
  'UVl8Ye': 'Export timeout and undelivered details (real-time)',
  'nxCFhm': 'Due to inconsistent update times, this data may be inconsistent with the page [Number of Timeout Outgoing Databases]',
  '+QH9aU': 'Expected domestic warehouse delivery',
  '61Q2bA': 'Expected overseas warehouse delivery',
  'Cyx0kU': 'Order weight',
  'XAVPBS': 'This preference is only applied to the cost estimate of the incoming order process. Other factors such as order restrictions, overseas inspection reservations and violation fee calculations are not subject to this preference',
  'd/umZj': 'Please note that after choosing to waive self-inspection, the order will automatically undergo inspection after submission and the shipping label cannot be modified.{break}Additionally, for B/C packages that have waived self-inspection, there will be no sub-package information in the inspection system, and they will be charged according to the standard for packages without sub-packages after being shelved.',
  'rSSvME': 'the system will display and estimate the cost according to the longest side, second longest side, and shortest side based on the length, width, and height you entered.',
  'zSDFbF': 'Order volume',
  '05TZVT': 'Outbound entry exception',
  '0Npq7r': 'Create Outbound order',
  '6g9Wst': 'Pending temporary orders',
  'AIywwl': 'Photo temporarily stored for processing',
  'IocBNZ': 'Abnormal situation in the warehouse',
  'KdkO6t': 'Pending confirmation of shortage order processing method',
  'VtgkiE': 'Outbound pending processing',
  'XNrxUg': 'Warehouse entry exception',
  'cHJ2tH': 'Inbound Pending Processing',
  'IaVnOG': 'Fee Estimation Preferences Settings',
  'cM+3En': 'Warehouse has received',
  'f9HdOe': 'Login IP',
  '+nKXJ/': 'Set Strategy',
  '0TIzQx': 'Pending Review',
  '16zLrM': 'Note: To ensure inspection effectiveness, please circle the location on the image and add necessary text annotations before uploading.',
  '35Ap1W': 'Are you sure to clear the return policy set for product(s)【{codes}】? If no product-level policy exists during returns, the default return policy you configured will be applied!',
  '4FyYBa': 'Default Return Policy (Customer Level)',
  '4wGMni': 'Delivery Failure:',
  '5V9CE8': 'When the overseas warehouse receives returned items with "Returned Item Status ≠ Normal", the return policy will be matched based on the following priority order:',
  'Aiuda0': 'Product Photo Template',
  'Bdb4rA': 'High Value',
  'CVPemq': 'Product Attributes - Priority Order',
  'DbtZiz': '1. Product-level return policies configured on the "Product Return Policy" page.',
  'EMUWj/': 'Standard Type',
  'ElZ9N0': 'Supports batch query of up to {num} entries. Separate entries with commas or line breaks for batch queries!',
  'FWkmOf': 'Page Template',
  'GRPOdU': 'Return policy matching priority: {break} Product Return Policy > Default Return Policy (Customer Level) > Winit Return Policy {break} *If neither "Product Return Policy" nor "Default Return Policy" is configured, the "Winit Return Policy" will be applied.',
  'IsZPwQ': 'Batch Edit',
  'LJjMp2': 'Winit Policy',
  'M0p1ky': 'Supported formats: JPG, PNG, GIF, JPEG',
  'Nu6ukW': 'Batch Clear Policies',
  'RJAU9A': 'Confirm to clear policies?',
  'SEGQZS': 'When "Returned Item Status = Normal", the return policy will be matched based on the following priority (Go to configure): {a1}>{a2}>{a3}',
  'SGo++1': '3. If neither 1 nor 2 is configured, the following default policies will apply during returns: No RMA: Photo Storage; Delivery Failure: Direct Shelving.',
  'U0+OQF': 'When the overseas warehouse receives returned items with "Returned Item Status = Normal", the return policy will be matched based on the following priority order:',
  'UPxP2W': 'Upload at least 5 images of good-condition items.',
  'VN1ezV': 'Good-Condition Images',
  'W3/yma': 'Default Return Policy',
  'XwFUS0': 'No RMA Return Policy',
  'YBQNBm': 'If the return photo template for a product is cleared, the default template will be used. If no default template is maintained, WINIT standard SOP will be applied for photo processing!',
  'YIGFVJ': 'If no return photo template is maintained for a product, the default template will be used. If no default template is maintained, WINIT standard SOP will be applied for photo processing!',
  'YzOXoA': '1. Customer-level return policies configured on this page.',
  'ZMYzQk': '*If neither "Product Return Policy" nor "Default Return Policy" is configured, physical returns will be processed according to the "Winit Return Policy". To avoid unexpected return handling, configure policies promptly based on actual business needs!',
  'aVh0hV': 'Return Policy Maintenance',
  'ax4G39': 'Edit Photos',
  'axey37': 'Returned Item Status',
  'bUJ3KI': 'Clear Policy',
  'c1hxVC': 'Winit Return Policy',
  'eivou1': 'Maintain Return Photo Template',
  'hBzbwm': 'No RMA:',
  'hXKE17': 'General Standard',
  'jJiNOd': 'Returned Item Status',
  'l0h4gZ': 'Separate multiple product codes/barcodes with line breaks or commas. Maximum {num} entries. Double-click to switch to single query.',
  'l8NWUi': 'When "Returned Item Status = Abnormal", the return policy will be matched based on the following priority (Go to configure): {a2}>{a3}',
  'm+CSKJ': 'No RMA',
  'mmuRHl': 'Batch Clear',
  'nzf0kE': '2. Follow WINIT\'s base rule configuration【{a}】',
  'o7BHmU': 'Batch Set Policies',
  'oEcYBH': '2. Customer-level return policies configured on this page.',
  'p7uXGN': 'Delivery Failure Return Policy',
  'ppO2BL': 'Number of Photos',
  'rs+KKE': 'Standard Name',
  's2MRUC': 'Priority Order',
  'uE11Jo': 'Defective Item Images',
  'veuVN/': 'At least one return policy (No RMA or Delivery Failure) must be filled.',
  'w7h6tB': 'Edit Policy',
  'wCQB8y': 'Please select products first',
  'zETnvF': 'Product Return Policy Settings',
  'zcAqKI': 'Default Photo Template',
  '8TxolX': 'Winit will follow the above rules to match return processing policies. Please configure the corresponding return policies in advance based on your actual business needs to ensure compliance with expected processing methods.',
  'ZxQtHK': 'You can configure different return processing policies based on your needs',
  'fhEV6C': 'When returned item status ≠ Normal**, the return policy will be matched in the following priority order: {a2}>{a3}',
  'kPQvJQ': 'When returned item status = Normal**, the return policy will be matched in the following priority order: {a1}>{a2}>{a3}',
  'Gtlk4r': 'Product import successful, you can view the products on the already set page.',
  'hvJv2u': '(Delivery Failed)',
  'ngTsgq': '(No RMA)',
  '2vV3rp': 'This WeChat account is bound to multiple WINIT accounts. Please select one to log in:',
  '6zf5WP': 'The current WeChat account ({nickname}) is already bound to the following accounts:',
  'A9zFcw': 'Recent Login',
  'HO+Y34': 'The current WeChat account ({nickname}) is bound to the following accounts ({bindTotal} in total):',
  'Jpe8pz': 'Go to Login',
  'RAXpq+': 'Log In Now',
  'REvR5Z': 'Scan to Log In',
  'RVmna3': 'Sorry, the maximum number of accounts bound to this WeChat account has been reached (maximum {bindUserNumLimit} accounts)',
  'UNKU4n': 'To continue binding the current account, please provide the following information:',
  'V3DdUR': 'This phone number is bound to multiple WINIT accounts. Please select one to log in:',
  'bVfn2l': 'Please select an account to log in',
  'dbmZAL': 'The mobile account does not exist or is not bound. Please register or bind before logging in.',
  'h2IpXC': 'If you need to continue modifying your phone number, please click the OK button',
  'hGVOxM': 'Email Password',
  'i/PpUw': 'Sorry, this WeChat account is already bound to an existing account and cannot register again.',
  'oacN/h': 'The current WeChat account ({nickname}) is bound to the following accounts ({bindTotal} in total):',
  'wHkfnl': 'The current phone number ({phone}) is bound to the following accounts:',
  'GtIdEi': 'Default inspection warehouse',
  '7mwRSS': 'The maximum number of accounts bound to this phone number has been reached (maximum {bindUserNumLimit} accounts)',
  'LtYRX8': 'Sorry, the modification failed~',

  '2r3IJC': 'Please enter a numerical value',
  '58WavZ': 'Custom Field Chinese Name',
  'HowtAS': 'Text',
  'Jueghe': 'Customer Custom Field Information',
  'ONR67m': 'Enable Custom Field',
  'ORgO0e': 'Maximum 24 characters',
  'P8Gwzr': 'Confirm to enable this custom field? After activation, API registration, page registration, and template registration will require corresponding custom field information according to the configuration. Failure to provide may affect product registration.',
  'RptCJU': 'Have you understood the usage scenarios of custom fields and confirmed the need to use them?',
  'XlfUm/': 'Supports creating up to 3 custom fields',
  'YtPtMs': 'Confirm to disable this field information?',
  'aZDBrY': 'Add Field',
  'bKnbER': 'Field Type',
  'dPCJQ/': 'Open API integration field (can be ignored if no API integration needed)',
  'dvrx23': 'Custom Fields',
  'eLT98I': 'Product longest side < {limitSize1}{unit} or second longest side < {limitSize2}{unit}. If subsequent outbound belongs to a single order, WINIT will add courier bags and generate corresponding fees to meet minimum delivery size requirements, ensuring successful final-mile delivery.',
  'hMZnus': 'API Field Name',
  'ksJ/3u': 'Extended Configuration',
  'pkMcXZ': 'This function allows users to provide additional information during product registration for better management. Enable selectively based on actual needs.',
  'pu4ANt': 'Maximum 48 characters',
  'qCk2e7': 'Custom Field English Name',
  'rRBPTT': 'Numerical Value',
  'x4370M': 'Please enter Chinese/English characters or numbers',
  'xOBjyi': 'Confirm to close?',
  'yYoxkN': 'Is Required',
  '5dS8AK': 'Upload third-party product barcode label file',
  'bs3A4X': 'Third-party product barcode label file',
  'iuaNK+': 'Label mapping',
  'C1L/tA': 'Currently only supports eBay, Temu, AliExpress, Shopify platform configuration rules. Other platforms will be opened one after another, so stay tuned!',
  'Nsa7YE': 'Select',
  'SFe2Aw': 'shopify platform synchronizes every 30 minutes',
  'f9xwVI': 'Store {account} authorization No inventory permissions: read_inventory, write_inventory, read_locations. Please check whether the corresponding permissions are selected in the store authorization token link.',
  'TB3rBj': 'Please use the "Self-Pickup Outbound - General Template" for import.',
  'gYXO5b': 'Please use the "General Template for Destruction Order" for import.',
  'lD87Nv': 'Please use the "Standard Outbound - Platform-Specific/General Template" for import.',
  'UDlvOw': 'Please enter letters, numbers, underscores (_), or horizontal bars (-).',
  'eGdiPg': 'The address code is used to create order by API or batch import way, you can defined the code in your style (letters, numbers, underscores (_), or horizontal bars (-) are allowed), but it can not be modified after the submission.',
  '+uX6k3': 'Shipping method selection preference',
  'EsdtJQ': 'Basic information selection preference',
  'KxdV6o': 'Whether to select the earliest pickup time by default',
  'LwZj/E': 'Whether to select the logistics plan with the earliest shipping time by default',
  'ReCcIp': 'Beijing time',
  'SQfknD': 'Customs declaration method selection preference',
  'sm0/fH': 'Local time',
  'JkvJX/': 'Logistics plan preference settings',
  'NZ5Lvz': 'Customs declaration method preference settings',
  'P2tp7i': 'For domestic warehouse inspection and the pickup type is Winit door-to-door pickup, Wanyilian Order/API Order will select the earliest pickup time to place the order based on the preference;',
  'PXtCFW': 'Pickup time preference settings',
  'yoFShO': 'For Winit carriers and customers have not selected a logistics plan, Wanyilian Order/API Order will select the logistics plan with the earliest delivery time to place the order based on the preference;',
  'Y4m/OW': 'Only supports destination country + first leg type + inspection type, and only one customs declaration method preference can be maintained. If the corresponding preference is matched, Wanyi Lian Order/API Order will place the order according to the preference content!',
  '5HNHGL': 'Does the product contain blades?',
  'NyXwQq': '#With blades',
  'duQQ3H': 'With blades',
  'six1wi': 'Products containing blade items that can harm humans by cutting skin (e.g., saw blades, kitchen knives, utility knives, razor blades) must check this option.',
  '7bdh+E': 'According to the requirements of local laws and regulations in the UK, the age must be verified when signing for parcels containing goods in the form of knives. The system will automatically add the value-added service of "Inspection/Subsidy Age Limit Label" for you. However, there is a configuration error in the application of this value-added service. Please contact our customer service for handling.',
  'TBpJ9a': 'According to the requirements of local laws and regulations in the UK, the age must be verified upon the receipt of all packages of goods containing knives. The system has automatically added the value-added service of "Last Mile VCA" for you, and the corresponding fee will be charged in the order. ',
  '6KfC40': 'Signing Completed',
  '8FOzIZ': 'Overseas Warehouse "Supply Chain Management Service Agreement" and "Supplementary Agreement on Overseas Warehouse Commercial Terms" {break} Due to the interrelated content of {a1} and {a2}, both agreements need to be signed simultaneously. You can click on the agreement name to view the specific content.',
  'R+sv2r': 'Supply Chain Management Service Agreement',
  'akmnDR': 'Unable to find the agreement or the agreement does not exist',
  'qSrqiP': 'Overseas Warehouse "Supply Chain Management Service Agreement" and "Supplementary Agreement on Overseas Warehouse Commercial Terms" {break} Due to the interrelated content of {a1} and {a2}, both agreements need to be signed simultaneously. You have signed the latest version, and you can click on the agreement name to view the specific content.',
  'zESJVr': 'Supplementary Agreement on Overseas Warehouse Commercial Terms',
  'zWDZbi': 'Don\'t upload WINIT tracking number to EBAY (Only for Belgium supplier B2C Europe service )',
  '8vrQgq': 'Self-pickup outbound (import draft order number).',
  'itoONc': 'Self-pickup service',
  'lRBa4q': 'If it is a self-pickup service {a}.',
  'p4H1SB': 'Self-pickup outbound (supports multiple value-added services).',
  'tpI9jm': 'Pick-up delivery - Self-pick-up service',
  'g6wYzy': 'It supports pasting the platform shipping label provided by the seller onto the package, and the package will be delivered to the buyer through the cooperative carrier.',
  'nZMq9z': 'single product volume accumulation (CBM)',
  'rwNEpG': 'Package size(cm)',
  'qhKv6X': 'The platform currently only supports {platform}，please bind the platform account first',
  'rlIAep': 'OTTO,PLentyMarket',
  '1L4o+6': 'Last login time',
  'NQMeVr': 'The maximum number of bindings for each phone number is 5, and the number of bindings for this phone number has reached the limit',
  'e4DUUm': 'Sub-account name',
  'gT/sAQ': 'Developer permissions',
  'zlZigq': 'Nickname',
  'TTS8yp': 'Developer permissions and authorized ERP permissions should be disabled if the current account has no requirement for developer privileges.',
  '0xa2hp': 'Enabling this permission will grant third-party access to the account. Please exercise caution when activating it.',

  '7FR7jP': 'If the express number is not linked in time, it may be treated as a return or unclaimed goods. The customer shall bear the abnormal expenses incurred, and the final receipt shall be subject to the actual receipt of WINIT;',
  'VVc+P7': 'Whether to Amazon removal orders',
  'C6x6Tv': 'Order fee estimate preference',
  '3ma4nl': 'The current product is not available due to "{error}" reasons. You can choose to change to other packaging types or other delivery methods; If it is a composite order, you can also split the order and place it separately.',
  '5ypbAw': 'Add {i} layer of packaging',
  '8q9EMC': 'Layer {i}',
  'Atjd5O': 'Enable double-layer packaging service',
  'BwGeIF': 'After completing the overall packaging of customer orders, an additional layer or two layers of packaging will be added to the original package according to brand promotion or protection needs. It should be noted that when a single layer of packaging cannot meet the packaging requirements of the order, it is not allowed to pack some items separately and then combine them with other items that have not been fully packaged for additional packaging.',
  'G37PK3': 'Third layer',
  'GtNbsM': '<strong>Illustration</strong>{img}',
  'IELDaK': 'Have you understood the applicable scenarios of this service and confirmed the need to use the double-layer packaging service?',
  'IUEZRN': 'Copy product code',
  'OHQMeB': 'Second layer',
  'TdjNLW': 'By default, it is an additional single-layer packaging service. If you need to use multi-layer packaging services, please go to Preferences>SKU Settings>{a}',
  'V4pQH6': 'Click to view illustration',
  'ZiSqLR': 'First layer',
  'efGs6k': 'Purpose of packaging materials',
  'qke9N+': 'SKU packaging layers',
  'xmBGan': 'Due to the inclusion of gift box packaging materials in the SKUs in the order, the information on added packaging value during outbound will be cleared. Please select the outbound packaging value-added service again.',
  'hZJNn1': 'Due to the not included of gift box packaging materials in the SKUs in the order, the information on added packaging value during outbound will be cleared. Please select the outbound packaging value-added service again.',
  '/k5tdz': '1. Gift Box Packaging Materials: Used for inner layers in multi-layer packaging. Customers must separately select outer packaging. During warehouse packing, first use gift box packaging materials to wrap the product, then add an outer layer of packaging. (This material usage is not supported if multi-layer packaging service is not activated.){ break}2. Logistics Packaging Materials: Can be used as single-layer packaging or the outer layer in multi-layer packaging.',
  'hhIIwx': 'The Multi-Layer Packaging Service adds an extra layer of packaging materials to the existing outbound packaging service, significantly enhancing the aesthetics, protective performance, and transportation safety of the packaging.',
  'PAwxvf': 'Please be sure to link all relevant express numbers to identification codes in time before the goods arrive at the warehouse. If the link is not made in time, the goods may be mistakenly processed as returns or destroyed due to the inability to identify the owner. The relevant risks and costs shall be borne by the seller.{break}The final receipt status will be based on the actual warehousing records of WINIT.',
  'WWz7Q4': 'Unable to provide/Cancel request',
  '+AVH+W': 'Business address',
  '+MPom9': 'Lift-gate\' refers to a lifting platform installed at the rear of a truck, used to lift goods from the ground to the truck\'s cargo box, or to lower goods from the truck\'s cargo box to the ground. This equipment is particularly useful for handling heavy or large goods, especially in places without loading and unloading facilities. Additional fees may be required when providing lifting platform services. ',
  '+big95': 'After WINIT completes the packing, palletizing, and temporary storage, add value-added documents such as pallet labels.',
  '/dySAg': 'For the same repository, if there is an updated WINIT version, you can click Refresh to switch to the WINIT version.',
  '0Y5hzY': 'Switch to WINIT version ',
  '0zyVbu': 'Supplier name ',
  '2BqPCg': 'FBA Warehouse Address Maintenance Operation Guide ',
  '5wy87y': 'This address has an updated version of WINIT, you are currently using a custom version',
  '6qy1xl': 'Value-added options',
  '7SZjFs': 'Fill in the shipping address and outbound SKU information, select the final product of [Global Quote Shipping], and submit the outbound form.',
  '7YtkDc': 'Based on the outbound order information, create an inquiry value-added order to supplement the information required for the final inquiry.',
  '7l3fV0': 'Detailed operating instructions',
  '8JScbo': 'Estimated pallet quantity is greater than 22 pallets, online quotation does not support FBA delivery, please choose manual quotation. ',
  '8RfQE7': 'Guide to the operation of the tail process inquiry and delivery order ',
  '8RlcuN': 'Residential addresses do not support castles for unloading by default. Lift-Gate and APPT must be selected for LTL delivery. FBA transfer defaults to commercial addresses.',
  '8U/rTl': 'Currently, only US supports online inquiry. After submitting the inquiry value-added order, the system will complete the online quotation in about 5 minutes. Please patiently wait for the result and confirm the quotation on the value-added order query page in a timely manner. ',
  '9Cez6q': 'The first step has been completed, please continue to create an inquiry value-added order',
  'AD5sEw': 'Quote mode ',
  'AXrI4w': 'Insured ',
  'EAOyFB': 'Step 1: Submit an export order ',
  'ELWNit': 'FBA address',
  'ExQ/dx': 'FBA warehouse address library collected by WINIT ',
  'HG2EsH': 'Model name ',
  'HvLzJn': 'The system estimates the number of pallets based on the order volume, which is for reference only. The final billing is based on the actual number of pallets placed in the warehouse. ',
  'JiRAVh': 'After receiving feedback from WINIT (informed through homepage to-do list or email notification), confirm the quote on the value-added order inquiry page. ',
  'JsLztN': 'WINIT warehouse appointment supplier pick-up, complete outbound shipment. ',
  'K78O7t': 'WINIT version ',
  'KPTVBp': 'View FBA warehouse address',
  'LRNoCX': 'Step 5: Warehouse appointment with supplier for pickup ',
  'MAz12w': 'Version type ',
  'MG/bFQ': 'Order consignee type ',
  'Mbi+c9': 'Create Inquiry Value Order ',
  'Nkqbad': 'Inquiry request ',
  'NxHqKo': 'After submitting the inquiry value-added order, WINIT will manually inquire with the offline supplier for you and notify you by email after the inquiry is completed. ',
  'OQ0psa': 'The system is obtaining a quote, please check it in 5 minutes',
  'Ope61w': 'Estimated pallet quantity is greater than 6 pallets, online quotation does not support non-residential addresses, please select manual quotation. ',
  'OsuCLL': 'FBA warehouse number ',
  'PaHEXB': 'LTL (less than truckload transport), FTL (truckload transport) {break} 1. FBA only supports LTL. {break} 2. Residential address only supports LTL and must be less than 6 torr. {break} 3. Commercial address and greater than 22 torr, only supports FTL. {break} ',
  'PihFBF': 'Lift-Gate',
  'Pp1TTV': 'Step 3: Operation Confirm Quote ',
  'QGuvON': 'If it is found that the WINIT address library is insufficient or incorrect, the customer can add or modify it to a custom version. After verification by WINIT, it can be changed to the WINIT version. ',
  'QVA75B': 'Contact information ',
  'RUSzK5': 'Switched to WINIT version successfully ',
  'Swiv0A': 'FBA warehouse contact information ',
  'U0U2in': 'consignee address type ',
  'YcT8hM': 'FBA warehouse code ',
  'ard8gk': 'APPT',
  'bhbSjx': 'Expected arrival time ',
  'cbqjLX': 'FBA warehouse address information ',
  'dRWDB0': 'Add FBA address',
  'dY7J2f': 'To be quoted, please place an order based on<a>Operating guidelines</a>Submit an additional inquiry value-added order &#39;',
  'enEHaF': 'Step 4: Add value to pallet labels, etc. ',
  'f0EiQE': 'Customer custom version ',
  'fMDeau': 'The FBA warehouse address information currently collected by WINIT will be saved as a customer-defined version after modification. You will use the custom version later, and WINIT will verify the content you modified. If the verification is correct, the modified content will be included in the WINIT address library. ',
  'fXO+U6': 'Please enter a number in English or a horizontal line ',
  'fmmUkd': 'Switch to new version ',
  'hY4Lvl': 'Keep my version ',
  'iIP2Yn': 'FBA warehouse information, will switch to WINIT version, do you want to continue? ',
  'iJ+RdK': 'Only supports numbers, English, and horizontal lines',
  'j4y83C': 'Residential address',
  'kfR22B': 'Manual quotation ',
  'l3JdZG': 'Custom version ',
  'lEIbzS': 'Please enter the FBA warehouse code ',
  'lsd6bP': 'Order basic information ',
  'lyk5VK': 'FBA repository information ',
  'oDhajK': 'Online quote ',
  'seveoq': 'Does it support unloading at the crate ',
  'tNh07V': 'APPT refers to the need for assistance in scheduling delivery. This ensures that the goods are ready when they arrive, and also helps transportation companies arrange their transportation plans more effectively.',
  'tXv5//': 'Residential address does not support unloading by default ',
  'uWDzGt': 'Step 2: Create Inquiry Value Order ',
  'uktYmS': '1. WINIT version: FBA warehouse address library collected by WINIT. {break} 2. Customer-defined version: If it is found that the WINIT address library is insufficient or incorrect, the customer can add or modify it to a custom version, which can be changed to the WINIT version after verification by WINIT ',
  'vCy5Po': 'Failed to verify country, state/city, zip code, you can<url>Click here</url>Perform a query. &#39;',
  'vGdZ04': 'Only supports numbers, plus signs, dashes, spaces, parentheses',
  'wq9xDI': 'Version number ',
  '35Hi9P': 'Dependency cost',
  '1OlJRk': 'Last mile inquiry quotation <span>(The actual number of pallets will affect the final last mile cost, please confirm the unit price on the quotation, and the actual deduction amount shall prevail)</span>',
  'b+NmJQ': 'LTL (Less than Truckload), FTL (Full Truckload) {break} 1. FBA only supports LTL. {break} 2. Residential addresses do not support more than 6 pallets, only support LTL. {break} 3. Commercial addresses and more than 22 pallets, only support FTL. {break}',
  'dTGv8M': 'Must be greater than today',
  'uNwwIP': 'Local',
  '0H7ext': 'Abnormal closure time',
  '1kGGA/': 'Closed',
  'g49BG6': 'Outbound date (local)',
  'oDyZLy': 'Not closed',
  '6JWI9W': 'Exception Creation Time (local)',
  '8d7pkA': 'Abnormal Closure Time (local)',
  'WyERxh': 'Stamped bill — first page',
  '+X8eaX': 'View exception',
  'BsmZGD': 'Please enter digit, letter, minus , underline or spaces,and a box number less than 50 characters in length',
  'vlsmJo': 'This expense item has a minimum charge threshold, with the amount being{currency}{amount}。According to the minimum charge standard, the current calculation result has been adjusted to this minimum charge amount. If you want to know the detailed charging rules and any changes in the standards, please refer to the content of the newly released price list.',
  'Jf5+Im': 'Unconfirmed shortage orders',
  '6bE8su': 'If the default packing strategy cannot meet your business requirements:{break}Please click here <a>to customize your packing rule preferences.</a>',
  'ARuxev': 'Limited 2*length  +2* width +2*height',
  'CZLnVK': 'Limited length  * width *height',
  'OTiLOA': 'Limit the volume',
  'PQyi+9': 'You have not configured the preference for the packing strategy. Therefore, WINIT will adopt the standardized outbound packing strategy to carry out the packing operation. The default strategy is as follows: ',
  'RjFpnF': 'When multiple types of packages are supported in the strategy, the warehouse will comprehensively consider practical factors such as the characteristics of the goods, volumetric weight, and transportation requirements, and select the appropriate package type for packaging. ',
  'jeqrK/': 'This strategy will limit the packaging into {miss} type of packages.',
  'pidHAI': 'View all WINIT default packing rules.',
  'yQjltk': 'Supported parcel types for packing.',
  'M8w2+G': 'Step 4: Add pallet labels and other value-added (optional)',
  'ZoVbvy': 'If you need to add value-added, please select the corresponding value-added in advance when submitting the order. {break} After WINIT completes the packing, palletizing and temporary storage, add pallet labels and other value-added documents. {break} If you do not select the corresponding value-added in advance when submitting the order, the warehouse will not temporarily store it after confirming the quotation and will directly ship out. ',
  'e3qaPy': 'When the consignee address type is a commercial address, the company name must be provided. ',
  'xHcWNS': '{break}When requesting a online quote , the estimated number of pallets should be based on the system\'s estimate.',
  'CDAxI1': 'Due to label size constraints, if the SKU code exceeds 40 characters, the excess part will not be printed. This does not affect barcode recognition.',
  'WDxSgQ': '#Gift',
  'h2khcY': 'If you choose to add GPSR information, the label will include the associated GPSR data. Products without linked GPSR information cannot be printed.',
  'ihOQRf': 'When selecting "Generate separate files for different SKUs" in the print settings, files will be named using the [SKU code]. Since filenames cannot contain characters [ / : * ? " < > | ], these will be automatically omitted. Please verify barcode information to prevent mislabeling.',
  'jMNHyP': 'Inner diameter size of packaging material (cm)',
  'pkctCa': 'Print product model/type information',
  'vYqf9H': 'This product is prohibited from storage and label printing is not supported!',
  'wNcK1v': 'The following products are prohibited from storage in {country}. Even with printed barcode labels, inbound orders cannot be created. Confirm to proceed with printing?{break}{skus}',
  '2L50ht': 'The following products are prohibited from storage in {country}. Even with printed barcode labels, inbound orders cannot be created. Confirm to proceed with printing?',
  'eB8frW': 'Self-pickup default uses {break}WINIT outbound number for pickup',
  'hVMnqa': 'You can choose to configure pickup using WINIT outbound number. When you check this option, it means you have confirmed and authorized the supplier to use the WINIT outbound number for pickup, and you will bear the related risks. Please make sure you manage the WINIT outbound number properly. This configuration is only valid for non-FBA transfer orders.',
  'wTt7mK': 'I have known',
  '+rb3z9': 'Please select the abnormal order under the same warehouse',
  '//qX98': 'Remove the order source',
  '/TyAL3': 'After the destruction, the order (order number: {totalNum}) cannot be restored. Please confirm again whether to destroy it with one click! ',
  '/bEUPt': 'A total of {orderNum} abnormal orders have been destroyed. Please confirm again whether to destroy them!',
  '/suo4m': 'Abnormal number',
  '035Ocl': '*Please fill in the serial number of the value-added service order submitted for this abnormality. If you have not submitted the value-added service, please <a>click here</a> to jump to the value-added service page to submit the value-added service and fill in the value-added service order number. ',
  '0O5T7r': '{successCount} removal orders successfully created inbound orders: {inboundOrderNoList}',
  '1Iy4LH': 'Expected destruction date',
  '1NYW+/': 'Exception category',
  '1WB+di': 'Handle exception',
  '3JRmkd': 'View exception orders immediately',
  '3jtEoL': 'Emergency notice <tag>about to be destroyed</tag>',
  '4ZtU8H': 'Number in disposal',
  '53J/Nd': 'Task execution status',
  '5gRDaT': 'Latest synchronization time',
  '6/g2Xy': 'Removal order type',
  '9ZVJ3+': 'Register warehouse',
  'AvkS7o': 'Removal order conditions',
  'B4z3E3': 'I understand',
  'BFxcTt': 'Abnormal orders to be destroyed',
  'BWTsPT': 'Place of abnormality',
  'ByZHeO': '1. The system will build a value-added destruction order according to an abnormal order and send it to the cloud warehouse;',
  'C/fSWX': 'Removal order update time',
  'CSNtjK': 'Reason for submission failure',
  'CfPc0f': '{failedCount} removal orders failed to be created. The reasons for failure are as follows:',
  'D2X2wB': 'Removal order submission time',
  'DlDTj8': 'Please select the abnormal order for which a value-added service order needs to be created',
  'E4dkSU': 'Modify the value-added order number',
  'F+eZ2H': 'shipped-quantiy',
  'FsSkcq': 'Batch processing exception',
  'GLBv34': 'Automatic warehousing rule configuration',
  'GlMRI+': 'tracking-number',
  'H7s5l3': 'No restrictions on package type',
  'KjADFd': 'Execution result',
  'LGMqRm': 'Removal order product attributes',
  'LgyOft': 'Disposed quantity',
  'M/DPSo': 'Removal order status',
  'N3qOVE': 'Destruction execution data is only retained for 30 days',
  'NBabp4': 'Removal order',
  'OXdYxg': 'All removal orders were submitted successfully, and the warehousing order was successfully created: {inboundOrderNoList}',
  'P6DzWR': 'The currently selected abnormal order already has a saved value-added order [<a>{orderNo}</a>]. Please cancel the draft order first and then initiate the value-added order!',
  'PbNM0f': 'carrter',
  'PcKqH0': 'Physical third-party package code',
  'QnDR2H': 'The FBA removal order logistics information report is updated once a day, the latest update time is 2024-01-01 12:34',
  'Rcgps+': '{idListLength} orders have been selected. Do you want to re-execute the automatic warehousing rules for the selected removal orders? ',
  'RdBKhC': 'Please select the abnormal order to be reported',
  'SDLjvC': 'Automatic destruction date: {expectedDestroyDate} (remaining processing time: {remainHandlingDays} days)',
  'T10lmn': 'The currently selected abnormal order already has a saved order in the warehouse [<a>{houseNo}</a>]. Please cancel the draft order first and then initiate the value-added!',
  'Vwp5Qh': 'Selected removal order',
  'X6oAf8': 'Batch submit incoming orders',
  'YDnB35': 'Please check the data first',
  'ZN9vv0': 'Only unsubmitted status operations',
  'ZTHPCS': 'The following removal orders have been associated with incoming orders or the type is return. Submitting incoming orders is not supported. Please reselect: {break}{removeOrderNos}',
  'ZsgS/g': 'If you only want to perform value-added processing on some items in temporary storage, please distinguish them according to the unique identification code in the temporary storage, delete the items that do not need to be value-added in the product list, and then click [Next] to continue to select the value-added service you need to operate',
  'cCPVaz': 'The following removal orders have been associated with the warehouse order or the type is return. It does not support submitting the warehouse order, please reselect:{break}{removeOrderNos}The removal order is incorrect, please reselect',
  'cg9FE4': 'Process immediately',
  'ciIGU9': 'Specified package type for warehouse entry',
  'dT/edB': 'FNSKU',
  'dkSzVa': 'Rule of warehouse order',
  'eX5wuL': 'The FBA removal order report is updated once a day, and only the report within 180 days is updated. Latest update time 2024-01-01 12:34 <a1>View detailed introduction</a1>',
  'epqxJG': 'Second confirmation',
  'g1I4y4': 'One-click destruction of abnormal orders',
  'hCtT4f': 'Attributes',
  'hX26oC': 'Batch feedback',
  'iFtdRX': 'First synchronization time',
  'imSP3c': 'Number of pending orders:',
  'j6L4GB': 'Cancelled quantity',
  'k+gK7m': 'Unsubmitted',
  'k4brJy': 'SKU',
  'mZJznr': 'Batch creation and destruction of value-added orders is in progress, please go to <a>Query execution results</a> to view',
  'mgv9pg': 'Number shipped',
  'n6WAyp': 'Abnormal link',
  'nE3EBp': 'Abnormal batch feedback',
  'o/9IfL': 'Submit the warehouse order',
  'p6VkG4': 'Remove fees',
  'qf+53n': 'One-click immediate destruction',
  'r6tjAG': 'Re-execute the rules',
  's6MvYD': '2. Before the warehouse is officially destroyed, if you want to cancel the destruction, you can go to the <a>Wanyi Lian Overseas Warehouse-All Value-added Orders</a> page to cancel the destruction of the value-added order!',
  'tDxB5+': 'Physical WINIT package code',
  'uqTux2': '{orderNum} order (detained for {stayDays} days)',
  'w7Tfhn': 'Whether the review is passed',
  'wuoIy0': 'Currently, only Amazon platform configuration removal order entry rules are supported. ',
  'xfLWzZ': 'Whether to collect A+ package code',
  'yOZtjM': 'Please select at least one exception order! ',
  'ycib7Y': 'If you have not handled the exception before the expected destruction date, the system will automatically generate a destruction value-added order based on the goods involved in the exception order. If your abnormal goods do not need to be destroyed, please handle the exception before this date! ',
  'ymrffm': 'Check the tracking number',
  'zEhHZc': 'Query the execution result of the destruction task',
  'lYT4QZ': '<bold>abnormal orders are about to be destroyed, please handle them immediately</bold>{break} <span>Dear customers:</span>{break} <ul> <li>The following orders have been marked as "to be destroyed" due to abnormalities, and the system has entered the countdown for mandatory processing:{break} <liText></liText> </li> <li>Please submit the value-added service for processing immediately. If the deadline is exceeded, the system will automatically perform the destruction operation and charge the destruction fee.</li> <li>If you have any questions, you can contact the online customer service for assistance, or refer to the <a>"WINIT Value-added and Abnormal Service Price List - Overseas Warehouse Abnormal Processing"</a> to understand the fee standards and process instructions.</li> </ul> <line></line> <space><icon></icon><text>Important statement: If the goods are destroyed because you fail to handle the abnormal order in time, the risk of damage, loss and destruction of the relevant goods and the cost of destruction will be borne by you, and our company will not bear any responsibility for this. Please pay attention to this notice!</text></space>',
  'x5AWo7': '<bold>Please handle abnormal orders in time to avoid goods being destroyed</bold>{break} <span>Dear customers:</span>{break} <ul> <li>According to the Winit warehouse management regulations, if your abnormal order is in the "new submission" or "temporarily stored for customer feedback" status, and you have not actively submitted a value-added service application for processing for more than 30 days, the system will automatically perform the destruction operation and charge the corresponding destruction fee to ensure warehouse operation efficiency.</li> <li>To avoid loss of goods and additional costs, please confirm and handle abnormal orders as soon as possible. If you have any questions, you can contact the online customer service for assistance, or refer to the <a>"WINIT Value-added and Abnormal Service Price List - Overseas Warehouse Abnormal Handling" </a>to understand the fee standards and process instructions.</li> </ul> <line></line> <space><icon></icon><text>Risk warning: If the goods are destroyed because you fail to handle abnormal orders in time, the risk of damage, loss and destruction of the relevant goods and the cost of destruction shall be borne by you, and our company does not bear any responsibility for this. Please pay attention!</text></space>',
  '0nMsYn': 'About to be destroyed',
  '3+yUFF': 'Priority length cannot exceed {max} bits',
  '6Qi/57': 'The following removal orders have been associated with a stock-in order or the type is not Return. Please reselect if the stock-in order is not supported: {break}{onReturnOrderNos}{ononWFRs}',
  'AXV/j/': 'FBA removal order reports are updated {pullCount} times a day, and only reports within {pullFrequency} days are updated. Latest update time {pullDate} <a1>View detailed introduction</a1>',
  'GXPjP8': 'The following removal orders have been associated with inbound orders or the type is not Return. Please reselect if you do not support submitting inbound orders: {break}{onReturnOrderNos}{ononWFRs} The removal order is incorrect. Please reselect',
  'J1iEpx': 'Reason for automatic inbound failure/failure to submit inbound orders',
  'R98SA0': 'Operation of unsubmitted/failed submission status only',
  'WkbNTV': 'Submission successful, successful creation of inbound order: {inboundOrderNoList}',
  'dsinlh': '{successCount} removal orders successfully created inbound orders: {inboundOrderNoList}{break}',
  'hP8D5r': 'The system prioritizes matching inbound rules with larger numbers. ',
  'k9JHsi': '{failedCount} removal orders failed to create warehousing orders. The reasons for failure are as follows:',
  'nRzQb9': 'The match will be successful only when all products in the removal order have the same attributes. {break}Note: If this condition is configured, please place removal orders separately for saleable and non-saleable goods',
  'qFm139': '{noMatchRuleCount} removal orders failed to match the automatic warehousing rules{break}',
  'rkxcrn': 'carrier',
  'sbvVn+': 'Execution successful',
  'tTPoBP': 'Removal order number failed to copy',
  'u8ASMN': 'shipped-quantity',
  'uj13LR': 'FBA removal order logistics information report is updated {rderPullCount} times a day, and only reports are updated within {rderPullFrequency} days. The latest update time is {rderPullDate}',
  '/N9qIp': 'Outer diameter',
  '/P3Q7V': 'Close window',
  '/W9M3v': 'After selecting the {serviceName} value-added service, all WINIT products will become unavailable. You can close the window and check the detailed reasons in the product list.',
  '3vwUoT': 'Determine whether defective products require photography',
  '4od2yG': 'WINIT photo template type for failed deliveries',
  'Du8ONy': 'Custom photo templates take precedence over WINIT standard templates. If a product has a custom product-level or customer-level photo template configured, this setting does not apply, and the warehouse will follow the custom template for photography. Otherwise, the WINIT template type specified in this configuration will be used.',
  'QdKb8u': 'WINIT photo template type for RMA-free returns',
  'Ugy0ia': 'WINIT photo template type',
  'WNgpY5': 'Determine whether non-defective products require photography',
  'XSlHT6': 'Determine whether non-defective products require photography. <a>Click here to jump</a>',
  'hpp6a7': 'If "No photo required" is selected, it indicates acceptance of WINIT\'s inspection results. Subsequent exceptions may not have supporting photo documentation available.',
  'rpHIiV': 'A product-level custom photo template is already configured, so this setting is currently not effective. If the WINIT standard template needs to be used, you can proceed to cancel the custom template. <a>Click here to jump</a>',
  '1XWEMv': 'Reason for platform return',
  '42qy1H': 'The corresponding outbound order number is not matched through the platform order ID. Please check/confirm whether the seller order number/e-commerce platform order number of the outbound order is correct',
  '44+kGE': 'View failed orders',
  '7Uao9y': 'Platform return ID',
  'AsSGAy': 'Auto sync return orders',
  'BZAEo6': 'Add a new return reason',
  'KMIhD4': 'Platform return status',
  'L2LYhY': 'No matching outbound order found',
  'TX5626': 'Request time',
  'VnaZN/': 'Return status',
  'XpmFr3': 'Return amount',
  'Xwktyf': 'Currently only supports {platform} platform. Other platforms will be opened one after another, so stay tuned!',
  'ZUVA4E': 'Order failed {count} orders',
  'cvZE/f': 'Return order synchronization rules description',
  'fpFH8o': 'The platform return order is not matched with the delivery order, and the order is not supported at the moment. {break}{break} The platform order ID is not matched with the corresponding delivery order number. Please check/confirm whether the delivery order seller order number/e-commerce platform order number is correctly transmitted. If you can accurately locate the delivery order, you can manually match the delivery order. Please note that once confirmed, it cannot be modified, so please operate with caution. ',
  'jgVhXT': 'Platform return type',
  'kG7ECj': 'Return warehouse address',
  'kv0q/g': 'Enter up to {max} characters',
  'nOsaxu': 'Manual matching',
  'nkIyWE': 'The reason for return already exists, please do not add it again',
  'npWR53': 'Only orders with the status of canceled orders are allowed to be withdrawn, please reselect! ',
  'pRhMg1': 'Platform Provider',
  'piC/s7': 'Order successfully placed {count} orders',
  'q4hPiU': 'Matching method',
  'qpub+R': 'Whether the system needs to auto synchronize return orders to the return order list',
  'rHLNSh': 'View orders placed',
  'rtEeyT': 'Orders that do not meet the automatic return rules will remain in the unordered list.',
  'scMay5': 'Manually match the outbound order',
  'sqvgrn': 'Automatic matching',
  'vRc+X0': 'Return shipment type',
  'y0M/fZ': 'Currently, only {platform} platform needs to configure return rules, and other platform configurations are invalid',
  'zlJeYF': 'Reason/abnormal information for failure to place an automatic order',
  'zreIM8': 'Return ID',
  '/UjyGI': 'Platform {platform} and TikTok cannot be selected at the same time',
  'M0h2VP': 'Edit return reason',
  'RsmTDW': 'There are multiple outbound order numbers',
  'r6NAzV': 'Only order operations with status <strong>{status}</strong> are supported',
  '9lEixA': 'More Billing Information Customization',
  'h/GSwA': 'Output file mode',
  'xtelGq': 'Overseas warehouse billing factor details download project configuration',
  '5xobfv': '<strong>Configuration instructions:</strong>{break} 1. Check the billing details and expense items you need and click Save;{break} 2. After saving, return to the original bill billing details download page, refresh the page and pull down again to select the billing details you need for export and download;{break} 3. Do not select too many unnecessary billing items. Too many expense items will cause the download of billing details to fail or the system to use slowly;{break} 4. The configuration of the master and sub-accounts is subject to the master account, and the sub-accounts do not have configuration permissions;{break} 5. If you have any wallet reconciliation issues, you can contact us directly: <a>https://support.qq.com/products/306264</a>',
  'TJX5Wu': 'Deleting will automatically unbind the third-party product barcode associated with the product. If needed, remember to rebind the product!',
  'hgWy9L': 'Confirm deletion? Deleting will automatically unbind the third-party product barcode associated with this product. If needed, remember to rebind the product!',
  'LdRw+j': '1. SDS + transport identification report issued by the factory; or SDS issued by the testing company, product images',
  'NZioeb': '1. SDS + transport identification report issued by the factory; or SDS issued by the testing company; 2. CPNP registration + product images',
  'Sb09Tb': '1. SDS + transport identification report issued by the factory; or SDS issued by the testing company; 2. SCPN registration + product images',
  'exIT3S': 'SDS, UN38.3 test report, product images',
  'l1yTJd': 'MSDS and product images issued by the testing company',
  'I2TiMV': 'LTL (Less than Truckload), FTL (Full Truckload) {break} 1. FBA only supports LTL and must be less than or equal to 14 pallets. {break} 2. Residential addresses do not support more than 6 pallets, only support LTL. {break} 3. Commercial addresses and more than 22 pallets, only support FTL. {break}',
  'cSQL5W': 'The estimated number of pallets is greater than 14, FBA warehouse only supports up to 14 pallets for online quoting, please choose manual quoting.',
  'KF+p1c': 'Last leg fee to be quoted, please refer to <a>Operation Guide</a>',
  'xMhgUa': 'View package track',
  'Y6U20U': 'Track name',
  '+DyXxN': 'Result Feedback',
  '/RHREI': 'Total Price of Goods for Claim Application',
  '/eSpXG': 'Damage Details of Packaging and Damage Type',
  '0Crtv6': 'Number greater than 0, with two decimal places',
  '0KX1jR': 'No Order Splitting',
  '0QE4q1': 'Order Splitting Type',
  '0oSDZg': 'System Prompt',
  '16pzIO': 'Actual Compensation Amount',
  '1HMYGa': 'Submitter',
  '2V7sQs': 'Document Information',
  '4KPJBi': 'File size should not exceed {attachmentSizeMax}M, please compress before uploading',
  '4jD36a': 'Delivery Method',
  '4vcHWR': 'Attachment Format/Quantity: Supports formats {attachmentFileFormat}, up to {attachmentNumMax} attachments can be uploaded, each attachment should not exceed {attachmentSizeMax}M. (Preview function is not supported temporarily after the picture is uploaded successfully)',
  '5LSBrI': 'Including detailed information such as goods name, material, quantity, etc.',
  '5T21V/': 'Non - compliant Packaging',
  '5vXAK1': 'Within the Warehouse Group',
  '5xr61k': 'Insufficient Description of Commodity Information',
  '6UYLU2': 'Claim Remarks',
  '6Ydk+8': 'Confirm the Supplier\'s Account Arrival Time',
  '71P5RG': 'LMA Warehouse',
  '7IWrtA': 'I have read and agreed to the agreement',
  '7xGGCf': 'Please check!',
  '9k/Y15': 'Please enter the outbound order number or package number',
  '9pKQNp': 'Surepost transferred to the post office without claim',
  '9vmp+C': 'Hello, your order has the situation of order splitting, please select the package number or express waybill number to claim',
  'A64kW0': 'Up to {maxCount} files can be uploaded',
  'ABs//h': 'Please enter the claim remarks',
  'BqZvMO': 'Are you sure to cancel?',
  'Cvv7k2': 'Only letters, numbers or - can be entered and no more than 40 characters',
  'D7iu6g': 'Acceptance Time',
  'DjDXF1': 'Acceptance Customer Service',
  'EEunZe': 'The export task has been submitted, please check it in the task center later',
  'EurVT+': 'Financial Account Arrival Date',
  'Ew2J1p': 'Must enter an integer greater than 0',
  'FCDKaG': 'Delivered',
  'FGj5pD': 'Confirm the Amount',
  'FM6KfN': 'Submission of Claim Notice:',
  'FNy4pi': 'The proof of goods value does not meet the requirements',
  'GrwYYL': 'The selected product does not provide claim service',
  'H0Kuhb': 'Claim Result',
  'HNFUfF': 'Please upload the attachment!',
  'Hi/fbr': 'Claim End Date',
  'I5gP3d': 'Evaluation Grade',
  'Ip2JsU': 'The claim application materials are incorrect',
  'JPecZE': 'Less than the deductible, the supplier refuses to pay',
  'MHwPat': 'Serial Number',
  'Meo6z8': 'Attachment Requirements: {message}',
  'N5ov41': 'Acceptance Information',
  'NLrJ1E': 'Outbound Order Status',
  'Nu9lbs': 'Reasons for Rejecting the Claim',
  'Okhk3M': 'Add a Valet Claim Form',
  'PHnJZl': 'Claim Number',
  'QDa1XA': 'The supplier does not admit receiving the package',
  'QQLUuU': 'Please enter English characters!',
  'Qw55Un': 'Outbound Time',
  'R0SWqT': 'Evaluation Successful',
  'S0J1qQ': 'Please enter a number greater than or equal to {applyTotalItemPriceMin}, with up to 2 decimal places',
  'S4FFpE': 'Outbound Date',
  'SrU9lU': 'Document Details',
  'SuNgBE': 'Please enter the English description of the claimed goods',
  'THiiin': 'Acceptance Date',
  'TXC7kZ': 'Please select the sub - order number',
  'UmXhDu': '《Valet Claim Service Agreement》',
  'VGOA2e': 'Inadequate Damaged Picture Evidence',
  'VmkyQv': 'Please select!',
  'Vw3U6j': 'The buyer does not cooperate with the investigation',
  'WeJTWt': 'Selling Price',
  'WfQfPL': 'The recipient is not filed',
  'WhsF10': 'Notification Email',
  'XYe+Jv': 'Accepted',
  'YIWnSk': 'Feedback Attachment',
  'YXPE2M': 'Please select the claim type',
  'ZEEWDf': 'Please fill in a number between {applyTotalItemPriceMin} and {applyTotalItemPriceMax}, with up to 2 decimal places',
  'ZdXHn3': 'Please fill in a number less than or equal to {applyTotalItemPriceMax}, with up to 2 decimal places',
  'a1GC6B': 'Valet Claim Service Agreement',
  'aEjIKB': 'Quantity of Goods Applied for Claim',
  'ci/d9J': 'Application Date',
  'dBccG5': 'The supplier does not reply to the claim result',
  'e3jwTU': 'Please enter!',
  'eJgUUz': 'Application Information',
  'eLONg8': 'Currency of Claim Application',
  'eaF3d8': 'The supplier refuses to pay beyond the claim period',
  'eqH27/': 'Supplier\'s Confirmation Time of Compensation Result',
  'fDm5Jz': 'All valet claims must be submitted before 12:00 on the last working day within the claim period, and those overdue will not be processed. The processing and review period is 1 working day!',
  'fDnTRk': '1. The customer cannot provide the certification documents or claim application documents required by Wint completely and correctly; the customer cannot put forward the claim within the valid period, and Winit will not accept it; {break}2. Winit only acts as an agent for the customer to claim from the last - mile supplier. Winit does not make any commitment to the claim period and the final compensation amount, and does not bear any responsibility, which shall be subject to the period and the final compensation amount of the last - mile delivery supplier; {break}3. The compensation result confirmed by the last - mile delivery supplier is the final result of the claim, and Winit will no longer act as an agent for the customer to file a second claim appeal with the last - mile delivery supplier.',
  'foeSsK': 'Edit Valet Claim Form: {compensateApplyNo}',
  'h9CKhv': 'System Error!',
  'hJZyHS': 'Package Returned to the Sender',
  'hMWBOo': 'Please enter a valid email address. For multiple emails, please separate them with English commas',
  'hugHvs': 'Acceptance Scope',
  'j+a8uD': 'Please enter an email. Multiple emails are supported, and multiple emails are separated by English commas',
  'j2TO8a': 'Instructions for Filling in the English Description of Claimed Goods:',
  'kn569p': 'Is it an LMA Order?',
  'lqR+og': 'Please enter the quantity of claimed goods',
  'nQ5tSF': 'Please enter according to {applyTotalItemPriceType}, supporting 2 decimal places, and it needs to be consistent with the amount in the proof of goods value, otherwise there is a risk of claim rejection',
  'nf87O3': 'Special characters such as {invalidChar} are not allowed in the English description of claimed goods',
  'nisQHN': 'Actual Compensation Currency',
  'oy+a30': 'Evaluation',
  'q2Rokj': 'Between Warehouse Groups',
  'qHZ4DP': 'Exchange Rate of RMB Converted to Local Currency',
  'qdvxnx': 'File format is limited to {allowExtensions}',
  'rfi+L1': 'Reasons for Evaluation',
  'trjozq': 'Acceptance Period',
  'u02CN/': 'Supplier Confirms Compensation and Awaits Account Arrival',
  'vG/J9C': 'Last - mile Freight',
  'xIvUPW': 'Not within the Acceptance Scope of the Supplier',
  'xTzl0b': 'Between Warehouse Groups + Within Warehouse Groups',
  'xpYYfX': 'Please enter the quantity of claimed goods, which cannot exceed the total quantity of outbound goods: {merchandiseQTY}',
  'xplETi': 'Claim Details',
  'zRl49D': 'English Description of Claimed Goods',
  'zUiu6i': '(Multiple Selections Allowed)',
  'DIEfyv': 'Line break',
  'qpR1hg': 'Claim Standards Description',
  '+YWu7f': 'Edit reservation',
  '3Lerqg': 'Total number of items in reservation',
  '4Df3pr': 'Cancel value-added reservation',
  '6+vQ9D': 'Logistics order',
  '7i3N9K': 'Delete some orders',
  '82/C1l': 'Operation record',
  'ApzxyV': 'Remarks:{break} 1. If Winit has a default configuration of warehouse ratio, the system will automatically bring it out and support you to modify it yourself;{break} 2. The sum of the split order ratios of all warehouses in the same warehouse combination must be equal to 100%;{break} 3. If Winit has a bottom line ratio corresponding to the warehouse configuration, the split order ratio configured for the warehouse should be greater than or equal to the bottom line ratio;{break} 4. The warehouse rules are as follows:{break}',
  'B3tb1+': 'When the entry order supports merged appointment = yes, it means that the entry order sent directly by the seller can be merged with the entry order carried by Winit for delivery to the warehouse. Customers do not need to make an appointment, and Winit will arrange the appointment for delivery to the warehouse; if the customer needs to cancel the merged appointment, he can go to Wanyilian-Overseas Warehouse-Entry Order List-Operation Column Button: Cancel Merged Appointment, and cancel the merged appointment by himself;',
  'CGZi9F': 'Appointment Order to Warehouse',
  'CfgLmO': 'Time Replacement',
  'DLJr86': 'Remeasurement of Dimensions',
  'FhkIRV': 'Warehouse Ratio Preference Setting',
  'FzGNHO': 'The following is the warehouse combination recommended by Winit. You can modify the corresponding warehouse priority and split order ratio for different warehouse combinations as customized preferences;',
  'Gm0B5e': 'Number of Appointment Items',
  'HLw9KS': 'Whether to collect batch information',
  'HkOkP6': 'Re-measurement is initiated for a single temporarily stored product. If the re-measurement result of WINIT is within the error range of the current measurement result, a minimum fee will be charged. If there are multiple temporarily stored products in the same warehouse that need to be re-measured, you can go to the [Return Temporary Storage Processing] page to initiate a batch re-measurement. ',
  'IlmiwX': 'Total number of goods in reservation',
  'J/JI0w': 'Total number of packages in reservation',
  'JbGo8r': 'Number of packages for inspection',
  'K7uftF': 'Cabinet type',
  'KYyoJH': 'Is there a difference in the number of goods on the shelves',
  'OpxFPG': 'Is it possible to support combined reservations',
  'Ox8M6v': 'Bottom line ratio%',
  'QznX7j': 'Order split ratio%',
  'R+Rgaz': 'Warehouse delivery information',
  'RcmEcd': 'Receipt',
  'U/8+oQ': 'Seal number',
  'VHAAss': 'Warehouse order status',
  'WFHaMM': 'Not yet in the warehouse',
  'XoUWci': 'Appointment weight (kg)',
  'Y/Td5e': 'Number of unloaded packages',
  'ZksbG3': 'Temporarily stored goods',
  'a3zvco': 'Customized photo templates have a higher priority than WINIT standard templates. If the goods have been configured with customized photo templates or customer-level photo templates, this configuration is not applicable. The warehouse will take photos according to the customized templates. Otherwise, the photos will be taken according to the configured WINIT template type. ',
  'cpMIb6': 'Value-added order',
  'd7lb9g': 'Value-added reservation approval',
  'ewTYYR': '{break}<span>Splitting order rules:</span>{break}',
  'gVtDem': 'Splitting combination name',
  'ggWeEC': 'Number of packages ordered',
  'hXfCth': 'Booking',
  'iM4kr0': 'Booking volume (CBM)',
  'iXrDXP': 'The smart warehouse entry order cannot print the package barcode in the draft state. Please print the package barcode on the entry orders after the order is successfully placed! ',
  'ioriKB': 'Number of packages on the shelf',
  'jlGfDt': 'Cancel reservation',
  'k1wCYD': 'Seller\'s website',
  'nYLYtl': '<title>Warm Tips:</title>{break} <span>1. Please specify the destination warehouse for BC packages</span>{break} <span>2. The system will automatically split the A-class packages according to the warehouse ratio, and support self-adjustment. After confirmation and submission, the system will automatically split into multiple orders</span>',
  'nZ0IYP': '1) For A+/A packages, the products under the packages are summarized and split according to the warehouse ratio according to the number of items;{break} 2) For BC packages, they are allocated according to the specified destination warehouse;{break} <ml8>For example:</ml8>{break} <ml8>1. Place an order: place an order for 10 A+ packages and 5 A packages. The products under the packages are all SKU01, and each A package has 10 items; </ml8>{break} <ml8>2. Warehouse division: divided into 2 warehouses, warehouse A and warehouse B, with a warehouse division ratio of 71% and 29%. Warehouse A has a higher priority than warehouse B; </ml8>{break} <ml8>3. Calculation logic: </ml8>{break} <ml16>3.1. Calculate the number of items in A+/A packages: 10*1+5*10=60; </ml16>{break} <ml16>3.2. Calculate the warehouse division result according to the number of items: Warehouse A: 60*71%=42.6 items, Warehouse B 60*29%=17.4 items; </ml16>{break} <ml16>3.3. According to the priority, warehouse A has a higher priority than warehouse B, that is, warehouse A is allocated first; </ml16>{break} <ml24>3.3.1. The system defaults to giving priority to A+ packages;</ml24>{break} <ml24>3.3.2. The final result is: Warehouse A: 10 A+ packages + 4 A packages, a total of 50 items, Warehouse B: 1 A package, a total of 10 items;</ml24>',
  'peLNcQ': 'Rebook',
  'u9v0vg': 'Cancel merged appointment',
  'v5tuoD': 'Deliver warehouse receipt',
  'vsat58': 'Whether to intelligently divide warehouses',
  'x/VGSI': 'Management system',
  'yOnUB/': 'WINIT checks whether to take photos',
  'ySu2dq': 'Value-added appointment charges',
  'zQgoWI': 'Whether the package is on the shelf',
  'zfRpkM': 'According to the selected temporary storage products, a retest value-added order will be created according to the warehouse maintenance summary!',
  'iaJF/P': 'Please make sure that you have sufficient storage capacity at the destination warehouse before placing an order, otherwise the order will not be submitted. You can <a>click here to view</a>the capacity of each warehouse!',
  'X2jA1F': '1) For A+/A packages, the goods under the packages are summarized and divided according to the warehouse division ratio according to the number of items in the package;{break} 2) For BC packages, they are allocated according to the designated destination warehouse;{break} <ml8>The following is an example:</ml8>{break} <ml8>1. Order: Order 10 A+ packages and 5 A packages. The goods under the packages are all SKU01, and each A package has 10 items;</ml8>{break} <ml8>2. Warehouse division: Divide into 2 warehouses, warehouse A and warehouse B, with a warehouse division ratio of 71% and 29%, and warehouse A has a higher priority than warehouse B;</ml8>{break} <ml8>3. Calculation logic:</ml8>{break} <ml16>3.1. Calculate the number of items in A+/A packages: 10*1+5*10=60;</ml16>{break} <ml16>3.2. Calculate the warehouse division results according to the number of items: Warehouse A: 60*71%=42.6 items, Warehouse B 60*29%=17.4 items;</ml16>{break} <ml16>3.3. According to the priority, warehouse A has a higher priority than warehouse B, that is, warehouse A is allocated first;</ml16>{break} <ml24>3.3.1. The system prioritizes the allocation of packages with more items until the warehouse allocation ratio is reached;</ml24>{break} <ml24>3.3.2. The final result is: Warehouse A: 5 A packages are allocated, a total of 50 items, Warehouse B: 10 A+ packages are allocated, a total of 10 items;</ml24>',
  'mwgDgO': '{break}<span>The warehouse division rules are as follows:</span>{break}',
  '0pGnRG': 'Please confirm whether to create?',
  'avNw+9': 'Claim agency application',
  'zr9GzM': 'Cancel a third-party merge appointment',
  'f6Msch': 'The company name only supports English, spaces, numbers, hyphens (-) in English format, ampersands (&), parentheses (()), slashes (/), and periods (.). Please make the necessary changes and re-enter.',
  'BYrriq': 'Actual number of packages',
  'DMWygJ': 'Inspection volume (CBM)',
  'NdyxGS': 'Inspection weight',
  'fqPPUZ': 'Inspection weight (kg)',
  'zalGCs': 'Order weight',
  'W+h03U': 'Actual weight',
  'twcbGg': 'Confirm the quantity after sampling in domestic warehouse',
  'y3f54g': '7.If you need to upload orders with multiple consignee types, please split the orders before uploading.',
  '2+3GNH': 'Image size limit is {size}M or less, please compress before uploading',
  '5J4Kg7': 'Please enter {name}',
  'BuPcLP': 'And keep up to {scale} decimal places at most',
  'KJqOG1': 'Format error',
  'ROiSCr': 'Sheet page',
  'RYD/kA': 'Number must be less than {max}',
  'W+zrR1': 'File format must be {format}',
  'aPcADB': 'Minimum length limit is {minLength} characters',
  'fFsRGV': 'Image format must be {format}',
  'fWCKfV': 'Format must be within the range [{min},{max}]',
  'l36qrs': 'Number must be greater than {min}',
  'md1Oyf': 'Maximum length limit is {maxLength} characters',
  'x5UKly': 'Length must be between {minLength}-{maxLength} characters',
  'eKgHZC': 'Multi layer packaging cannot choose"No packaging specified"',
  'nxlceY': 'Product editing, United States is not allowed to be selected as the export country/area.',
  '/th1fU': 'The number of incoming orders that support appointments is 0! ',
  'HxC2VI': 'The number of incoming orders that support appointments:',
  'gX/Fwn': 'Remarks: If you click Create Appointment Order, the system will merge the incoming orders that support appointments to create a new appointment order!',
  'lILo+B': 'The number of incoming orders that do not support appointments:',
  'mJ3Mvf': 'Confirm to copy?',
  'mns98D': 'The incoming order [{orderNo}] has been bound to the appointment order [{bookingNo}]. After rolling back the draft, the appointment order will be cancelled. At that time, you will re-create the appointment order. Confirm whether to roll back to the draft? ',
  'qmTv4w': 'Reason for not supporting appointments',
  'sXp295': 'Copy to create an appointment order',
  'wGtjeJ': 'Do you want to copy the original appointment order information and create it directly?',
  '02dIi2': 'Platform return order creation time',
  '1Z7MG0': 'Platform RMA number',
  '6d79n8': 'Platform {platform} and eBay/TikTok cannot be selected at the same time',
  'CWQV3t': 'Confirm withdrawal? ',
  'Gdzq57': 'Return delivery time',
  'Gp5HaQ': 'TransactionID',
  'aA7INh': 'Fill in at least one item {break} Country, state, city, zip code If filled in, it must be exactly the same as the order to match',
  'LD7GZo': 'eBay can only select dates within 18 months',
  'M9LPoJ': 'Platform {platform} and ebay cannot be selected at the same time',
  'dtTOxf': 'Detailed address 2',
  'oAwNvZ': 'Detailed address 1',
  'yVadR+': 'Return warehouse address details',
  '+lfBfo': 'Arrival date',
  '/++xi3': 'Third-party warehouse has been shipped',
  '0LtbFX': 'No internet access and returned to warehouse',
  '0z9bjM': 'Supplementary receipt',
  '10x/wc': 'Kind reminder: The financial audit process takes 5 working days. As the package may still experience delays in updating its tracking information and is not considered lost, the financial department will base its audit on the latest tracking status at the time. If there are any updates in the tracking information during the audit, the claim for this order will be rejected. However, if compensation is granted, there will be no additional charges incurred when accessing the internet.<br/>The time limit for accepting claims is from the 11th natural day to the 45th natural day after the date of shipment, and the day of shipment is Day 0.',
  '1qZPE9': 'This attachment refers to： Received package and physical photos  which  can be clearly identify the express sheet outside the package, single product bar code of Si card head / commodity bar code beginning with m',
  '29WnEW': 'Claim rejected',
  '2Kp9u5': 'File a standard claim',
  '3ESazo': 'Claim Document Type',
  '3KXefx': 'Type of return',
  '3vdl5d': 'Timeout no internet access',
  '3yv61P': 'Pay the amount',
  '48/DRB': 'Lost in overseas warehouse',
  '4DetPs': 'More Items Sent than Original Order',
  '4UW5pU': 'Customer Code',
  '5gdhY5': 'Product Information(If you need to provide product information details, please contact online customer service)',
  '6YEHIA': 'lost in Warehouse transfer',
  '6Z+XFF': 'Cancelling',
  '6kavqv': '1.After choosing to hand over parcel with A-scan service to lastmile delivery vendor, the outbound order status is "delivering", correspondent lastmile delivery service has no effective delivery track generated.{break}2.Vendor didn\'t accept customer claim and buyer verifies that they didn\'t receive any parcels.{break}3.Acceptance time limit is 11 calendar days-45 calendar days after outbound date, the outbound date is Day 0.',
  '6vg3QB': 'Note: Only the package request in the delivery is allowed to be timeout no internet access.',
  '7qhI2u': 'Unloading time of parcel',
  '8cd7j6': 'This attachment refers to： The picture can clearly illustrate the Winit delivery number or delivery order number.',
  '9+KfPI': 'Please enter your claim description',
  'ATT7x+': 'Physical photo',
  'AnNqLb': 'Complete customer service',
  'B9FX6E': 'damaged in  Warehouse transfer',
  'CcSWqn': 'Empty',
  'DQCUED': 'Damaged in overseas warehouse',
  'DglTqP': 'Standard Claim Application',
  'DlyXTU': '1.The parcel without Tracking service isn\'t within this range{break}2.AU With Registration service without A-scan commitment, only signing proof, which isn\'t within this range{break}3.The parcel applying and with the lastmile vendor compensation(Winit agent claim service) isn\'t within this range.{break}4.Proven the parcel has handed over to lastmile vendor, which isn\'t this range.{break}5.Customer cannot provide the proof documents or documents for applying claim which Winit asking for',
  'DtcSoO': 'Amount Claimed（USD）',
  'E910VQ': 'Input export order NO, express delivery NO,Winit tracking NO',
  'F9hOqH': 'Return Tracking No',
  'FTHPZP': 'Pay the amount(USD)',
  'GMOAU7': 'Single face photo',
  'Hm5SLN': 'Opreation Time',
  'Icf5jG': 'This attachment refers to： Clear M-code or s-code photos of the received goods which is be able to clearly identify the single product bar code beginning with Si / commodity bar code beginning with m',
  'Ip8eFD': 'As the goods claimed have been recovered, the original claim amount will be charged again',
  'JP07eh': 'Product barcode',
  'K+M9tc': 'Feedback',
  'NdKn8a': 'Exception generation date',
  'ODouBx': 'Order number',
  'ONOXRP': 'Logistics track screenshots',
  'OqV75t': 'Single export cannot exceed {maxExport}, please narrow down the filter and export',
  'PK7a1r': 'Damaged in first leg',
  'PbNtRA': 'Submit successfully!',
  'PurMpo': 'Wrong delivery by Winit fulfillment. Mixed delivery or delivery to wrong buyer.',
  'QpJsOc': 'This attachment refers to： the screenshot of the buyer complaining to the seller about not receiving the goods and asking for a refund or reissue,{break} ① proving that the complaint is the buyer himself{break} ② It is proved that the complained order and the delivery order belong to the same order.',
  'R1gXZc': '1.Customer cannot provide the proof files or files for applying claim which Winit asking for.{break}2.The time limit for claim acceptance is 80 natural days after the date of delivery, and Day 0 is calculated on the day of delivery.',
  'RXddtb': 'Wrong supplier selection - Unable to return',
  'Ryp1al': 'Third-party warehouse re-stocked',
  'SGO2k0': 'Third-party warehouse relabeling',
  'SnQWkX': 'Return logistics list',
  'TWpf/3': 'CSR reply',
  'Tsnb9z': 'At least one item must have a claim quantity greater than 0',
  'U0BwdQ': 'Edit standard claim form:{serial_number}',
  'UgJWyM': 'Return stock order',
  'VIiRrc': 'Labeling error',
  'VerSyC': 'Data unique coding',
  'W02EEZ': 'Claim successful',
  'WjqeLR': 'Lost in the warehouse',
  'X5zp/w': 'Buyer complaint mail',
  'YjG8ws': '1.The online queried status (without A-scan track) of the correspondent lastmile delivery tracking No. after the parcel has outbound for 10 canlendar days {break}2.Screenshot of the buyer\'s communication with the seller about not receiving the goods, or the screenshot proving that the seller\'s package has been reissued according to the original order information or the seller has refunded according to the specified order.',
  'YtXXdL': 'This Annex refers to the screenshot that can prove that the seller has completed the resending or refund，or the screenshot  of the order on the platform initiating refund. {break}① the resending screenshot must reflect the recipient\'s address, recipient\'s name, recipient\'s telephone information and commodity information of the resending package, which must be consistent with the original order{break} ② The refund screenshot must include winit order number or express order number, which can be proved to be the refund of the order transaction{break} Please highlight the above information in the picture to prevent it from being returned by mistake{break} One of the buyer\'s complaint email and refund or reissue screenshot can meet the requirements',
  'Z/R8Iz': 'Whole package',
  'ZZg9Ba': 'Note: Only parcels that are delivered, delivered successfully, or failed to deliver are allowed to apply for the wrong shipment.',
  'ZmnSnN': 'Refund or reissue screenshot',
  'ZoAvYj': 'Online application is not supported for the claim of return loss. Please provide information according to the compensation standard and contact the online customer service to investigate the loss of return. If the investigation results confirm that the return is lost in the warehouse, winit will actively initiate compensation.',
  'aZHm4k': 'The courier number [{trackingNo}] has applied for a valet claim [<a1></a1>]. Repeated claims are not supported for the time being. If you have any questions, please contact online customer service.',
  'beR0hU': 'Item Missing',
  'br1oBU': 'Customer service work order number',
  'c48sip': 'This order has been submitted a claim, the claim number {serial_num}, please directly query.',
  'cM7IDg': 'Claim currency',
  'dG7pk9': 'To Account Time',
  'eCWHEh': '1.picture of waybill(with Winit outbound no.or tracking no.){break}2.Clear M-code or S-code picture of all received items.{break}3.Picture of parcel or actual object{break}Note: If buyer/seller cannot provide picture of waybill and clear M code or S code of received parcel, pls contact winit staff for investigation, if winit staff confirm it is wrong delivery by warehouse, then compensation will arouse automatically, and transfer to your account in 5 working days after confirmation{break}1)orginal outbound order No.{break}2)picture of received parcel and actual object{break}3)The complaint screenshot of receiving wrong parcel from buyer',
  'eCZEW+': 'Lost in First Leg',
  'eKQbFf': 'Original order',
  'gUvzzF': 'Item Wrongly Sent',
  'hDbcfV': 'Compensation form',
  'hVYsuo': 'Return weight',
  'ieLpUT': 'Original claim information',
  'izFnP+': 'Note: Only packages that are delivered, delivered successfully, or failed to deliver are lost.',
  'j4p94F': 'Warehouse verification leaky connection or mail screenshot',
  'k2mGmc': 'This attachment refers to： The buyer\'s e-mail complaining about wrong delivery  such as express order No. / winit Order No. / seller Order No. / e-commerce platform transaction No., such as eBay transactionid and itemid can be clearly identified',
  'm8Z4lP': 'Warehouse verification of the wrong link or mail screenshot',
  'mfVObj': 'Lost in Return',
  'p91JT+': 'Claim Marking Instructions',
  'pQ14T/': 'About unloading record',
  'qG/qcD': 'Abatement conditions',
  'qPibZC': 'Wrong supplier selection - Return to warehouse',
  'qzC1QW': 'Whether it is self-inspection',
  'rUKhaE': 'Application documents for claim',
  'tV2A33': 'Compensation unit',
  'thG2AF': 'Original claim',
  'tjA0bt': 'Original claim',
  'wflzko': 'Since the proposed library is lost',
  'wmO+TV': 'Transfer work orders',
  'xccF66': 'Incomplete package',
  'xfWrWt': 'Please enter the exception type',
  'ykapbL': 'At least one product is required',
  's0PQJ3': 'Damaged in Warehouse transfer',
  'ZQsadN': 'Input export order NO, express delivery NO',
  '7/6GMQ': 'Status Change',
  '33niK1': 'Restore credit limit after customer entity change review/approval.',
  'XI6ZFw': 'Suspend credit limit for customer entity change.',
  'hBJBNE': 'Association',
  'R0/9TS': 'Example of Standard Shipping Label',
  '/4W7Tn': 'Go to Placed Orders',
  '03t9MR': 'File Uploaded Successfully',
  '42OgKJ': 'Non-WINIT Outbound Return Label Order (Using WINIT Return Label Service)',
  '49sagY': 'Please select the correct template to create a return order based on your scenario. Currently supported scenarios:',
  '6tHpbq': 'For WINIT outbound returns <a>Click here to download "Standard Return - WINIT Outbound Non-Return Label Service Template"</a>',
  '9IJ/fA': 'Value-Added Processing Completion Time',
  'AWqqOx': 'Standard Return',
  'AyT4mM': 'Entering outbound order numbers will automatically download【recipient information & outbound product details】into the template{break}Remove unsupported orders from the input box before downloading the template',
  'Ef5GsY': 'WINIT Outbound Return Label Order (Using WINIT Return Label Service)',
  'GMlLgw': 'Creation Failed (Items)',
  'H7pUU5': 'For orders with multiple sub-orders, returns must be initiated using sub-order numbers',
  'JZBDVe': 'Please upload XLSX format template. Max: 10,000 entries per file (30MB max). Split large files into multiple uploads',
  'K9c8Oa': 'Standard Return - WINIT Outbound Non-Return Label Service Template',
  'NxjxR0': 'Download Receipt',
  'Y9M573': 'Actual processing completion time after warehouse receipt. Based on the last item\'s handling strategy: Storage after photo taken → Storage completion time; Direct shelving → Shelving completion time; Disposal → Disposal completion time.',
  'dDZYBp': 'Placed return orders cannot be updated here. Cancel and re-create if incorrect',
  'fXYgEh': 'Non-Return Label orders: Retrieve recipient details and RMA-specific addresses from receipt files after successful import',
  'gtWL6U': 'Created Successfully (Items)',
  'jG47FI': 'Standard Return - WINIT Outbound Return Label Service Template',
  'kVADjE': 'For non-WINIT outbound returns <a>Click here to download "Standard Return - Non-WINIT Outbound Template"</a>',
  'mR7h1z': 'WINIT Outbound Non-Return Label Order',
  'sQ0mrW': 'Max 100 outbound orders per batch',
  'se3hAx': 'For WINIT outbound returns <a>Click here to download "Standard Return - WINIT Outbound Return Label Service Template"</a>',
  'w3xp/Q': 'Completion time when the last RM item finishes value-added processing. Order status changes to Completed.',
  'zV1tv1': 'Download Template',
  'zfcyli': 'Enter WINIT outbound order numbers. Max 100 per batch. Separate multiple entries with line breaks or commas (,)',
  'qB8UnK': 'Third-party single service',
  '2BMovZ': 'Withdrawal successful',
  'Dpm3Fm': 'Cancel this payment order? ',
  'fi6T5Q': 'Please provide a model that is consistent with the actual product and the sales link to avoid review, return and modification. If there is no model, please fill in "none".',
  'iSkSqR': 'Three-party shipping label service order(General Template)',
  'kCS8F7': 'Three-party shipping label service order(Platform Specific Template)',
  '3C70KE': 'Please fill in the data',
  '6Dvzdw': 'Preferences for inventory adjustment sheet unpacking goods piece by piece',
  'ANYnok': 'In the warehouse',
  'KmPK3s': 'The declared value on the left side of the current line must be greater than the declared value on the right side of the previous line. Please modify and resubmit. ',
  'YvHGhi': 'The number to be filled in must be greater than or equal to 0! ',
  'ceBz7p': 'If you configure the following preferences, when you manually/system creates a box/set inventory adjustment order, your configuration preferences will be automatically obtained, and each item will be counted when unpacking;',
  'f9xtGe': 'The number to be filled in must be greater than 0! ',
  'imKkCz': 'Do you need to count each item',
  'rLSVYX': 'The number on the right must be greater than the number on the left',
  'sVvA5q': 'Import declared value of the product',
  'yzFo2u': 'When you create a single inventory adjustment document for box-to-box transfer, if the goods meet the import declaration value range you configured, the goods will be counted piece by piece when unpacking;',
  'QElQuf': 'Do not show again for {days} days',
  'XZVTu9': 'Validate Address',
  'xEJFBo': 'Intelligent recommendation for order placement means that the system calculates the optimal shipping plan (combination of shipping warehouse and shipping method) based on the configured shipping strategy according to information such as the buyer\'s address, shipping method, and overseas warehouse inventory when the customer places an order, and then ships automatically according to the optimal plan. {break} Note: {break} - If the order is a bundled order, the recommended shipping warehouse and shipping method are supported, but shipping to multiple warehouses is not supported. {break} - If the order source is "platform synchronization" and the e-commerce platform is "AliExpress" or "TikTok", the recommended shipping warehouse and shipping method are supported, but shipping to multiple warehouses is not supported. {break} - If the customer specifies batch products when placing an order, the recommended shipping warehouse and shipping method are not supported, and shipping to multiple warehouses is not supported. {break} - If the consignee type of the order is "FBA transfer - VC order" or "FBA transfer - non-VC order", the recommended shipping warehouse and shipping method are supported, but shipping to multiple warehouses is not supported. {break} - If the order contains value-added services that do not allow order splitting, the recommended shipping warehouse and shipping method are supported, but shipping to multiple warehouses is not supported. {break} - Pre-sale orders without inventory in stock do not support recommended warehouses and product shipments. {break} - If you select [Validate Address] in [Warehouse Group Configuration], the system will validate the address and estimate address-related additional fees during the recommendation process. If you do not select [Validate Address], the system will not validate the address or estimate address-related additional fees during the recommendation process, which may lead to deviations in the accuracy of the recommendation results.',
  '0n576u': 'Package Count (Estimated|Actual)',
  'Dai8r5': 'Total Item Count (Estimated|Actual)',
  'NrTd+i': 'Outbound Quantity (Estimated|Actual)',
  'Akeoip': 'How to perform inspection?',
  'TMYVPY': '<bold>Friendly Reminder:</bold>{break}For inquiries and export of historical order data that has been completed for more than 3 years, please contact our online customer service.',
  'NcucBQ': '<title>Address Verification Function Usage Tips</title>{break} ⚠️ <bold>Usage Notice</bold>：After checking the "Verify Address" option, the system will verify the address you filled in during the recommendation process （German address verification/residential address verification)），The following situations may occur: {break} 1.<bold>Increased order placement time</bold>：The address verification process requires interaction with the logistics provider\'s address verification interface, which may extend the order placement time by 3-5 seconds.{break} 2.<bold>Risk of order placement failure</bold>：If temporary failures occur in the logistics provider\'s address verification interface, network anomalies, or other exceptional circumstances, the order placement may fail.  {break} <red>Note: Please carefully review the above risk prompt information before making a cautious choice. Confirming the checkmark means accepting the above risks.</red>',
  '0f7VEw': 'Cancelled {failedCount} items failed, please try again later {break}',
  '3aeyfd': 'Not synchronized',
  '3eKKfh': 'Only unsynchronized/failed synchronization status order operations',
  '8QbMUo': 'Fulfillment Center ID',
  'BYYQoI': 'LPN',
  'HzNUHy': 'Cancellation successful',
  'KBgfjH': 'Batch Cancel',
  'L79/L5': 'Cancel failed {failedCount} {break}',
  'M72Spb': 'View the list of failed synchronization',
  'MMYQ00': 'FBA return order number',
  'MWWv4c': 'Cancel failed',
  'OA1lI2': 'Cancel failed',
  'OxY5CB': 'View the list of canceled synchronization',
  'TwN/uR': 'Batch synchronization',
  'W56e0Y': 'Resynchronize',
  'W6bBA3': 'View the list of unsynchronized',
  'X8qCBY': 'Cancel only the order operation in status',
  'XDQ2wC': 'Synchronization successful',
  'XjH2Wi': 'Synchronization successful',
  'ZiBmzg': 'LPN code',
  'dPGcC7': 'Confirm synchronization? ',
  'dRm8V9': 'Cancel successfully,',
  'dcdgId': 'Cancel synchronization',
  'fsHeVZ': 'Confirm cancellation? ',
  'hR4j9y': 'Revocation',
  'hYuyFy': 'Reason for abnormal product synchronization',
  'izEwJI': 'You have not turned on the FBA return order synchronization switch, so the report will not be synchronized <url2>Go to turn it on></url2> <a1>View detailed introduction</a1>',
  'j+em3g': 'View the synchronized list',
  'nfzk7/': 'Return time',
  'qnqsfV': 'Synchronization failed {failedCount} times{break}',
  'rkiG6m': 'Revocation failed,',
  's6vDiK': 'The FBA return order logistics information report is updated {pullCount} times a day, and only reports within {pullFrequency} days are updated. Latest update time {pullDate} <a1>View detailed introduction</a1>',
  'wKkI7s': 'Cancellation failed,',
  'xBcz9a': 'FNSKU',
  'xhmgv4': 'Revocation successful,',
  'zEIkLk': 'Synchronization failed,',
  'zwuANK': 'SKU synchronization status',
  '0tgneD': 'Already associated',
  '2uzTTX': 'Successfully revoked {successCount}',
  '3nppSO': 'Association failed',
  '6DCH+f': 'Amazon removal order instructions',
  'AN6GH5': 'Successfully canceled {successCount} items',
  'CdINvG': 'Cancel association',
  'NtY0E8': '{successCount} items successfully synchronized',
  'ex43en': 'Automatically synchronize removal orders & FBA return orders',
  'hXKgDD': 'Set automatic warehousing rules',
  'l06LmZ': 'FBA return order reports are updated {pullCount} times a day, and only reports within {pullFrequency} days are updated. Latest update time {pullDate} <a1>View detailed introduction</a1>',
  'o4+t2Y': 'Do you need to automatically synchronize and obtain the detailed data of the removal order and the tracking number information of the removal order, as well as the FBA return order information to obtain the LPN code for the warehouse to identify the product',
  'tXji6c': 'Not associated',
  'CtVsla': 'View the unassociated list',
  'KHYPUz': 'View the unassociated list',
  'Mz+pKJ': 'Synchronous association failed',
  'SqFYrJ': 'Synchronous association succeeded {successCount}',
  'axjLft': 'View the failed association list',
  'gLJGbs': 'Synchronous association succeeded',
  'lquvpq': 'View the associated list',
  'nu/e3p': 'Synchronous association failed {failedCount} {break}',
  '0XsEG/': 'You have not turned on the removal single synchronization switch, and the report will not be synchronized <url2>Go to turn it on></url2> <a1>See detailed introduction</a1>',
  'YGl5V/': 'There are currently {removeOrderNoLength} removal orders that have been placed but not put on the shelves. Please do not directly turn off the synchronization of removal orders. Example order number: {removeOrderNos}{break} If the switch is turned off, the above orders will not be able to obtain new express number/LPN code, and the warehouse will not be able to identify the warehouse package/product. Please operate with caution. Are you sure you still want to turn off the switch?',
  '5/YAvH': 'Allowable shortage ratio',
  '6HrVzW': 'Confirm normal delivery',
  '6QNfn6': 'Winit will cancel the order automatically if you do not agree to the shortage.You need to place a new order if you want to continue delivery.{break}Do you confirm and disagree with the short shipment?',
  '6khOLR': 'Missing SI number',
  '7FWwRs': 'The value you entered for {name}[{value}] is not a positive integer or zero. Please make the necessary corrections.',
  '8Asou7': 'Maximum allowable shortage ratio',
  'AHslQm': 'Processing of incomplete orders',
  'BHseVz': 'Rounded up to the nearest integer',
  'CnasbR': 'The value you entered for {name}[{value}] is not a number with zero or up to two decimal places and a positive integer. Please make the necessary corrections.',
  'DzZZQa': 'End point of order SI quantity',
  'GvnhBj': 'The shortage value [{value1}] you entered is greater than the order SI number [{value2} ]. The shortage value must be within the range of the order SI numbers. Please modify it.',
  'HH0mb1': 'The value you entered for {name}[{value}] is not a positive integer. Please make the necessary corrections.',
  'HSbl3Z': 'Range of order item quantity',
  'IZn7Zg': 'Confirm whether to modify?',
  'KNTy5n': 'The value you entered for {name}[{value}] exceeds the maximum limit of 100. Please modify it.',
  'MnNgWI': 'Winit will arrange the normal delivery of the order to the supplier after the agreement is made. If it is from bill of lading, please arrange the supplier to pick up the goods as soon as possible.{break}Do you confirm and disagree with the short shipment?',
  'PiBHfq': 'The value you entered for {name}[{value}] you entered is not a positive integer or zero. Please modify it.',
  'RAuvJQ': 'Exception Handling status',
  'SSltse': 'Rounded down to the nearest integer',
  'SxJ9GS': 'Allowable shortage SI quantity',
  'THF/1n': 'Confirm void order',
  'Uk/dcL': 'Shipping Warehouse',
  'WrVILK': 'Direct outbound',
  'YfrP7D': 'Order SI number',
  'ZWZbtt': 'Warehouse group inside',
  'aczPp4': 'Scheme confirmation time',
  'f2KXxR': 'Shortage value',
  'fo9KMc': 'View out-of-stock items',
  'gImTsw': 'Set shortage outbound rules',
  'hJL5I5': 'The value you entered for {name}[{value}] exceeds the maximum limit of 100,000. Please modify it.',
  'hhuy/C': 'Partial outbound rules',
  'iMwK3P': 'SI number packed',
  'iWsoz/': 'Scheme confirmer',
  'jmzqau': 'Maximum allowable shortage item quantity',
  'lkqAQX': 'Confirm the scheme',
  'mjQPee': 'The interval you entered [{start1}-{end1}] overlaps with [{start2}-{end2}]. Please modify it',
  'nsr4Y8': 'The SI number of the order you entered [{value1}]is smaller equal than [{value2}].The ending value must be greater than the starting value. Please modify it.',
  'p+tMyp': 'Packaging completion time',
  'pP65KW': 'Start point of order SI quantity',
  'x1egnc': 'Note: For orders not within the following rule scope, in case of stock shortage, WINIT\'s default outbound rule is "Outbound not allowed".',
  'zHVyhR': 'Shortage dimension',
  '8U2r1I': 'SKU Classification',
  'Re5nvq': 'Re-register merchandise',
  'UWi7Ma': 'Product receipt information',
  'YHQukw': 'Receipt information',
  'GvZcae': 'Reason for upload failure',
  '+7rXZn': 'Shelf sub-package volume',
  '/rFwLb': 'You can\'t select the pick-up time for the product [{winitProductName}] you selected when placing an order. After completing the inspection, please go to Wanyi Lian-Incoming Order All Orders-To-Be-Processed Items to add the pick-up time. Thank you! ',
  '8tfLG5': 'Modify identification code',
  'Iz/PPI': 'Sub-package source',
  'LTXQVa': 'Printing failed',
  'MHN+5B': 'Pick-up time to be supplemented',
  'TYcOfj': 'Has the warehouse been scanned',
  'aZfMpy': 'Dear customer, After placing an order, you need to complete the inspection before the goods can be sent to Wanyitong domestic warehouse, otherwise an abnormality will occur and abnormal fees will be charged! If you choose Winit to pick up the goods at home, please log in to Wanyilian-Warehouse All Orders after completing the inspection, and add the pick-up time of the warehouse order. At that time, Wanyitong will arrange door-to-door pick-up at the pick-up time. Thank you!',
  'e4T0CT': 'Non-customer',
  'teniS8': 'If you find that you cannot choose the pickup time, please modify the "Logistics Plan" or change the pickup type to "Self-delivered Logistics"!',
  'xRN4c5': 'Inspect the volume of the sub-package',
  'yejLLK': 'Maintain the identification code',
  'DkAqhG': 'Maximum volume',
  'FKbLCe': 'Maximum height',
  'YwI4T5': 'Maximum width',
  'odbnh2': 'Maximum weight',
  'v8espj': 'Maximum length',
  '4RJQ5E': 'Inspection Settings',
  'E3N588': 'Whether to open',
  'V3Vt+a': 'sub-package volume limit of self-inspects ',
  'Us+yh+': 'illustrate：{break} After the preference Settings are enabled, the volume of small sub-packages will be restricted to no more than 0.04cbm during the inspection process{break} If the restrictions are not enabled, WINIT will charge a sorting fee for SKUs with small sub-packages exceeding 0.04cbm in volume. Please pay attention to the relevant charges{break} *Please complete the preference Settings before the inspection begins. The preference Settings will not take effect on orders that have already started inspection{break}',
  '4NLuER': 'Supports SKU-specific in-warehouse placement methods',
  'JdX94J': 'When enabled, allows marking product storage placement methods [flat placement, side placement, vertical placement, etc.] at item level',
  'hE6rE9': 'Optional fulfillment requirements',
  'tU239Q': 'After enabling the service, storage fees for items with specified placement requirements will be higher than regular goods. Please enable with caution based on actual needs.',
  '5X6Sjh': 'Direct submission: Provide all necessary documents for value-added services at once when creating an order. {break} Supplement after temporary storage: If unable to provide documents when creating an order, they can be supplemented after the warehouse packing is temporarily stored.',
  'GU+Vrq': 'Submission step',
  'XQZcrd': 'Submit after temporary storage',
  'YmPeU6': 'Submission step: When supplementing files later, choose the step for supplementing files (such as submit after temporary storage).',
  'iZ4ZzP': 'Supplement after temporary storage',
  'ky6kSp': 'Direct submission',
  'vr/2qa': 'File submission method',
  '22Mqpn': 'No valid WEEE registration number',
  '3Qv+VL': 'Explanation: The quick association will be based on the "WEEE category" to which the "unassociated" SKU belongs, and the "WEEE category" and the current "valid" WEEE registration number will be quickly associated. If the corresponding SKU does not have a valid category of "WEEE registration number" will  ignore the association.',
  '5tt4V2': 'Failure reason',
  '6X472P': 'Confirm and agree to use quick association',
  '6uUWc2': 'WEEE category for un-associate SKUs',
  'ICNo7r': 'Product placement method',
  'EeBRbZ': 'There is no valid WEEE registration number for the corresponding category of the unassociated SKU, please add it and submit it for review, and then perform the associated operation after passing the review!',
  'FRsmym': 'Association is already in progress, please refresh later to check the association status!',
  'FvspUO': 'No unassociated SKU,To update use a single association or template import',
  'G3ZzET': 'WEEE registration document',
  'GOmMKL': '[{qty}] SKUs have been successfully associated',
  'IPThwp': 'In view of the content submitted above, I/Our company declares:{break} 1. For the products related to the German WEEE registration information provided by our company/our company, they must be registered with the German competent authority (Stiftung Elektroaltgeräte Register – EAR), and report the corresponding product delivery data and pay the recycling fee on time. In addition, the corresponding products Also print WEEE label.{break} 2. If there is any change in my/our company\'s WEEE registration information, I will notify your company of the modification.{break} 3. All the information submitted above is true, any responsibility and consequences caused by false information will be borne by me/our company. ',
  'MZTZvc': 'Click to view',
  'QMEQJC': 'Change',
  'V2XaN0': 'WEEE information list',
  'XfN2Ck': 'Up to 5 files can be uploaded, limited to JPG, PNG, GIF, BMP, and PDF formats within 5MB',
  'YJwhYM': 'WEEE registration number type',
  'YtGpRh': 'Add WEEE information',
  'YzNYFm': 'WEEE review information',
  'cIRvm+': 'Edit WEEE information',
  'dibfnz': 'There is no valid WEEE information for the corresponding category of the current SKU, please add it and submit it for review, and perform associated operations after the review is passed!',
  'l62HOb': 'Association time',
  'oIsHa4': 'Please specify the "WEEE registration number" to be associated with this category',
  'oPgCK9': 'WEEE Authorized Representative Name',
  'plTZLU': 'Quick association',
  'quexjV': 'There are 2 or more "valid" WEEE registration numbers in the following WEEE categories, please specify',
  'sqS2Da': 'status',
  't2bBzi': 'Confirm cancellation?',
  'uaCekg': 'Please enter 1 to 16 digits',
  'uueUH5': 'Associated with {relQty} items, not associated with {unRelQty} items{break} Tips:{break} 1. The WEEE category of the product displayed on the current page is for your reference. For the specific WEEE category of the product, please refer to the real information of the product registered with Stiftung EAR, the German electrical and electronic equipment waste management agency.{break} 2. After you maintain the WEEE information, you need to operate the WEEE registration number corresponding to the SKU association. The German inventory of SKUs that are not associated with the WEEE registration number will be prohibited from leaving the warehouse on July 1, 2023.',
  'vdYJd/': 'Association successful',
  'w3teYZ': 'Change WEEE information',
  'Rhyt5i': 'Overseas privacy data viewing permissions',
  'awKGiZ': 'On: Sub-accounts can view overseas privacy data; Off: Cannot view.',
  'uAVsJm': 'After opening this permission, overseas private data can be viewed, please open it with caution',
  '0Q61kB': 'Whether to confirm',
  '62t33v': 'Confirmation of goods that have not arrived at the warehouse',
  '7jTO69': 'Confirmation of non-delivery',
  'CQq8b/': 'Disassemble',
  'DzM13w': 'Confirmation of goods that have not arrived at the warehouse',
  'HGFjmH': 'Number of packages that have arrived at the warehouse/Number of packages that have not arrived at the warehouse',
  'HshCr8': 'Check the confirmation result',
  'Ln/QPz': 'Source of the split order',
  'Pvjte/': 'Confirmation result',
  'nmidO4': '<span>It cannot be modified after confirmation, please operate with caution! </span>{break}Please confirm that the packages (a total of <span>{number}</span>) are delivered to the warehouse in batches. After confirmation, the system will automatically split the packages that have not arrived at the warehouse into new warehouse orders. After the split is successful, you will be notified by email. Thank you! ',
  'ob/U9u': 'Actually shipped, warehouse investigation required',
  'ppLFVk': 'Warm reminder: If you have not confirmed within 3 natural days, the system will automatically confirm that the packages/goods that have not arrived at the warehouse will not be shipped, and terminate the packages/goods that have not arrived at the warehouse. If you need to continue shipping, please create a new warehouse entry order. Thank you!',
  'vMKAQH': 'Deliver in batches, split new warehouse entry orders',
  'xy4O9y': '<span>Cannot be modified after confirmation, please operate with caution! </span>{break}Please confirm that the selected packages (a total of <span>{number}</span>) will no longer be shipped. After confirmation, the package status will be switched to terminated. Thank you! ',
  '5cYC+0': 'No available products',
  'zgxeCD': '<span>It cannot be modified after confirmation, please operate with caution! </span>{break}Please confirm that the packages (a total of <span>{number}</span>) need to be investigated by the warehouse? The investigation results will be notified by email at that time, Thank you!',
  'jLakHl': 'The entire order has not arrived at the warehouse, and the order splitting is not supported! If you need to reschedule the order, please contact customer service!',
  '/wroH0': '《New Supply Chain Management Service Agreement》',
  '8BvNX5': 'Due to the interrelated nature of the contents of {a1}, {a2}, and {a3}, {break}the New  Supply Chain Management Service Agreement, the new Supplemental Agreementon Commercial Terms for Overseas Warehousing, and the Tripartite Transfer Agreement for the overseas warehouse need to be signed simultaneously. You can click on the agreement name to view the specific content.',
  'HQiSCu': '《New Supplemental Agreementon Commercial Terms for Overseas Warehousing》',
  'kQA+U7': '《Tripartite Transfer Agreement.》',
  'mjLaZm': '《New Supplemental Agreementon Commercial Terms for Overseas Warehousing》',
  's9oyw7': 'Due to the interrelated nature of the contents of {a1}, {a2}, and {a3}, {break}the "New Supply Chain Management Service Agreement", "the new Supplemental Agreementon Commercial Terms for Overseas Warehousing", and " the Tripartite Transfer Agreement" need to be signed simultaneously. You have signed the latest version and can click on the agreement name to view the specific content.',
  '3ECTBI': 'Quantity that has not arrived yet',
  '3fCA1g': '<span>Changes cannot be made after confirmation. Please proceed with caution!\' </span>{break}Please confirm that the selected items (a total of <span>{number}</span>) will no longer be shipped. The end quantity for these items will be updated after confirmation. Thank you! ',
  'KMwQTR': '<span>This cannot be modified after confirmation. Please proceed with caution! </span>{break}Please confirm that the selected items (a total of <span>{number}</span>) require warehouse investigation. The results of the investigation will be notified by email. Thank you! ',
  'p7jssq': 'Quantity Arrived',
  'u0wsEP': '<span>Only one new incoming order can be split. Please confirm that all items on the incoming order need to be split before splitting. This cannot be modified after confirmation. Please proceed with caution! </span>{break}Please confirm that the items (a total of <span>{number}</span>) will be delivered to the warehouse in batches. After confirmation, the system will split the undelivered items into new warehouse orders. We will notify you via email after the split is successful. Thank you!',
  'yEzifq': 'Number of split orders',
  'LAufzk': 'Need to confirm with me',
  '7ZddkT': 'Order Reference No',
  'Zmhygi': 'Enter the unique order ID from your company\'s order management system. This number may be used for account reconciliation tracking or internal control purposes.',
  'pcXfwX': 'Add supplementary identifiers required for your order processing, such as buyer\'s Purchase Order (PO) number or platform order ID. This reference primarily facilitates buyer support service or platform sourcing verification.',
  'IpNHiJ': 'Please first select the warehouse for sub-order outbound.',
  'GaGT99': 'Enter the order number from your order management system. For reconciliation tracking or company\'s internal management.',
  'y65Bht': 'Enter an associated reference number (e.g., Purchase Order No., platform-specific order number) for order matching or platform source tracing.',
  '+9aDJv': '<bold>Label/Indicator Definition:</bold>{break}SKU Temperature: The outbound quantity of this SKU in the past 30 days as of the selected date: High temperature >= 600, 600 > Medium temperature >= 100, 100 > Low temperature >= 3, Slow - moving < 3;{break}DOI: The average daily inventory quantity of this SKU in the past 30 days as of the selected date divided by the average daily sales quantity in the past 30 days as of the selected date;{break}Average Daily Inventory: The average daily inventory data of this SKU in the past 30 days as of the selected date;',
  '4gr3Fd': 'Over 180 days',
  '9kZp/B': 'Proportion of Tier',
  'AthNL5': '21-30 days',
  'B/fJkw': 'Data Update:{dateTime}',
  'BIsCsJ': '60-180 days',
  'EdFJ9X': 'Average Daily Inventory',
  'FNUvro': 'Date',
  'FRe/ki': 'Temperature DOI Matrix',
  'HyhSJn': 'Proportion of Average Daily Inventory',
  'K9l7PE': '7-14 days',
  'KWGy2X': '14-21 days',
  'PttrTD': '0-7 days',
  'YDZXyV': 'Medium Temperature',
  'ZM8is8': 'High Temperature',
  'f+39n8': 'DOI Tier',
  'kXNxl6': 'Total of Tier',
  'lG0CFz': 'Low Temperature',
  'nxyIG4': 'No Sales',
  'onzGxg': '30-60 days',
  'tg2hRM': 'Commodity Turnover Detail Data:<a1>Export</a1>',
  'wkMrVA': 'Slow - moving',
  'NwQeEI': 'Reasonable Stocking Cycle: It can effectively avoid the risks of stockouts or unsold inventory. Generally speaking, the higher the proportion of this tier, the better the overall health of the stocking process.',
  'WZ7oqy': 'Reasonable Stocking Cycle',
  'aKmWey': 'Poor Stocking Cycle',
  'az4jNg': 'Poor Stocking Cycle: In a situation where overall sales are sluggish, a relatively large amount of inventory is prepared, which can easily lead to overstocking of goods and is not conducive to capital turnover.',
  'oKpe5k': 'Optimal Stocking Cycle',
  'qgmxrj': 'Optimal Stocking Cycle: On the basis of reasonable stocking, when sales volume is in the high/medium range with rapid inventory turnover, it comprehensively reduces supply chain costs.',
  '15bR6/': '<head>Dear customer :</head><body>The main provider of supply chain services for Winit will be changed to a new entity name at 0:00 on October 1st. You need to sign the "New Supply Chain Management Service Agreement", "New Supplemental Agreementon Commercial Terms for Overseas Warehousing", and "Tripartite Transfer Agreement" with the new entity. The original agreement will expire on September 30th, and the newly signed agreement will take effect on October 1st. This update requires you to read and confirm the new version of the agreement before October 1st, otherwise it will affect your order.</body><footer>Thank you for your understanding and cooperation. Wishing you continued success in your business endeavors.～</footer>',
  'BiB45X': 'Please read and agree to the terms and conditions',
  'IbreHe': 'I hereby acknowledge that I have read, understood, and agreed to',
  'f9W2lq': 'I hereby acknowledge that I have read, understood, and agreed to <a1>《New Supply Chain Management Service Agreement》</a1><a2>《New Supplemental Agreementon Commercial Terms for Overseas Warehousing》</a2><a3>《Tripartite Transfer Agreement》</a3>',
  'voly0E': 'Agreement Update Notice',
  '+AV6Zf': 'Import third-party package barcodes',
  '0+nnZ/': 'The system will select the corresponding preference by default when you place an order;',
  '4eMQBe': 'If you import third-party package barcodes, you can use the imported third-party barcodes when inspecting the goods!',
  '8Wz3p+': 'Please add the product first! ',
  'DE6Al9': 'Inspection Selection Preference',
  'EgNZ25': 'Customer Self-Inspection Order Inspection Preference',
  'PPu6KQ': 'Order Default Selection: Whether to Specify Packing Details = No (New Self-Inspection)',
  'TdHsZ4': 'If you select "Whether to Specify Packing Details" = Yes, the system will automatically select the corresponding preference when you place an order;',
  'W1pRlN': 'Third-Party Package Barcode Information',
  'XIbJH2': 'When you place an API order, the system will default the value of the "Whether to Specify Packing Details" field based on your preference. If you select "Whether to Specify Packing Details" = No (New Self-Inspection), the system will automatically ignore the package details data passed in the API parameter and create the incoming order as if the packing details were not specified (New Self-Inspection);',
  'c1AyPu': 'When you place an API order, the system will assign a default value to the "Exempt from Inspection" field based on your preferences.',
  'eNhwBJ': 'Default order setting: Specify packing details = Yes (Original self-inspection)',
  'elKxGq': 'Edit third-party package barcodes',
  'fT/446': 'Upload third-party package barcodes',
  'hswgDD': 'Wanyi Lian Order',
  's7F86i': 'Specify packing details',
  'yGdlFl': 'Uploading third-party package barcodes is incremental; previously imported third-party package barcodes will not be deleted.',
  '7Su32t': 'Is a receipt issued',
  '+6z4NM': 'Box volume',
  '/j1Nes': 'Please select at least one allowed packing rule before saving.',
  '/lZTGu': 'Box Specifications',
  '/mnsQ1': 'Exceeds the maximum limit of {maxNum}cm, please modify it. ',
  '0GUSD4': '<strong>Side placement:</strong> Place with the second largest face downward (<a>Diagram</a>)',
  '1Rn687': 'Please first select a packing plan. ',
  '1hq6tu': 'Please check the box if you need to add packaging materials. ',
  '2jDOKC': 'Do you want to "Restore Recommended Plan"? Click "Yes" and the "Packing Result" will be cleared. ',
  '3mQBqU': 'Exceeding the pallet width limit',
  '4OPpGF': 'Palletizing Strategy',
  '4R+53J': 'Upload Matching Relationship Between Labels and Pallets',
  '4T3c5t': 'Carton Material Type',
  '4Vwdwu': 'Width Limit',
  '5AH58r': 'Quantity',
  '5cHCdK': 'Allowed Pallet Names',
  '5xJdbe': 'View Packing Rule Diagrams',
  '6cfIFr': 'Restore Recommended Plan',
  '7m0Fxg': 'Total Quantity (Cartons)',
  '7unEPz': 'Pallet Placement Tips',
  '8KpJnl': 'Main Carton',
  '8WiHte': 'Full carton outbound; additional packaging cannot be modified',
  '8iPloa': 'The width limit must be greater than or equal to the pallet\'s own width. Please re-enter.',
  '8kjA/n': 'Only single file upload is supported. Ensure the label order in the file matches the order in the packing list. Winit will apply labels in this order.',
  'AW3QJJ': 'After modification, the selected packing strategy will be cleared and needs to be reselected. Confirm modification?',
  'AaEbak': 'All strictly single SKU and single item per carton',
  'BAxU7U': 'The packing quantity you entered {packedCount} has exceeded the remaining unboxed SKU quantity {qty}. Please modify it.',
  'BB+JEa': 'Not satisfied, re-edit the plan',
  'Bqf6pC': 'Placement Method',
  'CY12bb': 'Only numbers greater than 0 are allowed. Maximum 8 digits for integer part and 2 digits for decimal part.',
  'DTz1y6': 'Limited Length * Width * Height',
  'DWBvxe': 'Enter packing information for a single product directly. Suitable for adding a small number of products at a time, supporting up to 10 products and no more than 5 cartons.',
  'EBTivJ': 'At least one of the pallet length limit excess (cm) or pallet width limit excess (cm) must be entered.',
  'EHymsE': 'Pallet Dimensions (Length * Width * Height cm)',
  'F/duGx': 'You have modified the products in the order. You need to reselect the packing strategy and value-added services. Confirm if changes are needed?',
  'FG3A/U': 'Do you want to "Re-edit Plan"? Click "Yes" and the "Palletizing Result" will be cleared.',
  'FQY5Zq': 'Enter Directly',
  'FSGPan': 'Side Placement',
  'GB20/S': 'Own Dimensions',
  'H+V3eT': 'Length Limit',
  'HQr2z9': 'Packing Details Template',
  'HtD9n3': 'Number of Carton Groups',
  'IXlNF8': '<font>Explanation of Package Types:</font>{break} <span>A+ Package: One SKU and one single item per carton</span>{break} <span>A Package: One SKU and multiple items per carton</span>{break} <span>B/C Package: Multiple SKUs and multiple items per carton</span>{break} {break} <font>Rules for Dimension Input:</font> Length = longest side, Width = second longest side, Height = shortest side',
  'IcGteJ': 'Packing Details',
  'IqBDoI': 'Quantity in Last Carton (pieces)',
  'JDV8nN': 'Is Default Rule',
  'JGOafx': 'Packed Quantity / Estimated Outbound Quantity',
  'JHgOt4': 'After selecting this packing plan, the charge amount and packing dimensions for the final-mile products have changed. Confirm if you want to view the changes?',
  'JvuaYt': 'No identical carton specifications',
  'KlgHAC': 'Outbound Packing/Palletizing Rules',
  'KqvuBs': 'View Palletizing Rule Diagrams',
  'LGc441': 'Pallet Details Template',
  'LMIuHR': 'Carton Group Number',
  'MC/oat': 'A maximum of {x} cartons can be added. To add more cartons, please select "Bulk Upload" to specify packing.',
  'MafQMV': 'Total Weight',
  'My6AUf': 'Loading Rate: {loadingRate}  Standard Carton Quantity: {qty} pcs/carton  Number of Cartons: {packageCount}  Last Carton Packaging Rule: {sectionPackagingSpecification}  Quantity in Last Carton: {sectionPackagingQty}',
  'NEFb2o': 'Weight Limit',
  'NZY0A1': 'Palletizing Dimension Limit',
  'Nw033A': 'Over-Pallet Dimensions',
  'P7aoMp': 'Designated Method',
  'PObaEM': 'When the dimension of any single item on a pallet exceeds the standard pallet dimension limit, palletizing shall be carried out according to the over-pallet limit.',
  'PoKQTB': 'After modification, the selected packing strategy and value-added services will be cleared and need to be reselected. Confirm modification?',
  'PtqCMz': 'Main Carton Specification',
  'PvQePz': 'Palletizing Result',
  'QHTjm4': 'Carton Type',
  'Qab4ip': '<strong>Flat placement:</strong> Place with the largest face downward (<a>Diagram</a>)',
  'SAbxQP': 'The default packing rules set here: when you select "Intelligent Recommendation for Packing" as the packing strategy when placing an order, the system will automatically select your preset default rules. There is no need to manually select them repeatedly, making the packing settings more efficient and convenient~',
  'SPdvq8': 'After selecting this packing plan, the currently selected WINIT product [{winitProductName}] is unavailable. The reason for unavailability: {errorMsg}. Moreover, there are no other available WINIT products. You can choose "Not satisfied, re-edit the plan"; after selection, the system will clear the packing results and the selected value-added services.',
  'U9NZ3C': 'You have modified the products in the order and need to reselect the packing strategy. Please confirm if changes are needed?',
  'VkIinq': 'Specified Packing Instructions: Packing operations follow the principle of prioritizing original cartons/product cartons for outbound. That is, if there are original cartons, they will be shipped out as the original cartons at the time of storage by default; if there are no original cartons, the packing rules of the platform warehouse will be followed.',
  'VmZF4A': 'Do you want to "Re-edit Plan"? Click "Yes" and the "Packing Result" will be cleared.',
  'W6iRgO': 'Bulk Specify Carton Specifications',
  'Wj97H8': 'Carton Weight',
  'WtCeVq': 'Select Packaging Materials',
  'X5GPMQ': 'The pallet length limit excess (cm) must be greater than the pallet\'s own length.',
  'YLdm+E': '<strong>Vertical placement:</strong> Place with the smallest face downward (<a>Diagram</a>)',
  'Ywtwbb': 'Pallet Number',
  'Z1Q2tF': 'Palletizing Group Number',
  'a1DFj6': 'The pallet width limit excess (cm) must be greater than the pallet\'s own width.',
  'aWPqMM': 'Total Number of Products (pieces)',
  'ahq67k': '{qty} pieces/carton',
  'ceEBzP': 'Modify Outbound Packing Restrictions',
  'cpRIqR': 'Add Packaging Materials',
  'dJty45': 'Select This Plan',
  'dVps5P': 'Palletizing Rule Diagrams',
  'f8UsQV': 'Packing Strategy',
  'fFccZQ': 'Add Carton',
  'fJxmVT': 'After modification, the selected value-added services will be cleared and need to be reselected. Please confirm modification?',
  'foCa09': 'Loading Rate',
  'gG/y9A': 'Not satisfied, re-edit the plan',
  'gZUjRC': 'Total Palletizing Quantity (pallets)',
  'gb2p8v': 'Pallet Weight',
  'hlxpPC': 'Total Volume',
  'i6zAH3': 'Standard Carton Quantity',
  'iB17zU': 'Packing Rule Diagrams',
  'iWyx6Q': 'Vertical Placement',
  'j77Gcv': 'Learn About Palletizing Strategy',
  'jILrrg': 'Loading Rate: {loadingRate}  Standard Carton Quantity: {qty} pieces/carton  Number of Cartons: {packageCount}',
  'jcohPw': 'Warehouse Repacks After Unpacking',
  'kTw4K8': 'You have modified the products in the order and need to reselect value-added services. Please confirm if changes are needed?',
  'lJtJ5S': 'Packing Plan',
  'lcA2Az': 'Re-adjust the Ordered SKUs',
  'nd8exK': 'Please set the default rule before saving.',
  'ngJ7SC': 'Direct Mixed Carton',
  'np++Iy': 'Palletizing Rules',
  'nxU6/z': 'Select Other WINIT Products',
  'o7U57u': 'Exceeding Pallet Length Limit',
  'p15MmV': 'Number of Cartons',
  'pHZsHe': 'Click to download <a>Packing Details Template</a>',
  'pJZPl3': 'Number of Loose Items (pieces)',
  'pvQHbv': 'The dimensions of the following products have exceeded the standard pallet size limit. Please select an appropriate placement method to optimize pallet space utilization.',
  'qo/H5E': 'Total Number of Cartons',
  'qyLPwx': 'Full carton outbound; quantity cannot be modified',
  'rJ+S+3': 'Packing Result',
  'rJ61OE': 'Warehouse staff will select appropriate package types and materials for palletizing based on actual factors such as product characteristics, volume weight, and transportation requirements. You can view the sub-order details later～',
  'rJbKfQ': 'Pallet Label Number',
  'rKbymg': 'Multi-SKU Mixed Packing Allowed: Based on the principle of optimal loading rate, B/C packages may be directly used for packing',
  's7iQpX': 'Flat Placement',
  'sHIbFj': 'The current palletizing result is empty. Please confirm the palletizing plan first～',
  'smFqf1': 'Allowed Packing Rules',
  't5KPFV': 'After selecting this packing plan, the currently selected WINIT product [{winitProductName}] is unavailable. Reason for unavailability: {errorMsg}. You can choose "Not satisfied, re-edit the plan" or select another WINIT product.',
  'tYs+0n': 'Click to download <a>Palletizing Rule Template</a>',
  'uAFTOr': 'Upload packing information for multiple products at once using an Excel template. Suitable for adding large quantities of products, supporting up to X SKUs at a time.',
  'uGh3tO': '[Intelligent Mixed Palletizing, Optimal Loading Function Description]{break} Provides an intelligent loading solution for mixed palletizing of multi-specification cartons, accurately adapting to the full loading needs of a single pallet. It simultaneously meets palletizing standards such as weight-bearing restrictions and stacking specifications, maximizing space utilization and satisfying transportation safety requirements.',
  'uMiwst': 'Loose Item Packing',
  'ud70DH': 'The packing quantity you entered {packedCount} is less than the number of unboxed SKU items {qty}. Please modify it.',
  'ukE51P': 'Last Carton Specification',
  'vKlKqA': 'Palletizing Restrictions',
  'w90uU5': 'Learn About Packing Strategy',
  'wLwT6c': 'All Pallet Labels Are the Same',
  'wUpUxY': 'Pack Directly as Loose Items',
  'wVvPMS': 'Bulk Upload',
  'wtq3Zr': 'To ensure smooth quotation and warehouse delivery appointment, please provide the FBA Reference No.',
  'xZpDye': 'Confirm This Packing Plan',
  'yKH7Zh': 'Pallet Labels Are Different',
  'ysCLVn': 'Pallet Volume',
  'ywBj4W': 'Carton Group Number / Carton Number',
  'z+MzSE': 'The length limit must be greater than or equal to the pallet\'s own length. Please re-enter.',
  'z/ofGG': 'The current packing result is empty. Please confirm the packing plan first～',
  'zfLCAh': 'All Single SKU and Single Item per Pallet',
  "+5bHd/": "One document upload for express waybill and package label",
  "0eBJCK": "Total number of boxes",
  "39gwem": "Package volume",
  "3WcfMz": "First tracking number",
  "3WwE4J": "Changing WINIT product information will trigger recalculation of packing. Confirm to continue?",
  "49fRpD": "Processing stage",
  "4MSrUM": "License plate number",
  "4Po5zN": "You can independently specify packages that need to be combined for palletizing to achieve precise personalized requirements.",
  "4g9jXw": "Warehouse personnel flexibly select packaging materials and packing methods based on product characteristics and transportation requirements.<span>Important note: By choosing this strategy, you authorize and agree to accept the final actual packing results from the warehouse.</span>",
  "5e8lgk": "Value-added service status",
  "6E6SYp": "Rule type",
  "8T3XtE": "Packages with identical packaging material specifications and completely consistent SKU types and quantities inside the box are considered the same category.",
  "AiBk8V": "This setting determines: when the length and width dimensions of a single item exceed standard pallet specifications, whether palletizing operations are allowed.",
  "C3Xyt8": "Number of boxes",
  "DO+dHk": "Own dimensions and weight",
  "Harof5": "You can independently select specific SKUs and quantities and load them into designated boxes to achieve precise personalized packing requirements.",
  "IIPa06": "Value-added orders pending confirmation",
  "Im+u+J": "Your current order contains a large number of individual items, causing the system packing calculation to timeout. To ensure rapid order processing, we recommend adjusting in the following ways: {break} 1. Split order: It is recommended to keep the number of individual items per order within 500. After splitting, new orders can be submitted separately. {break} 2. Adjust packing strategy: Choose the 'Warehouse Autonomous Packing' option, allowing the warehouse to complete packing efficiently based on actual inventory and packaging rules. {break} Thank you for your understanding and cooperation. You can submit the order after completing the adjustments.",
  "LWh2KY": "Pickup code",
  "MZoc4B": "Scheduled pickup time (local)",
  "QsPD6Q": "Package category number/Box number",
  "XTlijw": "Please select a palletizing solution first",
  "ZT1G1j": "Prompt: Packing calculation exceeded limit",
  "b0twXr": "Package category number",
  "cWxKfh": "All shipped out as A+ packages or case products",
  "eOA2gX": "The system automatically calculates the optimal pallet loading through algorithms to help you save space and reduce transportation costs.",
  "eQ4gDr": "Original box",
  "eeQgv3": "Outbound packing and palletizing rules",
  "eno/75": "No master carton specification",
  "fSzvk1": "Specified packaging materials",
  "kCzdh3": "Max limit length*width*height",
  "kTJOj4": "Changing WINIT product information will trigger recalculation of packing and clear selected value-added services. Confirm to continue?",
  "lGBTLd": "The system automatically calculates and recommends the optimal loading and most efficient packing specifications through algorithms, effectively improving space utilization.",
  "lZ/nB8": "Self-pickup type",
  "m5n5nA": "Actual pickup time (local)",
  "mDGWSk": "Your selected packing has been updated, and the corresponding handling fees, final leg shipping costs, and package chargeable weights have changed. Confirm to view details immediately?",
  "oIxJPB": "Choosing [One document upload for express waybill and package label] requires you to submit shipping information on Amazon according to the package sequence in the Winit packing list. Ensure the document contains alternating pages of package labels and express waybills, with the overall sequence matching the package order in the packing list. Winit will label according to this sequence.",
  "rpoODb": "Supplement after obtaining waybill",
  "rsm2O2": "Warehouse personnel perform palletizing flexibly based on sku characteristics and transportation requirements.<span>Important note: By choosing this strategy, you authorize and agree to accept the final actual palletizing results from the warehouse.</span>",
  "tIqy1V": "Self-pickup outbound orders",
  "uy8FVi": "Pending orders",
  "x1OCBv": "Supplementary document submission should ONLY commence once the final-mile shipping label is obtained.",
  "xuHdu0": "Standard outbound orders",
  "y7/5dq": "Loose items mixed packing mode",
  "yTOUwm": "Packing operations follow the '<span>priority outbound</span>' principle for 'case products/original boxes'. That is, the original boxes from when goods were received will be the preferred method for outbound shipping; if there are no original boxes, items will be repacked as loose pieces for outbound.",
  "yovoCg": "Skus are mixed and packed as individual pieces,compressing package volume to maximize shipping cost savings.",
  'DzkvrI': 'As commercial documents require carrier tracking number input, this process MUST await final-mile label acquisition from the provider.',
  '+UD0Nm': 'When closed, sub accounts are not allowed to access overseas data (outbound order receiving information/return section/claim inquiry section), but are allowed to view when opened.',
  'hxaUQ3': 'Cannot View Private Data',
  'ufuU7X': 'Can View Private Data',
  '/g7pR0': 'Or',
  '1VgmNe': 'Expression error',
  '22mHbq': 'Left bracket',
  '2ipN6G': 'DG label',
  '3urC7v': 'Item',
  '4eaeMn': 'Relationship',
  'BJg14B': 'Format error, please enter 0 or a positive integer',
  'ByhhM1': 'Condition',
  'CoKJg6': 'Enable clearing DG label preference',
  'CskvE/': 'Battery energy (watt-hours of battery pack or cell) (W)',
  'FkUlFv': 'Is the SKU identifier for last-mile air freight DG?',
  'HE8gpc': 'Winit label',
  'Iuq4N7': 'Should the overlay tag be automatically issued upon order placement?',
  'KYlUTy': 'Logical description for issuing the DG tag clearing feature by default upon receipt of incoming orders',
  'O+0Baa': 'If enabled, the DG tag will be automatically cleared upon receipt',
  'PYQhmH': 'Right bracket',
  'QhGPUl': 'Is the SKU identified as DG for final land transport?',
  'TIycpl': 'Battery packaging method',
  'U8IB+K': 'Value-added image',
  'XCFG+v': 'Does the order for Class A packages meet maintenance preferences?',
  'h624iv': 'Inbound value-added preferences',
  'kNbdh7': 'And',
  'rlpMbP': 'Non-DE',
  'ygrz65': 'Enable the DG tag clearing feature',
  'zbqD5q': 'Value',
  'WJOgVN': 'Overseas warehouse weight',
  'hw6hrK': 'Whether to automatically issue coverage label value-added',
  'mNZYcD': 'Do A+/A packages meet the first-leg DG label preference',
  'J9gDP9': 'Batch Register',
  'y29eMI': 'Register SKU',
  "252JpO": "Pending Restock",
  "M+WRRO": "SKU Exception Hold",
  "Pe6Wwv": "Sales Restricted",
  "jCdXSN": "Loss Under Investigation",
  '+I/eds': 'Reason for Sales Restriction',
  'rrtjDg': 'This account currently does not have a global shared inventory auto-split strategy configured. To prevent potential delays in future order fulfillment, it is recommended to configure the global shared inventory auto-split strategy. {a} configure',
  'tPBhkV': 'Sales Restricted Details',
  'Lpj+2t': 'This strategy is designed to prevent delays in order processing speed caused by unpacking and splitting cases during the outbound fulfillment stage due to insufficient quantity of a single product. Winit will proactively adjust inventory based on the auto-split strategy. If the global shared inventory auto-split strategy is not configured, in-warehouse splitting will not be performed in advance and will only be triggered during the outbound process.',
  'N6olth': 'Non-Compliant Sales Restricted',
  'rHWBj4': 'Sales-restricted inventory only supports pickup or disposal outbound processes; standard shipping is not supported.',
  'uKmlLO': 'Standard Inbound',
  'yg35yu': 'Pending Restock Inventory Details',
  'W0H3/3': 'Currently, only eBay, Temu, AliExpress, Shopify, and Shein platforms support rule configuration. Other platforms will be added soon, so stay tuned!',
  'g7NT9e': 'The token is not currently being used by {platform}. Please bind and authorize the platform promptly (you must use your current region account to log in).',
  'LTnlBS': 'The default pallet set here will be automatically selected by the system when you place an order (whether via API order or Website order). There is no need to manually select it repeatedly, making the order placement process more efficient and convenient~',
  'vfW36f': 'Please set the default pallet before saving.',
  'vjX//o': 'Default pallet',
  '5dZCxH': 'Warehouse staff will flexibly select packaging materials and packing methods based on sku characteristics and transportation requirements. Specific packing results can be viewed later in the sub-order details. {break}<span>Important note: If you choose this strategy, it means you authorize and agree to the final actual packing results determined by the warehouse.</span>',
  'Ma+ddR': 'Use an Excel template to upload packing information for multiple sku at once. Suitable for adding large quantities of sku, supporting up to {qty} SKUs per upload.',
  'fcN9C6': 'Please note: Mixed SKU packing is allowed, and boxes will be packed according to the optimal loading rate principle. Therefore, each box may contain multiple SKUs.',
  'tKqXle': 'Warehouse staff will flexibly perform palletizing based on product characteristics and transportation requirements. Specific palletizing results can be viewed later in the sub-order details. {break}<span>Important note: If you choose this strategy, it means you authorize and agree to the final actual palletizing results determined by the warehouse.</span>',
  'vEvtsT': 'Calculate Packing Results',
  '1kbSYq': 'Bill of Lading Document',
  '6MBNUQ': 'Bill of Lading Number',
  '7rNHUy': 'Container Pickup Application',
  'BvS8ua': 'Import only supports {accept} format files',
  'I2c7n+': 'DO File',
  'YMvE9K': 'Actual Return Time (Local)',
  'YR/KBR': 'View First-Mile Logistics Tracking',
  'ds+/g8': 'Change Container Number',
  'gqELkK': 'Estimated Time of Arrival',
  'jgq+/y': 'Container Pickup Information',
  'rQUakN': 'No logistics records found yet! ',
  'zbDuSi': 'Please fill in English letters + numbers',
  '+AkvtB': '#Accessories',
  'f4cDDj': '0% fee (limited time), instant credit',
  'is0zpP': 'No Airwallex account? ',
  '+RCnrG': 'Item Title',
  '/w6yVJ': 'Please select a time range',
  'BKJUwf': 'Hello, Winit has completed integration with Amazon MSF!{break}{break}Step 1: Please read the authorization agreement and agree to the authorization to obtain information.{break}Step 2: Authorize your Amazon platform store account.{break}{break}After completion, the platform will obtain your overseas warehouse information and push order and product inventory information.',
  'BObRVR': 'orderPlacedTime',
  'ImbJHn': 'lastUpdatedDateTime',
  'SWbb1G': 'The shipping warehouse is inconsistent, so batch shipping is unavailable. Please reselect the order.',
  'SwNQnT': 'Tips:{break}1. Once authorized, stores will automatically synchronize Amazon-MSF orders and synchronize product inventory.{break}2. Please do not ship Amazon-MSF orders through other methods to avoid duplicate shipments.',
  'V8FkeQ': 'creationDateTime',
  'VgausN': 'Only pending/failed order operations',
  'birAPV': 'buyerOrderId',
  'jqXs1M': 'channelName',
  'qDEUjP': 'Currently only supports rule configuration for eBay, Temu, AliExpress, Shopify, and AmazonMSF platforms. Other platforms will be added soon, so stay tuned!',
  'qVGRIE': 'Quantity',
  'qgWzlQ': 'locationId',
  'rQQzl2': 'shipmentLineltem Id',
  '+V514J': 'Are you sure you want to cancel the shipment? {break}Once the order is cancelled, it cannot be withdrawn or shipped again. Please confirm the order cancellation with the buyer, otherwise it may cause customer complaints.',
  'BfSxzs': 'Currently, only eBay, Temu, AliExpress, Shopify, Shein, and AmazonMSF platforms support rule configuration. Other platforms will be added soon, so stay tuned!',
  'BkMWxm': 'locationId',
  'oAQLO/': 'Packing List',
  'tDw37u': 'buyerOrderId',
  '2PgHwF': 'Product {platformItemSku} has not been added with synchronization rules',
  "BniMG4": "Upload Subsidy Requirements Corresponding to Package Numbers",
  "ENYSkf": "Different Requirements for Different Orders",
  "GyW4tb": "Same Requirements for All Orders",
  "I9WLTQ": "Expected Delivery Time",
  "LgA4cL": "Cargo Aircraft Only",
  "Ll79cT": "Import Only Supports XLSX Files",
  "OKmTEL": "Same Requirements for All Packages",
  "T3q6qf": "Import Template",
  "a0ONXZ": "Lithium Battery Restrictions - Prohibited for Air/Sea Shipping",
  "bHi3Ds": "Expected Delivery Time (Local)",
  "eecNUt": "Subsidy Project",
  "k6d0X+": "Batch Import Order Supplementary Information",
  "v0nty8": "Different Requirements for Different Packages",
  "yr4AkT": "UN Label",
  'j1+jO2': 'Upload the subsidy requirements corresponding to the customer order number',
  'Pb7qI/': 'Shared',
  'j8ekmd': 'Original packaging',
  'vt5ccv': 'Not shared',
  'wVMpVn': 'Main express tracking number',
  'H1T87h': 'Extended Settings',
  'aGxRt2': 'Content',
  'yVms9t': 'Settings',
  'HvFvBM': 'Enable API/ERP query to exclude defective inventory?',
  'YLWwb+': 'Disable API/ERP query to exclude defective inventory?',
  'bSNLne': 'Enable API/ERP Query to Exclude Defective Inventory',
  'ti8G4l': 'This configuration applies to scenarios where ERP integration with WINIT inventory queries requires filtering out defective inventory. Note: API integration users can choose whether to exclude defective inventory through API input parameters. If no parameters are passed via API, this function can also be used to enable exclusion.',
  '+YUL4t': 'Automatically create box products when placing API orders',
  'WnKmzk': 'Should shared inventory be enabled for automatically created box products',
  'XTFlnc': 'Enable this preference. When you place an order through the API, the system will automatically convert the ordered A package into a box of products and place the order through A+ package;',
  'K6A7Ay': 'After the current value-added order is cancelled, please select whether you want to continue submitting other value-added services or proceed directly with the outbound process as no additional value-added services are needed.',
  'xbWyo8': 'Continue submitting other value-added services',
  '+KQIYg': 'eBay account authorization successful',
  '+g5Odt': 'Submitted {successCount} items successfully. Please wait for processing results {break}',
  '+sOaux': 'Combined product length*width*height',
  '/5kMiS': 'Please enter an integer of up to 8 digits, with up to 2 decimal places',
  '/VKVEv': 'Enable re-item fee',
  '/eKhN1': 'Long in CM',
  '/ihAwV': 'To be added - not submitted',
  '03OdFd': 'Default inventory settings',
  '0rILia': 'Go to match >',
  '1NBcfx': 'Error',
  '1SepKA': '{countryCode} Enable international service. At least one regions shipping fee and surcharge must be specified',
  '1wOL8F': 'Exception Classification',
  '21qsQv': 'Out of Stock',
  '2B5Uox': 'This eBay account has been bound to the {ebayID} customer and cannot be authorized again for another Winit customer account. If you need a replacement, please contact customer service offline to apply. It is expected to take about three business days.',
  '2M+gaC': 'eBay item ID',
  '2h4etD': 'Authorized',
  '4LO5kZ': 'Preference 2',
  '4bdMX+': 'eBay Logistics Service',
  '5g4L3H': 'Combined Item',
  '6PECwn': 'Combined Item Weight',
  '7PexH5': 'View Authorization List',
  '8FvR5Y': 'eF SKUID',
  '8KPhfG': 'Waiting to be added - Under review',
  '98O571': 'Waiting to be added only - Not submitted yet',
  '9gwy+n': 'Please enter the eBay Custom Label',
  '9ozbDi': 'Outbound order submission date',
  'A/W0Ji': 'Tips: {break}1. Authorization will redirect you to the eBay page. Once authorization is complete, you will automatically be redirected to the Wanyilian page. {break}2. Once authorized, your eF order will be automatically shipped and your eF product inventory will be synchronized. {break}3. Please do not ship eF orders through other methods to avoid duplicate shipments.',
  'AlNl2K': 'Account authorization failed. Please re-authorize.',
  'AxfkAU': 'eBay account authorization failed.',
  'Bzgqgx': 'Winit products are inconsistent. Batch shipping is unavailable. Please reselect your order.',
  'Do/HOL': 'Add',
  'Dtffnt': 'eF abnormal category',
  'Du2hdU': 'Add a combination product',
  'EXXIMD': 'When manually adding/exiting: {break} You need to manually adjust the items addition/exit to eF. {break} When adding, the eBay listing s inventory will be displayed simultaneously with the Winit inventory (all warehouses on the site). {break} When exiting, the eBay listing will display the default inventory. {break} When automatically adding/exiting: {break} Automatically adding and exiting based on the default inventory. {break} When the items inventory > the default inventory, it will automatically add to eF, and the eBay listing will display the Winit inventory (all warehouses on the site). {break} When the item s inventory ≤ the default inventory, it will automatically exit eF, and the eBay listing will display the default inventory.',
  'ElIu9U': 'Domestic Delivery Service Settings',
  'Ere3ru': 'Setting Up eBay eF Service',
  'FcLwLD': 'Maintaining eBay Platform Information',
  'GkAFNd': 'eBay Custom Label',
  'GmBFbl': 'Exit Failed',
  'HTbmwk': 'Width in CM',
  'IckH3i': 'View itemId details',
  'J6Fbmp': 'eBay itemID',
  'JPJyCy': 'Add a new store',
  'JoL+d9': 'Confirm re-authorization?',
  'JyKQRL': 'Note: Batch add/exit operations are only available for products that have already been set up for eF. To set services for a batch of products, please use the batch setting eF function.',
  'Jznt1f': 'Please select a country to set up an eF service.',
  'KJrGS5': 'Cancel authorization',
  'KObBDp': 'Exited',
  'MJ6SAC': 'Join failed',
  'Mlalnn': 'Join/Exit eF settings',
  'Mp4ZYz': 'Join/Exit eF',
  'MzxSsq': 'Set stores for automatic product synchronization',
  'N6j14o': 'Combined product attributes',
  'Npzogu': 'Reference preference data',
  'OATknL': 'Modify product attributes',
  'Oex59+': 'Return to list',
  'P7HTrM': 'Under maintenance review',
  'PvFlx2': 'Product information is complete and waiting to be added to the service',
  'QnQAmD': 'Please select the data',
  'Qw1FMg': 'Import file to join/exit eF',
  'R9ZH2Y': 'Import only supports XLS and XLSX formats. {break} A maximum of 1000 rows of data is supported. If more than 1000 rows are required, please upload them in multiple files.',
  'Rl8xeS': 'Please enter an integer of up to 8 digits and retain up to 3 decimal places.',
  'Rr0WSm': 'Missing Custom Label',
  'TRVT74': 'Note: The US/AU shipping fee settings partition is defined by eBay and is inconsistent with the Winit partition. For details on eBay partitions, please refer to the <a1>EF Operation Manual</a1>',
  'UyqNZt': 'Do you want to combine products?',
  'VQLk5p': 'Hello, Winit has completed the eBay fulfillment certification service! {break}{break}Step 1: Please read the authorization agreement and agree to the authorization to obtain information. {break}Step 2: Authorize your eBay (eF) platform store account. {break}{break}After completing this operation, the platform will obtain your overseas warehouse information and push order and product inventory information.',
  'Wb/9Lq': 'eBay order ID',
  'XH+l/X': 'Site inconsistency, batch delivery is unavailable. Please reselect the order.',
  'XKyH1B': 'Maintenance successful.',
  'XOXZPD': 'Weight in kg',
  'ZR0XRH': 'When the product is removed from eF, I want it to be displayed in the default inventory on the eBay platform. This involves manual and automatic removal, as well as forced removal due to platform restrictions.',
  'ZdrhPk': 'The current product service timeline is lower than the order logistics service. This may result in delivery time not meeting the standard and resulting in compensation. Please choose carefully',
  'Zryluf': 'eBay Fulfillment Service Settings',
  'aRADb+': 'Service Group',
  'bfeRdA': '2. Establish a matching relationship between platform products and WINIT products {a}',
  'bqG/hC': 'eBay Custom Label',
  'byhm83': 'Do you use international delivery?',
  'cA7vYm': 'Hello, Winit has completed the {platformFullName} overseas warehouse certification! {break}{break}Step 1: Please read the authorization agreement and agree to the authorization to obtain information. {break}Step 2: Add Winit account information on the {platform} platform. {break}{break}After the operation is completed, the {platform} platform will obtain your overseas warehouse information and push order and product information.',
  'cKd6w4': 'Maintenance failed',
  'cgxdE6': 'Please select a service group.',
  'dURpJ2': '{qty} items have been selected. Please set up EF service in batches. {break}Note: Batch settings will overwrite historical settings for individual items.',
  'dgf6Kz': 'Submission failed {failedCount} times, reason: {break}{reason}',
  'e+f3fS': 'Check itemID status',
  'eBAL2u': 'Excel modification to join/exit eF',
  'eHWt7e': 'Joined - Exiting',
  'eJt1V9': 'Automatic',
  'eah4XJ': 'Manual',
  'fVg18v': 'High CM',
  'hQOH1X': 'Synchronize product matching',
  'htixct': 'eBay CustomLabel',
  'i03cgN': 'Synchronize store',
  'i4Byyo': 'International delivery service settings',
  'jjVprn': 'eBay Fulfillment Synchronization Settings',
  'jwCzpQ': 'Add Winit Combination Products and Quantities',
  'jxmDpa': 'Import Products',
  'kd2rGf': 'Added',
  'khc+Ia': 'Import successful {successNum}, import failed {failNum}. {break} Failed import data and failure reason <a>Click to download file</a>',
  'knDAam': 'Only supports batch submission of pending-unsubmitted, added, failed to add, added-failed to withdraw, and withdrawn status',
  'kvVJmi': 'eBay account',
  'l82W4w': 'Batch settings',
  'lWeKoR': 'Import successful {successNum}, import failed {failNum}. ',
  'lnrTIe': '1. After authorizing a store, you can perform the following functions: Synchronize Products and Match {a}',
  'ltCWTv': 'Are you sure you want to cancel authorization?',
  'lvAG2S': 'Please enter a maximum of 5 digits, with up to 6 decimal places.',
  'mEKJuC': 'Add to eF Status',
  'mcYu4G': 'After adding a store, you can synchronize matched eBay and Winit products to your current eF product management list. Note: This is a one-time addition only and will not be updated later. If product matching changes, unlisted products can be deleted and synchronized again. Products already listed in EF need to be removed from EF, modified, and then added again.',
  'njpUP6': 'Added - Failed to remove',
  'nofz0U': 'Custom Label duplicate/abnormal',
  'pg+yjf': 'Authorization successful. Please check the authorized account information in the list.',
  'qtqMeN': 'Preference 1',
  'rWR+im': 'Combined product code',
  'soCAd+': 'Preference data is only referenced for the first time. Modifications for the current product are supported. {break} Note: After selecting a preference, if the preference is updated, the current product s EF service data will not be updated synchronously. If a product needs to be updated, please reset the EF and submit it for review. Please check the review results promptly.',
  'tJw7sI': 'Inventory Error',
  'ukoMyS': 'Please enter weight',
  'vE/mGO': 'Maximum length is 10 digits, 2 decimal places',
  'wCa4U0': 'Product pending addition error',
  'xFYQzM': 'Pending addition',
  'xPAc/v': 'Exit',
  'yKQdCq': 'Select delivery service',
  'ywr1LG': 'Item ID',
  'Jlzdr6': '万邑通全场景高效海外仓{break}卖得好、备得少、综合成本就是少',

  'AHodEs': 'SN code collected from the outer box',
  'Y2eiCW': 'Has the value-added service been completed',
  'rurl0x': 'SN code image collected from the outer box',

  '+858kB': 'Average Daily Outbound Quantity',
  '/26ehQ': '分析备货情况，优化备货策略',
  '/J1+nW': '120-180 Days',
  '/dXFkQ': 'Inventory Quantity Proportion',
  '/dcLs3': 'Long-tail Stockout',
  '0zV38F': 'As of the selected date, the average daily inventory data of such SKUs in the past 30 days',
  '1Uct28': 'SKU Detailed Information',
  '2IP64b': 'Stocking Scenario Overview',
  '2JNYh6': 'Label/As of the selected date, calculate the outbound quantity of the SKU in the past 30 days. High temperature ≥ 600, 600 > Medium temperature ≥ 100, 100 > Low temperature ≥ 3, slow-moving < 3',
  '2j7huF': 'Very Poor',
  '34oQh+': 'Inventory Analysis Report',
  '39zJIR': 'Inventory Quantity (Units)',
  '3h1uIj': 'Optimal Stocking for Long-tail',
  '46DklJ': 'Optimal Stocking for Best-selling',
  '4S6nZ2': '7~14 Days',
  '4Y1/MP': 'Inventory Quantity',
  '5WSDbu': 'No data available for the current dimension',
  '5hqTM6': 'Sellable days exceed 90 days, and sales volume in the past 30 days is greater than 100 units',
  '5mq2mp': 'Storage fee of {amount}USD has been incurred in {month}',
  '5rQZjy': 'Sellable days: 14~60 days, and sales volume in the past 30 days is less than 100 units',
  '6TWotd': 'Sellable days: 14~60 days, and sales volume in the past 30 days is greater than 100 units',
  '6Z2+5w': 'All Warehouses',
  '7CajwD': 'Suspected Slow-moving',
  '8DZ3T0': 'Sellable Days: 90-120 Days',
  '8PQ6ib': 'The above data does not include new products, and the total average daily inventory quantity is {sum} units',
  '8R0XTD': 'Summary of average daily inventory quantity of SKUs with sales volume ≥ 600 in the past 30 days - Inventory quantity in this DOI tier',
  '8vXYwp': 'Display the actual average daily inventory quantity of SKUs with different temperature labels under each DOI tier',
  '9ZdkeY': 'Total inventory quantity of all temperature labels in this DOI tier',
  '9bSO34': 'Severely Slow-moving',
  '9bZ7dW': 'Display the inventory proportion of SKUs with different temperature labels under each DOI tier',
  'AoPi1s': '60~90 Days',
  'CgmpGr': 'Sellable days exceed 90 days, and sales volume in the past 30 days is in the range of 3~100 units',
  'Evsugq': 'Quality Benchmark',
  'G4q89I': 'Click to view details of suspected slow-moving SKUs',
  'GbVzIC': 'Sellable Days: 7-14 Days | Replenishment Scenario: Suitable for Air Transport',
  'GkdN8K': '{countryCode}-{warehouseCode}-Average Daily Inventory Quantity Analysis Table',
  'I/0jhD': '14~30 Days',
  'ICVSdt': 'Click to view details of severely slow-moving SKUs',
  'IY3rSF': '{countryCode}-{warehouseCode}-Average Daily Inventory Proportion Analysis Table',
  'JGXefD': 'Click to view details of long-tail stockout SKUs',
  'JXxGYT': 'Total inventory quantity proportion of all temperature labels in this DOI tier',
  'K7Y7hZ': 'The proportion of the total inventory of SKUs with a certain temperature label in this DOI tier to the total inventory of all SKUs of the customer',
  'Kc3Byd': 'Average Daily Outbound Quantity of the SKU',
  'L4kgwc': 'Stocking Scenario',
  'LsPFcF': 'Summary of average daily inventory quantity of SKUs with sales volume of 100-599 in the past 30 days - Inventory quantity proportion in this DOI tier',
  'MoU1SM': 'Click the cell to view the specific scenario definition',
  'NCEBh6': 'Inventory Health Scenario Analysis',
  'NINLUY': 'Sellable days: 60~90 days, regardless of sales volume in the past 30 days, covering best-selling/long-tail products',
  'NLDJt+': 'Click to view last months data',
  'Opb6fg': 'Feature',
  'PZSxPC': 'Sellable Days: More than 180 Days | Replenishment Scenario: Slow-moving situation has occurred, need to digest inventory',
  'Pp7hrx': 'Summary of average daily inventory quantity of SKUs with sales volume of 3-99 in the past 30 days - Inventory quantity in this DOI tier',
  'RWHlVK': 'Label/Indicator Definition',
  'S01oYn': 'Average Daily Inventory Quantity Proportion',
  'TgIPS8': 'Inventory Quantity Proportion',
  'Tkmxf1': 'The proportion of the total inventory of all SKUs in this DOI tier to the total inventory of all SKUs of the customer (reflecting the inventory weight of the DOI tier)',
  'TyBqOs': 'Export Commodity Turnover Detailed D ata',
  'U8oHOq': 'Sellable days are less than 14 days, and sales volume in the past 30 days is greater than 100 units',
  'aK+HmM': 'This months inventory health rating is Excellent. The inventory turnover efficiency is in the best state, and the warehousing resources and working capital are fully utilized. It is recommended to maintain the existing refined inventory management strategy, and focus on investing resources to optimize the stocking rhythm of best-selling products to further improve the overall operational efficiency.',
  'aXAH1x': 'This Brand',
  'b0/WDq': 'Reasonable Stocking',
  'bpytH2': '0~7 Days',
  'c+Ctye': 'Inventory Proportion',
  'dhFvnz': 'Excessive Stocking',
  'e652NE': 'Sellable Days: 30-60 Days | Replenishment Scenario: Suitable for Regular Shipping',
  'f8aEjy': 'As of the selected date, calculate the average daily inventory quantity of the SKU in the past 30 days / average daily sales quantity in the past 30 days',
  'fjhs9t': 'SKU Name (Commodity Name)',
  'fw5J/X': 'Judge the stocking scenario category of the SKU according to the DOI tier and SKU temperature',
  'gScA5O': 'Sellable Days: 0-7 Days | Replenishment Scenario: Difficult to Replenish in Time',
  'j3IhHx': 'This months inventory health rating is very poor. Slow-moving inventory has seriously occupied core warehousing resources and a large amount of working capital, and may lead to the squeeze of inventory space for best-selling products, directly affecting the overall inventory turnover rate and profit efficiency. It is recommended to digest the inventory as soon as possible',
  'j7q9fm': 'Summary of average daily inventory quantity of SKUs with sales volume < 3 in the past 30 days - Inventory quantity proportion in this DOI tier',
  'jaUYvO': 'Best-selling Stockout',
  'jpnytt': 'Ultra-low Temperature',
  'kp1/ug': 'Good',
  'nHh1If': 'Excellent',
  'nZCtyB': 'This months inventory health rating is Good. The existing slow-moving inventory is controlled within a reasonable range. It is recommended to continue to maintain the current inventory management strategy and focus on the replenishment rhythm of best-selling products.',
  'nwrCxp': 'This months inventory health rating',
  'oybLIK': '90-120 Days',
  'pCZBqi': 'Click to view details of best-selling stockout SKUs',
  'py2OYq': 'SKU Temperature',
  'qjEp5a': 'Average Daily Inventory Quantity',
  'qoGZJH': 'Sellable Days: 14-30 Days | Replenishment Scenario: Suitable for Express Shipping',
  'r/mys+': 'Sellable Days: 14-30 Days | Replenishment Scenario: Suitable for Express Shipping',
  'rfWEbZ': 'Summary of average daily inventory quantity of SKUs with sales volume of 3-99 in the past 30 days - Inventory quantity proportion in this DOI tier',
  'rv2S54': 'Total inventory of SKUs with a certain temperature label in this DOI tier (directly summarize the inventory of the same group)',
  'sJ8cBQ': 'Sellable Days: 60-90 Days',
  'sS7wyq': 'No sales volume of such SKUs in the past 30 days, unable to calculate DOI, counted separately',
  'sTsns5': 'This months inventory health rating is Poor. Slow-moving inventory has occupied part of the warehousing resources. It is recommended to give priority to investigating high-inventory slow-moving SKUs, and accelerate digestion through promotional activities, inventory transfer and other methods to reduce capital occupation.',
  'sXUdP8': 'Poor',
  'st5qfR': 'WINIT Fulfillment Report - {month} Inventory Analysis Report',
  'tEXOrZ': 'Summary of average daily inventory quantity of SKUs with sales volume < 3 in the past 30 days - Inventory quantity in this DOI tier',
  'v2LNfY': 'Sellable days are less than 14 days, and sales volume in the past 30 days is less than 100 units',
  'wUEfqW': 'Average Daily Inventory Quantity of the SKU',
  'xGV2rF': 'Sellable Days: 120-180 Days',
  'xfrc9e': 'Sellable days exceed 90 days, and sales volume in the past 30 days is less than 3 units',
  'xpNOm9': 'Temperature-DOI Matrix',
  'yH0TiS': 'Summary of average daily inventory quantity of SKUs with sales volume ≥ 600 in the past 30 days - Inventory quantity proportion in this DOI tier',
  'zvoAIf': '30~60 Days',
  'BHOXG6': 'Sellable time exceeds 90 days, and display detailed information of SKUs with sales volume in the range of 3~100 units in the past 30 days, including inventory and outbound status (sorted in descending order of the ratio of average daily outbound quantity to average daily inventory quantity of each SKU)',
  'CB0FTm': 'This months inventory health rating is Poor. Slow-moving inventory has occupied part of the warehousing resources. It is recommended to give priority to investigating high-inventory slow-moving SKUs, and accelerate digestion through promotional activities, inventory transfer and other methods to reduce capital occupation.',
  'SyF7YC': 'Category benchmark (Comprehensive Retail)',
  'jsPyiB': 'This months inventory health rating is Excellent. The inventory turnover efficiency is in the best state, and the warehousing resources and working capital are fully utilized. It is recommended to maintain the existing refined inventory management strategy, and focus on investing resources to optimize the stocking rhythm of best-selling products to further improve the overall operational efficiency.',
  't3EZ/p': 'This months inventory health rating is Good. The existing slow-moving inventory is controlled within a reasonable range. It is recommended to continue to maintain the current inventory management strategy and focus on the replenishment rhythm of best-selling products.',
  'I2haAQ': 'Want to precisely manage inventory risks and avoid overstocking and capital occupation? This report uses objective data instead of empirical judgment to help you identify the risk of overstocking. Unlock more efficient inventory management solutions through data!',
  'S5IKvF': 'Sellable time exceeds 90 days, and display detailed information of SKUs with sales volume less than 3 units in the past 30 days, including inventory and outbound status(sort by descending order of average daily inventory quantity for each SKU)',
  'YPCIjO': 'Sellable time exceeds 90 days, and display detailed information of SKUs with sales volume in the range of 3~100 units in the past 30 days, including inventory and outbound status(sort by descending order of average daily inventory quantity for each SKU)',
  'eQigZu': 'Sellable time is less than 14 days, and display detailed information of SKUs with sales volume less than 100 units in the past 30 days, including inventory and outbound status (sort by descending order of average daily inventory quantity for each SKU)',
  'pC8w8l': 'Sellable time is less than 14 days, and display detailed information of SKUs with sales volume greater than 100 units in the past 30 days, including inventory and outbound status (sort by the ratio of average daily inventory to average daily shipments per SKU in descending order)',
  'Dx3xZs': 'Sellable time exceeds 90 days, and display detailed information of SKUs with sales volume in the range of 3~100 units in the past 30 days, including inventory and outbound status(sort by descending order of average daily inventory quantity for each SKU)',
  'wGenC7': 'Sellable time exceeds 90 days, and display detailed information of SKUs with sales volume less than 3 units in the past 30 days, including inventory and outbound status (sort by the ratio of average daily inventory to average daily shipments per SKU in descending order)',
  'AoYxot': 'Optimal Stocking for Best-selling',
  'UgVDmg': 'Optimal Stocking for Long-tail',
  'aI14f6': 'Inventory status distribution',
  '2cEeD0': 'AU warehouse',
  '3lXXUZ': 'DEBR2 warehouse',
  'Dp6hUU': 'AUME warehouse',
  'ONTDVL': 'USWC2 warehouse',
  'SmiBHH': 'USKY5 warehouse',
  'Xc1MK9': 'USKY3 warehouse',
  'cN4WwM': 'UKTW warehouse',
  'dfM18m': 'CATO warehouse',
  'hyw36k': 'DE warehouse',
  'jq8YEp': 'USWC5 warehouse',
  's3rYvE': 'USWC warehouse',
  'wtLyGS': 'UKGF warehouse',
  '8AFKQY': 'Parent Container Barcode',
  '8nT9ZY': 'Batch Processing',
  '9fCuYD': 'Bulk Import Processing',
  'AdLyfK': 'Source Sub-order No.',
  'Bwqwwx': 'Weight (kg) ',
  'CRrx95': 'Estimated Restocking Fee to be Generated: <span>{amount}{currency}</span>  ',
  'EBMdAL': 'Creation Successful',
  'Gu6ve5': 'Bulk Restocking',
  'HhBSTd': 'Packaging Type',
  'KDST00': 'Actual Outbound Quantity',
  'KffZZe': 'Total Number of Items',
  'Qml+Jw': 'New Order No.',
  'TzdYjm': 'Destroy All',
  'UXBFYM': 'Restock',
  'VGTfHQ': 'Total {count} items imported, {success} items verified successfully, {error} items failed verification',
  'Ww4mvO': 'Convert All to Standard Outbound',
  'ZeTTNk': 'To modify the processing method, you need to re-upload the template file. Confirm modification?',
  'ZqyX8H': 'Source Order No.',
  'bSaNQ3': 'A total of {count} containers selected this time, estimated restocking fee to be generated: {amount} {currency}',
  'bnfcAI': 'Container Weight',
  'c8/6P+': 'Source Customer Order No.',
  'cS4CeZ': 'Confirm the destruction of containers including 【{code}】?',
  'dH6cPS': 'Convert All to Self-pickup Outbound',
  'fMVIuu': 'Total Number of Packages',
  'h0JOsy': 'Container Length * Width * Height',
  'lWg/Rm': 'Restocking Reason',
  'mnflXu': 'Confirm the destruction of this container 【{code}】? ',
  'rHTOUC': 'Maximum support for {num} order numbers',
  'tATKZZ': 'Staging Completion Time (Local)',
  'vkVx/K': 'The total volume of the products you have ordered exceeds {configVolume} cubic meters. It is recommended that you choose this product instead.',
  'xxS2pF': '1. Only XLS and XLSX format templates are supported{break}2. Each file supports a maximum of 5000 containers. If exceeding 5000, please split into multiple files and upload in batches{break}3. The maximum file size is 5M. If the file is too large, please split into multiple files and upload in batches{break}',
  'zOsH5H': 'Whole order merging processing',
  'LN1bBn': 'After return staging, replace with a new order slip',
  'LuUUcY': 'After outbound staging, replace with a new order slip',
  '1/GyvI': 'Select to create a new self‑pickup order',
  'Ial38i': 'Merge by order No. to create a new order',
  'JTfl/3': 'Select to return to shelf',
  'MO51pO': 'Import using the template to create new orders',
  'PegTHG': 'Select to create a new outbound order',
  'sN4Z/2': 'Select to destroy',
  '5LrpOS': 'Invalid pending processing',
  'D5Qa5n': '<a1>What is the UK VAT number you want to check? -Check a UK VAT number - GOV.UK</a1>verification has expired. There is still inventory (in transit) under the VAT name. Please handle it within the time limit. If it is not handled within the deadline, our company will freeze the inventory, prohibit the goods from leaving the warehouse, and only self pickup and destruction can be carried out in the future. At the same time, the expired VAT number should be reported to HMRC agency according to the requirements of UK supervision. Please be informed. ',
  'PJk9rP': 'Unchecked',
  'gtBqMe': 'Exception handling in progress',
  'kTopMl': 'VAT status',
  'v0fN/N': '{vatRemainExpireDate} days remaining',
  'yrpZqC': 'Under inspection',
  '1z+PUC': 'Invalid VAT Number',
  '2Wr8ti': 'In Inventory Total = Available Inventory + Unavailable Inventory',
  '4C52jb': 'Unavailability Type',
  'D/IEZc': 'Return in Staging',
  'IqhS6n': 'Non-Compliant Hold',
  'L1oad9': 'Reason for Non-Compliant Hold',
  'MZGnPz': 'Unavailable Inventory',
  'Nkzb4e': 'Importer/Trader',
  'NyrztL': 'Inventory Details for Loss Under Investigation',
  'R1UfwV': 'Inventory Details for VAT Invalid Sales Restricted',
  'RxOEEB': 'Reason for unavailability',
  'Sn+VZl': 'Inventory Details for Return in Staging',
  'Tmm/ts': 'Inventory Details for Sales Order Allocated Hold',
  'ZcAx93': 'Outbound in Staging',
  'f0R63Z': 'VAT Invalid Sales Restricted',
  'fvgxnz': 'Inventory Details for Non-Compliant Hold',
  'hGGMo3': 'Non-Compliant Sales Restriction Details',
  'hJLtvk': 'Sales Restriction Time',
  'j/abtG': 'Reason for Non-Compliant Restriction',
  'kqVWhs': 'Invalid Sales Restriction Time',
  'lMeQIl': 'Sales Order Allocated Hold',
  'q1B+zO': 'Inventory Details for Outbound in Staging',
  'y2IUn0': 'Item Exception Hold Inventory Details',
  'ydYOXN': 'Inventory Details',
  'RJpcKu': 'Sales Restricted VAT Invalid Quantity',
  'aaTDNr': 'Unavailable inventory quantity',
  'cyH+CL': 'Unavailable inventory type',
  'WFc0E0': '<red>Please provide a complete operation video, upload up to 1 video, limited to avi, dat, mpg, wmv, asf, rm, rmvb, mov, flv, mp4 formats within 50M.</red>',
  'Da2ffQ': 'This function is used to temporarily lock sales inventory to prevent it from being allocated by other orders. After locking, the system will freeze the corresponding quantity of inventory. Once released, the inventory will revert to an available status. Please ensure that an outbound order is created promptly after release to prevent this inventory from being allocated to other orders.{break}Please note: This operation only freezes the inventory quantity and does not designate or lock specific physical items or storage locations within the warehouse.',
  '0GMK7Y': 'Lock/Release Sales Inventory',
  '+swO4L': 'Note: Modifying preferences will not affect product data that has been historically referenced. {break} If you need to modify product service data, please reset the EF service in [Platform Synchronization - eBay Fulfillment Product Management | Menu].',
  '3YAh2J': 'Export current product matching data',
  '6cvqQC': 'Using preferences will fully update all content in the service settings. {break} Do you want to use preferences?',
  'BPAh3l': 'Please select the listing information you want to export.',
  'GU8kAT': 'If a product already in EF requires maintenance information, the EF information will not be updated until the maintenance is completed.',
  'KzSXfU': 'Export based on current listing information.',
  'MyYCNq': 'You can set EF service information in advance to help you quickly join the eBay Fulfillment service.',
  'NJ3JfH': 'Are you sure you want to delete the current product? ',
  'OwvQbz': 'eBay Fulfillment Service Preferences',
  'YIvnlG': 'Please set up an eBay service',
  'YNHo/g': 'Export information is the same as the eBay Fulfillment import template, and supports direct import via Excel after modification. Currently, only matched data for non-combined products and products without specifications are exported.',
  'c5rvdd': 'eBay Fulfillment Preferences',
  'qXGWFz': 'Export according to the information required to import the eBay eBay Fulfillment Add Product Template',
  'y3FPak': '<a1>Manage my eBay Fulfillment preferences</a1>',
  'IBAsbe': 'Containers to be batched',
  'qs/sEC': 'Please select a palletizing strategy',
  '0Qjh2e': 'Please Select Condition',
  '1le4VE': 'Product Category Name',
  '2k/NaR': 'Supports batch query, up to 500 items maximum',
  '3kiSJD': 'Edit Category',
  '62KzCa': 'Specify SKU',
  '7gWnrn': 'Confirm Activation?',
  'C0a1YB': 'Customer Custom Group - Category Information',
  'J7BQCH': 'Configure Products',
  'LUruKv': 'Add Category',
  'P2ZRxg': 'Supports 64-bit characters, Chinese, English, and numbers',
  'Tp4hPZ': 'Group Name',
  'VYPW7Q': 'Please Select Category',
  'aYnWaR': 'Add Group',
  'leNznf': 'Initial Unclassified',
  'ltjhyJ': 'Category',
  'mR+91E': 'Confirm Deactivation?',
  'pfb8mk': 'Edit Group',
  'rEIk6P': 'Group',
  's5s2ZC': 'Category Name',
  'IRsr6r': 'View SKUs Details in Category {className}',
  'aD9f+6': 'Group Classification Rules',
  'dI3AcE': 'Associated Business Strategies',
  'fXe0i9': 'Configure Products in Category {className}',
  'yGtqiA': 'Add Products to Category {className}',
  '+eg7JV': 'Please select a claim order',
  '0mnS/Y': 'Number of successes: {successNum}, Number of failures: {failNum}, Failed data file: {a1}',
  '1CaoGO': 'Please click to download <a1>Import Template</a1>',
  '1qBbCX': 'Download claim forms with pending attachment uploads',
  '8o9WZa': 'Batch submit draft forms',
  '9HoB8V': 'Pending supplementary attachments',
  '9wtfmH': 'Import result of batch supplementary claim attachments: {successCount} successful forms / {failedCount} failed forms',
  'A3wZYS': 'Batch upload claim attachments',
  'BoHeLy': 'Are there any pending supplementary attachments?',
  'DWtPOJ': 'Attachment format: Supported formats {attachmentFileFormat}, each attachment does not exceed {attachmentSizeMax} MB.',
  'Ho12yP': 'Description: {break} After batch creation, claim forms are in draft status. You need to batch supplement claim attachment information to complete the submission of claim forms.',
  'SfkC0A': 'Batch add customer-representative claim forms',
  'UQHOCp': 'Batch change draft forms to submitted status',
  'UWPWwZ': 'No attachment upload configuration available yet',
  'XPpHtm': 'File upload successful: {successUploadNum} files',
  'Y2g3bc': 'File format: {allowExtensions}',
  'pVw6Hz': 'Batch add claim draft files',
  'u9ZvIB': 'Batch apply for customer-representative claims',
  'x18yAp': 'Click <a1>Download Failure Reasons</a1>',
  'x6oA5O': 'Batch supplement claim attachments',
  'pTe5/s': 'Description: {break} 1. The batch supplementary attachment function only applies to the currently selected claim forms in draft status. A maximum of {attachmentNumMax} attachments can be uploaded for a single attachment type. It supports uploading only attachments for some checked claim forms and only attachments of some attachment types. {break} 2. Please name the attachments by "express order number or outbound order number". If there are multiple attachments of the same type for the same order, add a sequence number (e.g.: 9200190389086505358894_01, WO10129482224, claim_WO10129182224); otherwise, the system cannot recognize them. {break} 3. For attachments of the same type, if an attachment with the same file name already exists in the claim form, it will be overwritten; if the file name is different, a new attachment will be added.',
  'jTcDk6': 'Import result of batch supplementary claim attachments: Successfully processed {successCount} attachments; {failedCount} attachments failed.',
  "4q8NAE": "Confirm batch submission of draft orders?",
  "XlpMPJ": "Do you need to supplement attachments",
  '+rqZZp': 'Cancel Group',
  '3Pel4Z': 'Business Object Attributes',
  'HT2Yg+': 'Please Set Conditions',
  'IffoXK': 'And',
  'P9Bukq': 'Operator',
  'S5F4CX': 'Order Cancellation and Fee Description',
  'ZY7dz0': 'Add Group',
  'c1hrRi': 'Add Condition',
  'kbdFu6': 'Condition Settings',
  'lH+4LY': 'Combine Existing Conditions and Add',
  'lNBWTt': 'If the current order is successfully cancelled, the following fees are expected to be incurred {break} Note: Once an order is cancelled, it cannot be revoked. Please confirm whether to cancel this order?',
  'p4KceZ': 'Note: Once an order is cancelled, it cannot be revoked. Please confirm whether to cancel this order?',
  'zcHSrz': 'Add Action',
  'svVpbB': 'Please go to <a>[Preferences > Order Placement Settings > Outbound > Outbound Packing and Palletizing Rules]</a>, first customize the specific conditions for "SKU Separate Packing". After the settings are completed, select this rule during packing. The SKUs in the order that meet the conditions will be automatically packed separately, while those that do not meet the conditions can be packed in a mixed manner.',
  '303VyS': 'Item barcode in box',
  '9lv9YM': 'Staging Information',
  'IOixLx': 'Unpack Staging',
  'JW+UnW': 'Confirm, acknowledge this processing method',
  'L0npSX': 'All Standard Outbound',
  'TK6NXC': 'SKU-Specification',
  'VZOsju': 'Confirm to execute this operation?',
  'ZyPM4b': 'Full Pallet Staging',
  'qfDt0+': 'Processing Mode',
  'rjXuaJ': 'Prepaid Fee Total {amount}',
  'utLXuQ': 'Return staging continued restocking: The system will automatically create an overseas inspection receipt without packing list for putaway. Subsequent processing fees will be charged as inbound handling fees.',
  'vVCO9b': 'All Self-Pickup Outbound',
  'yuTIzT': 'All Continue Restocking',
  'CUWc65': 'Restocking',
  'IWzg8c': 'Redelivery',
  'UhU6pD': 'Please note: The system will automatically create an inbound order [Without Packing List Forecast] for you and charge corresponding inbound processing fees and other related charges.',
  'hnI3J7': 'Confirm Restocking',
  'oOO3DI': 'Please note: For failed deliveries of [Standard Outbound Order - Pallet Service] returned to warehouse, WINIT will place the full pallet in staging, awaiting your selection of subsequent processing method: redelivery, customer pickup, complete disposal, or restocking.',
  'DEesVZ': 'File generation method',
  '+/R6RX': 'Task Status',
  '4wdEel': 'Exceeds <remaining></remaining> tracking numbers',
  '9jqt68': 'Batch Create Task',
  'AXARO9': 'Operation Stage',
  'E1T1CC': 'Download Video',
  'JTjHlt': 'Attachment Format/Quantity: Supported formats {attachmentFileFormat}, each attachment must not exceed {attachmentSizeMax} MB.',
  'O1Fcla': 'Video Processing Completion Time',
  'O6+tgT': 'Processing Successful',
  'RONThN': 'Sub Tracking Number',
  'WB2Dlp': 'Maximum of {maxBueinessNo} orders supported. Separate multiple orders with semicolons or line breaks.',
  'XCWQC8': 'Processing Details',
  'bmxEvb': 'View Screenshots',
  'elh3I5': 'Video Retention Period (Days)',
  'jrz36o': 'Please select the records to export',
  'lJykMl': 'Processing Failed',
  'nU5XCN': '<remaining></remaining> tracking numbers remaining for input',
  'oYCouL': 'View Video',
  'whFLBl': 'Create Task',
  'BZtqw8': 'Please select the records you want to download',
  'DsN6/g': '<strong>Note:</strong>{break}1、The current video function only supports querying the "Outbound Packing" stage.{break}2、If the system fails to retrieve the video, please contact customer service/account manager directly, and we will handle it promptly.',
  'G2+WDL': 'Failed to get video cloud link',
  'PaaQBb': 'Creation failed',
  'k/ZYCd': 'No video file',
  'xkHjBa': 'Batch download results',
  "/vrVEz": "<strong>Dear Valued Customer:</strong>{break}{break} Before using the video inquiry function, you need to sign the 《{agreementName}》. Please read and accept the agreement carefully.{break}Thank you for your understanding and cooperation. Best regards～",
  "Jast2K": "I have read and accept",
  "UzxG4z": "Agreement signed successfully",
  "orZ3MI": "Agreement Signing Notification",
  '2LSGCJ': 'Based on the current status and tracking of the order, the fee handling rules for voiding orders are as follows:',
  'J7LVnb': 'Please note: Once an order is voided, the action cannot be undone. Please confirm whether you want to void this order.',
  'JuDvIb': '<font>In the following scenarios, no fee will be charged for successfully voiding an order:</font>{break} 1.The outbound order status is "Confirming Outbound";{break} 2.The outbound order status is "Outbound Confirmed," and the "Picking" status does not appear in the order tracking (order tracking can be viewed on the sub-order details page).{break}',
  'ks86QP': 'Total selected orders this time: {orderList} orders.If voided successfully, the estimated voiding fee will be:<span>{money}<a>Download fee details.</a></span>',
  'tOYzEt': 'Total selected orders this time: {orderList} orders.',
  'PcipCg': '<font>In the following scenarios, an order interception fee will be incurred for successfully voiding an order:</font>{break} 1.The outbound order status is "Outbound Confirmed," and the "Picking" status has already appeared in the order tracking.{break} 2.The outbound order status is "Picking Completed" or "Temporary Storage Completed".{break}',
  'DgiUWw': 'You have not yet enabled this report permission. If you need it, please contact the business department to activate it.',
  '0pBOr8': 'This feature uses a two-level Group-Category structure. Groups are recommended to distinguish usage scenarios, while Categories are used to associate different strategies within each scenario. {break}Each group contains all published SKUs, and every group categorizes based on the complete SKU set. An SKU can only belong to one category within the same group.',
  '6ZFs0i': 'For {skuType} [{skuCodes}], the outbound quantity is 1 {unit}. Please confirm if you only want to {type} 1 {unit}？',
  'Xagh1G': 'take off the shelf',
  'bEBWR+': 'Among the commodities you selected:',
  '+ey7Yq': 'itemId',
  'PUjSsA': 'Currently supports configuration rules only for eBay, eBay eF, Temu, AliExpress, Shopify, Shein, and Amazon (MSF). Other platforms will be added soon, so stay tuned!',
  'PoV573': 'Is this an EF service?',
  'S/dUu1': 'ef SKUID',
  'lLS+rK': 'Only synchronize products on registered platforms.',
  '/TI8v+': 'According to the platform requirements, the eF platform does not allow an organization’s inventory to be shared with other platforms.',
  'AizcnV': 'After selecting the "Inbound label feature = no package code, only product code" option, the existing packing list information will be cleared and you will need to re-import the packing list. Please confirm whether to select this option?',
  'MSpE0K': 'The container pickup application has been submitted. At that time, Wanyitong will go to the destination port to pick up the container according to your container pickup application. You do not need to make an appointment for this order. Wanyitong will notify you by email when the container pickup and delivery are completed. If you have any questions, you can consult customer service. Thank you!',
  'gXvdYK': 'No package code is attached, only the product code is attached. Note: This entry label feature only supports SKUs that meet the following conditions for ordering:{break}1. SKU product package type = A+ package;{break}2. Whether to collect package code when SKU is shipped out = No;{break}3. SKU batch management type ≠ shelf life management/production batch management;',
  'qvErRI': 'In the [Sea Freight FCL 100% A+ Package] scenario, each FCL can only correspond to one inbound order. Please do not create multiple inbound orders or place the goods of one inbound order in multiple cabinets.',
  '05eCAs': 'System Upgrade Notification',
  'DkFwmu': 'System Announcement',
  'L24ioQ': 'Title',
  'MtNsT8': 'Guess you want to choose:',
  '/F5ua7': 'Role Management',
  '/kcDRM': 'Priviledge Assignment',
  '0fPGWA': 'Transfer-in',
  '39n5YN': 'Invoice generated successfully.',
  '50JdGS': 'Add Role',
  '7WRAqc': 'Reception confirmed successfully.',
  'CwD34X': 'Transfer-out',
  'EWyvCn': 'Transfer No. {orderNo}, status is not "Put Away", not allowed to generate invoice',
  'Eco+Vy': '*After the priviledges are modified, the related sub accounts will be effective.',
  'F7+3p7': 'Invoice No.',
  'IPlwHh': 'Transfer PVA inventory',
  'JiNi3f': 'Create Invoice',
  'T7TK6n': 'Authorization order',
  'TMLZfW': 'In Confirmation',
  'TOmMNL': 'Role Name',
  'UlzvsW': 'System generation',
  '4Rjjko': 'Transfer No. {orderNo}, status not "In Confirmation"',
  'f/1WBy': 'Accepted',
  'j/5P4C': 'Are you sure you want to delete this role?',
  'k+zCG7': 'Role Description',
  'mFr2rC': 'Reception confirmed successfully.',
  'mGo/vP': 'Rejected',
  'v0zMRx': 'The order cannot be recovered after scrapping, confirm to scrap?',
  'vTqH3H': '<font>Please note: To ensure the smooth operation of the 【100% A+ Parcel Inbound】 service, please create inbound orders according to the following rules:</font>{break} <font>FCL</font>: One full container or full truckload<red> can only correspond to one inbound order.</red>Do not create multiple inbound orders for one container/truck, and do not split goods from one inbound order into multiple containers/trucks.{break} <font>LCL</font>: Within the same order,<red>one SKU can only correspond to one inbound order.</red>Do not create multiple inbound orders for the same SKU under the same order, and do not split an inbound order for one SKU into multiple orders.',
  'tXn/GP': 'The container pickup application has been submitted. At that time, Wanyitong will go to the destination port to pick up the container according to your container pickup application.{break}You do not need to make an appointment for this order. Wanyitong will notify you by email when the container pickup and delivery are completed. If you have any questions, you can consult customer service. Thank you!',
  '4wYj0s': 'Exact query by order number',
  'AnBOmT': 'This report only collects data from standard outbound orders in the last 12 months.',
  'DQVpB8': 'Overseas warehouse unloading time',
  'DcJ5SS': 'Month',
  'dm5kaR': 'Fuzzy query supports only one record, at least 6 characters required',
  'fLikOl': 'Report description: 1. Only collects inbound orders from the last 12 months; 2. Excludes orders in draft, voided, suspended statuses; 3. Excludes orders with customer exceptions and no tracking number.',
  'nJMBKl': 'Delay',
  'vB+VpF': '{countryCode} has enabled international service, must configure shipping rates and additional item fees for at least one region',
  'wXBORv': 'For batch queries, enter one record per line, up to {num} lines maximum',
  'y7RIrZ': 'Fuzzy query by order number',
  '10cSqN': 'Inbound packaging material type',
  'Dyhkec': 'Associated business document number',
  'Ek/myJ': 'Custom grouping',
  'iicPwU': 'Please select a group',
  'x4UkYl': 'Description:Supports importing up to 10000 rows of data at a time;ImportedSingle product bar codes will automatically ignore case (eg: A001=a001).',
  '4+JGPX': 'Click to jump to view',
  'XfMvRR': 'The SKU NO. already exists, please do not register again',
  'tgl+wy': 'The attery weight cannot exceed the registered weight of the product',
  '6F/qMC': 'Cannot contain Chinese characters and spaces are not allowed before or after',
  'VzWDBN': 'Transfer of Owner Order No.',
  '849JPP': 'No:',
  'HWGh4O': 'Current data acquisition time {time}. Data is for preview only, showing only registered platform products and repositories supported by the service',
  'SMfcim': '{msg}',
  '+74dRQ': 'Confirm Voidance',
  '8XdH/H': 'Please note, the current order has been <font>packed</font> by the warehouse.',
  'EJ0ilf': 'Please note, the current order has entered the <font>picking stage</font> (you can check the tracking in the sub-order details).',
  'GElz75': 'Please note, the current order has been <font>picked</font> by the warehouse.',
  'K0VbUB': 'Please verify the specific situation and confirm whether to proceed.',
  'QUABn3': 'The current order is in the {status} stage. Once voided, it cannot be restored. {break} According to system estimates, <font>no fees will be incurred for voiding this order.</font> Please confirm if you wish to proceed.',
  'Snx1CT': 'Voiding the order at this stage will <font>incur additional handling fees</font>, as detailed below:',
  'VbK2G8': 'Attempt to Intercept and Void',
  'W/umjf': 'Order status has changed',
  'a/7jJk': 'The order status and the estimated voidance fee have changed. Click OK to view the latest estimated fee.',
  'pISR6a': 'We will attempt to intercept the order. <font>If successful, the following fees will apply.</font> If the interception fails, the order will be shipped as normal.',
  'snmY5L': 'Reconfirm Order Voidance',
  'v1TKFQ': 'Still Void',
  '8xggaR': '<bold>Friendly reminder:</bold>Value-added services from the original order will not carry over automatically when you place a new order. If needed, please reselect them in the new order.{break} <bold>Important notice:</bold>To avoid duplicate orders, after performing the "Void" action, please confirm that the system status has updated successfully.',
  'MmsgRh': 'Please note: <font>This voidance fee is higher than the total order cost (Product Value: {currency}{totalDeclareValue} + Estimated Final Delivery Fee: {currency}{totalFreezeFee} = {currency}{allPrce}).</font>',
  'yUuXcJ': 'Voiding this order will incur an estimated fee of {currency}{totalAmount}.',
  "+VopDc": "Defective Item Inspection Result{break}Processing Method",
  "+mYfas": "Inspection Item Configuration",
  "/n+tKs": "WINIT will officially disable the configuration entry for 'Return Policy Maintenance 1.0' starting January 1, 2026.",
  "0cMr0D": "Click to Complete",
  "1IIbDN": "Other Configurations",
  "2BxBTv": "Policy Pending Information",
  "2KONJS": "Return Policy Maintenance 2.0",
  "4HISCS": "Historical Version Records",
  "4dEEgP": "Quality Inspection Plan at Order Placement",
  "5tkC4Q": "Edit Return Policy",
  "61cDzQ": "Confirm deactivation of [{name}]?",
  "6ytQ75": "Product Group Categories",
  "73eXMD": "Yes, follow WINIT standards",
  "7vX7Un": "Only Final Processing Comments",
  "9Hn46w": "Create New Plan | View All Plans",
  "9YUNcP": "Note: Since actual quality inspection results and final processing methods with value-added processing cannot be determined during order placement; the above estimated costs do not include warehouse processing fees for items requiring quality inspection services.",
  "9yRzlq": "Inspection Result Criteria",
  "AI6DDX": "Continue Inspection cannot be selected for the last inspection item",
  "AtdvGF": "Global Photos:",
  "AzJgkv": "2. Policy Priority:",
  "B40RlV": "<bold>How are final processing comments determined?</bold>{break} Step 1: Warehouse conducts sequential inspection. If a 'process and terminate inspection' result is triggered, the quality inspection process terminates and this result becomes the final comment;{break} Step 2: If no interruption occurs, the system collects all inspection results and determines the final processing comment based on priority: Destruction > Defective Restocking > Good Restocking.",
  "CDdDy+": "Global Photos Required",
  "D23Qrv": "Inspection item information is missing in the RMA quality inspection plan for this product. Please <a>complete</a> the information!",
  'DY6+vH': 'Quality Inspection Type - Inspection Group',
  "EECzKR": "Value-Added Repair Processing Executed",
  "GS1Lum": "Execute",
  "GZsvFK": "Applicable Scope",
  "GluGBZ": "Return Policy Maintenance 1.0",
  "HfSjD4": "Historical configurations from version 1.0 will remain effective after feature retirement. To ensure policy consistency, please complete configurations in version 2.0 promptly. Original policies will expire when overwritten by new version 2.0 policies.",
  "ISikVi": "Quality Inspection Service Pending Information",
  "Irs1wT": "Quality Inspection Service Designated Plan",
  "JEav9w": "Special Packing Restoration Required",
  "JK2HF/": "Create Product Category | View All Product Categories",
  "JoXUXa": "Diagram",
  "KbwupO": "Not Executed",
  "LAH16f": "Return Policy Maintenance Version Upgrade",
  "MFIIR2": "Please select category first!",
  "MLSFI9": "Applicable Product Group Categories",
  "MpyhY0": "1. Feature Retirement:",
  "ODFB43": "Quality Inspection Plan",
  "OjHnTC": "View Quality Inspection Results",
  "Q2tIhz": "Restocking Processing Method",
  "RF4cO0": "Publisher",
  "RjQfND": "Inspection Completed",
  "TT18ya": "Applicable SKU Level",
  "U5LjS2": "WINIT receiving process conducts preliminary assessment of product condition and exceptions based on unified standards!",
  "VWqu6P": "Select Inspection Items for Category [<span>{categoryName}</span>]",
  "WSbvVj": "Inspection Result - Processing Method",
  "X5lvqc": "Please enter a positive integer. Smaller number indicates higher priority.",
  "Xqvhg+": "Photo Required",
  "YBE8cL": "Quality Inspection Results",
  "YS1hEm": "Information Required",
  "Yygon3": "Inspection Result - Processing Comments",
  "ZNKoOi": "Quality Inspection Category",
  "ZSIyhH": "Confirm activation of [{name}]?",
  "aMWIVz": "Plan Version",
  "bU9iQR": "Policies configured in 'Return Policy Maintenance 2.0' have higher priority than version 1.0.",
  "bwYTdQ": "Add Quality Inspection Plan",
  "c1d3HN": "This policy has pending quality inspection service information. Please complete the information promptly to avoid impact on quality inspection service availability.",
  "cGhj/6": "RMA quality inspection service and plan are not configured in the return policy for this product. Please <a>configure</a>!",
  "dr80Nj": "Quality Inspection Plan Maintenance",
  "dtzzvy": "Add Return Policy",
  "fgmSvQ": "Quality Inspection Plan Name",
  "fi0x6R": "Special Packing Restoration Required",
  "fxqKz3": "Release Date",
  "g/7FFs": "Please select inspection items according to your requirements. WINIT standard inspection items have been pre-selected and locked to meet basic quality inspection requirements and cannot be deselected.{break} Note: Additional extended inspection items will be charged per item based on the inspection level.",
  "gFmt0w": "Execute Value-Added Processing",
  "gskk4+": "View Photos",
  "hBFKEL": "Special Packing Restoration Executed:",
  "hDlNTS": "View Quality Inspection Plan Version <span>[{version}]</span>",
  "hME8oO": "Quality Inspection Plan Type",
  "hTCHMm": "Optional Value-Added Processing",
  "iwyzfn": "Edit Quality Inspection Plan Version <span>[{version}]</span>",
  "j5Iaok": "Applicable Group-Category",
  "jZgtLX": "No, normal folding is sufficient",
  "k869y5": "Minimum 1 template image, maximum 5 template images supported!",
  "kbEx/Z": "Inspection Sequence",
  "l/g30I": "Selected receiving warehouse has no quality inspection service permissions!",
  "lT4lHY": "3. Transition Period Arrangement:",
  "leNLKM": "Policy Code",
  "mXVcp/": "Continue Inspection",
  "mt22Qq": "Please Select Inspection Items",
  "n3ssO6": "No",
  "nZHz3j": "Good Item Inspection Result{break}Processing Method",
  "oMwON9": "Quality Inspection Type",
  "ozSlY1": "Information Type",
  "p9IpMU": "Action When Any Processing{break}Cannot Be Completed",
  "qFVFrW": "Yes, follow SOP procedures",
  "qKuhZr": "Important Notice:",
  "qZChGk": "Inspection Items",
  "qaw9Fz": "Maximum Image Size 10M",
  "qfjmAq": "Select Inspection Items",
  "quY7u+": "Plan Type",
  "sAcyRI": "Product Group-Category",
  "tYfrZI": "Policy Priority",
  "u5ohvf": "Final Processing Method:",
  "wDr1QD": "Quality Inspection Items",
  "wIzG3R": "Inspection Group",
  "wTnJse": "Process and Terminate Inspection When Triggered",
  "xDRO8r": "Applicable Product Group-Category",
  "zMhU9B": "Global Photo Required",
  '5Dydff': 'Global Photos Required',
  'D2YSB/': 'Quality Inspection Type - Inspection Group',
};
